import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Decimal: any;
  Long: any;
  UUID: any;
};

export type ActionPayload = {
  __typename?: 'ActionPayload';
  data?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type AddClientPartnerInput = {
  clientId: Scalars['String'];
  currentFileGenerationNumber?: InputMaybe<Scalars['Int']>;
  defaultCurrencyCode?: InputMaybe<Scalars['String']>;
  maxFileGenerationNumber?: InputMaybe<Scalars['Int']>;
  partnerId: Scalars['String'];
};

export type AddClientPartnerPayload = {
  __typename?: 'AddClientPartnerPayload';
  clientPartnerId?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type AddClientPartnerTransactionPayload = {
  __typename?: 'AddClientPartnerTransactionPayload';
  clientPartnerTransactions?: Maybe<Array<Maybe<ClientPartnerTransactionModel>>>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type AddClientPartnerTransactionsInput = {
  clientPartnerId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  partnerTransactionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type AddNotificationFormatterTransactionsInput = {
  id?: InputMaybe<Scalars['String']>;
  notificationFormatterId: Scalars['String'];
  transactionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type AddNotificationFormatterTransactionsPayload = {
  __typename?: 'AddNotificationFormatterTransactionsPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  notificationFormatterTransactions?: Maybe<Array<Maybe<NotificationFormatterTransactionModel>>>;
  result: RequestResult;
};

export type AddPartnerTransactionsInput = {
  id?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['String'];
  pipelineId?: InputMaybe<Scalars['String']>;
  transactionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type AddPartnerTransactionsPayload = {
  __typename?: 'AddPartnerTransactionsPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  partnerTransactions?: Maybe<Array<Maybe<PartnerTransactionModel>>>;
  result: RequestResult;
};

export type AddressFilterInput = {
  cities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  postalCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateIds?: InputMaybe<Array<Scalars['String']>>;
};

export type AddressModel = {
  __typename?: 'AddressModel';
  /** Address line 1 of the Address. */
  addressLine1: Scalars['String'];
  /** Address line 2 of the Address. */
  addressLine2?: Maybe<Scalars['String']>;
  /** Address line 3 of the Address. */
  addressLine3?: Maybe<Scalars['String']>;
  /** Address line 4 of the Address. */
  addressLine4?: Maybe<Scalars['String']>;
  /** City of the Address. */
  city?: Maybe<Scalars['String']>;
  country?: Maybe<CountryModel>;
  /** Country code of the address. */
  countryCode?: Maybe<Scalars['String']>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Id of the Address */
  id: Scalars['UUID'];
  /** Primary status of address. */
  isPrimary?: Maybe<Scalars['Boolean']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Parent Id of the Address */
  parentId: Scalars['UUID'];
  /** Postal code of the address. */
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<StateModel>;
  /** Parent Id of the Address */
  stateId?: Maybe<Scalars['UUID']>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER'
}

export type AttachmentModel = {
  __typename?: 'AttachmentModel';
  /** Attachment string of the Attachment. */
  attachmentString?: Maybe<Scalars['String']>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** User name that has created the record. */
  createdByName?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Attachment. */
  description?: Maybe<Scalars['String']>;
  /** Last modification time of the attachment file */
  fileLastModifiedTime?: Maybe<Scalars['DateTime']>;
  /** File name of the Attachment. */
  fileName: Scalars['String'];
  /** Id of the Attachment */
  id: Scalars['UUID'];
  isLink?: Maybe<Scalars['Boolean']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** User name that has last modified the record. */
  lastModifiedByName?: Maybe<Scalars['String']>;
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Mime type of the Attachment. */
  mimeType: Scalars['String'];
  /** Parent Id of the Attachment */
  parentId: Scalars['UUID'];
};

export enum AttachmentType {
  Client = 'CLIENT',
  ClientPartner = 'CLIENT_PARTNER',
  Partner = 'PARTNER'
}

export type AuditRecordModel = {
  __typename?: 'AuditRecordModel';
  /** When this audit record was created. */
  createdTime: Scalars['DateTime'];
  /** ID of the entity being audited. */
  entityId: Scalars['String'];
  /** Name of the entity being audited. */
  entityName: Scalars['String'];
  /** State of the entity during this audit record (Added, Modified, Deleted, etc.). */
  entityState: EntityState;
  /** Id of the audit record. */
  id: Scalars['UUID'];
  /** New values of the entity. */
  newValues?: Maybe<Scalars['String']>;
  /** Previous values of the entity (if available). */
  oldValues?: Maybe<Scalars['String']>;
  /** ID of the user who performed the action. */
  userId: Scalars['UUID'];
  /** Name of the user who performed the action. */
  userName: Scalars['String'];
};

export type AuditRecordOrderByInput = {
  createdTime?: InputMaybe<OrderDirection>;
  entityName?: InputMaybe<OrderDirection>;
  entityState?: InputMaybe<OrderDirection>;
  userName?: InputMaybe<OrderDirection>;
};

export type BillingAggregatesModel = {
  __typename?: 'BillingAggregatesModel';
  /** Billing Id of the billing aggregates. */
  billingId: Scalars['UUID'];
  /** Comments for the billing aggregates. */
  comments: Scalars['String'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Currency Code of the billing aggregates. */
  currencyCode: Scalars['String'];
  /** Document Charges of the billing aggregates. */
  documentCharges: Scalars['Decimal'];
  /** Id of the billing aggregates. */
  id: Scalars['UUID'];
  /** Internal Client Code of the billing aggregates. */
  internalClientCode: Scalars['String'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Line Charges of the billing aggregates. */
  lineCharges: Scalars['Decimal'];
  /** Month of the billing aggregates. */
  month: Scalars['Int'];
  /** Service Fee of the billing aggregates. */
  serviceFee: Scalars['Decimal'];
  /** Total Charges of the billing aggregates. */
  totalCharges: Scalars['Decimal'];
  /** Total Documents of the billing aggregates. */
  totalDocuments: Scalars['Int'];
  /** Total Lines of the billing aggregates. */
  totalLines: Scalars['Int'];
  /** Year of the billing aggregates. */
  year: Scalars['Int'];
};

export type BillingItemModel = {
  __typename?: 'BillingItemModel';
  /** Billing of the Billing Item */
  billing?: Maybe<BillingModel>;
  /** Billing Id of the Billing Item */
  billingId: Scalars['UUID'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Date To of the Billing Item */
  dateFrom?: Maybe<Scalars['DateTime']>;
  /** Date To of the Billing Item */
  dateTo?: Maybe<Scalars['DateTime']>;
  /** Id of the Billing Item */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Pricing of the Billing Item */
  pricing?: Maybe<PricingModel>;
  /** Pricing Id of the Billing Item */
  pricingId: Scalars['UUID'];
};

export type BillingModel = {
  __typename?: 'BillingModel';
  /** Billing Item Count of the Billing */
  billingItemCount?: Maybe<Scalars['Int']>;
  /** Number of Clients that have this Billing */
  clientCount?: Maybe<Scalars['Int']>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** User name that has created the record. */
  createdByName?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Currency Code of the Billing */
  currencyCode?: Maybe<Scalars['String']>;
  /** Description of the Billing */
  description: Scalars['String'];
  /** Id of the Billing */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** User name that has last modified the record. */
  lastModifiedByName?: Maybe<Scalars['String']>;
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
};

export enum BlobDocumentFormat {
  Base64 = 'BASE64',
  BinaryData = 'BINARY_DATA',
  ByteArray = 'BYTE_ARRAY',
  RawString = 'RAW_STRING'
}

export enum BlobDocumentType {
  EdiDocument = 'EDI_DOCUMENT',
  EdiXml = 'EDI_XML',
  EdiXmlConfig = 'EDI_XML_CONFIG',
  ErpTransactionSchema = 'ERP_TRANSACTION_SCHEMA',
  PostProcessing = 'POST_PROCESSING',
  Sef = 'SEF',
  TransactionMap = 'TRANSACTION_MAP',
  TransactionXpath = 'TRANSACTION_XPATH',
  Unknown = 'UNKNOWN'
}

/** Request object for downloading a blob. */
export type BlobDownloadRequestInput = {
  /** Blob Document Format. */
  blobDocumentFormat: BlobDocumentFormat;
  /** Blob Document Id. */
  blobDocumentId: Scalars['String'];
  /** Blob Document Type. */
  blobDocumentType: BlobDocumentType;
  /** Blob File Name. */
  blobFileName?: InputMaybe<Scalars['String']>;
};

export type BlobStorageModel = {
  __typename?: 'BlobStorageModel';
  /** Blob document type of the blob storage. */
  blobDocumentType: BlobDocumentType;
  /** Unique blob file name for blob storage. */
  blobFileName: Scalars['String'];
  /** Blob Storage Reference. */
  blobStorageReference?: Maybe<BlobStorageReferenceModel>;
  /** Comment for blob storage. */
  comment: Scalars['String'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** User name that has created the record. */
  createdByName?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** File name of the blob storage. */
  fileName: Scalars['String'];
  /** Id of the blob storage. */
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** User name that has last modified the record. */
  lastModifiedByName?: Maybe<Scalars['String']>;
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Version of the blob storage. */
  version: Scalars['Int'];
};

export type BlobStorageReferenceModel = {
  __typename?: 'BlobStorageReferenceModel';
  /** Blob document id of the blob storage reference. */
  blobDocumentId: Scalars['UUID'];
  /** Blob storage id of the blob storage reference. */
  blobStorageId: Scalars['UUID'];
  /** Blob storage version and details. */
  blobStorages?: Maybe<Array<Maybe<BlobStorageModel>>>;
  /** Id of the blob storage reference. */
  id: Scalars['UUID'];
  standardExchangeFormat?: Maybe<StandardExchangeFormatModel>;
};

/** Represents the request to upload a blob. */
export type BlobUploadRequestInput = {
  /** Gets or sets the blob document format. */
  blobDocumentFormat: BlobDocumentFormat;
  /** Gets or sets the blob document identifier. */
  blobDocumentId?: InputMaybe<Scalars['String']>;
  /** Gets or sets the blob document type. */
  blobDocumentType: BlobDocumentType;
  /** Gets or sets the blob file name. */
  blobFileName?: InputMaybe<Scalars['String']>;
  /** Gets or sets the comment. */
  comment?: InputMaybe<Scalars['String']>;
  /** Gets or sets the file content. */
  fileContent?: InputMaybe<Scalars['String']>;
  /** Gets or sets the file name with extension. */
  fileNameWithExtension?: InputMaybe<Scalars['String']>;
  /** Gets or sets a value indicating whether this is the active version of the document. */
  isActive: Scalars['Boolean'];
  /** Gets or sets a value indicating whether this is the first version of the document. */
  isFirstVersion?: InputMaybe<Scalars['Boolean']>;
};

/** Bulk Blob Upload Request. */
export type BulkDataLakeFileUploadRequestInput = {
  dataLakeFileUploadRequests?: InputMaybe<Array<InputMaybe<DataLakeFileUploadRequestInput>>>;
};

export type BusinessAreaModel = {
  __typename?: 'BusinessAreaModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the business area */
  description?: Maybe<Scalars['String']>;
  /** Id of the business area */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Name of business area */
  name: Scalars['String'];
};

export type BusinessAreaOrderByInput = {
  name?: InputMaybe<OrderDirection>;
};

export type ClientAkaModel = {
  __typename?: 'ClientAkaModel';
  /** Client Code of the ClientAKA */
  clientCode: Scalars['String'];
  /** Id of the ClientAKA */
  clientId: Scalars['UUID'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the ClientAKA */
  description?: Maybe<Scalars['String']>;
  /** Id of the ClientAKA */
  id: Scalars['UUID'];
  /** ISA Qualifier of the ClientAKA */
  isaQualifier?: Maybe<IsaQualifierModel>;
  /** ISA Qualifier Code of the ClientAKA */
  isaQualifierCode: Scalars['String'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
};

export type ClientContactModel = {
  __typename?: 'ClientContactModel';
  /** Address info of the client contact */
  addresses?: Maybe<Array<Maybe<AddressModel>>>;
  /** Client Id of the client contact */
  clientId: Scalars['UUID'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  /** Email info of the client contact */
  emails?: Maybe<Array<Maybe<EmailModel>>>;
  /** Id of the client contact */
  id: Scalars['String'];
  /** If the Contact is Active. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** If the Contact is Primary. */
  isPrimary?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Name of the client contact */
  name: Scalars['String'];
  /** Note info of the client contact */
  notes?: Maybe<Array<Maybe<NoteModel>>>;
  /** Phone info of the client contact */
  phones?: Maybe<Array<Maybe<PhoneModel>>>;
};

export type ClientModel = {
  __typename?: 'ClientModel';
  /** Address info of the client */
  addresses?: Maybe<Array<Maybe<AddressModel>>>;
  /** Attachments of the client */
  attachments?: Maybe<Array<Maybe<AttachmentModel>>>;
  /** Billing of the client */
  billing?: Maybe<BillingModel>;
  /** Billing id of the client */
  billingId?: Maybe<Scalars['UUID']>;
  /** Billing start date of the client */
  billingStartDate?: Maybe<Scalars['DateTime']>;
  /** Bulk Notification time for the client */
  bulkNotificationTime?: Maybe<Scalars['DateTime']>;
  /** Business area of the client */
  businessArea?: Maybe<BusinessAreaModel>;
  /** Client AKA info of the client */
  clientAKAs?: Maybe<Array<Maybe<ClientAkaModel>>>;
  /** Code of the client */
  clientCode: Scalars['String'];
  /** Contact info of the client */
  clientContacts?: Maybe<Array<Maybe<ClientContactModel>>>;
  /** Notification Recipients of the client */
  clientNotificationRecipients?: Maybe<Array<Maybe<ClientNotificationRecipientsModel>>>;
  /** Client Trading partners association of the client */
  clientPartners?: Maybe<Array<Maybe<ClientPartnerModel>>>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** User name that has created the record. */
  createdByName?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Default currency for the client */
  defaultCurrencyCode?: Maybe<Scalars['String']>;
  /** EdiXmlConfig of the client */
  ediXmlConfig?: Maybe<EdiXmlConfigModel>;
  /** Email info of the client */
  emails?: Maybe<Array<Maybe<EmailModel>>>;
  /** ERP Document Format for ERP Document of the client */
  erpDocumentFormat?: Maybe<ErpDocumentFormat>;
  /** ERP Product of the client */
  erpProduct?: Maybe<ErpProductModel>;
  /** Error Notification Formatter for the client */
  errorFormatter?: Maybe<NotificationFormatterModel>;
  /** External id of the client */
  externalId?: Maybe<Scalars['String']>;
  /** Id of the client */
  id: Scalars['UUID'];
  /** Internal code of the client */
  internalClientCode: Scalars['String'];
  /** ISA qualifier code of the client */
  isaQualifierCode: Scalars['String'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** User name that has last modified the record. */
  lastModifiedByName?: Maybe<Scalars['String']>;
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Locale code of the client */
  localeCode?: Maybe<Scalars['String']>;
  /** Notification Mode for Missing Acknowledgments for transactions of the client */
  missingAcknowledgementNotificationMode?: Maybe<MissingAcknowledgementNotificationMode>;
  /** Name of the client */
  name: Scalars['String'];
  /** Note info of the client */
  notes?: Maybe<Array<Maybe<NoteModel>>>;
  /** Notification Formatter for the client */
  notificationFormatter?: Maybe<NotificationFormatterModel>;
  /** Phone info of the client */
  phones?: Maybe<Array<Maybe<PhoneModel>>>;
  primaryClientId?: Maybe<Scalars['String']>;
  /** Production date of the client */
  productionDate?: Maybe<Scalars['DateTime']>;
  /** SalesForce country code for the client */
  salesForceCountryCode?: Maybe<Scalars['String']>;
  /** SalesForce customer number for the client */
  salesForceCustomerNumber?: Maybe<Scalars['String']>;
  /** SalesForce entity code for the client */
  salesForceEntityCode?: Maybe<Scalars['String']>;
  /** Status of the client */
  statusCode?: Maybe<ClientStatus>;
  /** Tenant id of the client */
  tenantId: Scalars['UUID'];
  /** Number of partners for the client */
  totalPartners?: Maybe<Scalars['Int']>;
  /** Number of transactions for the client */
  totalTransactions?: Maybe<Scalars['Int']>;
  /** Website of the client */
  website?: Maybe<Scalars['String']>;
};

export type ClientNotificationRecipientsModel = {
  __typename?: 'ClientNotificationRecipientsModel';
  /** Client Id of the ClientNotificationRecipients */
  clientId: Scalars['UUID'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the ClientNotificationRecipients */
  description?: Maybe<Scalars['String']>;
  /** Id of the ClientNotificationRecipients */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** NotificationType of the ClientNotificationRecipients */
  notificationType: NotificationType;
  /** Flag to indicate if recipient receives errors of the ClientNotificationRecipients */
  receivesErrors?: Maybe<Scalars['Boolean']>;
  /** Flag to indicate if recipient receives notifications of the ClientNotificationRecipients */
  receivesNotifications?: Maybe<Scalars['Boolean']>;
  /** Recipients of the ClientNotificationRecipients */
  recipients: Scalars['String'];
};

export type ClientOrderByInput = {
  clientCode?: InputMaybe<OrderDirection>;
  lastModifiedTime?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type ClientPartnerModel = {
  __typename?: 'ClientPartnerModel';
  /** Attachments of the Client-Partner. */
  attachments?: Maybe<Array<Maybe<AttachmentModel>>>;
  /** Client in Client-Partner. */
  client: ClientModel;
  clientId: Scalars['String'];
  /** Client-Partner-Transactions of the Client-Partner. */
  clientPartnerTransactions?: Maybe<Array<Maybe<ClientPartnerTransactionModel>>>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Default currency for the client */
  defaultCurrencyCode?: Maybe<Scalars['String']>;
  /** File Generation Number configuration of the Client-Partner. */
  fileGenerationNumber?: Maybe<FileGenerationNumberModel>;
  /** Id of the Client-Partner. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Partner in Client-Partner. */
  partner: PartnerModel;
  partnerId: Scalars['String'];
  /** Partner-Transactions of the Client-Partner. */
  partnerTransactions?: Maybe<Array<Maybe<PartnerTransactionModel>>>;
  /** Production Date of the Client-Partner. */
  productionDate?: Maybe<Scalars['DateTime']>;
  /** Number of transactions for the trading partner */
  totalTransactions?: Maybe<Scalars['Int']>;
};

export type ClientPartnerTransactionAliasModel = {
  __typename?: 'ClientPartnerTransactionAliasModel';
  /** Alias of the ClientPartnerTransaction */
  alias: Scalars['String'];
  /** Id of the ClientPartnerTransaction */
  clientPartnerTransactionId: Scalars['UUID'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Id of the ClientPartnerTransactionAlias */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
};

export type ClientPartnerTransactionMapModel = {
  __typename?: 'ClientPartnerTransactionMapModel';
  /** Client Partner Transaction of the Client Partner Transaction Map */
  clientPartnerTransaction?: Maybe<ClientPartnerTransactionModel>;
  /** Client Partner Transaction id of the Client Partner Transaction Map. */
  clientPartnerTransactionId: Scalars['UUID'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Id of the Client Partner Transaction Map. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Transaction map of the Client Partner Transaction Map */
  transactionMap?: Maybe<TransactionMapModel>;
  /** Transaction Map id of the Client Partner Transaction Map. */
  transactionMapId?: Maybe<Scalars['UUID']>;
};

export type ClientPartnerTransactionModel = {
  __typename?: 'ClientPartnerTransactionModel';
  /** Client-Partner in Client-Partner-Transaction. */
  clientPartner?: Maybe<ClientPartnerModel>;
  /** Client Partner Id of the Client-Partner-Transaction. */
  clientPartnerId: Scalars['UUID'];
  /** Transaction Aliases for client partner transaction. */
  clientPartnerTransactionAliases?: Maybe<Array<Maybe<ClientPartnerTransactionAliasModel>>>;
  /** Client Partner Transaction Map in Client-Partner-Transaction. */
  clientPartnerTransactionMaps?: Maybe<Array<Maybe<ClientPartnerTransactionMapModel>>>;
  /** Post Processes in client partner transaction. */
  clientPartnerTransactionPostProcessings?: Maybe<Array<Maybe<ClientPartnerTransactionPostProcessingModel>>>;
  /** Transaction schema in client partner transaction. */
  clientPartnerTransactionSchemas?: Maybe<Array<Maybe<ClientPartnerTransactionSchemaModel>>>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Destination Path of the  Client-Partner-Transaction. */
  destinationPath?: Maybe<Scalars['String']>;
  /** Effective Partner Interchange Id for the  Client-Partner-Transaction. */
  effectivePartnerInterchangeId?: Maybe<Scalars['String']>;
  /** Functional Reconciliation Mode for the Client-Partner-Transaction */
  functionalReconciliationMode: FunctionalReconciliationMode;
  /** Identifies if a Transaction Map exists. */
  hasMap: Scalars['Boolean'];
  /** Id of the Client-Partner-Transaction. */
  id: Scalars['UUID'];
  /** Indicates active status for Client-Partner-Transaction. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Indicates if pipeline is interited for Client-Partner-Transaction. */
  isPipelineInherited?: Maybe<Scalars['Boolean']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Outbound Acknowledgement Option for the Client-Partner-Transaction */
  outboundAcknowledgementOption?: Maybe<OutboundAcknowledgementType>;
  /** Partner-Transaction in Client-Partner-Transaction. */
  partnerTransaction?: Maybe<PartnerTransactionModel>;
  /** Partner Transaction Id of the Client-Partner-Transaction. */
  partnerTransactionId: Scalars['UUID'];
  /** Pipeline in Client-Partner-Transaction. */
  pipeline?: Maybe<PipelineModel>;
  /** Pipeline Id of the Client-Partner-Transaction. */
  pipelineId?: Maybe<Scalars['UUID']>;
  /** Indicates wether should create/not create target document for Client-Partner-Transaction or inherit underlying transaction behavior. */
  skipTargetDocumentCreation?: Maybe<Scalars['Boolean']>;
};

export type ClientPartnerTransactionPostProcessingModel = {
  __typename?: 'ClientPartnerTransactionPostProcessingModel';
  /** Client Partner Transaction Id of the Client Partner Post Processing. */
  clientPartnerTransactionId: Scalars['UUID'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Edi Process Name of the Client Partner Post Processing. */
  ediProcessName?: Maybe<ProcessName>;
  /** Id of the Client Partner Transaction Post Processing. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Post ProcessingBlob of the Client Partner Post Processing. */
  postProcessingBlob?: Maybe<PostProcessingBlobModel>;
  /** Post Processing Blob Id of the Client Partner Post Processing. */
  postProcessingBlobId: Scalars['UUID'];
  /** Arguments of the Client Partner Post Processing. */
  processArguments: Scalars['String'];
  /** Process Name of the Client Partner Post Processing. */
  processName: Scalars['String'];
  /** Sort Order of the Client Partner Post Processing. */
  sortOrder: Scalars['Int'];
};

export type ClientPartnerTransactionSchemaModel = {
  __typename?: 'ClientPartnerTransactionSchemaModel';
  /** Client Partner Transaction Id of the Client Partner Transaction Schema. */
  clientPartnerTransactionId: Scalars['UUID'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Id of the Client Partner Transaction Schema. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Partner Transaction Schema for Client Partner Transaction Schema. */
  partnerTransactionSchema?: Maybe<PartnerTransactionSchemaModel>;
  /** Partner Transaction Schema Id of the Client Partner Transaction Schema. */
  partnerTransactionSchemaId: Scalars['UUID'];
};

export type ClientPortalUserModel = {
  __typename?: 'ClientPortalUserModel';
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Customer Role of the portal user */
  customerRole: UserRole;
  /** Email address of the portal user */
  email: Scalars['String'];
  /** First name of the portal user */
  firstName: Scalars['String'];
  /** Id of the portal user */
  id: Scalars['UUID'];
  /** Last name of the portal user */
  lastName: Scalars['String'];
  /** Subscription Role of the portal user */
  subscriptionRole: UserRole;
  /** TenantId of the client for the portal user */
  tenantId: Scalars['UUID'];
};

export enum ClientStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Inprocess = 'INPROCESS',
  Onboarding = 'ONBOARDING',
  Suspended = 'SUSPENDED'
}

export type ClientTransactionModel = {
  __typename?: 'ClientTransactionModel';
  /** Indicates Bulk Notify for the client transaction. */
  bulkNotify?: Maybe<Scalars['Boolean']>;
  /** Transaction Map in client transaction. */
  client?: Maybe<ClientModel>;
  /** Client Id of the client transaction. */
  clientId: Scalars['UUID'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Transaction schema in client transaction. */
  erpTransactionSchema?: Maybe<ErpTransactionSchemaModel>;
  /** Erp Transaction Schema Id of the client transaction. */
  erpTransactionSchemaId: Scalars['UUID'];
  /** File Name Pattern of the client transaction */
  fileNamePattern?: Maybe<Scalars['String']>;
  /** Id of the client transaction. */
  id: Scalars['UUID'];
  /** Indicates active status for client transaction. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Notification Formatter in client transaction. */
  notificationFormatter?: Maybe<NotificationFormatterModel>;
  /** Notification Formatter Id of the client transaction. */
  notificationFormatterId?: Maybe<Scalars['UUID']>;
  /** Indicates Notify for the client transaction. */
  notify?: Maybe<Scalars['Boolean']>;
  /** Pipeline in client transaction. */
  pipeline?: Maybe<PipelineModel>;
  /** Pipeline Id of the client transaction. */
  pipelineId?: Maybe<Scalars['UUID']>;
  /** Transaction in client transaction. */
  transaction?: Maybe<TransactionModel>;
  /** Transaction Id of the client transaction. */
  transactionId: Scalars['UUID'];
};

export type ClonePipelineInput = {
  pipelineId: Scalars['String'];
};

export type ClonePipelinePayload = {
  __typename?: 'ClonePipelinePayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  pipeline?: Maybe<PipelineModel>;
  result: RequestResult;
};

export type ClonePricingInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  minServiceFees?: InputMaybe<Scalars['Decimal']>;
};

export type ClonePricingPayload = {
  __typename?: 'ClonePricingPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  pricing?: Maybe<PricingModel>;
  result: RequestResult;
};

export type ConfigurationModel = {
  __typename?: 'ConfigurationModel';
  /** Channel Id of the Configuration. */
  channelId?: Maybe<Scalars['Int']>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Configuration */
  description?: Maybe<Scalars['String']>;
  /** Dest Path of the Configuration */
  destPath: Scalars['String'];
  /** Edi Process of the Configuration */
  ediProcess: Scalars['String'];
  /** Execution Mode of the Configuration */
  executionMode: Scalars['String'];
  /** Extension of the Configuration */
  extension: Scalars['String'];
  /** Home Directory of the Configuration */
  homeDirectory?: Maybe<Scalars['String']>;
  /** Id of the Configuration. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** P1 of the Configuration */
  p1?: Maybe<Scalars['String']>;
  /** P2 of the Configuration */
  p2?: Maybe<Scalars['String']>;
  /** P3 of the Configuration */
  p3?: Maybe<Scalars['String']>;
  /** P4 of the Configuration */
  p4?: Maybe<Scalars['String']>;
  /** P5 of the Configuration */
  p5?: Maybe<Scalars['String']>;
  /** P6 of the Configuration */
  p6?: Maybe<Scalars['String']>;
  /** Pid of the Configuration */
  pid?: Maybe<Scalars['Int']>;
  /** Tpg Client of the Configuration */
  tpgClient: Scalars['String'];
  /** Watcher Path of the Configuration */
  watcherPath: Scalars['String'];
};

export type CounterModel = {
  __typename?: 'CounterModel';
  /** Comments of the Counter. */
  comments?: Maybe<Scalars['String']>;
  /** Control Number of the Counter. */
  controlNumber?: Maybe<Scalars['String']>;
  /** Id of the Counter. */
  id: Scalars['UUID'];
  /** Machine of the Counter. */
  machine?: Maybe<Scalars['String']>;
  /** Segment of the Counter. */
  segment: CounterSegmentType;
  /** Sender ID of the Counter. */
  senderId: Scalars['String'];
};

export type CounterOrderByInput = {
  controlNumber?: InputMaybe<OrderDirection>;
  machine?: InputMaybe<OrderDirection>;
  segment?: InputMaybe<OrderDirection>;
  senderId?: InputMaybe<OrderDirection>;
};

export enum CounterSegmentType {
  Ffo = 'FFO',
  Gs = 'GS',
  Idi = 'IDI',
  Isa = 'ISA',
  Mbx = 'MBX',
  St = 'ST'
}

export type CountryModel = {
  __typename?: 'CountryModel';
  /** Country Code of the Country */
  countryCode: Scalars['String'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Country */
  description?: Maybe<Scalars['String']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** States of the Country. */
  states?: Maybe<Array<Maybe<StateModel>>>;
};


export type CountryModelStatesArgs = {
  description: Scalars['String'];
  limit: Scalars['Int'];
};

export type CrossReferenceModel = {
  __typename?: 'CrossReferenceModel';
  /** Code of the Document Archive. */
  code?: Maybe<Scalars['String']>;
  /** Description of the Document Archive. */
  description?: Maybe<Scalars['String']>;
  /** Id of the Cross Reference. */
  id: Scalars['UUID'];
  /** Val of the Document Archive. */
  val?: Maybe<Scalars['String']>;
  /** Version of the Document Archive. */
  version?: Maybe<Scalars['String']>;
};

export type CrossReferenceOrderByInput = {
  code?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  val?: InputMaybe<OrderDirection>;
  version?: InputMaybe<OrderDirection>;
};

export type CurrencyModel = {
  __typename?: 'CurrencyModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Currency Code of the Currency */
  currencyCode: Scalars['String'];
  /** Description of the Currency */
  description: Scalars['String'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
};

export type DashboardModel = {
  __typename?: 'DashboardModel';
  /** Number of Active Clients without Billing to display on the dashboard */
  clientsBillingNotSetCount: Scalars['Int'];
  /** Number of Clients to display on the dashboard that have notifications turned on, but don't have any notification recipients set up */
  clientsNotificationsNoRecipientsCount: Scalars['Int'];
  /** Number of Errors to display on the dashboard */
  errorsCount: Scalars['Int'];
  /** Number of Mapping Errors to display on the dashboard */
  mappingErrorsCount: Scalars['Int'];
  /** Number of Transactions to display on the dashboard that don't have a notification sent */
  notificationNotSentTransactionsCount: Scalars['Int'];
  /** Number of Onboarding Clients to display on the dashboard */
  onboardingClientsCount: Scalars['Int'];
  /** Number of Rejected Transactions to display on the dashboard */
  rejectedTransactionsCount: Scalars['Int'];
  /** Number of Unacknowledged Transactions to display on the dashboard */
  unacknowledgedTransactionsCount: Scalars['Int'];
};

export type DataLakeDirectoryCreateRequestInput = {
  directoryName?: InputMaybe<Scalars['String']>;
  parentDirectoryPath?: InputMaybe<Scalars['String']>;
};

export type DataLakeDirectoryDeleteRequestInput = {
  directoryFullPath?: InputMaybe<Scalars['String']>;
};

export type DataLakeDirectoryListPayload = {
  __typename?: 'DataLakeDirectoryListPayload';
  directoryHierarchyJson?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

/** Represents a directory structure in a Data Lake storage system. */
export type DataLakeDirectoryModel = {
  __typename?: 'DataLakeDirectoryModel';
  /** List of child directories contained in this directory */
  childDirectories?: Maybe<Array<Maybe<DataLakeDirectoryModel>>>;
  /** Time when the file was created */
  createdTime: Scalars['DateTime'];
  /** List of files contained in this directory */
  dataLakeFileModels?: Maybe<Array<Maybe<DataLakeFileModel>>>;
  /** Indicates whether this directory can be deleted */
  isDeleteDisabled: Scalars['Boolean'];
  /** Indicates whether this directory is a root directory */
  isRoot: Scalars['Boolean'];
  /** Time when the file was last modified */
  lastModifiedTime: Scalars['DateTime'];
  /** Name of the directory */
  name: Scalars['String'];
  /** Full path of the directory within the Data Lake */
  path: Scalars['String'];
};

/** Request object for deleting a file from the Data Lake. */
export type DataLakeFileDeleteRequestInput = {
  /** The full paths and names of the files to delete. */
  fileNamesWithFullPaths: Array<InputMaybe<Scalars['String']>>;
};

/** Request object for downloading a blob. */
export type DataLakeFileDownloadRequestInput = {
  /** Returned format Blob Document Format. */
  blobDocumentFormat: BlobDocumentFormat;
  /** Blob File Name. */
  fileNameWithFullPath: Scalars['String'];
};

/** Blob Download Response. */
export type DataLakeFileDownloadResponse = {
  __typename?: 'DataLakeFileDownloadResponse';
  /** List of Errors during download attempt */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Content of the Data Lake file */
  fileContent: Scalars['String'];
  /** Name of the Data Lake file */
  fileName: Scalars['String'];
};

/** Represents a file stored in a Data Lake storage system. */
export type DataLakeFileModel = {
  __typename?: 'DataLakeFileModel';
  /** Content of the file */
  content?: Maybe<Scalars['String']>;
  /** Time when the file was created */
  createdTime: Scalars['DateTime'];
  /** Formatted size of the file with unit of storage. */
  fileSize: Scalars['String'];
  /** File size bytes. */
  fileSizeBytes: Scalars['Long'];
  /** Time when the file was last modified */
  lastModifiedTime: Scalars['DateTime'];
  /** Name of the file */
  name: Scalars['String'];
  /** Full path of the file within the Data Lake */
  path: Scalars['String'];
};

/** Represents a file system container in a Data Lake storage system. */
export type DataLakeFileSystemModel = {
  __typename?: 'DataLakeFileSystemModel';
  /** Name of the container in the Data Lake */
  containerName: Scalars['String'];
  /** List of root directories in the Data Lake file system container */
  rootDataLakeDirectories?: Maybe<Array<Maybe<DataLakeDirectoryModel>>>;
};

/** Represents the request to upload a blob. */
export type DataLakeFileUploadRequestInput = {
  /** Gets or sets the blob document format. */
  blobDocumentFormat: BlobDocumentFormat;
  /** Gets or sets the file content. */
  fileContent: Scalars['String'];
  /** Gets or sets the full path with file name and extension. */
  fileNameWithFullPath: Scalars['String'];
};

/** Blob Upload Response. */
export type DataLakeFileUploadResponse = {
  __typename?: 'DataLakeFileUploadResponse';
  /** List of Errors during upload attempt of the Data Lake file */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Name of the Data Lake file with its blob storage compatible path */
  fileNameWithFullPath: Scalars['String'];
};

/** Represents a request to move a file within a data lake, specifying the file name and the target directory path. */
export type DataLakeMoveFileRequestInput = {
  /** Gets or sets the new directory path for file. */
  destinationDirectoryFullPath: Scalars['String'];
  /** Gets or sets the file names with full paths. */
  fileNamesWithFullPaths: Array<InputMaybe<Scalars['String']>>;
};

/** Represents a request to reprocess a failed file in the data lake. */
export type DataLakeReprocessFailedFileRequestInput = {
  /** Gets or sets the file names with full paths. */
  fileNamesWithFullPaths: Array<InputMaybe<Scalars['String']>>;
};

export type DeleteBusinessAreaInput = {
  id: Scalars['String'];
};

export type DeleteBusinessAreaPayload = {
  __typename?: 'DeleteBusinessAreaPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  id?: Maybe<Scalars['UUID']>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type DeleteByIdInput = {
  /** Name of entity to be deleted. */
  entityName: Scalars['String'];
  /** Id of entity to be deleted. */
  id: Scalars['String'];
};

export type DeleteByIdPayload = {
  __typename?: 'DeleteByIdPayload';
  entityName?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type DeleteClientAkaInput = {
  id: Scalars['String'];
};

export type DeleteClientAkaPayload = {
  __typename?: 'DeleteClientAKAPayload';
  clientAKAId?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type DeleteClientContactInput = {
  id: Scalars['String'];
};

export type DeleteClientContactPayload = {
  __typename?: 'DeleteClientContactPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  id?: Maybe<Scalars['UUID']>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type DeleteClientNotificationRecipientsInput = {
  id: Scalars['String'];
};

export type DeleteClientNotificationRecipientsPayload = {
  __typename?: 'DeleteClientNotificationRecipientsPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  id?: Maybe<Scalars['UUID']>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type DeleteClientPartnerTransactionMapInput = {
  id: Scalars['String'];
};

export type DeleteClientPartnerTransactionMapPayload = {
  __typename?: 'DeleteClientPartnerTransactionMapPayload';
  clientPartnerTransactionMapId?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type DeleteClientPartnerTransactionSchemaInput = {
  id: Scalars['String'];
};

export type DeleteClientPartnerTransactionSchemaPayload = {
  __typename?: 'DeleteClientPartnerTransactionSchemaPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionSchemaId?: Maybe<Scalars['UUID']>;
};

export type DeleteClientPortalUserInput = {
  portalUserId: Scalars['String'];
  tenantId: Scalars['String'];
};

export type DeleteClientPortalUserPayload = {
  __typename?: 'DeleteClientPortalUserPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  portalUserId: Scalars['String'];
  result: RequestResult;
  tenantId?: Maybe<Scalars['UUID']>;
};

export type DeleteCurrencyInput = {
  currencyCode?: InputMaybe<Scalars['String']>;
};

export type DeleteCurrencyPayload = {
  __typename?: 'DeleteCurrencyPayload';
  currencyCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type DeleteErpProductInput = {
  id: Scalars['String'];
};

export type DeleteErpProductPayload = {
  __typename?: 'DeleteErpProductPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  id?: Maybe<Scalars['UUID']>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type DeleteErpTransactionSchemaInput = {
  id: Scalars['String'];
};

export type DeleteErpTransactionSchemaPayload = {
  __typename?: 'DeleteErpTransactionSchemaPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionSchemaId?: Maybe<Scalars['UUID']>;
};

export type DeleteMultipleByIdsInput = {
  entityName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DeleteMultipleByIdsPayload = {
  __typename?: 'DeleteMultipleByIdsPayload';
  entityName?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type DeletePartnerContactInput = {
  id: Scalars['String'];
};

export type DeletePartnerContactPayload = {
  __typename?: 'DeletePartnerContactPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  id?: Maybe<Scalars['UUID']>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type DeletePartnerInput = {
  id: Scalars['String'];
};

export type DeletePartnerPayload = {
  __typename?: 'DeletePartnerPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  id?: Maybe<Scalars['UUID']>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type DeletePartnerTransactionSchemaInput = {
  id: Scalars['String'];
};

export type DeletePartnerTransactionSchemaPayload = {
  __typename?: 'DeletePartnerTransactionSchemaPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionSchemaId?: Maybe<Scalars['UUID']>;
};

export type DeleteTransactionInput = {
  id: Scalars['String'];
};

export type DeleteTransactionMapInput = {
  id: Scalars['String'];
};

export type DeleteTransactionMapPartnerInput = {
  id: Scalars['String'];
};

export type DeleteTransactionMapPartnerPayload = {
  __typename?: 'DeleteTransactionMapPartnerPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionMapPartnerId?: Maybe<Scalars['UUID']>;
};

export type DeleteTransactionMapPayload = {
  __typename?: 'DeleteTransactionMapPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionMapId?: Maybe<Scalars['UUID']>;
};

export type DeleteTransactionPayload = {
  __typename?: 'DeleteTransactionPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  id?: Maybe<Scalars['UUID']>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type DeleteUserInput = {
  id: Scalars['String'];
};

export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  userId?: Maybe<Scalars['UUID']>;
};

export enum DocumentAcknowledgementStatus {
  Accepted = 'ACCEPTED',
  NotApplicable = 'NOT_APPLICABLE',
  PartialRejected = 'PARTIAL_REJECTED',
  Rejected = 'REJECTED',
  Unacknowledged = 'UNACKNOWLEDGED'
}

export type DocumentArchiveModel = {
  __typename?: 'DocumentArchiveModel';
  /** Acknowledgement Request Count of the Document of the Document Archive. */
  acknowledgementRequestCount?: Maybe<Scalars['Int']>;
  /** Acknowledgement Request Time of the Document of the Document Archive. */
  acknowledgementRequestTime?: Maybe<Scalars['DateTime']>;
  /** Acknowledgement Status of the Document of the Document Archive. */
  acknowledgementStatus?: Maybe<DocumentAcknowledgementStatus>;
  /** Bulk Notify indicator of the the Document Archive. */
  bulkNotify?: Maybe<Scalars['Boolean']>;
  /** Client of the Document Archive. */
  client?: Maybe<ClientModel>;
  /** Control number of the Document Archive. */
  controlNumber?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Currency Code of the Document Archive. */
  currencyCode?: Maybe<Scalars['String']>;
  /** Direction of the Transaction of the Document Archive. */
  direction?: Maybe<Scalars['String']>;
  /** Document date of the Document Archive. */
  documentDate?: Maybe<Scalars['DateTime']>;
  documentId?: Maybe<Scalars['String']>;
  /** Document number of the Document Archive. */
  documentNumber?: Maybe<Scalars['String']>;
  /** Document reference id of the Document Archive. */
  documentReferenceId?: Maybe<Scalars['String']>;
  /** Document transaction id of the Document Archive. */
  documentTransactionId?: Maybe<Scalars['String']>;
  /** Document type of the Document Archive. */
  documentType?: Maybe<Scalars['String']>;
  /** EDI Document of the Document Archive. */
  ediDocument?: Maybe<Scalars['String']>;
  /** EDI Document Resent Count of the Document of the Document Archive. */
  ediDocumentResentCount?: Maybe<Scalars['Int']>;
  /** EDI Document Resent Time of the Document of the Document Archive. */
  ediDocumentResentTime?: Maybe<Scalars['DateTime']>;
  /** EDI XML of the Document Archive. */
  ediXml?: Maybe<Scalars['String']>;
  /** Erp provided order number of the Document Archive. */
  erpOrderNumber?: Maybe<Scalars['String']>;
  /** ERP XML of the Document Archive. */
  erpXml?: Maybe<Scalars['String']>;
  /** File name of the Document Archive. */
  fileName?: Maybe<Scalars['String']>;
  /** Functional Group Control number of the Document Archive. */
  functionalGroupControlNumber?: Maybe<Scalars['String']>;
  /** Id of the Document Archive. */
  id: Scalars['UUID'];
  /** Internal client code of the Document Archive. */
  internalClientCode?: Maybe<Scalars['String']>;
  /** Internal partner of the Document Archive. */
  internalPartnerCode?: Maybe<Scalars['String']>;
  /** Internal Transaction Id of the Document Archive. */
  internalTransactionId?: Maybe<Scalars['String']>;
  /** Invoice number of the Document Archive. */
  invoice?: Maybe<Scalars['String']>;
  /** Indicator for if the Document Archive is abandoned */
  isAbandoned: Scalars['Boolean'];
  /** Note info of the Document Archive. */
  notes?: Maybe<Array<Maybe<NoteModel>>>;
  /** Notified Date of the the Document Archive. */
  notifiedTime?: Maybe<Scalars['DateTime']>;
  /** Original File name of the Document Archive. */
  originalFileName?: Maybe<Scalars['String']>;
  /** Partner of the Document Archive. */
  partner?: Maybe<PartnerModel>;
  /** Purchase Order number of the Document Archive. */
  purchaseOrder?: Maybe<Scalars['String']>;
  /** Receiver id of the Document Archive. */
  receiverId?: Maybe<Scalars['String']>;
  /** Sender id of the Document Archive. */
  senderId?: Maybe<Scalars['String']>;
  /** Total lines of the Document Archive. */
  totalLines?: Maybe<Scalars['Int']>;
  /** Total quantity of the Document Archive. */
  totalQuantity?: Maybe<Scalars['Decimal']>;
  /** Total value of the Document Archive. */
  totalValue?: Maybe<Scalars['Decimal']>;
  /** Transaction Control number of the Document Archive. */
  transactionControlNumber?: Maybe<Scalars['String']>;
  wasNotificationSent?: Maybe<Scalars['Boolean']>;
};

export type DocumentArchiveOrderByInput = {
  bulkNotify?: InputMaybe<OrderDirection>;
  clientName?: InputMaybe<OrderDirection>;
  createdTime?: InputMaybe<OrderDirection>;
  direction?: InputMaybe<OrderDirection>;
  documentType?: InputMaybe<OrderDirection>;
  functionalGroupControlNumber?: InputMaybe<OrderDirection>;
  isAbandoned?: InputMaybe<OrderDirection>;
  notifiedTime?: InputMaybe<OrderDirection>;
  partnerName?: InputMaybe<OrderDirection>;
  purchaseOrderNumber?: InputMaybe<OrderDirection>;
};

export enum DocumentStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Adapting = 'ADAPTING',
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Mapping = 'MAPPING',
  Received = 'RECEIVED',
  Rejected = 'REJECTED',
  ResolvedError = 'RESOLVED_ERROR',
  Sent = 'SENT',
  Splitting = 'SPLITTING',
  Translating = 'TRANSLATING'
}

export enum ErpDocumentFormat {
  Csv = 'CSV',
  FixedLength = 'FIXED_LENGTH',
  TabDelimited = 'TAB_DELIMITED'
}

export type EdiActionServiceInput = {
  actionArguments?: InputMaybe<Scalars['String']>;
  actionName?: InputMaybe<Scalars['String']>;
  arguments?: InputMaybe<Scalars['String']>;
};

export type EdiStandardModel = {
  __typename?: 'EdiStandardModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the edi standard */
  description: Scalars['String'];
  /** Id of the standard */
  id?: Maybe<Scalars['UUID']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Name of the standard */
  name: Scalars['String'];
  partners?: Maybe<Array<Maybe<PartnerModel>>>;
};

export type EdiXmlConfigModel = {
  __typename?: 'EdiXmlConfigModel';
  /** Name of the EDI XML Config */
  clientId: Scalars['UUID'];
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** User name that has created the record */
  createdByName?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the EDI XML Config */
  description?: Maybe<Scalars['String']>;
  /** String representation of the EDI XML Config Document Blob */
  documentString?: Maybe<Scalars['String']>;
  /** File name of the EDI XML Config */
  fileName: Scalars['String'];
  /** Id of the EDI XML Config */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** User name that has last modified the record */
  lastModifiedByName?: Maybe<Scalars['String']>;
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
};

export type EmailModel = {
  __typename?: 'EmailModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Email. */
  description?: Maybe<Scalars['String']>;
  /** Email of the Email. */
  email: Scalars['String'];
  /** Id of the Email */
  id: Scalars['UUID'];
  /** Whether the email is primary. */
  isPrimary?: Maybe<Scalars['Boolean']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Parent Id of the Email */
  parentId: Scalars['UUID'];
};

export enum EntityState {
  Added = 'ADDED',
  Deleted = 'DELETED',
  Detached = 'DETACHED',
  Modified = 'MODIFIED',
  Unchanged = 'UNCHANGED'
}

export enum EntityType {
  Client = 'CLIENT',
  Partner = 'PARTNER',
  Unknown = 'UNKNOWN'
}

export type ErpProductModel = {
  __typename?: 'ErpProductModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the erp product */
  description: Scalars['String'];
  /** Id of the product */
  id: Scalars['UUID'];
  /** Is an Aptean product */
  isAptean?: Maybe<Scalars['Boolean']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Name of the product */
  name: Scalars['String'];
};

export type ErpTransactionSchemaModel = {
  __typename?: 'ErpTransactionSchemaModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Erp Transaction Schema. */
  description: Scalars['String'];
  /** Document String of the Erp Transaction Schema. */
  documentString?: Maybe<Scalars['String']>;
  /** Id of the Erp Transaction Schema. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Source File Name of the Erp Transaction Schema. */
  sourceFileName?: Maybe<Scalars['String']>;
  /** Transaction Id of the Erp Transaction Schema. */
  transactionId: Scalars['UUID'];
};

export type ErrorModel = {
  __typename?: 'ErrorModel';
  code?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  innerError?: Maybe<ErrorModel>;
  message?: Maybe<Scalars['String']>;
  /** message plus stack trace */
  rawMessage?: Maybe<Scalars['String']>;
};

export enum ExceptionStatus {
  Error = 'ERROR',
  ResolvedError = 'RESOLVED_ERROR',
  Unknown = 'UNKNOWN'
}

export enum FlgnResetMethod {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export type FavoriteModel = {
  __typename?: 'FavoriteModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Id of the entity this favorite item points to */
  entityId: Scalars['UUID'];
  /** The type of entity this favorite item represents */
  entityType: EntityType;
  /** Id of this favorite. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** The display name of the entity this favorite item points to */
  name: Scalars['String'];
};

/** Configuration for file generation number related to Client-Partner. */
export type FileGenerationNumberModel = {
  __typename?: 'FileGenerationNumberModel';
  /** Associated Client-Partner ID. */
  clientPartnerId: Scalars['UUID'];
  /** User who created this record. */
  createdBy: Scalars['UUID'];
  /** Timestamp when this record was created. */
  createdTime: Scalars['DateTime'];
  /** Current file generation number. */
  currentFileGenerationNumber: Scalars['Int'];
  /** Unique identifier of the File Generation Number. */
  id: Scalars['UUID'];
  /** User who last modified this record. */
  lastModifiedBy: Scalars['UUID'];
  /** Timestamp of last modification. */
  lastModifiedTime: Scalars['DateTime'];
  /** Last date the generation number was reset. */
  lastResetDate?: Maybe<Scalars['DateTime']>;
  /** Maximum allowed file generation number. */
  maxFileGenerationNumber: Scalars['Int'];
  /** Reset method (Manual or Automatic). */
  resetMethod?: Maybe<FlgnResetMethod>;
};

export enum FunctionalReconciliationMode {
  Acknowledgement = 'ACKNOWLEDGEMENT',
  Manual = 'MANUAL',
  Na = 'NA'
}

export type GetAttachmentInput = {
  attachmentIds?: InputMaybe<Array<Scalars['String']>>;
  attachmentType: AttachmentType;
  parentId?: InputMaybe<Scalars['String']>;
};

export type GetAuditRecordsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  entityId?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  entityState?: InputMaybe<EntityState>;
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AuditRecordOrderByInput>>;
  userName?: InputMaybe<Scalars['String']>;
};

export type GetBillingAggregatesInput = {
  billingId?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalClientCode?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type GetBillingItemsInput = {
  billingId?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pricingId?: InputMaybe<Scalars['String']>;
};

export type GetBillingsInput = {
  currencyCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type GetBusinessAreaInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<BusinessAreaOrderByInput>>;
};

export type GetClientAkaInput = {
  clientCode?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isaQualifierCode?: InputMaybe<Scalars['String']>;
};

export type GetClientNotificationRecipientsInput = {
  clientId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  notificationType?: InputMaybe<NotificationType>;
  receivesErrors?: InputMaybe<Scalars['Boolean']>;
  receivesNotifications?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Scalars['String']>;
};

export type GetClientPartnerTransactionAliasInput = {
  alias?: InputMaybe<Scalars['String']>;
  clientPartnerTransactionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type GetClientPartnerTransactionMapInput = {
  clientPartnerTransactionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  transactionMapId?: InputMaybe<Scalars['String']>;
};

export type GetClientPartnerTransactionPostProcessingInput = {
  clientPartnerTransactionId?: InputMaybe<Scalars['String']>;
  ediProcessName?: InputMaybe<ProcessName>;
  id?: InputMaybe<Scalars['String']>;
  postProcessingBlob?: InputMaybe<PostProcessingBlobModelInput>;
  postProcessingBlobId?: InputMaybe<Scalars['String']>;
};

export type GetClientPartnerTransactionSchemaInput = {
  clientPartnerTransactionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  partnerTransactionSchemaId?: InputMaybe<Scalars['String']>;
  partnerTransactionSchemaModel?: InputMaybe<PartnerTransactionSchemaModelInput>;
};

export type GetClientPartnerTransactionsInput = {
  clientId?: InputMaybe<Scalars['String']>;
  clientPartnerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPipelineInherited?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['String']>;
  partnerTransactionId?: InputMaybe<Scalars['String']>;
  pipelineId?: InputMaybe<Scalars['String']>;
};

export type GetClientPartnersInput = {
  clientId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
};

export type GetClientTransactionsInput = {
  bulkNotify?: InputMaybe<Scalars['Boolean']>;
  clientId?: InputMaybe<Scalars['String']>;
  erpTransactionSchemaId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  notify?: InputMaybe<Scalars['Boolean']>;
  pipelineId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type GetClientsInput = {
  addressFilter?: InputMaybe<AddressFilterInput>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessAreaIds?: InputMaybe<Array<Scalars['String']>>;
  clientCode?: InputMaybe<Scalars['String']>;
  erpProductIds?: InputMaybe<Array<Scalars['String']>>;
  hasBillingSet?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<ClientOrderByInput>>;
  statusCodes?: InputMaybe<Array<ClientStatus>>;
};

export type GetConfigurationsInput = {
  id?: InputMaybe<Scalars['String']>;
  pipelineId?: InputMaybe<Scalars['String']>;
  processDescription?: InputMaybe<Scalars['String']>;
  processName?: InputMaybe<Scalars['String']>;
};

export type GetCounterInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  controlNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  machine?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<CounterOrderByInput>>;
  segment?: InputMaybe<CounterSegmentType>;
  senderId?: InputMaybe<Scalars['String']>;
};

export type GetCrossReferenceInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CrossReferenceOrderByInput>>;
  val?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type GetDashboardCountsInput = {
  errorDateFrom?: InputMaybe<Scalars['DateTime']>;
  unacknowledgedDateTo?: InputMaybe<Scalars['DateTime']>;
};

export type GetDataLakeFileInput = {
  directoryPath?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  searchAllChildDirectories?: InputMaybe<Scalars['Boolean']>;
};

export type GetDocumentArchiveInput = {
  id: Scalars['String'];
};

export type GetDocumentArchivesInput = {
  acknowledgementStatuses?: InputMaybe<Array<DocumentAcknowledgementStatus>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  controlNumber?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  direction?: InputMaybe<Scalars['String']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  erpOrderNumber?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  functionalGroupControlNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isAbandoned?: InputMaybe<Scalars['Boolean']>;
  isNotificationRequired?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<DocumentArchiveOrderByInput>>;
  partnerId?: InputMaybe<Scalars['String']>;
  partnerName?: InputMaybe<Scalars['String']>;
  purchaseOrder?: InputMaybe<Scalars['String']>;
  transactionControlNumber?: InputMaybe<Scalars['String']>;
  wasNotificationSent?: InputMaybe<Scalars['Boolean']>;
};

export type GetErpTransactionSchemaInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sourceFileName?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type GetFavoriteInput = {
  entityType?: InputMaybe<EntityType>;
  id?: InputMaybe<Scalars['String']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type GetMessagingLogsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  createdTime?: InputMaybe<Scalars['DateTime']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  documentDate?: InputMaybe<Scalars['DateTime']>;
  documentId?: InputMaybe<Scalars['String']>;
  documentReferenceId?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalClientCode?: InputMaybe<Scalars['String']>;
  internalPartnerCode?: InputMaybe<Scalars['String']>;
  invoice?: InputMaybe<Scalars['String']>;
  isAcknowledged?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  machineName?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<MessageLogOrderByInput>>;
  originalFileName?: InputMaybe<Scalars['String']>;
  pO?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  partnerName?: InputMaybe<Scalars['String']>;
  processName?: InputMaybe<ProcessName>;
  rawMessage?: InputMaybe<Scalars['String']>;
  receiverId?: InputMaybe<Scalars['String']>;
  senderId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DocumentStatus>;
};

export type GetNotificationFormatterInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bodyType?: InputMaybe<NotificationFormatterBodyType>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isForError?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<NotificationFormatterOrderByInput>>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type GetNotificationFormatterTransactionsInput = {
  id?: InputMaybe<Scalars['String']>;
  notificationFormatterId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type GetPartnerAkaInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isaQualifierCode?: InputMaybe<Scalars['String']>;
  partnerCode?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
};

export type GetPartnerNotificationRecipientsInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  notificationType?: InputMaybe<NotificationType>;
  partnerId?: InputMaybe<Scalars['String']>;
  receivesErrors?: InputMaybe<Scalars['Boolean']>;
  receivesNotifications?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Scalars['String']>;
};

export type GetPartnerTransactionSchemaInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  partnerTransactionId?: InputMaybe<Scalars['String']>;
  sourceFileName?: InputMaybe<Scalars['String']>;
  standardVersion?: InputMaybe<Scalars['String']>;
};

export type GetPartnerTransactionsInput = {
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['String']>;
  pipelineId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type GetPartnersInput = {
  addressFilter?: InputMaybe<AddressFilterInput>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessAreaIds?: InputMaybe<Array<Scalars['String']>>;
  clientIds?: InputMaybe<Array<Scalars['String']>>;
  ediStandardIds?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<PartnerOrderByInput>>;
  partnerCode?: InputMaybe<Scalars['String']>;
  statusCodes?: InputMaybe<Array<PartnerStatus>>;
};

export type GetPhoneTypeInput = {
  phoneTypeCode?: InputMaybe<Scalars['String']>;
};

export type GetPipelinesInput = {
  id?: InputMaybe<Scalars['String']>;
  isLegacy?: InputMaybe<Scalars['Boolean']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type GetPortalTransactionsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  erpOrderNumber?: InputMaybe<Scalars['String']>;
  hasException?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isDocumentResent?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  normalizedDocumentType?: InputMaybe<NormalizedDocumentType>;
  order?: InputMaybe<Array<PortalTransactionOrderByInput>>;
  partnerId?: InputMaybe<Scalars['String']>;
  partnerName?: InputMaybe<Scalars['String']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']>;
};

export type GetPortalUsersInput = {
  id?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};

export type GetPostProcessingBlobInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PostProcessingBlobOrderByInput>>;
};

export type GetPricingsInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  minServiceFees?: InputMaybe<Scalars['Decimal']>;
};

export type GetRecentInput = {
  entityType?: InputMaybe<EntityType>;
  id?: InputMaybe<Scalars['String']>;
  lastEdited?: InputMaybe<Scalars['DateTime']>;
  lastViewed?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
};

export type GetStandardExchangeFormatInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  blobDocumentId?: InputMaybe<Scalars['String']>;
  blobStorageDateFrom?: InputMaybe<Scalars['DateTime']>;
  blobStorageDateTo?: InputMaybe<Scalars['DateTime']>;
  blobStorageFileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<StandardExchangeFormatOrderByInput>>;
};

export type GetStatesInput = {
  /** After cursor. */
  after?: InputMaybe<Scalars['String']>;
  /** Before cursor. */
  before?: InputMaybe<Scalars['String']>;
  /** Country Code filter for the state. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Description filter for the state. */
  description?: InputMaybe<Scalars['String']>;
  /** Id of the state */
  id?: InputMaybe<Scalars['UUID']>;
  /** Number of states to be resolved */
  limit?: InputMaybe<Scalars['Int']>;
  /** Order for resolving the states. */
  order?: InputMaybe<Array<StateOrderByInput>>;
  /** State Code filter for the state. */
  stateCode?: InputMaybe<Scalars['String']>;
};

export type GetTransactionErrorsInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  documentReferenceId?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  messageType?: InputMaybe<MessageType>;
  normalizedDocumentType?: InputMaybe<NormalizedDocumentType>;
  order?: InputMaybe<Array<TransactionErrorOrderByInput>>;
  originalFileName?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  partnerName?: InputMaybe<Scalars['String']>;
  processName?: InputMaybe<ProcessName>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ExceptionStatus>;
};

export type GetTransactionMapInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TransactionMapOrderByInput>>;
  standardVersion?: InputMaybe<Scalars['String']>;
  transactionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type GetTransactionMapPartnerInput = {
  id?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  transactionMapId?: InputMaybe<Scalars['String']>;
};

export type GetTransactionsInput = {
  description?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<TransactionDirection>;
  ediStandardIds?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isBillable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  normalizedDocumentType?: InputMaybe<NormalizedDocumentType>;
};

export type GetUserInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type GetUsersInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<UserOrderByInput>>;
  role?: InputMaybe<UserRole>;
};

export type IsaQualifierModel = {
  __typename?: 'IsaQualifierModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the ISAQualifier. */
  description?: Maybe<Scalars['String']>;
  /** Code of the ISAQualifier. */
  isaQualifierCode: Scalars['String'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
};

export type LocaleModel = {
  __typename?: 'LocaleModel';
  /** Description of the Locale. */
  description?: Maybe<Scalars['String']>;
  /** Code of the Locale. */
  localeCode: Scalars['String'];
};

export type MessageLogOrderByInput = {
  createdTime?: InputMaybe<OrderDirection>;
  documentId?: InputMaybe<OrderDirection>;
  documentReferenceId?: InputMaybe<OrderDirection>;
  documentType?: InputMaybe<OrderDirection>;
  internalClientCode?: InputMaybe<OrderDirection>;
  internalPartnerCode?: InputMaybe<OrderDirection>;
  purchaseOrderNumber?: InputMaybe<OrderDirection>;
};

export enum MessageType {
  CommunicationEventFileMonitorScan = 'COMMUNICATION_EVENT_FILE_MONITOR_SCAN',
  Custom = 'CUSTOM',
  DocumentProcessing = 'DOCUMENT_PROCESSING',
  Error = 'ERROR'
}

export type MessagingLogModel = {
  __typename?: 'MessagingLogModel';
  /** Client of the Messaging Log. */
  client?: Maybe<ClientModel>;
  /** Client-Partner of the Messaging Log. */
  clientPartner?: Maybe<ClientPartnerModel>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Messaging Log. */
  description?: Maybe<Scalars['String']>;
  /** Direction of the Messaging Log. */
  direction?: Maybe<Scalars['String']>;
  /** Document date of the Messaging Log. */
  documentDate?: Maybe<Scalars['DateTime']>;
  /** Document id of the Messaging Log. */
  documentId?: Maybe<Scalars['String']>;
  /** Document reference id of the Messaging Log. */
  documentReferenceId?: Maybe<Scalars['String']>;
  /** Document transaction id of the Messaging Log. */
  documentTransactionId?: Maybe<Scalars['String']>;
  /** Document type of the Messaging Log. */
  documentType?: Maybe<Scalars['String']>;
  /** File name of the Messaging Log. */
  fileName?: Maybe<Scalars['String']>;
  /** Id of the Messaging Log. */
  id: Scalars['UUID'];
  /** Internal client code of the Messaging Log. */
  internalClientCode?: Maybe<Scalars['String']>;
  /** Internal partner of the Messaging Log. */
  internalPartnerCode?: Maybe<Scalars['String']>;
  /** Internal Transaction Id of the Messaging Log. */
  internalTransactionId?: Maybe<Scalars['String']>;
  /** Invoice of the Messaging Log. */
  invoice?: Maybe<Scalars['String']>;
  /** Acknowledgement status of the Messaging Log. */
  isAcknowledged?: Maybe<Scalars['Boolean']>;
  /** Machine name of the Messaging Log. */
  machineName?: Maybe<Scalars['String']>;
  /** Message Type of the Messaging Log. */
  messageType?: Maybe<Scalars['String']>;
  /** Original file name of the Messaging Log. */
  originalFileName?: Maybe<Scalars['String']>;
  /** Purchase order of the Messaging Log. */
  pO?: Maybe<Scalars['String']>;
  /** Partner of the Messaging Log. */
  partner?: Maybe<PartnerModel>;
  /** Process name of the Messaging Log. */
  processName: ProcessName;
  /** Raw message of the Messaging Log. */
  rawMessage?: Maybe<Scalars['String']>;
  /** Receiver id of the Messaging Log. */
  receiverId?: Maybe<Scalars['String']>;
  /** Sender id of the Messaging Log. */
  senderId?: Maybe<Scalars['String']>;
  /** Status of the Document of the Messaging Log. */
  status?: Maybe<DocumentStatus>;
  /** Total lines of the Messaging Log. */
  totalLines?: Maybe<Scalars['Int']>;
  /** Total quantity of the Messaging Log. */
  totalQuantity?: Maybe<Scalars['Decimal']>;
  /** Machine name of the Messaging Log. */
  totalSize?: Maybe<Scalars['String']>;
  /** Machine name of the Messaging Log. */
  totalSizeType?: Maybe<TotalSizeType>;
  /** Total value of the Messaging Log. */
  totalValue?: Maybe<Scalars['Decimal']>;
};

export enum MissingAcknowledgementNotificationMode {
  AutoReconcile = 'AUTO_RECONCILE',
  EmailAfter_3 = 'EMAIL_AFTER_3',
  EmailEachTime = 'EMAIL_EACH_TIME'
}

export type Mutations = {
  __typename?: 'Mutations';
  addClientPartner?: Maybe<AddClientPartnerPayload>;
  addClientPartnerTransactions?: Maybe<AddClientPartnerTransactionPayload>;
  addNotificationFormatterTransactions?: Maybe<AddNotificationFormatterTransactionsPayload>;
  addPartnerTransactions?: Maybe<AddPartnerTransactionsPayload>;
  clonePipeline?: Maybe<ClonePipelinePayload>;
  clonePricing?: Maybe<ClonePricingPayload>;
  createDataLakeDirectory?: Maybe<ActionPayload>;
  deleteBusinessArea?: Maybe<DeleteBusinessAreaPayload>;
  deleteById?: Maybe<DeleteByIdPayload>;
  deleteClientAka?: Maybe<DeleteClientAkaPayload>;
  deleteClientContact?: Maybe<DeleteClientContactPayload>;
  deleteClientNotificationRecipients?: Maybe<DeleteClientNotificationRecipientsPayload>;
  deleteClientPartnerTransactionMap?: Maybe<DeleteClientPartnerTransactionMapPayload>;
  deleteClientPartnerTransactionSchema?: Maybe<DeleteClientPartnerTransactionSchemaPayload>;
  deleteClientPortalUserRelationship?: Maybe<DeleteClientPortalUserPayload>;
  deleteCurrency?: Maybe<DeleteCurrencyPayload>;
  deleteDataLakeDirectory?: Maybe<ActionPayload>;
  deleteDataLakeFile?: Maybe<ActionPayload>;
  deleteErpProduct?: Maybe<DeleteErpProductPayload>;
  deleteErpTransactionSchema?: Maybe<DeleteErpTransactionSchemaPayload>;
  deleteMultipleByIds?: Maybe<DeleteMultipleByIdsPayload>;
  deletePartner?: Maybe<DeletePartnerPayload>;
  deletePartnerContact?: Maybe<DeletePartnerContactPayload>;
  deletePartnerTransactionSchema?: Maybe<DeletePartnerTransactionSchemaPayload>;
  deleteTransaction?: Maybe<DeleteTransactionPayload>;
  deleteTransactionMap?: Maybe<DeleteTransactionMapPayload>;
  deleteTransactionMapPartner?: Maybe<DeleteTransactionMapPartnerPayload>;
  deleteUser?: Maybe<DeleteUserPayload>;
  executeBlobStorageDownload?: Maybe<ActionPayload>;
  executeBlobStorageUpload?: Maybe<ActionPayload>;
  executeDataLakeFileDownload?: Maybe<ActionPayload>;
  executeDataLakeFileUpload?: Maybe<ActionPayload>;
  executeEdiActionSvcAction?: Maybe<ActionPayload>;
  moveDataLakeFile?: Maybe<ActionPayload>;
  reprocessFailedDataLakeFile?: Maybe<ActionPayload>;
  updateClientPartner?: Maybe<UpdateClientPartnerPayload>;
  updateClientPartnerTransaction?: Maybe<UpdateClientPartnerTransactionPayload>;
  updateDocumentArchiveAcknowledgementStatus?: Maybe<UpdateDocumentArchivesPayload>;
  updateDocumentArchiveIsAbandoned?: Maybe<UpdateDocumentArchivesPayload>;
  updateFileVersionIsActive?: Maybe<UpdateBlobStoragePayload>;
  updatePartnerTransaction?: Maybe<UpdatePartnerTransactionsPayload>;
  updateTransactionErrorCategory?: Maybe<UpdateTransactionErrorCategoryPayload>;
  updateTransactionErrors?: Maybe<UpdateTransactionErrorsPayload>;
  uploadTransactionMapToAzureFiles?: Maybe<UploadTransactionMapToAzureFilesPayload>;
  upsertBilling?: Maybe<UpsertBillingPayload>;
  upsertBillingItem?: Maybe<UpsertBillingItemPayload>;
  upsertBusinessArea?: Maybe<UpsertBusinessAreaPayload>;
  upsertClient?: Maybe<UpsertClientPayload>;
  upsertClientAka?: Maybe<UpsertClientAkaPayload>;
  upsertClientAttachment?: Maybe<UpsertClientAttachmentPayload>;
  upsertClientContact?: Maybe<UpsertClientContactPayload>;
  upsertClientContactNote?: Maybe<UpsertNotePayload>;
  upsertClientNote?: Maybe<UpsertNotePayload>;
  upsertClientNotificationRecipients?: Maybe<UpsertClientNotificationRecipientsPayload>;
  upsertClientPartnerAttachment?: Maybe<UpsertClientPartnerAttachmentPayload>;
  upsertClientPartnerTransactionAlias?: Maybe<UpsertClientPartnerTransactionAliasPayload>;
  upsertClientPartnerTransactionMap?: Maybe<UpsertClientPartnerTransactionMapPayload>;
  upsertClientPartnerTransactionPipeline?: Maybe<UpsertClientPartnerTransactionPipelinePayload>;
  upsertClientPartnerTransactionPostProcessing?: Maybe<UpsertClientPartnerTransactionPostProcessingPayload>;
  upsertClientPartnerTransactionSchema?: Maybe<UpsertClientPartnerTransactionSchemaPayload>;
  upsertClientPortalUser?: Maybe<UpsertPortalUserPayload>;
  upsertClientTransaction?: Maybe<UpsertClientTransactionPayload>;
  upsertConfiguration?: Maybe<UpsertConfigurationPayload>;
  upsertCounter?: Maybe<UpsertCounterPayload>;
  upsertCrossReference?: Maybe<UpsertCrossReferencePayload>;
  upsertCurrency?: Maybe<UpsertCurrencyPayload>;
  upsertDocumentArchiveNote?: Maybe<UpsertNotePayload>;
  upsertEdiStandard?: Maybe<UpsertEdiStandardPayload>;
  upsertEdiXmlConfig?: Maybe<UpsertEdiXmlConfigPayload>;
  upsertEntity?: Maybe<UpsertEntityPayload>;
  upsertErpProduct?: Maybe<UpsertErpProductPayload>;
  upsertErpTransactionSchema?: Maybe<UpsertErpTransactionSchemaPayload>;
  upsertFavorite?: Maybe<UpsertFavoritePayload>;
  upsertNotificationFormatter?: Maybe<UpsertNotificationFormatterPayload>;
  upsertPartner?: Maybe<UpsertPartnerPayload>;
  upsertPartnerAka?: Maybe<UpsertPartnerAkaPayload>;
  upsertPartnerAttachment?: Maybe<UpsertPartnerAttachmentPayload>;
  upsertPartnerContact?: Maybe<UpsertPartnerContactPayload>;
  upsertPartnerContactNote?: Maybe<UpsertNotePayload>;
  upsertPartnerNote?: Maybe<UpsertNotePayload>;
  upsertPartnerNotificationRecipients?: Maybe<UpsertPartnerNotificationRecipientsPayload>;
  upsertPartnerTransactionSchema?: Maybe<UpsertPartnerTransactionSchemaPayload>;
  upsertPipeline?: Maybe<UpsertPipelinePayload>;
  upsertPipelineItem?: Maybe<UpsertPipelineItemPayload>;
  upsertPostProcessingBlob?: Maybe<UpsertPostProcessingBlobPayload>;
  upsertPricing?: Maybe<UpsertPricingPayload>;
  upsertPricingItem?: Maybe<UpsertPricingItemPayload>;
  upsertRecent?: Maybe<UpsertRecentPayload>;
  upsertSystemConfiguration?: Maybe<UpsertSystemConfigurationPayload>;
  upsertSystemNotification?: Maybe<UpsertSystemNotificationPayload>;
  upsertTransaction?: Maybe<UpsertTransactionPayload>;
  upsertTransactionErrorNote?: Maybe<UpsertNotePayload>;
  upsertTransactionMap?: Maybe<UpsertTransactionMapPayload>;
  upsertTransactionMapPartner?: Maybe<UpsertTransactionMapPartnerPayload>;
  upsertTransactionXPath?: Maybe<UpsertTransactionXPathPayload>;
  upsertUser?: Maybe<UpsertUserPayload>;
};


export type MutationsAddClientPartnerArgs = {
  input: AddClientPartnerInput;
};


export type MutationsAddClientPartnerTransactionsArgs = {
  input: AddClientPartnerTransactionsInput;
};


export type MutationsAddNotificationFormatterTransactionsArgs = {
  input: AddNotificationFormatterTransactionsInput;
};


export type MutationsAddPartnerTransactionsArgs = {
  input: AddPartnerTransactionsInput;
};


export type MutationsClonePipelineArgs = {
  input: ClonePipelineInput;
};


export type MutationsClonePricingArgs = {
  input: ClonePricingInput;
};


export type MutationsCreateDataLakeDirectoryArgs = {
  input: DataLakeDirectoryCreateRequestInput;
};


export type MutationsDeleteBusinessAreaArgs = {
  input: DeleteBusinessAreaInput;
};


export type MutationsDeleteByIdArgs = {
  input: DeleteByIdInput;
};


export type MutationsDeleteClientAkaArgs = {
  input: DeleteClientAkaInput;
};


export type MutationsDeleteClientContactArgs = {
  input: DeleteClientContactInput;
};


export type MutationsDeleteClientNotificationRecipientsArgs = {
  input: DeleteClientNotificationRecipientsInput;
};


export type MutationsDeleteClientPartnerTransactionMapArgs = {
  input: DeleteClientPartnerTransactionMapInput;
};


export type MutationsDeleteClientPartnerTransactionSchemaArgs = {
  input: DeleteClientPartnerTransactionSchemaInput;
};


export type MutationsDeleteClientPortalUserRelationshipArgs = {
  input: DeleteClientPortalUserInput;
};


export type MutationsDeleteCurrencyArgs = {
  input: DeleteCurrencyInput;
};


export type MutationsDeleteDataLakeDirectoryArgs = {
  input: DataLakeDirectoryDeleteRequestInput;
};


export type MutationsDeleteDataLakeFileArgs = {
  input: DataLakeFileDeleteRequestInput;
};


export type MutationsDeleteErpProductArgs = {
  input: DeleteErpProductInput;
};


export type MutationsDeleteErpTransactionSchemaArgs = {
  input: DeleteErpTransactionSchemaInput;
};


export type MutationsDeleteMultipleByIdsArgs = {
  input: DeleteMultipleByIdsInput;
};


export type MutationsDeletePartnerArgs = {
  input: DeletePartnerInput;
};


export type MutationsDeletePartnerContactArgs = {
  input: DeletePartnerContactInput;
};


export type MutationsDeletePartnerTransactionSchemaArgs = {
  input: DeletePartnerTransactionSchemaInput;
};


export type MutationsDeleteTransactionArgs = {
  input: DeleteTransactionInput;
};


export type MutationsDeleteTransactionMapArgs = {
  input: DeleteTransactionMapInput;
};


export type MutationsDeleteTransactionMapPartnerArgs = {
  input: DeleteTransactionMapPartnerInput;
};


export type MutationsDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationsExecuteBlobStorageDownloadArgs = {
  input: BlobDownloadRequestInput;
};


export type MutationsExecuteBlobStorageUploadArgs = {
  input: BlobUploadRequestInput;
};


export type MutationsExecuteDataLakeFileDownloadArgs = {
  input: DataLakeFileDownloadRequestInput;
};


export type MutationsExecuteDataLakeFileUploadArgs = {
  input: BulkDataLakeFileUploadRequestInput;
};


export type MutationsExecuteEdiActionSvcActionArgs = {
  input: EdiActionServiceInput;
};


export type MutationsMoveDataLakeFileArgs = {
  input: DataLakeMoveFileRequestInput;
};


export type MutationsReprocessFailedDataLakeFileArgs = {
  input: DataLakeReprocessFailedFileRequestInput;
};


export type MutationsUpdateClientPartnerArgs = {
  input: UpdateClientPartnerInput;
};


export type MutationsUpdateClientPartnerTransactionArgs = {
  input: UpdateClientPartnerTransactionInput;
};


export type MutationsUpdateDocumentArchiveAcknowledgementStatusArgs = {
  input: UpdateDocumentArchivesInput;
};


export type MutationsUpdateDocumentArchiveIsAbandonedArgs = {
  input: UpdateDocumentArchivesInput;
};


export type MutationsUpdateFileVersionIsActiveArgs = {
  input: UpdateBlobStorageInput;
};


export type MutationsUpdatePartnerTransactionArgs = {
  input: UpdatePartnerTransactionInput;
};


export type MutationsUpdateTransactionErrorCategoryArgs = {
  input: UpdateTransactionErrorCategoryInput;
};


export type MutationsUpdateTransactionErrorsArgs = {
  input: UpdateTransactionErrorsInput;
};


export type MutationsUploadTransactionMapToAzureFilesArgs = {
  input: UploadTransactionMapToAzureFilesInput;
};


export type MutationsUpsertBillingArgs = {
  input: UpsertBillingInput;
};


export type MutationsUpsertBillingItemArgs = {
  input: UpsertBillingItemInput;
};


export type MutationsUpsertBusinessAreaArgs = {
  input: UpsertBusinessAreaInput;
};


export type MutationsUpsertClientArgs = {
  input: UpsertClientInput;
};


export type MutationsUpsertClientAkaArgs = {
  input: UpsertClientAkaInput;
};


export type MutationsUpsertClientAttachmentArgs = {
  input: UpsertClientAttachmentInput;
};


export type MutationsUpsertClientContactArgs = {
  input: UpsertClientContactInput;
};


export type MutationsUpsertClientContactNoteArgs = {
  input: UpsertNoteInput;
};


export type MutationsUpsertClientNoteArgs = {
  input: UpsertNoteInput;
};


export type MutationsUpsertClientNotificationRecipientsArgs = {
  input: UpsertClientNotificationRecipientsInput;
};


export type MutationsUpsertClientPartnerAttachmentArgs = {
  input: UpsertClientPartnerAttachmentInput;
};


export type MutationsUpsertClientPartnerTransactionAliasArgs = {
  input: UpsertClientPartnerTransactionAliasInput;
};


export type MutationsUpsertClientPartnerTransactionMapArgs = {
  input: UpsertClientPartnerTransactionMapInput;
};


export type MutationsUpsertClientPartnerTransactionPipelineArgs = {
  input: UpsertClientPartnerTransactionPipelineInput;
};


export type MutationsUpsertClientPartnerTransactionPostProcessingArgs = {
  input: UpsertClientPartnerTransactionPostProcessingInput;
};


export type MutationsUpsertClientPartnerTransactionSchemaArgs = {
  input: UpsertClientPartnerTransactionSchemaInput;
};


export type MutationsUpsertClientPortalUserArgs = {
  input: UpsertPortalUserInput;
};


export type MutationsUpsertClientTransactionArgs = {
  input: UpsertClientTransactionInput;
};


export type MutationsUpsertConfigurationArgs = {
  input: UpsertConfigurationInput;
};


export type MutationsUpsertCounterArgs = {
  input: UpsertCounterInput;
};


export type MutationsUpsertCrossReferenceArgs = {
  input: UpsertCrossReferenceInput;
};


export type MutationsUpsertCurrencyArgs = {
  input: UpsertCurrencyInput;
};


export type MutationsUpsertDocumentArchiveNoteArgs = {
  input: UpsertNoteInput;
};


export type MutationsUpsertEdiStandardArgs = {
  input: UpsertEdiStandardInput;
};


export type MutationsUpsertEdiXmlConfigArgs = {
  input: UpsertEdiXmlConfigInput;
};


export type MutationsUpsertEntityArgs = {
  input: UpsertEntityInput;
};


export type MutationsUpsertErpProductArgs = {
  input: UpsertErpProductInput;
};


export type MutationsUpsertErpTransactionSchemaArgs = {
  input: UpsertErpTransactionSchemaInput;
};


export type MutationsUpsertFavoriteArgs = {
  input: UpsertFavoriteInput;
};


export type MutationsUpsertNotificationFormatterArgs = {
  input: UpsertNotificationFormatterInput;
};


export type MutationsUpsertPartnerArgs = {
  input: UpsertPartnerInput;
};


export type MutationsUpsertPartnerAkaArgs = {
  input: UpsertPartnerAkaInput;
};


export type MutationsUpsertPartnerAttachmentArgs = {
  input: UpsertPartnerAttachmentInput;
};


export type MutationsUpsertPartnerContactArgs = {
  input: UpsertPartnerContactInput;
};


export type MutationsUpsertPartnerContactNoteArgs = {
  input: UpsertNoteInput;
};


export type MutationsUpsertPartnerNoteArgs = {
  input: UpsertNoteInput;
};


export type MutationsUpsertPartnerNotificationRecipientsArgs = {
  input: UpsertPartnerNotificationRecipientsInput;
};


export type MutationsUpsertPartnerTransactionSchemaArgs = {
  input: UpsertPartnerTransactionSchemaInput;
};


export type MutationsUpsertPipelineArgs = {
  input: UpsertPipelineInput;
};


export type MutationsUpsertPipelineItemArgs = {
  input: UpsertPipelineItemInput;
};


export type MutationsUpsertPostProcessingBlobArgs = {
  input: UpsertPostProcessingBlobInput;
};


export type MutationsUpsertPricingArgs = {
  input: UpsertPricingInput;
};


export type MutationsUpsertPricingItemArgs = {
  input: UpsertPricingItemInput;
};


export type MutationsUpsertRecentArgs = {
  input: UpsertRecentInput;
};


export type MutationsUpsertSystemConfigurationArgs = {
  input: UpsertSystemConfigurationInput;
};


export type MutationsUpsertSystemNotificationArgs = {
  input: UpsertSystemNotificationInput;
};


export type MutationsUpsertTransactionArgs = {
  input: UpsertTransactionInput;
};


export type MutationsUpsertTransactionErrorNoteArgs = {
  input: UpsertNoteInput;
};


export type MutationsUpsertTransactionMapArgs = {
  input: UpsertTransactionMapInput;
};


export type MutationsUpsertTransactionMapPartnerArgs = {
  input: UpsertTransactionMapPartnerInput;
};


export type MutationsUpsertTransactionXPathArgs = {
  input: UpsertTransactionXPathInput;
};


export type MutationsUpsertUserArgs = {
  input: UpsertUserInput;
};

export enum NormalizedDocumentType {
  Acknowledgement = 'ACKNOWLEDGEMENT',
  AcknowledgementInbound = 'ACKNOWLEDGEMENT_INBOUND',
  ApplicationAdvice = 'APPLICATION_ADVICE',
  Control = 'CONTROL',
  CreditDebitAdjustment = 'CREDIT_DEBIT_ADJUSTMENT',
  DeliveryJustInTime = 'DELIVERY_JUST_IN_TIME',
  DeliverySchedule = 'DELIVERY_SCHEDULE',
  FunctionalAcknowledgement = 'FUNCTIONAL_ACKNOWLEDGEMENT',
  InventoryAdvice = 'INVENTORY_ADVICE',
  Invoice = 'INVOICE',
  InvoiceInbound = 'INVOICE_INBOUND',
  OrganizationalRelationships = 'ORGANIZATIONAL_RELATIONSHIPS',
  Payment = 'PAYMENT',
  ProductTransferResaleReport = 'PRODUCT_TRANSFER_RESALE_REPORT',
  PurchaseOrder = 'PURCHASE_ORDER',
  PurchaseOrderChange = 'PURCHASE_ORDER_CHANGE',
  PurchaseOrderOutbound = 'PURCHASE_ORDER_OUTBOUND',
  PurchaseOrderReceipt = 'PURCHASE_ORDER_RECEIPT',
  RemittanceAdvice = 'REMITTANCE_ADVICE',
  RequestForQuotation = 'REQUEST_FOR_QUOTATION',
  RequestForRoutingInstructions = 'REQUEST_FOR_ROUTING_INSTRUCTIONS',
  SalesOrderStatus = 'SALES_ORDER_STATUS',
  SalesOrderStatusRequest = 'SALES_ORDER_STATUS_REQUEST',
  Shipment = 'SHIPMENT',
  ShipmentInbound = 'SHIPMENT_INBOUND',
  ShippingSchedule = 'SHIPPING_SCHEDULE',
  StockReceipt = 'STOCK_RECEIPT',
  StockTransfer = 'STOCK_TRANSFER',
  Taxcon = 'TAXCON',
  TextMessage = 'TEXT_MESSAGE',
  Unknown = 'UNKNOWN',
  WarehouseInventoryAdjustmentAdvice = 'WAREHOUSE_INVENTORY_ADJUSTMENT_ADVICE',
  WarehouseShippingAdvice = 'WAREHOUSE_SHIPPING_ADVICE',
  WarehouseShippingOrder = 'WAREHOUSE_SHIPPING_ORDER'
}

export type NoteModel = {
  __typename?: 'NoteModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** User name that has created the record. */
  createdByName?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Header of the Note. */
  header?: Maybe<Scalars['String']>;
  /** Id of the Note. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** User name that has last modified the record. */
  lastModifiedByName?: Maybe<Scalars['String']>;
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Note of the Note. */
  note: Scalars['String'];
  /** Parent Id of the Note */
  parentId: Scalars['UUID'];
};

export enum NotificationFormatterBodyType {
  Html = 'HTML',
  Text = 'TEXT'
}

export type NotificationFormatterModel = {
  __typename?: 'NotificationFormatterModel';
  /** Attachment indicator of the Notification Formatter */
  asAttachment?: Maybe<Scalars['Boolean']>;
  /** Body of the Notification Formatter */
  body?: Maybe<Scalars['String']>;
  /** Body Type of the Notification Formatter */
  bodyType?: Maybe<NotificationFormatterBodyType>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Notification Formatter */
  description: Scalars['String'];
  /** File Type of the Notification Formatter */
  fileType?: Maybe<Scalars['String']>;
  /** Formatter Type of the Notification Formatter */
  formatterType?: Maybe<Scalars['String']>;
  /** Id of the Notification Formatter */
  id: Scalars['UUID'];
  /** Indicator of if the Notification Formatter should be used as an Error Formatter */
  isForError?: Maybe<Scalars['Boolean']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Notification Formatter Transactions info of the Notification Formatter */
  notificationFormatterTransactions?: Maybe<Array<Maybe<NotificationFormatterTransactionModel>>>;
  /** Preprocessor Type of the Notification Formatter */
  preprocessorType?: Maybe<Scalars['String']>;
  /** Source Type of the Notification Formatter */
  sourceType?: Maybe<NotificationSourceType>;
  /** Subject of the Notification Formatter */
  subject?: Maybe<Scalars['String']>;
  /** Template of the Notification Formatter */
  template?: Maybe<Scalars['String']>;
  /** Number of transactions for the Notification Formatter */
  totalTransactions?: Maybe<Scalars['Int']>;
  /** Watcher Path of the Notification Formatter */
  watcherPath?: Maybe<Scalars['String']>;
};

export type NotificationFormatterOrderByInput = {
  description?: InputMaybe<OrderDirection>;
  lastModifiedTime?: InputMaybe<OrderDirection>;
};

export type NotificationFormatterTransactionModel = {
  __typename?: 'NotificationFormatterTransactionModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Id of the notification formatter transaction. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Notification Formatter for transaction */
  notificationFormatter?: Maybe<NotificationFormatterModel>;
  /** Notification Formatter Id of the formatter for the transaction */
  notificationFormatterId: Scalars['UUID'];
  /** Transaction in NotificationFormatter-Transaction. */
  transaction?: Maybe<TransactionModel>;
  /** Transaction Id of the transaction. */
  transactionId: Scalars['UUID'];
};

export enum NotificationSourceType {
  EdiXml = 'EDI_XML',
  ErpXml = 'ERP_XML'
}

export enum NotificationType {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OutboundAcknowledgementType {
  Detailed = 'DETAILED',
  Normal = 'NORMAL'
}

export type PageModel = {
  __typename?: 'PageModel';
  /** Next Page cursor */
  nextPage?: Maybe<Scalars['String']>;
  /** Previous Page cursor. */
  previousPage?: Maybe<Scalars['String']>;
};

export type PageModelSortInput = {
  nextPage?: InputMaybe<SortEnumType>;
  previousPage?: InputMaybe<SortEnumType>;
};

export type PagingResultModelOfAttachmentModel = {
  __typename?: 'PagingResultModelOfAttachmentModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<AttachmentModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfAuditRecordModel = {
  __typename?: 'PagingResultModelOfAuditRecordModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<AuditRecordModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfBillingAggregatesModel = {
  __typename?: 'PagingResultModelOfBillingAggregatesModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<BillingAggregatesModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfBillingItemModel = {
  __typename?: 'PagingResultModelOfBillingItemModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<BillingItemModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfBillingModel = {
  __typename?: 'PagingResultModelOfBillingModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<BillingModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfBillingModelSortInput = {
  cursor?: InputMaybe<PageModelSortInput>;
  totalCount?: InputMaybe<SortEnumType>;
};

export type PagingResultModelOfBlobStorageModel = {
  __typename?: 'PagingResultModelOfBlobStorageModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<BlobStorageModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfBusinessAreaModel = {
  __typename?: 'PagingResultModelOfBusinessAreaModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<BusinessAreaModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfClientAkaModel = {
  __typename?: 'PagingResultModelOfClientAkaModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ClientAkaModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfClientModel = {
  __typename?: 'PagingResultModelOfClientModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ClientModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfClientNotificationRecipientsModel = {
  __typename?: 'PagingResultModelOfClientNotificationRecipientsModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ClientNotificationRecipientsModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfClientPartnerModel = {
  __typename?: 'PagingResultModelOfClientPartnerModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ClientPartnerModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfClientPartnerTransactionAliasModel = {
  __typename?: 'PagingResultModelOfClientPartnerTransactionAliasModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ClientPartnerTransactionAliasModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfClientPartnerTransactionMapModel = {
  __typename?: 'PagingResultModelOfClientPartnerTransactionMapModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ClientPartnerTransactionMapModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfClientPartnerTransactionModel = {
  __typename?: 'PagingResultModelOfClientPartnerTransactionModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ClientPartnerTransactionModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfClientPartnerTransactionPostProcessingModel = {
  __typename?: 'PagingResultModelOfClientPartnerTransactionPostProcessingModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ClientPartnerTransactionPostProcessingModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfClientPartnerTransactionSchemaModel = {
  __typename?: 'PagingResultModelOfClientPartnerTransactionSchemaModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ClientPartnerTransactionSchemaModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfClientTransactionModel = {
  __typename?: 'PagingResultModelOfClientTransactionModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ClientTransactionModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfConfigurationModel = {
  __typename?: 'PagingResultModelOfConfigurationModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ConfigurationModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfCounterModel = {
  __typename?: 'PagingResultModelOfCounterModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<CounterModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfCrossReferenceModel = {
  __typename?: 'PagingResultModelOfCrossReferenceModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<CrossReferenceModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfCurrencyModel = {
  __typename?: 'PagingResultModelOfCurrencyModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<CurrencyModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfDocumentArchiveModel = {
  __typename?: 'PagingResultModelOfDocumentArchiveModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<DocumentArchiveModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfEdiStandardModel = {
  __typename?: 'PagingResultModelOfEdiStandardModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<EdiStandardModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfErpProductModel = {
  __typename?: 'PagingResultModelOfErpProductModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ErpProductModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfErpTransactionSchemaModel = {
  __typename?: 'PagingResultModelOfErpTransactionSchemaModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<ErpTransactionSchemaModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfIsaQualifierModel = {
  __typename?: 'PagingResultModelOfIsaQualifierModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<IsaQualifierModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfLocaleModel = {
  __typename?: 'PagingResultModelOfLocaleModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<LocaleModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfMessagingLogModel = {
  __typename?: 'PagingResultModelOfMessagingLogModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<MessagingLogModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfNotificationFormatterModel = {
  __typename?: 'PagingResultModelOfNotificationFormatterModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<NotificationFormatterModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfNotificationFormatterTransactionModel = {
  __typename?: 'PagingResultModelOfNotificationFormatterTransactionModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<NotificationFormatterTransactionModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfPartnerAkaModel = {
  __typename?: 'PagingResultModelOfPartnerAkaModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<PartnerAkaModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfPartnerModel = {
  __typename?: 'PagingResultModelOfPartnerModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<PartnerModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfPartnerNotificationRecipientsModel = {
  __typename?: 'PagingResultModelOfPartnerNotificationRecipientsModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<PartnerNotificationRecipientsModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfPartnerTransactionModel = {
  __typename?: 'PagingResultModelOfPartnerTransactionModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<PartnerTransactionModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfPartnerTransactionSchemaModel = {
  __typename?: 'PagingResultModelOfPartnerTransactionSchemaModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<PartnerTransactionSchemaModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfPhoneTypeModel = {
  __typename?: 'PagingResultModelOfPhoneTypeModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<PhoneTypeModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfPipelineItemClassNameModel = {
  __typename?: 'PagingResultModelOfPipelineItemClassNameModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<PipelineItemClassNameModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfPipelineModel = {
  __typename?: 'PagingResultModelOfPipelineModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<PipelineModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfPortalTransactionModel = {
  __typename?: 'PagingResultModelOfPortalTransactionModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<PortalTransactionModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfPostProcessingBlobModel = {
  __typename?: 'PagingResultModelOfPostProcessingBlobModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<PostProcessingBlobModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfPricingModel = {
  __typename?: 'PagingResultModelOfPricingModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<PricingModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfStandardExchangeFormatModel = {
  __typename?: 'PagingResultModelOfStandardExchangeFormatModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<StandardExchangeFormatModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfStateModel = {
  __typename?: 'PagingResultModelOfStateModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<StateModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfTransactionErrorCategoryModel = {
  __typename?: 'PagingResultModelOfTransactionErrorCategoryModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<TransactionErrorCategoryModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfTransactionErrorModel = {
  __typename?: 'PagingResultModelOfTransactionErrorModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<TransactionErrorModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfTransactionMapModel = {
  __typename?: 'PagingResultModelOfTransactionMapModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<TransactionMapModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfTransactionMapPartnerModel = {
  __typename?: 'PagingResultModelOfTransactionMapPartnerModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<TransactionMapPartnerModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfTransactionModel = {
  __typename?: 'PagingResultModelOfTransactionModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<TransactionModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PagingResultModelOfUserModel = {
  __typename?: 'PagingResultModelOfUserModel';
  cursor?: Maybe<PageModel>;
  nodes?: Maybe<Array<UserModel>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PartnerAkaModel = {
  __typename?: 'PartnerAkaModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the PartnerAKA */
  description?: Maybe<Scalars['String']>;
  /** Id of the PartnerAKA */
  id: Scalars['UUID'];
  /** ISA Qualifier of the PartnerAKA */
  isaQualifier?: Maybe<IsaQualifierModel>;
  /** ISA Qualifier Code of the PartnerAKA */
  isaQualifierCode: Scalars['String'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Partner Code of the PartnerAKA */
  partnerCode: Scalars['String'];
  /** Id of the PartnerAKA */
  partnerId: Scalars['UUID'];
};

export type PartnerContactModel = {
  __typename?: 'PartnerContactModel';
  /** Address info of the partner contact. */
  addresses?: Maybe<Array<Maybe<AddressModel>>>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Name of trading partner contact. */
  description: Scalars['String'];
  /** Email info of the partner contact. */
  emails?: Maybe<Array<Maybe<EmailModel>>>;
  /** Id of trading partner contact. */
  id: Scalars['UUID'];
  /** If the Contact is Active. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** If the Contact is Primary. */
  isPrimary?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Name of trading partner contact. */
  name: Scalars['String'];
  /** Note info of the partner */
  notes?: Maybe<Array<Maybe<NoteModel>>>;
  partnerId: Scalars['String'];
  /** Phone info of the partner contact. */
  phones?: Maybe<Array<Maybe<PhoneModel>>>;
};

export type PartnerModel = {
  __typename?: 'PartnerModel';
  /** Address info of the trading partner */
  addresses?: Maybe<Array<Maybe<AddressModel>>>;
  /** Attachments of the partner */
  attachments?: Maybe<Array<Maybe<AttachmentModel>>>;
  /** Business area of trading partner */
  businessArea?: Maybe<BusinessAreaModel>;
  /** Clients associated to the partner */
  clients?: Maybe<Array<Maybe<ClientModel>>>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Edi standard info of the trading partner */
  ediStandards?: Maybe<Array<Maybe<EdiStandardModel>>>;
  /** Email info of the trading partner */
  emails?: Maybe<Array<Maybe<EmailModel>>>;
  /** Functional Reconciliation Mode for the trading partner */
  functionalReconciliationMode: FunctionalReconciliationMode;
  /** Id of trading partner */
  id: Scalars['UUID'];
  /** Internal code of trading partner */
  internalPartnerCode: Scalars['String'];
  /** ISA Qualifier Code of trading partner */
  isaQualifierCode: Scalars['String'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Locale code of the trading partner */
  localeCode?: Maybe<Scalars['String']>;
  /** Name of trading partner */
  name: Scalars['String'];
  /** Note info of the partner */
  notes?: Maybe<Array<Maybe<NoteModel>>>;
  /** Notification Formatter for trading partner */
  notificationFormatter?: Maybe<NotificationFormatterModel>;
  /** Partner AKA info of the partner */
  partnerAKAs?: Maybe<Array<Maybe<PartnerAkaModel>>>;
  /** Code of trading partner */
  partnerCode: Scalars['String'];
  /** Contact info of trading partner */
  partnerContacts?: Maybe<Array<Maybe<PartnerContactModel>>>;
  /** Partner-Transactions info of the trading partner */
  partnerTransactions?: Maybe<Array<Maybe<PartnerTransactionModel>>>;
  /** Phone info of the trading partner */
  phones?: Maybe<Array<Maybe<PhoneModel>>>;
  /** Status of the trading partner */
  statusCode?: Maybe<PartnerStatus>;
  /** Number of transactions for the trading partner */
  totalTransactions?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
};

export type PartnerNotificationRecipientsModel = {
  __typename?: 'PartnerNotificationRecipientsModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the PartnerNotificationRecipients */
  description?: Maybe<Scalars['String']>;
  /** Id of the PartnerNotificationRecipients */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** NotificationType of the PartnerNotificationRecipients */
  notificationType: NotificationType;
  /** Partner Id of the PartnerNotificationRecipients */
  partnerId: Scalars['UUID'];
  /** Flag to indicate if recipient receives errors of the PartnerNotificationRecipients */
  receivesErrors?: Maybe<Scalars['Boolean']>;
  /** Flag to indicate if recipient receives notifications of the PartnerNotificationRecipients */
  receivesNotifications?: Maybe<Scalars['Boolean']>;
  /** Recipients of the PartnerNotificationRecipients */
  recipients: Scalars['String'];
};

export type PartnerOrderByInput = {
  name?: InputMaybe<OrderDirection>;
  partnerCode?: InputMaybe<OrderDirection>;
};

export enum PartnerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  New = 'NEW'
}

export type PartnerTransactionModel = {
  __typename?: 'PartnerTransactionModel';
  clientPartnerTransactions?: Maybe<Array<Maybe<ClientPartnerTransactionModel>>>;
  clientPartners?: Maybe<Array<Maybe<ClientPartnerModel>>>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Functional Reconciliation Mode for the partner transaction */
  functionalReconciliationMode: FunctionalReconciliationMode;
  /** Id of the partner transaction. */
  id: Scalars['UUID'];
  /** Indicates active status for partner transaction. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Notification Formatter for partner transaction */
  notificationFormatter?: Maybe<NotificationFormatterModel>;
  /** Outbound Acknowledgement Option for the partner transaction */
  outboundAcknowledgementOption?: Maybe<OutboundAcknowledgementType>;
  partner?: Maybe<PartnerModel>;
  /** Partner Id of the partner transaction. */
  partnerId: Scalars['UUID'];
  /** Transaction schema in partner transaction. */
  partnerTransactionSchemas?: Maybe<Array<Maybe<PartnerTransactionSchemaModel>>>;
  /** Pipeline in Partner-Transaction. */
  pipeline?: Maybe<PipelineModel>;
  /** Pipeline Id of the partner transaction. */
  pipelineId?: Maybe<Scalars['UUID']>;
  /** Transaction in Partner-Transaction. */
  transaction?: Maybe<TransactionModel>;
  /** Transaction Id of the partner transaction. */
  transactionId: Scalars['UUID'];
  /** Transaction Map in Partner-Transaction. */
  transactionMaps?: Maybe<Array<Maybe<TransactionMapModel>>>;
};

export type PartnerTransactionSchemaModel = {
  __typename?: 'PartnerTransactionSchemaModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Partner Transaction Schema. */
  description: Scalars['String'];
  /** Document String of the Partner Transaction Schema. */
  documentString?: Maybe<Scalars['String']>;
  /** Id of the Partner Transaction Schema. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Partner Transaction Id of the Partner Transaction Schema. */
  partnerTransactionId: Scalars['UUID'];
  /** Source File Name of the Erp Transaction Schema. */
  sourceFileName?: Maybe<Scalars['String']>;
  /** Standard Version of the Partner Transaction Schema. */
  standardVersion?: Maybe<Scalars['String']>;
};

export type PartnerTransactionSchemaModelInput = {
  createdBy: Scalars['String'];
  createdTime: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  documentString?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastModifiedBy: Scalars['String'];
  lastModifiedTime: Scalars['DateTime'];
  partnerTransactionId: Scalars['String'];
  sourceFileName?: InputMaybe<Scalars['String']>;
  standardVersion?: InputMaybe<Scalars['String']>;
};

export type PhoneModel = {
  __typename?: 'PhoneModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Phone. */
  description?: Maybe<Scalars['String']>;
  /** Id of the Phone. */
  id: Scalars['UUID'];
  /** Primary status of phone. */
  isPrimary?: Maybe<Scalars['Boolean']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Partner Id of the Phone. */
  parentId: Scalars['UUID'];
  phoneNumber?: Maybe<Scalars['String']>;
  phoneType?: Maybe<PhoneTypeModel>;
  phoneTypeCode?: Maybe<Scalars['String']>;
};

export type PhoneTypeModel = {
  __typename?: 'PhoneTypeModel';
  createdBy: Scalars['String'];
  createdTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  lastModifiedBy: Scalars['String'];
  lastModifiedTime: Scalars['DateTime'];
  phoneTypeCode?: Maybe<Scalars['String']>;
};

export type PipelineItemClassNameModel = {
  __typename?: 'PipelineItemClassNameModel';
  /** Class name of the Edi Process. */
  className: Scalars['String'];
  /** Description of the class fetched from assembly meta data. */
  description?: Maybe<Scalars['String']>;
  /** Fully qualified Type name of the Edi Process. */
  typeName: Scalars['String'];
};

export type PipelineItemModel = {
  __typename?: 'PipelineItemModel';
  /** Edi Processes for Pipeline Item */
  configuration?: Maybe<ConfigurationModel>;
  /** Configuration Id of the Pipeline Item. */
  configurationId?: Maybe<Scalars['UUID']>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Pipeline Item. */
  description?: Maybe<Scalars['String']>;
  /** EDI Process Class name of the Pipeline Item. */
  ediProcessClassName?: Maybe<Scalars['String']>;
  /** Id of the Pipeline Item. */
  id: Scalars['UUID'];
  /** JSON Args of the Pipeline Item. */
  jsonArgs?: Maybe<Scalars['String']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Pipeline Id of the Pipeline Item. */
  pipelineId: Scalars['UUID'];
  /** Sort Order of the Pipeline Item. */
  sortOrder: Scalars['Int'];
};

export type PipelineModel = {
  __typename?: 'PipelineModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** User name that has created the record. */
  createdByName?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Pipeline. */
  description?: Maybe<Scalars['String']>;
  /** Id of the Pipeline. */
  id: Scalars['UUID'];
  /** Is Legacy flag for the Pipeline. */
  isLegacy?: Maybe<Scalars['Boolean']>;
  /** Template status of Pipeline. */
  isTemplate?: Maybe<Scalars['Boolean']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** User name that has last modified the record. */
  lastModifiedByName?: Maybe<Scalars['String']>;
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** PipelineItems of the Pipeline. */
  pipelineItems?: Maybe<Array<Maybe<PipelineItemModel>>>;
  /** Transaction for the Pipeline (only for legacy). */
  transaction?: Maybe<TransactionModel>;
  /** Transaction Id of the Pipeline (only needed for legacy). */
  transactionId?: Maybe<Scalars['UUID']>;
};

export type PortalCustomerModel = {
  __typename?: 'PortalCustomerModel';
  /** Coid of the portal customer. */
  coid?: Maybe<Scalars['String']>;
  /** When this portal customer was created. */
  createdTime: Scalars['DateTime'];
  /** ID of the portal customer. */
  id: Scalars['UUID'];
  /** Name of the portal customer. */
  name?: Maybe<Scalars['String']>;
};

export type PortalSubscriptionModel = {
  __typename?: 'PortalSubscriptionModel';
  /** Time when the subscription was created. */
  createdTime: Scalars['DateTime'];
  /** Domain service associated with the subscription. */
  domainService: Scalars['String'];
  /** ID of the portal subscription. */
  id: Scalars['UUID'];
  /** ID of the portal customer. */
  portalCustomerId: Scalars['UUID'];
  /** ID of the tenant. */
  tenantId: Scalars['UUID'];
  /** Name of the tenant. */
  tenantName: Scalars['String'];
};

export type PortalTransactionModel = {
  __typename?: 'PortalTransactionModel';
  /** Acknowledged Date of the Document of the portal transaction */
  acknowledgedTime?: Maybe<Scalars['DateTime']>;
  /** Acknowledgement Status of the Document of the portal transaction */
  acknowledgementStatus?: Maybe<DocumentAcknowledgementStatus>;
  /** Client in portal transaction */
  client?: Maybe<ClientModel>;
  /** Client Id of the portal transaction. */
  clientId?: Maybe<Scalars['UUID']>;
  /** ClientPartner in portal transaction */
  clientPartner?: Maybe<ClientPartnerModel>;
  /** Client Tenant Id of the portal transaction. */
  clientTenantId?: Maybe<Scalars['UUID']>;
  /** Creation time of the portal transaction */
  createdTime?: Maybe<Scalars['DateTime']>;
  /** Currency Code of the portal transaction */
  currencyCode?: Maybe<Scalars['String']>;
  /** Document Date of the portal transaction */
  documentDate?: Maybe<Scalars['DateTime']>;
  /** Document Id of the portal transaction */
  documentId?: Maybe<Scalars['String']>;
  /** Document Number of the portal transaction */
  documentNumber?: Maybe<Scalars['String']>;
  /** Document Reference Id of the portal transaction */
  documentReferenceId?: Maybe<Scalars['String']>;
  /** EDI Document Resent Count of the portal transaction */
  ediDocumentResentCount?: Maybe<Scalars['Int']>;
  /** EDI Document Resent Date of the portal transaction */
  ediDocumentResentTime?: Maybe<Scalars['DateTime']>;
  /** ERP Order Number of the portal transaction */
  erpOrderNumber?: Maybe<Scalars['String']>;
  /** Id of the portal transaction */
  id: Scalars['UUID'];
  /** Internal Transaction Id of the portal transaction */
  internalTransactionId?: Maybe<Scalars['String']>;
  /** Indicates abandoned status for portal transaction. */
  isAbandoned?: Maybe<Scalars['Boolean']>;
  /** Original File Name of the portal transaction */
  originalFileName?: Maybe<Scalars['String']>;
  /** Partner in portal transaction */
  partner?: Maybe<PartnerModel>;
  /** Partner Id of the portal transaction. */
  partnerId?: Maybe<Scalars['UUID']>;
  /** Purchase Order Number of the portal transaction */
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  /** Total Lines of the portal transaction */
  totalLines?: Maybe<Scalars['Int']>;
  /** Total Quantity of the portal transaction */
  totalQuantity?: Maybe<Scalars['Decimal']>;
  /** Total Value of the portal transaction */
  totalValue?: Maybe<Scalars['Decimal']>;
  /** Transaction in portal transaction */
  transaction?: Maybe<TransactionModel>;
  /** Transaction Errors of of the portal transaction */
  transactionErrors?: Maybe<Array<Maybe<TransactionErrorModel>>>;
  /** Transaction Id of the portal transaction. */
  transactionId?: Maybe<Scalars['UUID']>;
};

export type PortalTransactionOrderByInput = {
  createdTime?: InputMaybe<OrderDirection>;
  documentNumber?: InputMaybe<OrderDirection>;
  erpOrderNumber?: InputMaybe<OrderDirection>;
  purchaseOrderNumber?: InputMaybe<OrderDirection>;
  totalValue?: InputMaybe<OrderDirection>;
};

export type PortalUserCustomerModel = {
  __typename?: 'PortalUserCustomerModel';
  /** ID of the portal user customer. */
  id: Scalars['UUID'];
  /** Customer information. */
  portalCustomer?: Maybe<PortalCustomerModel>;
  /** ID of the portal customer. */
  portalCustomerId: Scalars['UUID'];
  /** Customer's subscription information. */
  portalUserCustomerSubscriptions?: Maybe<Array<Maybe<PortalUserCustomerSubscriptionModel>>>;
  /** ID of the portal user. */
  portalUserId: Scalars['UUID'];
  /** Role of the user in this customer. */
  role: UserRole;
};

export type PortalUserCustomerSubscriptionModel = {
  __typename?: 'PortalUserCustomerSubscriptionModel';
  /** ID of the portal user customer subscription. */
  id: Scalars['UUID'];
  /** Portal subscription details. */
  portalSubscription?: Maybe<PortalSubscriptionModel>;
  /** ID of the portal subscription. */
  portalSubscriptionId: Scalars['UUID'];
  /** ID of the portal user customer. */
  portalUserCustomerId: Scalars['UUID'];
  /** Role of the user in this subscription. */
  role: UserRole;
};

export type PortalUserModel = {
  __typename?: 'PortalUserModel';
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Email address of the portal user */
  email: Scalars['String'];
  /** First name of the portal user */
  firstName: Scalars['String'];
  /** Id of the portal user */
  id: Scalars['UUID'];
  /** Last name of the portal user */
  lastName: Scalars['String'];
  /** List of customers associated with this portal user */
  portalUserCustomers?: Maybe<Array<Maybe<PortalUserCustomerModel>>>;
};

export type PostProcessingBlobModel = {
  __typename?: 'PostProcessingBlobModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the  Post Processing Blob */
  description?: Maybe<Scalars['String']>;
  /** Id of the Post Processing Blob */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Process Blob String of the  Post Processing Blob */
  processBlobString?: Maybe<Scalars['String']>;
};

export type PostProcessingBlobModelInput = {
  createdBy: Scalars['String'];
  createdTime: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastModifiedBy: Scalars['String'];
  lastModifiedTime: Scalars['DateTime'];
  processBlobString?: InputMaybe<Scalars['String']>;
};

export type PostProcessingBlobOrderByInput = {
  description?: InputMaybe<OrderDirection>;
};

export type PricingItemModel = {
  __typename?: 'PricingItemModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Pricing Item */
  description?: Maybe<Scalars['String']>;
  /** Fee Per Document of the Pricing */
  feePerDocument: Scalars['Decimal'];
  /** Fee Per Line of the Pricing */
  feePerLine: Scalars['Decimal'];
  /** Id of the Pricing Item */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  maxNumberOfTransactions: Scalars['Int'];
  /** Pricing Id of the Pricing Item */
  pricingId: Scalars['UUID'];
};

export type PricingModel = {
  __typename?: 'PricingModel';
  /** Number of Billing Items that have this Pricing */
  billingItemCount?: Maybe<Scalars['Int']>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** User name that has created the record. */
  createdByName?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Currency Code of the Pricing */
  currencyCode: Scalars['String'];
  /** Description of the Pricing */
  description: Scalars['String'];
  /** Id of the Pricing */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** User name that has last modified the record. */
  lastModifiedByName?: Maybe<Scalars['String']>;
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Minimum service fees of the Pricing */
  minServiceFees: Scalars['Decimal'];
  /** Pricing Items of the Pricing */
  pricingItems?: Maybe<Array<Maybe<PricingItemModel>>>;
};

export enum ProcessName {
  ActionService = 'ACTION_SERVICE',
  Adapter = 'ADAPTER',
  Custom = 'CUSTOM',
  FileMonitor = 'FILE_MONITOR',
  Mapper = 'MAPPER',
  MapDataValidation = 'MAP_DATA_VALIDATION',
  MegaXmlConsumerService = 'MEGA_XML_CONSUMER_SERVICE',
  PartnerGateway = 'PARTNER_GATEWAY',
  PipelineService = 'PIPELINE_SERVICE',
  PowerShell = 'POWER_SHELL',
  RestApi = 'REST_API',
  Splitter = 'SPLITTER',
  Translator = 'TRANSLATOR'
}

export type Queries = {
  __typename?: 'Queries';
  activeSystemNotification?: Maybe<SystemNotificationModel>;
  attachments?: Maybe<PagingResultModelOfAttachmentModel>;
  auditHistoryForEntity?: Maybe<Array<Maybe<AuditRecordModel>>>;
  auditRecords?: Maybe<PagingResultModelOfAuditRecordModel>;
  billingItems?: Maybe<PagingResultModelOfBillingItemModel>;
  billings?: Maybe<PagingResultModelOfBillingModel>;
  businessAreas?: Maybe<PagingResultModelOfBusinessAreaModel>;
  clientAkas?: Maybe<PagingResultModelOfClientAkaModel>;
  clientBillingAggregates?: Maybe<PagingResultModelOfBillingAggregatesModel>;
  clientNotificationRecipients?: Maybe<PagingResultModelOfClientNotificationRecipientsModel>;
  clientPartnerTransactionAliases?: Maybe<PagingResultModelOfClientPartnerTransactionAliasModel>;
  clientPartnerTransactionMaps?: Maybe<PagingResultModelOfClientPartnerTransactionMapModel>;
  clientPartnerTransactionPostProcessings?: Maybe<PagingResultModelOfClientPartnerTransactionPostProcessingModel>;
  clientPartnerTransactionSchemas?: Maybe<PagingResultModelOfClientPartnerTransactionSchemaModel>;
  clientPartnerTransactions?: Maybe<PagingResultModelOfClientPartnerTransactionModel>;
  clientPartners?: Maybe<PagingResultModelOfClientPartnerModel>;
  clientPortalUsers?: Maybe<Array<Maybe<ClientPortalUserModel>>>;
  clientTransactions?: Maybe<PagingResultModelOfClientTransactionModel>;
  clients?: Maybe<PagingResultModelOfClientModel>;
  clientsNotificationsNoRecipients?: Maybe<PagingResultModelOfClientModel>;
  configurations?: Maybe<PagingResultModelOfConfigurationModel>;
  counters?: Maybe<PagingResultModelOfCounterModel>;
  crossReferences?: Maybe<PagingResultModelOfCrossReferenceModel>;
  currencies?: Maybe<PagingResultModelOfCurrencyModel>;
  dashboardCounts?: Maybe<DashboardModel>;
  dataLakeFailedFiles?: Maybe<Array<Maybe<DataLakeFileModel>>>;
  dataLakeFileDirectories?: Maybe<DataLakeDirectoryListPayload>;
  dataLakeFiles?: Maybe<Array<Maybe<DataLakeFileModel>>>;
  dataLakeFilesAndSubDirectories?: Maybe<DataLakeDirectoryModel>;
  dataLakeFilesSearch?: Maybe<Array<Maybe<DataLakeFileModel>>>;
  documentArchive?: Maybe<DocumentArchiveModel>;
  documentArchives?: Maybe<PagingResultModelOfDocumentArchiveModel>;
  ediStandards?: Maybe<PagingResultModelOfEdiStandardModel>;
  erpProducts?: Maybe<PagingResultModelOfErpProductModel>;
  erpTransactionSchemas?: Maybe<PagingResultModelOfErpTransactionSchemaModel>;
  favorites?: Maybe<Array<Maybe<FavoriteModel>>>;
  isaQualifiers?: Maybe<PagingResultModelOfIsaQualifierModel>;
  locales?: Maybe<PagingResultModelOfLocaleModel>;
  messagingLogs?: Maybe<PagingResultModelOfMessagingLogModel>;
  notificationFormatterTransactions?: Maybe<PagingResultModelOfNotificationFormatterTransactionModel>;
  notificationFormatters?: Maybe<PagingResultModelOfNotificationFormatterModel>;
  partnerAkas?: Maybe<PagingResultModelOfPartnerAkaModel>;
  partnerNotificationRecipients?: Maybe<PagingResultModelOfPartnerNotificationRecipientsModel>;
  partnerTransactionSchemas?: Maybe<PagingResultModelOfPartnerTransactionSchemaModel>;
  partnerTransactions?: Maybe<PagingResultModelOfPartnerTransactionModel>;
  partners?: Maybe<PagingResultModelOfPartnerModel>;
  phoneTypes?: Maybe<PagingResultModelOfPhoneTypeModel>;
  pipelineItemClassNames?: Maybe<PagingResultModelOfPipelineItemClassNameModel>;
  pipelines?: Maybe<PagingResultModelOfPipelineModel>;
  portalTransactions?: Maybe<PagingResultModelOfPortalTransactionModel>;
  postProcessingBlobs?: Maybe<PagingResultModelOfPostProcessingBlobModel>;
  pricings?: Maybe<PagingResultModelOfPricingModel>;
  recents?: Maybe<Array<Maybe<RecentModel>>>;
  standardExchangeFormatStorageFiles?: Maybe<PagingResultModelOfBlobStorageModel>;
  standardExchangeFormats?: Maybe<PagingResultModelOfStandardExchangeFormatModel>;
  states?: Maybe<PagingResultModelOfStateModel>;
  systemConfiguration?: Maybe<SystemConfigurationModel>;
  systemNotifications?: Maybe<Array<Maybe<SystemNotificationModel>>>;
  transactionErrorCategories?: Maybe<PagingResultModelOfTransactionErrorCategoryModel>;
  transactionErrors?: Maybe<PagingResultModelOfTransactionErrorModel>;
  transactionMapPartners?: Maybe<PagingResultModelOfTransactionMapPartnerModel>;
  transactionMaps?: Maybe<PagingResultModelOfTransactionMapModel>;
  transactions?: Maybe<PagingResultModelOfTransactionModel>;
  user?: Maybe<UserModel>;
  users?: Maybe<PagingResultModelOfUserModel>;
};


export type QueriesAttachmentsArgs = {
  input: GetAttachmentInput;
};


export type QueriesAuditHistoryForEntityArgs = {
  entityId?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
};


export type QueriesAuditRecordsArgs = {
  input: GetAuditRecordsInput;
};


export type QueriesBillingItemsArgs = {
  input: GetBillingItemsInput;
};


export type QueriesBillingsArgs = {
  input: GetBillingsInput;
  order?: InputMaybe<Array<PagingResultModelOfBillingModelSortInput>>;
};


export type QueriesBusinessAreasArgs = {
  input?: InputMaybe<GetBusinessAreaInput>;
};


export type QueriesClientAkasArgs = {
  input?: InputMaybe<GetClientAkaInput>;
};


export type QueriesClientBillingAggregatesArgs = {
  input: GetBillingAggregatesInput;
};


export type QueriesClientNotificationRecipientsArgs = {
  input?: InputMaybe<GetClientNotificationRecipientsInput>;
};


export type QueriesClientPartnerTransactionAliasesArgs = {
  input?: InputMaybe<GetClientPartnerTransactionAliasInput>;
};


export type QueriesClientPartnerTransactionMapsArgs = {
  input: GetClientPartnerTransactionMapInput;
};


export type QueriesClientPartnerTransactionPostProcessingsArgs = {
  input: GetClientPartnerTransactionPostProcessingInput;
};


export type QueriesClientPartnerTransactionSchemasArgs = {
  input: GetClientPartnerTransactionSchemaInput;
};


export type QueriesClientPartnerTransactionsArgs = {
  input: GetClientPartnerTransactionsInput;
};


export type QueriesClientPartnersArgs = {
  input: GetClientPartnersInput;
};


export type QueriesClientPortalUsersArgs = {
  input: GetPortalUsersInput;
};


export type QueriesClientTransactionsArgs = {
  input: GetClientTransactionsInput;
};


export type QueriesClientsArgs = {
  input: GetClientsInput;
};


export type QueriesConfigurationsArgs = {
  input: GetConfigurationsInput;
};


export type QueriesCountersArgs = {
  input: GetCounterInput;
};


export type QueriesCrossReferencesArgs = {
  input: GetCrossReferenceInput;
};


export type QueriesDashboardCountsArgs = {
  input: GetDashboardCountsInput;
};


export type QueriesDataLakeFileDirectoriesArgs = {
  input: GetDataLakeFileInput;
};


export type QueriesDataLakeFilesArgs = {
  input: GetDataLakeFileInput;
};


export type QueriesDataLakeFilesAndSubDirectoriesArgs = {
  input: GetDataLakeFileInput;
};


export type QueriesDataLakeFilesSearchArgs = {
  input: GetDataLakeFileInput;
};


export type QueriesDocumentArchiveArgs = {
  input: GetDocumentArchiveInput;
};


export type QueriesDocumentArchivesArgs = {
  input: GetDocumentArchivesInput;
};


export type QueriesErpTransactionSchemasArgs = {
  input: GetErpTransactionSchemaInput;
};


export type QueriesFavoritesArgs = {
  input?: InputMaybe<GetFavoriteInput>;
};


export type QueriesMessagingLogsArgs = {
  input: GetMessagingLogsInput;
};


export type QueriesNotificationFormatterTransactionsArgs = {
  input: GetNotificationFormatterTransactionsInput;
};


export type QueriesNotificationFormattersArgs = {
  input?: InputMaybe<GetNotificationFormatterInput>;
};


export type QueriesPartnerAkasArgs = {
  input?: InputMaybe<GetPartnerAkaInput>;
};


export type QueriesPartnerNotificationRecipientsArgs = {
  input?: InputMaybe<GetPartnerNotificationRecipientsInput>;
};


export type QueriesPartnerTransactionSchemasArgs = {
  input: GetPartnerTransactionSchemaInput;
};


export type QueriesPartnerTransactionsArgs = {
  input: GetPartnerTransactionsInput;
};


export type QueriesPartnersArgs = {
  input: GetPartnersInput;
};


export type QueriesPhoneTypesArgs = {
  input: GetPhoneTypeInput;
};


export type QueriesPipelinesArgs = {
  input?: InputMaybe<GetPipelinesInput>;
};


export type QueriesPortalTransactionsArgs = {
  input: GetPortalTransactionsInput;
};


export type QueriesPostProcessingBlobsArgs = {
  input: GetPostProcessingBlobInput;
};


export type QueriesPricingsArgs = {
  input: GetPricingsInput;
};


export type QueriesRecentsArgs = {
  input?: InputMaybe<GetRecentInput>;
};


export type QueriesStandardExchangeFormatStorageFilesArgs = {
  input: GetStandardExchangeFormatInput;
};


export type QueriesStandardExchangeFormatsArgs = {
  input: GetStandardExchangeFormatInput;
};


export type QueriesStatesArgs = {
  input: GetStatesInput;
};


export type QueriesTransactionErrorsArgs = {
  input: GetTransactionErrorsInput;
};


export type QueriesTransactionMapPartnersArgs = {
  input: GetTransactionMapPartnerInput;
};


export type QueriesTransactionMapsArgs = {
  input: GetTransactionMapInput;
};


export type QueriesTransactionsArgs = {
  input: GetTransactionsInput;
};


export type QueriesUserArgs = {
  input: GetUserInput;
};


export type QueriesUsersArgs = {
  input: GetUsersInput;
};

export type RecentModel = {
  __typename?: 'RecentModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Id of the entity this recent item points to */
  entityId: Scalars['UUID'];
  /** The type of entity this recent item represents */
  entityType: EntityType;
  /** Id of this recent. */
  id: Scalars['UUID'];
  /** The date time the item was last edited by the user */
  lastEdited?: Maybe<Scalars['DateTime']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** The date time the item was last viewed by the user */
  lastViewed: Scalars['DateTime'];
  /** The display name of the entity recently viewed */
  name: Scalars['String'];
};

export enum RequestResult {
  Fail = 'FAIL',
  Success = 'SUCCESS'
}

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StandardExchangeFormatModel = {
  __typename?: 'StandardExchangeFormatModel';
  /** Blob document id of the sef file. */
  blobDocumentId: Scalars['UUID'];
  /** Blob Storage Reference. */
  blobStorageReferences?: Maybe<Array<Maybe<BlobStorageReferenceModel>>>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** User name that has created the record. */
  createdByName?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Id of the sef file. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** User name that has last modified the record. */
  lastModifiedByName?: Maybe<Scalars['String']>;
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
};

export type StandardExchangeFormatOrderByInput = {
  fileName?: InputMaybe<OrderDirection>;
  lastModifiedTime?: InputMaybe<OrderDirection>;
};

export type StateModel = {
  __typename?: 'StateModel';
  /** Country to which the State belongs */
  country?: Maybe<CountryModel>;
  /** Country Code of the Country to which the State belongs */
  countryCode?: Maybe<Scalars['String']>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the State */
  description?: Maybe<Scalars['String']>;
  /** Id of the State */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** State Code of the State. */
  stateCode?: Maybe<Scalars['String']>;
};

export type StateOrderByInput = {
  countryCode?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  stateCode?: InputMaybe<OrderDirection>;
};

export type SystemConfigurationModel = {
  __typename?: 'SystemConfigurationModel';
  /** Comma-separated string of Billing Recipient Emails of the System Configuration. */
  billingRecipientsEmail?: Maybe<Scalars['String']>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Comma-separated string of EDI Direct Recipient Emails of the System Configuration. */
  ediDirectRecipientsEmail?: Maybe<Scalars['String']>;
  /** Comma-separated string of Error Recipient Emails of the System Configuration. */
  errorRecipientsEmail?: Maybe<Scalars['String']>;
  /** Id of the System Configuration. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
};

export enum SystemNotificationEnvironment {
  Edi = 'EDI',
  EdiPortal = 'EDI_PORTAL'
}

export type SystemNotificationModel = {
  __typename?: 'SystemNotificationModel';
  /** End Date of the current notification */
  dateEnd?: Maybe<Scalars['DateTime']>;
  /** Start Date of the current notification */
  dateStart?: Maybe<Scalars['DateTime']>;
  /** Environment of the System Notification. */
  environment?: Maybe<SystemNotificationEnvironment>;
  /** Id of the System Notification. */
  id: Scalars['UUID'];
  /** Message of the System Notification. */
  message?: Maybe<Scalars['String']>;
  /** Severity Type of the System Notification. */
  notificationType?: Maybe<SystemNotificationType>;
};

export enum SystemNotificationType {
  Alert = 'ALERT',
  Information = 'INFORMATION',
  Warning = 'WARNING'
}

export enum TotalSizeType {
  Byte = 'BYTE',
  None = 'NONE'
}

export enum TransactionDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type TransactionErrorCategoryModel = {
  __typename?: 'TransactionErrorCategoryModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** User name that has created the record. */
  createdByName?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Category. */
  description?: Maybe<Scalars['String']>;
  /** Id of the Category. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** User name that has last modified the record. */
  lastModifiedByName?: Maybe<Scalars['String']>;
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Name of the Category. */
  name: Scalars['String'];
};

export type TransactionErrorModel = {
  __typename?: 'TransactionErrorModel';
  /** Category of the Transaction Error. */
  category?: Maybe<TransactionErrorCategoryModel>;
  /** CategoryId of the Transaction Error. */
  categoryId?: Maybe<Scalars['UUID']>;
  /** Client of the Transaction Error. */
  client?: Maybe<ClientModel>;
  /** ClientId of the Transaction Error. */
  clientId?: Maybe<Scalars['UUID']>;
  /** ClientPartner of the Transaction Error. */
  clientPartner?: Maybe<ClientPartnerModel>;
  /** ClientTenantId of the Transaction Error. */
  clientTenantId?: Maybe<Scalars['UUID']>;
  /** Creation time of the Transaction Error. */
  createdTime?: Maybe<Scalars['DateTime']>;
  /** Description of the Transaction Error. */
  description?: Maybe<Scalars['String']>;
  /** Document Id of the Transaction Error. */
  documentId?: Maybe<Scalars['String']>;
  /** Document Reference Id of the Transaction Error. */
  documentReferenceId?: Maybe<Scalars['String']>;
  /** Document Transaction Id of the Transaction Error. */
  documentTransactionId?: Maybe<Scalars['String']>;
  /** Id of the Transaction Error. */
  id: Scalars['UUID'];
  /** Internal Transaction Id of the Transaction Error. */
  internalTransactionId?: Maybe<Scalars['String']>;
  /** Message Type of the Transaction Error. */
  messageType?: Maybe<MessageType>;
  /** Note info of the Transaction Error. */
  notes?: Maybe<Array<Maybe<NoteModel>>>;
  /** Original file name of the Transaction Error. */
  originalFileName?: Maybe<Scalars['String']>;
  /** Partner of the Transaction Error. */
  partner?: Maybe<PartnerModel>;
  /** PartnerId of the Transaction Error. */
  partnerId?: Maybe<Scalars['UUID']>;
  /** Process Name of the Transaction Error. */
  processName?: Maybe<ProcessName>;
  /** Purchase Order Number of the Transaction Error. */
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  /** Raw Message of the Transaction Error. */
  rawMessage?: Maybe<Scalars['String']>;
  /** User that resolved the Transaction Error. */
  resolvedBy?: Maybe<Scalars['UUID']>;
  /** Name of the User that resolved the Transaction Error. */
  resolvedByName?: Maybe<Scalars['String']>;
  /** Resolved time of the Transaction Error. */
  resolvedTime?: Maybe<Scalars['DateTime']>;
  /** Status of the Exception of the Transaction Error. */
  status?: Maybe<ExceptionStatus>;
  /** Transaction of the Transaction Error. */
  transaction?: Maybe<TransactionModel>;
  /** TransactionId of the Transaction Error. */
  transactionId?: Maybe<Scalars['UUID']>;
};

export type TransactionErrorOrderByInput = {
  clientTenantId?: InputMaybe<OrderDirection>;
  createdTime?: InputMaybe<OrderDirection>;
  documentId?: InputMaybe<OrderDirection>;
  documentReferenceId?: InputMaybe<OrderDirection>;
  purchaseOrderNumber?: InputMaybe<OrderDirection>;
};

export type TransactionMapModel = {
  __typename?: 'TransactionMapModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** User name that has created the record. */
  createdByName?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the Transaction Map. */
  description: Scalars['String'];
  /** DestinationPath of the Transaction Map. */
  destinationPath?: Maybe<Scalars['String']>;
  documentString?: Maybe<Scalars['String']>;
  /** Id of the Transaction Map. */
  id: Scalars['UUID'];
  /** Identifies if Transaction Map is deployed. */
  isMapDeployed: Scalars['Boolean'];
  /** Identifies if Transaction Map is loaded. */
  isMapLoaded: Scalars['Boolean'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** User name that has last modified the record. */
  lastModifiedByName?: Maybe<Scalars['String']>;
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Source file name of the Transaction Map. */
  sourceFileName?: Maybe<Scalars['String']>;
  /** Version of the Transaction Map. */
  standardVersion?: Maybe<Scalars['String']>;
  /** Number of partners for the Transaction Map */
  totalPartners?: Maybe<Scalars['Int']>;
  /** Transaction of the Transaction Map */
  transaction?: Maybe<TransactionModel>;
  /** Id of the Transaction Map Transaction. */
  transactionId: Scalars['UUID'];
};

export type TransactionMapOrderByInput = {
  description?: InputMaybe<OrderDirection>;
};

export type TransactionMapPartnerModel = {
  __typename?: 'TransactionMapPartnerModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Id of the Transaction Map Partner. */
  id: Scalars['UUID'];
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Partner of the Transaction Map Partner */
  partner?: Maybe<PartnerModel>;
  /** Partner id of the Transaction Map Partner. */
  partnerId?: Maybe<Scalars['UUID']>;
  /** Transaction Map of the Transaction Map Partner */
  transactionMap?: Maybe<TransactionMapModel>;
  /** Transaction Map id of the Transaction Map Partner. */
  transactionMapId: Scalars['UUID'];
};

export type TransactionModel = {
  __typename?: 'TransactionModel';
  /** Billable factore of the transaction. */
  billableFactor?: Maybe<Scalars['Decimal']>;
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  createdByName?: Maybe<Scalars['String']>;
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Description of the transaction */
  description?: Maybe<Scalars['String']>;
  /** Whether an Inbound or Outbound Transaction */
  direction?: Maybe<TransactionDirection>;
  /** Display schema for Document Transformation */
  documentTransformationSchema?: Maybe<Scalars['String']>;
  /** EDI Standard related to the transaction */
  ediStandard?: Maybe<EdiStandardModel>;
  /** EDI Standard Id of the transaction */
  ediStandardId?: Maybe<Scalars['UUID']>;
  /** Id of the transaction */
  id: Scalars['UUID'];
  /** If the transaction is Active. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** If the transaction is billable. */
  isBillable?: Maybe<Scalars['Boolean']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  lastModifiedByName?: Maybe<Scalars['String']>;
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Name of transaction */
  name: Scalars['String'];
  /** Normalized Document Type, INVOICE, PO, SHIPMENT */
  normalizedDocumentType?: Maybe<NormalizedDocumentType>;
  /** If the transaction should skip target document creation */
  skipTargetDocumentCreation?: Maybe<Scalars['Boolean']>;
  /** Transaction Maps of the Transaction */
  transactionMaps?: Maybe<Array<Maybe<TransactionMapModel>>>;
  /** Transaction XPath of the Transaction */
  transactionXPath?: Maybe<TransactionXPathModel>;
};

export type TransactionXPathModel = {
  __typename?: 'TransactionXPathModel';
  createdBy: Scalars['String'];
  createdTime: Scalars['DateTime'];
  id: Scalars['String'];
  lastModifiedBy: Scalars['String'];
  lastModifiedTime: Scalars['DateTime'];
  transactionId: Scalars['String'];
  xPathJson?: Maybe<Scalars['String']>;
};

export type UpdateBlobStorageInput = {
  blobStorageId: Scalars['String'];
};

export type UpdateBlobStoragePayload = {
  __typename?: 'UpdateBlobStoragePayload';
  blobStorageId?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpdateClientPartnerInput = {
  clientPartnerId: Scalars['String'];
  currentFileGenerationNumber?: InputMaybe<Scalars['Int']>;
  defaultCurrencyCode?: InputMaybe<Scalars['String']>;
  fileGenerationNumberID?: InputMaybe<Scalars['String']>;
  maxFileGenerationNumber?: InputMaybe<Scalars['Int']>;
};

export type UpdateClientPartnerPayload = {
  __typename?: 'UpdateClientPartnerPayload';
  clientPartnerId?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpdateClientPartnerTransactionInput = {
  destinationPath?: InputMaybe<Scalars['String']>;
  effectivePartnerInterchangeId?: InputMaybe<Scalars['String']>;
  functionalReconciliationMode: FunctionalReconciliationMode;
  id: Scalars['String'];
  isPipelineInherited?: InputMaybe<Scalars['Boolean']>;
  outboundAcknowledgementOption?: InputMaybe<OutboundAcknowledgementType>;
  pipelineId?: InputMaybe<Scalars['String']>;
  skipTargetDocumentCreation?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateClientPartnerTransactionPayload = {
  __typename?: 'UpdateClientPartnerTransactionPayload';
  clientPartnerTransaction?: Maybe<ClientPartnerTransactionModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpdateDocumentArchivesInput = {
  documentArchiveIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  noteHeader?: InputMaybe<Scalars['String']>;
};

export type UpdateDocumentArchivesPayload = {
  __typename?: 'UpdateDocumentArchivesPayload';
  documentArchiveIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpdatePartnerTransactionInput = {
  functionalReconciliationMode: FunctionalReconciliationMode;
  id: Scalars['String'];
  notificationFormatterId?: InputMaybe<Scalars['String']>;
  outboundAcknowledgementOption?: InputMaybe<OutboundAcknowledgementType>;
  pipelineId?: InputMaybe<Scalars['String']>;
};

export type UpdatePartnerTransactionsPayload = {
  __typename?: 'UpdatePartnerTransactionsPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  partnerTransaction?: Maybe<PartnerTransactionModel>;
  result: RequestResult;
};

export type UpdateTransactionErrorCategoryInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  transactionErrorId: Scalars['String'];
};

export type UpdateTransactionErrorCategoryPayload = {
  __typename?: 'UpdateTransactionErrorCategoryPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionErrorId?: Maybe<Scalars['UUID']>;
};

export type UpdateTransactionErrorsInput = {
  errorCategoryId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  noteHeader?: InputMaybe<Scalars['String']>;
  status: ExceptionStatus;
  transactionErrorIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateTransactionErrorsPayload = {
  __typename?: 'UpdateTransactionErrorsPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionErrors?: Maybe<Array<Maybe<TransactionErrorModel>>>;
};

export type UploadTransactionMapToAzureFilesInput = {
  id: Scalars['String'];
};

export type UploadTransactionMapToAzureFilesPayload = {
  __typename?: 'UploadTransactionMapToAzureFilesPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionMapId?: Maybe<Scalars['UUID']>;
};

export type UpsertAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressLine3?: InputMaybe<Scalars['String']>;
  addressLine4?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  postalCode?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
};

export type UpsertAttachmentInput = {
  attachmentString?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fileLastModifiedTime?: InputMaybe<Scalars['DateTime']>;
  fileName?: InputMaybe<Scalars['String']>;
  isLink: Scalars['Boolean'];
  mimeType?: InputMaybe<Scalars['String']>;
};

export type UpsertBillingInput = {
  /** Currency Code of the Billing. */
  currencyCode: Scalars['String'];
  /** Description of the Billing */
  description?: InputMaybe<Scalars['String']>;
  /** Id of the Blling. */
  id?: InputMaybe<Scalars['UUID']>;
};

export type UpsertBillingItemInput = {
  billingId: Scalars['String'];
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  pricingId: Scalars['String'];
};

export type UpsertBillingItemPayload = {
  __typename?: 'UpsertBillingItemPayload';
  billingItem?: Maybe<BillingItemModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertBillingPayload = {
  __typename?: 'UpsertBillingPayload';
  billing?: Maybe<BillingModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertBusinessAreaInput = {
  /** Description of the Business Area */
  description?: InputMaybe<Scalars['String']>;
  /** Id of the Business Area */
  id?: InputMaybe<Scalars['UUID']>;
  /** Name of the Business Area */
  name?: InputMaybe<Scalars['String']>;
};

export type UpsertBusinessAreaPayload = {
  __typename?: 'UpsertBusinessAreaPayload';
  businessArea?: Maybe<BusinessAreaModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertClientAkaInput = {
  clientCode?: InputMaybe<Scalars['String']>;
  clientId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isaQualifierCode?: InputMaybe<Scalars['String']>;
};

export type UpsertClientAkaPayload = {
  __typename?: 'UpsertClientAkaPayload';
  clientAKA?: Maybe<ClientAkaModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertClientAttachmentInput = {
  attachments?: InputMaybe<Array<InputMaybe<UpsertAttachmentInput>>>;
  clientId: Scalars['String'];
};

export type UpsertClientAttachmentPayload = {
  __typename?: 'UpsertClientAttachmentPayload';
  clientAttachmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertClientContactInput = {
  addresses?: InputMaybe<Array<InputMaybe<UpsertAddressInput>>>;
  clientId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<InputMaybe<UpsertEmailInput>>>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<InputMaybe<UpsertPhoneInput>>>;
};

export type UpsertClientContactPayload = {
  __typename?: 'UpsertClientContactPayload';
  clientContact?: Maybe<ClientContactModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertClientInput = {
  addresses?: InputMaybe<Array<InputMaybe<UpsertAddressInput>>>;
  billingId?: InputMaybe<Scalars['String']>;
  billingStartDate?: InputMaybe<Scalars['DateTime']>;
  bulkNotificationTime?: InputMaybe<Scalars['DateTime']>;
  businessAreaId?: InputMaybe<Scalars['String']>;
  clientCode?: InputMaybe<Scalars['String']>;
  defaultCurrencyCode?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<InputMaybe<UpsertEmailInput>>>;
  erpDocumentFormat?: InputMaybe<ErpDocumentFormat>;
  erpProductId?: InputMaybe<Scalars['String']>;
  errorFormatterId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalClientCode?: InputMaybe<Scalars['String']>;
  isaQualifierCode?: InputMaybe<Scalars['String']>;
  localeCode?: InputMaybe<Scalars['String']>;
  missingAcknowledgementNotificationMode?: InputMaybe<MissingAcknowledgementNotificationMode>;
  name?: InputMaybe<Scalars['String']>;
  notificationFormatterId?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<InputMaybe<UpsertPhoneInput>>>;
  primaryClientId?: InputMaybe<Scalars['String']>;
  salesForceCountryCode?: InputMaybe<Scalars['String']>;
  salesForceCustomerNumber?: InputMaybe<Scalars['String']>;
  salesForceEntityCode?: InputMaybe<Scalars['String']>;
  statusCode?: InputMaybe<ClientStatus>;
  tenantId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpsertClientNotificationRecipientsInput = {
  clientId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  notificationType: NotificationType;
  receivesErrors?: InputMaybe<Scalars['Boolean']>;
  receivesNotifications?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Scalars['String']>;
};

export type UpsertClientNotificationRecipientsPayload = {
  __typename?: 'UpsertClientNotificationRecipientsPayload';
  clientNotificationRecipients?: Maybe<ClientNotificationRecipientsModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertClientPartnerAttachmentInput = {
  attachments?: InputMaybe<Array<InputMaybe<UpsertAttachmentInput>>>;
  clientPartnerId: Scalars['String'];
};

export type UpsertClientPartnerAttachmentPayload = {
  __typename?: 'UpsertClientPartnerAttachmentPayload';
  clientPartnerAttachmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertClientPartnerTransactionAliasInput = {
  alias?: InputMaybe<Scalars['String']>;
  clientPartnerTransactionId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};

export type UpsertClientPartnerTransactionAliasPayload = {
  __typename?: 'UpsertClientPartnerTransactionAliasPayload';
  clientPartnerTransactionAlias?: Maybe<ClientPartnerTransactionAliasModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertClientPartnerTransactionMapInput = {
  clientPartnerTransactionId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  transactionMapId: Scalars['String'];
};

export type UpsertClientPartnerTransactionMapPayload = {
  __typename?: 'UpsertClientPartnerTransactionMapPayload';
  clientPartnerTransactionMapId?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertClientPartnerTransactionPipelineInput = {
  clientPartnerTransactionId: Scalars['String'];
  pipelineId: Scalars['String'];
};

export type UpsertClientPartnerTransactionPipelinePayload = {
  __typename?: 'UpsertClientPartnerTransactionPipelinePayload';
  clientPartnerTransactionId?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  pipelineId?: Maybe<Scalars['UUID']>;
  result: RequestResult;
};

export type UpsertClientPartnerTransactionPostProcessingInput = {
  clientPartnerTransactionId: Scalars['String'];
  ediProcessName?: InputMaybe<ProcessName>;
  id?: InputMaybe<Scalars['String']>;
  postProcessingBlobId: Scalars['String'];
  processArguments?: InputMaybe<Scalars['String']>;
  processName?: InputMaybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
};

export type UpsertClientPartnerTransactionPostProcessingPayload = {
  __typename?: 'UpsertClientPartnerTransactionPostProcessingPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionPostProcessingId?: Maybe<Scalars['UUID']>;
};

export type UpsertClientPartnerTransactionSchemaInput = {
  clientPartnerTransactionId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  partnerTransactionSchemaId: Scalars['String'];
};

export type UpsertClientPartnerTransactionSchemaPayload = {
  __typename?: 'UpsertClientPartnerTransactionSchemaPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionSchemaId?: Maybe<Scalars['UUID']>;
};

export type UpsertClientPayload = {
  __typename?: 'UpsertClientPayload';
  client?: Maybe<ClientModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertClientTransactionInput = {
  bulkNotify?: InputMaybe<Scalars['Boolean']>;
  clientId: Scalars['String'];
  erpTransactionSchemaId?: InputMaybe<Scalars['String']>;
  fileNamePattern?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  notificationFormatterId?: InputMaybe<Scalars['String']>;
  notify?: InputMaybe<Scalars['Boolean']>;
  pipelineId?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};

export type UpsertClientTransactionPayload = {
  __typename?: 'UpsertClientTransactionPayload';
  clientTransaction?: Maybe<ClientTransactionModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertConfigurationInput = {
  channelId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  destPath?: InputMaybe<Scalars['String']>;
  ediProcess?: InputMaybe<Scalars['String']>;
  executionMode?: InputMaybe<Scalars['String']>;
  extension?: InputMaybe<Scalars['String']>;
  homeDirectory?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  p1?: InputMaybe<Scalars['String']>;
  p2?: InputMaybe<Scalars['String']>;
  p3?: InputMaybe<Scalars['String']>;
  p4?: InputMaybe<Scalars['String']>;
  p5?: InputMaybe<Scalars['String']>;
  p6?: InputMaybe<Scalars['String']>;
  pid?: InputMaybe<Scalars['Int']>;
  tpgClient?: InputMaybe<Scalars['String']>;
  watcherPath?: InputMaybe<Scalars['String']>;
};

export type UpsertConfigurationPayload = {
  __typename?: 'UpsertConfigurationPayload';
  configuration?: Maybe<ConfigurationModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertCounterInput = {
  comments?: InputMaybe<Scalars['String']>;
  controlNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  machine?: InputMaybe<Scalars['String']>;
  segment?: InputMaybe<CounterSegmentType>;
  senderId?: InputMaybe<Scalars['String']>;
};

export type UpsertCounterPayload = {
  __typename?: 'UpsertCounterPayload';
  counter?: Maybe<CounterModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertCrossReferenceInput = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  val?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type UpsertCrossReferencePayload = {
  __typename?: 'UpsertCrossReferencePayload';
  crossReference?: Maybe<CrossReferenceModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertCurrencyInput = {
  /** Currency Code of the Currency. */
  currencyCode: Scalars['String'];
  /** Description of the Currency */
  description: Scalars['String'];
};

export type UpsertCurrencyPayload = {
  __typename?: 'UpsertCurrencyPayload';
  currency?: Maybe<CurrencyModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertEdiStandardInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpsertEdiStandardPayload = {
  __typename?: 'UpsertEdiStandardPayload';
  ediStandard?: Maybe<EdiStandardModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertEdiXmlConfigInput = {
  clientId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  documentString?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type UpsertEdiXmlConfigPayload = {
  __typename?: 'UpsertEdiXmlConfigPayload';
  clientId?: Maybe<Scalars['UUID']>;
  ediXmlConfigId?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertEmailInput = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
};

export type UpsertEntityArgumentsInput = {
  propertyName?: InputMaybe<Scalars['String']>;
  propertyValue?: InputMaybe<Scalars['String']>;
};

export type UpsertEntityInput = {
  entityName?: InputMaybe<Scalars['String']>;
  upsertArguments?: InputMaybe<Array<InputMaybe<UpsertEntityArgumentsInput>>>;
};

export type UpsertEntityPayload = {
  __typename?: 'UpsertEntityPayload';
  entityName?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertErpProductInput = {
  /** Description of the Erp Product */
  description: Scalars['String'];
  /** Id of the Erp Product */
  id?: InputMaybe<Scalars['UUID']>;
  /** If the Erp Product belongs to Aptean or not. */
  isAptean: Scalars['Boolean'];
  /** Name of the Erp Product */
  name: Scalars['String'];
};

export type UpsertErpProductPayload = {
  __typename?: 'UpsertErpProductPayload';
  erpProduct?: Maybe<ErpProductModel>;
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertErpTransactionSchemaInput = {
  description?: InputMaybe<Scalars['String']>;
  documentString?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sourceFileName?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};

export type UpsertErpTransactionSchemaPayload = {
  __typename?: 'UpsertErpTransactionSchemaPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionSchemaId?: Maybe<Scalars['UUID']>;
};

export type UpsertFavoriteInput = {
  /** Entity Id of the entity this favorite item points to */
  entityId: Scalars['UUID'];
  /** The type of entity this favorite item represents */
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']>;
  /** Flag to track whether being added or removed from favorites */
  isFavorite: Scalars['Boolean'];
  /** The display name of the entity this favorite item points to */
  name: Scalars['String'];
};

export type UpsertFavoritePayload = {
  __typename?: 'UpsertFavoritePayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  favorite?: Maybe<FavoriteModel>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
};

export type UpsertNoteInput = {
  header?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
};

export type UpsertNotePayload = {
  __typename?: 'UpsertNotePayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  note?: Maybe<NoteModel>;
  result: RequestResult;
};

export type UpsertNotificationFormatterInput = {
  asAttachment?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
  bodyType?: InputMaybe<NotificationFormatterBodyType>;
  description?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  formatterType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isForError?: InputMaybe<Scalars['Boolean']>;
  preprocessorType?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<NotificationSourceType>;
  subject?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  watcherPath?: InputMaybe<Scalars['String']>;
};

export type UpsertNotificationFormatterPayload = {
  __typename?: 'UpsertNotificationFormatterPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  notificationFormatter?: Maybe<NotificationFormatterModel>;
  result: RequestResult;
};

export type UpsertPartnerAkaInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isaQualifierCode?: InputMaybe<Scalars['String']>;
  partnerCode?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['String'];
};

export type UpsertPartnerAkaPayload = {
  __typename?: 'UpsertPartnerAkaPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  partnerAKA?: Maybe<PartnerAkaModel>;
  result: RequestResult;
};

export type UpsertPartnerAttachmentInput = {
  attachments?: InputMaybe<Array<InputMaybe<UpsertAttachmentInput>>>;
  partnerId: Scalars['String'];
};

export type UpsertPartnerAttachmentPayload = {
  __typename?: 'UpsertPartnerAttachmentPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  partnerAttachmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  result: RequestResult;
};

export type UpsertPartnerContactInput = {
  addresses?: InputMaybe<Array<InputMaybe<UpsertAddressInput>>>;
  description?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<InputMaybe<UpsertEmailInput>>>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['String'];
  phones?: InputMaybe<Array<InputMaybe<UpsertPhoneInput>>>;
};

export type UpsertPartnerContactPayload = {
  __typename?: 'UpsertPartnerContactPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  partnerContact?: Maybe<PartnerContactModel>;
  result: RequestResult;
};

export type UpsertPartnerInput = {
  addresses?: InputMaybe<Array<InputMaybe<UpsertAddressInput>>>;
  businessAreaId?: InputMaybe<Scalars['String']>;
  ediStandardIds?: InputMaybe<Array<Scalars['String']>>;
  emails?: InputMaybe<Array<InputMaybe<UpsertEmailInput>>>;
  functionalReconciliationMode: FunctionalReconciliationMode;
  id?: InputMaybe<Scalars['String']>;
  internalPartnerCode?: InputMaybe<Scalars['String']>;
  isaQualifierCode?: InputMaybe<Scalars['String']>;
  localeCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notificationFormatterId?: InputMaybe<Scalars['String']>;
  partnerCode?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<InputMaybe<UpsertPhoneInput>>>;
  statusCode?: PartnerStatus;
  website?: InputMaybe<Scalars['String']>;
};

export type UpsertPartnerNotificationRecipientsInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  notificationType: NotificationType;
  partnerId: Scalars['String'];
  receivesErrors?: InputMaybe<Scalars['Boolean']>;
  receivesNotifications?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Scalars['String']>;
};

export type UpsertPartnerNotificationRecipientsPayload = {
  __typename?: 'UpsertPartnerNotificationRecipientsPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  partnerNotificationRecipients?: Maybe<PartnerNotificationRecipientsModel>;
  result: RequestResult;
};

export type UpsertPartnerPayload = {
  __typename?: 'UpsertPartnerPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  partner?: Maybe<PartnerModel>;
  result: RequestResult;
};

export type UpsertPartnerTransactionSchemaInput = {
  description?: InputMaybe<Scalars['String']>;
  documentString?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  partnerTransactionId: Scalars['String'];
  sourceFileName?: InputMaybe<Scalars['String']>;
  standardVersion?: InputMaybe<Scalars['String']>;
};

export type UpsertPartnerTransactionSchemaPayload = {
  __typename?: 'UpsertPartnerTransactionSchemaPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionSchemaId?: Maybe<Scalars['UUID']>;
};

export type UpsertPhoneInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneTypeCode?: InputMaybe<Scalars['String']>;
};

export type UpsertPipelineInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isLegacy?: InputMaybe<Scalars['Boolean']>;
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type UpsertPipelineItemInput = {
  configurationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  ediProcessClassName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  jsonArgs?: InputMaybe<Scalars['String']>;
  pipelineId: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type UpsertPipelineItemPayload = {
  __typename?: 'UpsertPipelineItemPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  pipelineItem?: Maybe<PipelineItemModel>;
  result: RequestResult;
};

export type UpsertPipelinePayload = {
  __typename?: 'UpsertPipelinePayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  pipeline?: Maybe<PipelineModel>;
  result: RequestResult;
};

export type UpsertPortalUserInput = {
  customerRole?: InputMaybe<UserRole>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  subscriptionRole?: InputMaybe<UserRole>;
  tenantId?: InputMaybe<Scalars['String']>;
};

export type UpsertPortalUserPayload = {
  __typename?: 'UpsertPortalUserPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  portalUser?: Maybe<PortalUserModel>;
  result: RequestResult;
};

export type UpsertPostProcessingBlobInput = {
  /** Description of the Post Processing Blob */
  description?: InputMaybe<Scalars['String']>;
  /** Id of the Post Processing Blob */
  id?: InputMaybe<Scalars['UUID']>;
  /** Name of the Post Processing Blob */
  processBlobString?: InputMaybe<Scalars['String']>;
};

export type UpsertPostProcessingBlobPayload = {
  __typename?: 'UpsertPostProcessingBlobPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  postProcessingBlob?: Maybe<PostProcessingBlobModel>;
  result: RequestResult;
};

export type UpsertPricingInput = {
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Description of the Pricing */
  description?: InputMaybe<Scalars['String']>;
  /** Id of the Pricing */
  id?: InputMaybe<Scalars['UUID']>;
  /** Minimum service fees of the Pricing */
  minServiceFees: Scalars['Decimal'];
};

export type UpsertPricingItemInput = {
  /** Description of the Pricing Item */
  description?: InputMaybe<Scalars['String']>;
  /** Fee Per Document of the Pricing Item */
  feePerDocument: Scalars['Decimal'];
  /** Fee Per Line of the Pricing Item */
  feePerLine: Scalars['Decimal'];
  /** Id of the Pricing Item */
  id?: InputMaybe<Scalars['UUID']>;
  /** Max Number Of Transactions of the Pricing Item */
  maxNumberOfTransactions: Scalars['Int'];
  /** Pricing Id of the Pricing Item */
  pricingId: Scalars['UUID'];
};

export type UpsertPricingItemPayload = {
  __typename?: 'UpsertPricingItemPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  pricingItem?: Maybe<PricingItemModel>;
  result: RequestResult;
};

export type UpsertPricingPayload = {
  __typename?: 'UpsertPricingPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  pricing?: Maybe<PricingModel>;
  result: RequestResult;
};

export type UpsertRecentInput = {
  /** Id of the entity this recent item points to */
  entityId: Scalars['UUID'];
  /** The type of entity this recent item represents */
  entityType: EntityType;
  /** The display name of the entity recently viewed */
  name: Scalars['String'];
};

export type UpsertRecentPayload = {
  __typename?: 'UpsertRecentPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  recent?: Maybe<RecentModel>;
  result: RequestResult;
};

export type UpsertSystemConfigurationInput = {
  billingRecipientsEmail?: InputMaybe<Scalars['String']>;
  ediDirectRecipientsEmail?: InputMaybe<Scalars['String']>;
  errorRecipientsEmail?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type UpsertSystemConfigurationPayload = {
  __typename?: 'UpsertSystemConfigurationPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  systemConfiguration?: Maybe<SystemConfigurationModel>;
};

export type UpsertSystemNotificationInput = {
  dateEnd?: InputMaybe<Scalars['DateTime']>;
  dateStart?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
};

export type UpsertSystemNotificationPayload = {
  __typename?: 'UpsertSystemNotificationPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  systemNotification?: Maybe<SystemNotificationModel>;
};

export type UpsertTransactionInput = {
  billableFactor: Scalars['Decimal'];
  /** Description of the transaction */
  description: Scalars['String'];
  /** Whether an Inbound or Outbound Transaction */
  direction?: InputMaybe<TransactionDirection>;
  /** Display schema for Document Transformation */
  documentTransformationSchema?: InputMaybe<Scalars['String']>;
  /** Edi Standard Id related to the transaction */
  ediStandardId: Scalars['UUID'];
  /** Id of the transaction */
  id?: InputMaybe<Scalars['UUID']>;
  /** If the transaction is Active. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** If the transaction is billable. */
  isBillable?: InputMaybe<Scalars['Boolean']>;
  /** Name of transaction */
  name: Scalars['String'];
  /** Normalized Document Type, INVOICE, PO, SHIPMENT */
  normalizedDocumentType?: InputMaybe<NormalizedDocumentType>;
  /** If the transaction should skip target document creation */
  skipTargetDocumentCreation?: InputMaybe<Scalars['Boolean']>;
};

export type UpsertTransactionMapInput = {
  description?: InputMaybe<Scalars['String']>;
  destinationPath?: InputMaybe<Scalars['String']>;
  documentString?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sourceFileName?: InputMaybe<Scalars['String']>;
  standardVersion?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};

export type UpsertTransactionMapPartnerInput = {
  id?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['String'];
  transactionMapId: Scalars['String'];
};

export type UpsertTransactionMapPartnerPayload = {
  __typename?: 'UpsertTransactionMapPartnerPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionMapPartnerId?: Maybe<Scalars['UUID']>;
};

export type UpsertTransactionMapPayload = {
  __typename?: 'UpsertTransactionMapPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionMapId?: Maybe<Scalars['UUID']>;
};

export type UpsertTransactionPayload = {
  __typename?: 'UpsertTransactionPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transaction?: Maybe<TransactionModel>;
};

export type UpsertTransactionXPathInput = {
  id?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
  xPathJson?: InputMaybe<Scalars['String']>;
};

export type UpsertTransactionXPathPayload = {
  __typename?: 'UpsertTransactionXPathPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  transactionXPath?: Maybe<TransactionXPathModel>;
};

export type UpsertUserInput = {
  /** Email of the user */
  email?: InputMaybe<Scalars['String']>;
  /** First name of the user */
  firstName: Scalars['String'];
  /** Id of the user */
  id?: InputMaybe<Scalars['UUID']>;
  /** Active status of the user */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Last name of the user */
  lastName: Scalars['String'];
  /** Role of the user */
  role: UserRole;
};

export type UpsertUserPayload = {
  __typename?: 'UpsertUserPayload';
  errors?: Maybe<Array<Maybe<ErrorModel>>>;
  isReactivated: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  result: RequestResult;
  user?: Maybe<UserModel>;
};

export type UserModel = {
  __typename?: 'UserModel';
  /** User that has created the record */
  createdBy: Scalars['UUID'];
  /** Creation time of the current record */
  createdTime: Scalars['DateTime'];
  /** Email address of the user */
  email: Scalars['String'];
  favorites?: Maybe<Array<Maybe<FavoriteModel>>>;
  /** First name of the user */
  firstName: Scalars['String'];
  /** Id of the user */
  id: Scalars['UUID'];
  /** Active status of the user */
  isActive?: Maybe<Scalars['Boolean']>;
  /** User that has last modified the record */
  lastModifiedBy: Scalars['UUID'];
  /** Last modification time of the record */
  lastModifiedTime: Scalars['DateTime'];
  /** Last name of the user */
  lastName: Scalars['String'];
  recents?: Maybe<Array<Maybe<RecentModel>>>;
  /** Role of the user */
  role: UserRole;
};

export type UserOrderByInput = {
  email?: InputMaybe<OrderDirection>;
  firstName?: InputMaybe<OrderDirection>;
  isActive?: InputMaybe<OrderDirection>;
  lastModifiedTime?: InputMaybe<OrderDirection>;
  lastName?: InputMaybe<OrderDirection>;
  role?: InputMaybe<OrderDirection>;
};

export enum UserRole {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  Primary = 'PRIMARY',
  Reader = 'READER',
  Unknown = 'UNKNOWN'
}

export type UpdateDocumentArchiveAcknowledgementStatusMutationVariables = Exact<{
  input: UpdateDocumentArchivesInput;
}>;


export type UpdateDocumentArchiveAcknowledgementStatusMutation = { __typename?: 'Mutations', updateDocumentArchiveAcknowledgementStatus?: { __typename?: 'UpdateDocumentArchivesPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type AddClientPartnerMutationVariables = Exact<{
  input: AddClientPartnerInput;
}>;


export type AddClientPartnerMutation = { __typename?: 'Mutations', addClientPartner?: { __typename?: 'AddClientPartnerPayload', message?: string | null, result: RequestResult, clientPartnerId?: any | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type AddClientPartnerTransactionsMutationVariables = Exact<{
  input: AddClientPartnerTransactionsInput;
}>;


export type AddClientPartnerTransactionsMutation = { __typename?: 'Mutations', addClientPartnerTransactions?: { __typename?: 'AddClientPartnerTransactionPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type AddNotificationFormatterTransactionsMutationVariables = Exact<{
  input: AddNotificationFormatterTransactionsInput;
}>;


export type AddNotificationFormatterTransactionsMutation = { __typename?: 'Mutations', addNotificationFormatterTransactions?: { __typename?: 'AddNotificationFormatterTransactionsPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type AddPartnerTransactionsMutationVariables = Exact<{
  input: AddPartnerTransactionsInput;
}>;


export type AddPartnerTransactionsMutation = { __typename?: 'Mutations', addPartnerTransactions?: { __typename?: 'AddPartnerTransactionsPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type ClonePipelineMutationVariables = Exact<{
  input: ClonePipelineInput;
}>;


export type ClonePipelineMutation = { __typename?: 'Mutations', clonePipeline?: { __typename?: 'ClonePipelinePayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, pipeline?: { __typename?: 'PipelineModel', id: any, description?: string | null, transaction?: { __typename?: 'TransactionModel', id: any, name: string, description?: string | null } | null } | null } | null };

export type ClonePricingMutationVariables = Exact<{
  input: ClonePricingInput;
}>;


export type ClonePricingMutation = { __typename?: 'Mutations', clonePricing?: { __typename?: 'ClonePricingPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, pricing?: { __typename?: 'PricingModel', id: any } | null } | null };

export type CreateDataLakeDirectoryMutationVariables = Exact<{
  input: DataLakeDirectoryCreateRequestInput;
}>;


export type CreateDataLakeDirectoryMutation = { __typename?: 'Mutations', createDataLakeDirectory?: { __typename?: 'ActionPayload', message?: string | null, result: RequestResult, data?: string | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type DeleteBusinessAreaMutationVariables = Exact<{
  input: DeleteBusinessAreaInput;
}>;


export type DeleteBusinessAreaMutation = { __typename?: 'Mutations', deleteBusinessArea?: { __typename?: 'DeleteBusinessAreaPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type DeleteClientContactMutationVariables = Exact<{
  input: DeleteClientContactInput;
}>;


export type DeleteClientContactMutation = { __typename?: 'Mutations', deleteClientContact?: { __typename?: 'DeleteClientContactPayload', message?: string | null, result: RequestResult, id?: any | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type DeleteClientPortalUserRelationshipMutationVariables = Exact<{
  input: DeleteClientPortalUserInput;
}>;


export type DeleteClientPortalUserRelationshipMutation = { __typename?: 'Mutations', deleteClientPortalUserRelationship?: { __typename?: 'DeleteClientPortalUserPayload', message?: string | null, result: RequestResult, tenantId?: any | null, portalUserId: string } | null };

export type DeleteCurrencyMutationVariables = Exact<{
  input: DeleteCurrencyInput;
}>;


export type DeleteCurrencyMutation = { __typename?: 'Mutations', deleteCurrency?: { __typename?: 'DeleteCurrencyPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type DeleteDataLakeDirectoryMutationVariables = Exact<{
  input: DataLakeDirectoryDeleteRequestInput;
}>;


export type DeleteDataLakeDirectoryMutation = { __typename?: 'Mutations', deleteDataLakeDirectory?: { __typename?: 'ActionPayload', message?: string | null, result: RequestResult, data?: string | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type DeleteDataLakeFileMutationVariables = Exact<{
  input: DataLakeFileDeleteRequestInput;
}>;


export type DeleteDataLakeFileMutation = { __typename?: 'Mutations', deleteDataLakeFile?: { __typename?: 'ActionPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type DeleteEntityByIdMutationVariables = Exact<{
  input: DeleteByIdInput;
}>;


export type DeleteEntityByIdMutation = { __typename?: 'Mutations', deleteById?: { __typename?: 'DeleteByIdPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type DeleteErpProductMutationVariables = Exact<{
  input: DeleteErpProductInput;
}>;


export type DeleteErpProductMutation = { __typename?: 'Mutations', deleteErpProduct?: { __typename?: 'DeleteErpProductPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type DeleteTransactionMutationVariables = Exact<{
  input: DeleteTransactionInput;
}>;


export type DeleteTransactionMutation = { __typename?: 'Mutations', deleteTransaction?: { __typename?: 'DeleteTransactionPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type DeleteEdiUserMutationVariables = Exact<{
  input: DeleteUserInput;
}>;


export type DeleteEdiUserMutation = { __typename?: 'Mutations', deleteUser?: { __typename?: 'DeleteUserPayload', message?: string | null, result: RequestResult, userId?: any | null } | null };

export type ExecuteBlobStorageDownloadMutationVariables = Exact<{
  input: BlobDownloadRequestInput;
}>;


export type ExecuteBlobStorageDownloadMutation = { __typename?: 'Mutations', executeBlobStorageDownload?: { __typename?: 'ActionPayload', message?: string | null, result: RequestResult, data?: string | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type ExecuteBlobStorageUploadMutationVariables = Exact<{
  input: BlobUploadRequestInput;
}>;


export type ExecuteBlobStorageUploadMutation = { __typename?: 'Mutations', executeBlobStorageUpload?: { __typename?: 'ActionPayload', message?: string | null, result: RequestResult, data?: string | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type ExecuteDataLakeFileDownloadMutationVariables = Exact<{
  input: DataLakeFileDownloadRequestInput;
}>;


export type ExecuteDataLakeFileDownloadMutation = { __typename?: 'Mutations', executeDataLakeFileDownload?: { __typename?: 'ActionPayload', message?: string | null, result: RequestResult, data?: string | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type ExecuteDataLakeFileUploadMutationVariables = Exact<{
  input: BulkDataLakeFileUploadRequestInput;
}>;


export type ExecuteDataLakeFileUploadMutation = { __typename?: 'Mutations', executeDataLakeFileUpload?: { __typename?: 'ActionPayload', message?: string | null, result: RequestResult, data?: string | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type ExecuteEdiActionSvcActionMutationVariables = Exact<{
  input: EdiActionServiceInput;
}>;


export type ExecuteEdiActionSvcActionMutation = { __typename?: 'Mutations', executeEdiActionSvcAction?: { __typename?: 'ActionPayload', message?: string | null, result: RequestResult, data?: string | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type MassDeleteEntityByIdsMutationVariables = Exact<{
  input: DeleteMultipleByIdsInput;
}>;


export type MassDeleteEntityByIdsMutation = { __typename?: 'Mutations', deleteMultipleByIds?: { __typename?: 'DeleteMultipleByIdsPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type MoveDataLakeFileMutationVariables = Exact<{
  input: DataLakeMoveFileRequestInput;
}>;


export type MoveDataLakeFileMutation = { __typename?: 'Mutations', moveDataLakeFile?: { __typename?: 'ActionPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type ReprocessFailedDataLakeFileMutationVariables = Exact<{
  input: DataLakeReprocessFailedFileRequestInput;
}>;


export type ReprocessFailedDataLakeFileMutation = { __typename?: 'Mutations', reprocessFailedDataLakeFile?: { __typename?: 'ActionPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpdateBlobStorageActiveMutationVariables = Exact<{
  input: UpdateBlobStorageInput;
}>;


export type UpdateBlobStorageActiveMutation = { __typename?: 'Mutations', updateFileVersionIsActive?: { __typename?: 'UpdateBlobStoragePayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpdateClientPartnerMutationVariables = Exact<{
  input: UpdateClientPartnerInput;
}>;


export type UpdateClientPartnerMutation = { __typename?: 'Mutations', updateClientPartner?: { __typename?: 'UpdateClientPartnerPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpdateClientPartnerTransactionMutationVariables = Exact<{
  input: UpdateClientPartnerTransactionInput;
}>;


export type UpdateClientPartnerTransactionMutation = { __typename?: 'Mutations', updateClientPartnerTransaction?: { __typename?: 'UpdateClientPartnerTransactionPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, clientPartnerTransaction?: { __typename?: 'ClientPartnerTransactionModel', id: any } | null } | null };

export type UpdateDocumentArchiveIsAbandonedMutationVariables = Exact<{
  input: UpdateDocumentArchivesInput;
}>;


export type UpdateDocumentArchiveIsAbandonedMutation = { __typename?: 'Mutations', updateDocumentArchiveIsAbandoned?: { __typename?: 'UpdateDocumentArchivesPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpdatePartnerTransactionMutationVariables = Exact<{
  input: UpdatePartnerTransactionInput;
}>;


export type UpdatePartnerTransactionMutation = { __typename?: 'Mutations', updatePartnerTransaction?: { __typename?: 'UpdatePartnerTransactionsPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, partnerTransaction?: { __typename?: 'PartnerTransactionModel', id: any } | null } | null };

export type UpdateTransactionErrorCategoryMutationVariables = Exact<{
  input: UpdateTransactionErrorCategoryInput;
}>;


export type UpdateTransactionErrorCategoryMutation = { __typename?: 'Mutations', updateTransactionErrorCategory?: { __typename?: 'UpdateTransactionErrorCategoryPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpdateTransactionErrorsMutationVariables = Exact<{
  input: UpdateTransactionErrorsInput;
}>;


export type UpdateTransactionErrorsMutation = { __typename?: 'Mutations', updateTransactionErrors?: { __typename?: 'UpdateTransactionErrorsPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertBillingMutationVariables = Exact<{
  input: UpsertBillingInput;
}>;


export type UpsertBillingMutation = { __typename?: 'Mutations', upsertBilling?: { __typename?: 'UpsertBillingPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, billing?: { __typename?: 'BillingModel', id: any } | null } | null };

export type UpsertBillingItemMutationVariables = Exact<{
  input: UpsertBillingItemInput;
}>;


export type UpsertBillingItemMutation = { __typename?: 'Mutations', upsertBillingItem?: { __typename?: 'UpsertBillingItemPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertBusinessAreaMutationVariables = Exact<{
  input: UpsertBusinessAreaInput;
}>;


export type UpsertBusinessAreaMutation = { __typename?: 'Mutations', upsertBusinessArea?: { __typename?: 'UpsertBusinessAreaPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertClientMutationVariables = Exact<{
  input: UpsertClientInput;
}>;


export type UpsertClientMutation = { __typename?: 'Mutations', upsertClient?: { __typename?: 'UpsertClientPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, client?: { __typename?: 'ClientModel', id: any } | null } | null };

export type UpsertClientAkaMutationVariables = Exact<{
  input: UpsertClientAkaInput;
}>;


export type UpsertClientAkaMutation = { __typename?: 'Mutations', upsertClientAka?: { __typename?: 'UpsertClientAkaPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, clientAKA?: { __typename?: 'ClientAkaModel', id: any } | null } | null };

export type UpsertClientAttachmentsMutationVariables = Exact<{
  input: UpsertClientAttachmentInput;
}>;


export type UpsertClientAttachmentsMutation = { __typename?: 'Mutations', upsertClientAttachment?: { __typename?: 'UpsertClientAttachmentPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertClientContactMutationVariables = Exact<{
  input: UpsertClientContactInput;
}>;


export type UpsertClientContactMutation = { __typename?: 'Mutations', upsertClientContact?: { __typename?: 'UpsertClientContactPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertClientContactNoteMutationVariables = Exact<{
  input: UpsertNoteInput;
}>;


export type UpsertClientContactNoteMutation = { __typename?: 'Mutations', upsertClientContactNote?: { __typename?: 'UpsertNotePayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertClientNoteMutationVariables = Exact<{
  input: UpsertNoteInput;
}>;


export type UpsertClientNoteMutation = { __typename?: 'Mutations', upsertClientNote?: { __typename?: 'UpsertNotePayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertClientNotificationRecipientsMutationVariables = Exact<{
  input: UpsertClientNotificationRecipientsInput;
}>;


export type UpsertClientNotificationRecipientsMutation = { __typename?: 'Mutations', upsertClientNotificationRecipients?: { __typename?: 'UpsertClientNotificationRecipientsPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, clientNotificationRecipients?: { __typename?: 'ClientNotificationRecipientsModel', id: any } | null } | null };

export type UpsertClientPartnerAttachmentsMutationVariables = Exact<{
  input: UpsertClientPartnerAttachmentInput;
}>;


export type UpsertClientPartnerAttachmentsMutation = { __typename?: 'Mutations', upsertClientPartnerAttachment?: { __typename?: 'UpsertClientPartnerAttachmentPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertClientPartnerTransactionAliasMutationVariables = Exact<{
  input: UpsertClientPartnerTransactionAliasInput;
}>;


export type UpsertClientPartnerTransactionAliasMutation = { __typename?: 'Mutations', upsertClientPartnerTransactionAlias?: { __typename?: 'UpsertClientPartnerTransactionAliasPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, clientPartnerTransactionAlias?: { __typename?: 'ClientPartnerTransactionAliasModel', id: any } | null } | null };

export type UpsertClientPartnerTransactionMapMutationVariables = Exact<{
  input: UpsertClientPartnerTransactionMapInput;
}>;


export type UpsertClientPartnerTransactionMapMutation = { __typename?: 'Mutations', upsertClientPartnerTransactionMap?: { __typename?: 'UpsertClientPartnerTransactionMapPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertClientPartnerTransactionPostProcessingMutationVariables = Exact<{
  input: UpsertClientPartnerTransactionPostProcessingInput;
}>;


export type UpsertClientPartnerTransactionPostProcessingMutation = { __typename?: 'Mutations', upsertClientPartnerTransactionPostProcessing?: { __typename?: 'UpsertClientPartnerTransactionPostProcessingPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertClientPartnerTransactionSchemaMutationVariables = Exact<{
  input: UpsertClientPartnerTransactionSchemaInput;
}>;


export type UpsertClientPartnerTransactionSchemaMutation = { __typename?: 'Mutations', upsertClientPartnerTransactionSchema?: { __typename?: 'UpsertClientPartnerTransactionSchemaPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertClientPortalUserMutationVariables = Exact<{
  input: UpsertPortalUserInput;
}>;


export type UpsertClientPortalUserMutation = { __typename?: 'Mutations', upsertClientPortalUser?: { __typename?: 'UpsertPortalUserPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertClientTransactionMutationVariables = Exact<{
  input: UpsertClientTransactionInput;
}>;


export type UpsertClientTransactionMutation = { __typename?: 'Mutations', upsertClientTransaction?: { __typename?: 'UpsertClientTransactionPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertCounterMutationVariables = Exact<{
  input: UpsertCounterInput;
}>;


export type UpsertCounterMutation = { __typename?: 'Mutations', upsertCounter?: { __typename?: 'UpsertCounterPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, counter?: { __typename?: 'CounterModel', id: any } | null } | null };

export type UpsertCrossReferenceMutationVariables = Exact<{
  input: UpsertCrossReferenceInput;
}>;


export type UpsertCrossReferenceMutation = { __typename?: 'Mutations', upsertCrossReference?: { __typename?: 'UpsertCrossReferencePayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, crossReference?: { __typename?: 'CrossReferenceModel', id: any } | null } | null };

export type UpsertCurrencyMutationVariables = Exact<{
  input: UpsertCurrencyInput;
}>;


export type UpsertCurrencyMutation = { __typename?: 'Mutations', upsertCurrency?: { __typename?: 'UpsertCurrencyPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, currency?: { __typename?: 'CurrencyModel', currencyCode: string, description: string } | null } | null };

export type UpsertDocumentArchiveNoteMutationVariables = Exact<{
  input: UpsertNoteInput;
}>;


export type UpsertDocumentArchiveNoteMutation = { __typename?: 'Mutations', upsertDocumentArchiveNote?: { __typename?: 'UpsertNotePayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertEdiStandardMutationVariables = Exact<{
  input: UpsertEdiStandardInput;
}>;


export type UpsertEdiStandardMutation = { __typename?: 'Mutations', upsertEdiStandard?: { __typename?: 'UpsertEdiStandardPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertEdiXmlConfigMutationVariables = Exact<{
  input: UpsertEdiXmlConfigInput;
}>;


export type UpsertEdiXmlConfigMutation = { __typename?: 'Mutations', upsertEdiXmlConfig?: { __typename?: 'UpsertEdiXmlConfigPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertErpTransactionSchemaMutationVariables = Exact<{
  input: UpsertErpTransactionSchemaInput;
}>;


export type UpsertErpTransactionSchemaMutation = { __typename?: 'Mutations', upsertErpTransactionSchema?: { __typename?: 'UpsertErpTransactionSchemaPayload', message?: string | null, result: RequestResult, transactionSchemaId?: any | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertFavoriteMutationVariables = Exact<{
  input: UpsertFavoriteInput;
}>;


export type UpsertFavoriteMutation = { __typename?: 'Mutations', upsertFavorite?: { __typename?: 'UpsertFavoritePayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, favorite?: { __typename?: 'FavoriteModel', id: any } | null } | null };

export type UpsertMapMutationVariables = Exact<{
  input: UpsertTransactionMapInput;
}>;


export type UpsertMapMutation = { __typename?: 'Mutations', upsertTransactionMap?: { __typename?: 'UpsertTransactionMapPayload', message?: string | null, result: RequestResult, transactionMapId?: any | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertNotificationFormatterMutationVariables = Exact<{
  input: UpsertNotificationFormatterInput;
}>;


export type UpsertNotificationFormatterMutation = { __typename?: 'Mutations', upsertNotificationFormatter?: { __typename?: 'UpsertNotificationFormatterPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, notificationFormatter?: { __typename?: 'NotificationFormatterModel', id: any } | null } | null };

export type UpsertPartnerAkaMutationVariables = Exact<{
  input: UpsertPartnerAkaInput;
}>;


export type UpsertPartnerAkaMutation = { __typename?: 'Mutations', upsertPartnerAka?: { __typename?: 'UpsertPartnerAkaPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, partnerAKA?: { __typename?: 'PartnerAkaModel', id: any } | null } | null };

export type UpsertPartnerNotificationRecipientsMutationVariables = Exact<{
  input: UpsertPartnerNotificationRecipientsInput;
}>;


export type UpsertPartnerNotificationRecipientsMutation = { __typename?: 'Mutations', upsertPartnerNotificationRecipients?: { __typename?: 'UpsertPartnerNotificationRecipientsPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, partnerNotificationRecipients?: { __typename?: 'PartnerNotificationRecipientsModel', id: any } | null } | null };

export type UpsertPipelineMutationVariables = Exact<{
  input: UpsertPipelineInput;
}>;


export type UpsertPipelineMutation = { __typename?: 'Mutations', upsertPipeline?: { __typename?: 'UpsertPipelinePayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, pipeline?: { __typename?: 'PipelineModel', id: any } | null } | null };

export type UpsertPipelineItemMutationVariables = Exact<{
  input: UpsertPipelineItemInput;
}>;


export type UpsertPipelineItemMutation = { __typename?: 'Mutations', upsertPipelineItem?: { __typename?: 'UpsertPipelineItemPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertPostProcessingBlobMutationVariables = Exact<{
  input: UpsertPostProcessingBlobInput;
}>;


export type UpsertPostProcessingBlobMutation = { __typename?: 'Mutations', upsertPostProcessingBlob?: { __typename?: 'UpsertPostProcessingBlobPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, postProcessingBlob?: { __typename?: 'PostProcessingBlobModel', id: any } | null } | null };

export type UpsertPricingMutationVariables = Exact<{
  input: UpsertPricingInput;
}>;


export type UpsertPricingMutation = { __typename?: 'Mutations', upsertPricing?: { __typename?: 'UpsertPricingPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, pricing?: { __typename?: 'PricingModel', id: any } | null } | null };

export type UpsertPricingItemMutationVariables = Exact<{
  input: UpsertPricingItemInput;
}>;


export type UpsertPricingItemMutation = { __typename?: 'Mutations', upsertPricingItem?: { __typename?: 'UpsertPricingItemPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertProcessMutationVariables = Exact<{
  input: UpsertConfigurationInput;
}>;


export type UpsertProcessMutation = { __typename?: 'Mutations', upsertConfiguration?: { __typename?: 'UpsertConfigurationPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, configuration?: { __typename?: 'ConfigurationModel', id: any } | null } | null };

export type UpsertErpProductMutationVariables = Exact<{
  input: UpsertErpProductInput;
}>;


export type UpsertErpProductMutation = { __typename?: 'Mutations', upsertErpProduct?: { __typename?: 'UpsertErpProductPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertRecentMutationVariables = Exact<{
  input: UpsertRecentInput;
}>;


export type UpsertRecentMutation = { __typename?: 'Mutations', upsertRecent?: { __typename?: 'UpsertRecentPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertSystemConfigurationMutationVariables = Exact<{
  input: UpsertSystemConfigurationInput;
}>;


export type UpsertSystemConfigurationMutation = { __typename?: 'Mutations', upsertSystemConfiguration?: { __typename?: 'UpsertSystemConfigurationPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertSystemNotificationMutationVariables = Exact<{
  input: UpsertSystemNotificationInput;
}>;


export type UpsertSystemNotificationMutation = { __typename?: 'Mutations', upsertSystemNotification?: { __typename?: 'UpsertSystemNotificationPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertTradingPartnerMutationVariables = Exact<{
  input: UpsertPartnerInput;
}>;


export type UpsertTradingPartnerMutation = { __typename?: 'Mutations', upsertPartner?: { __typename?: 'UpsertPartnerPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, partner?: { __typename?: 'PartnerModel', id: any } | null } | null };

export type UpsertPartnerAttachmentsMutationVariables = Exact<{
  input: UpsertPartnerAttachmentInput;
}>;


export type UpsertPartnerAttachmentsMutation = { __typename?: 'Mutations', upsertPartnerAttachment?: { __typename?: 'UpsertPartnerAttachmentPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertTradingPartnerContactMutationVariables = Exact<{
  input: UpsertPartnerContactInput;
}>;


export type UpsertTradingPartnerContactMutation = { __typename?: 'Mutations', upsertPartnerContact?: { __typename?: 'UpsertPartnerContactPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertPartnerContactNoteMutationVariables = Exact<{
  input: UpsertNoteInput;
}>;


export type UpsertPartnerContactNoteMutation = { __typename?: 'Mutations', upsertPartnerContactNote?: { __typename?: 'UpsertNotePayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertPartnerNoteMutationVariables = Exact<{
  input: UpsertNoteInput;
}>;


export type UpsertPartnerNoteMutation = { __typename?: 'Mutations', upsertPartnerNote?: { __typename?: 'UpsertNotePayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertPartnerTransactionSchemaMutationVariables = Exact<{
  input: UpsertPartnerTransactionSchemaInput;
}>;


export type UpsertPartnerTransactionSchemaMutation = { __typename?: 'Mutations', upsertPartnerTransactionSchema?: { __typename?: 'UpsertPartnerTransactionSchemaPayload', message?: string | null, result: RequestResult, transactionSchemaId?: any | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertTransactionMutationVariables = Exact<{
  input: UpsertTransactionInput;
}>;


export type UpsertTransactionMutation = { __typename?: 'Mutations', upsertTransaction?: { __typename?: 'UpsertTransactionPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertTransactionErrorNoteMutationVariables = Exact<{
  input: UpsertNoteInput;
}>;


export type UpsertTransactionErrorNoteMutation = { __typename?: 'Mutations', upsertTransactionErrorNote?: { __typename?: 'UpsertNotePayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertTransactionMapPartnerMutationVariables = Exact<{
  input: UpsertTransactionMapPartnerInput;
}>;


export type UpsertTransactionMapPartnerMutation = { __typename?: 'Mutations', upsertTransactionMapPartner?: { __typename?: 'UpsertTransactionMapPartnerPayload', message?: string | null, result: RequestResult, transactionMapPartnerId?: any | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type UpsertTransactionXPathMutationVariables = Exact<{
  input: UpsertTransactionXPathInput;
}>;


export type UpsertTransactionXPathMutation = { __typename?: 'Mutations', upsertTransactionXPath?: { __typename?: 'UpsertTransactionXPathPayload', message?: string | null, result: RequestResult, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null, transactionXPath?: { __typename?: 'TransactionXPathModel', id: string } | null } | null };

export type UpsertUserMutationVariables = Exact<{
  input: UpsertUserInput;
}>;


export type UpsertUserMutation = { __typename?: 'Mutations', upsertUser?: { __typename?: 'UpsertUserPayload', message?: string | null, result: RequestResult, isReactivated: boolean, user?: { __typename: 'UserModel', id: any, firstName: string, lastName: string, email: string, role: UserRole, isActive?: boolean | null } | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type GetAttachmentQueryVariables = Exact<{
  input: GetAttachmentInput;
}>;


export type GetAttachmentQuery = { __typename?: 'Queries', attachments?: { __typename?: 'PagingResultModelOfAttachmentModel', nodes?: Array<{ __typename?: 'AttachmentModel', id: any, parentId: any, attachmentString?: string | null, fileName: string, fileLastModifiedTime?: any | null, description?: string | null, mimeType: string }> | null } | null };

export type AuditRecordByIdQueryVariables = Exact<{
  input: GetAuditRecordsInput;
}>;


export type AuditRecordByIdQuery = { __typename?: 'Queries', auditRecords?: { __typename?: 'PagingResultModelOfAuditRecordModel', nodes?: Array<{ __typename?: 'AuditRecordModel', id: any, createdTime: any, entityId: string, entityName: string, entityState: EntityState, newValues?: string | null, oldValues?: string | null, userId: any, userName: string }> | null } | null };

export type AuditRecordListQueryVariables = Exact<{
  input: GetAuditRecordsInput;
}>;


export type AuditRecordListQuery = { __typename?: 'Queries', auditRecords?: { __typename?: 'PagingResultModelOfAuditRecordModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'AuditRecordModel', id: any, createdTime: any, entityId: string, entityName: string, entityState: EntityState, newValues?: string | null, oldValues?: string | null, userId: any, userName: string }> | null } | null };

export type GetBillingByIdQueryVariables = Exact<{
  input: GetBillingsInput;
}>;


export type GetBillingByIdQuery = { __typename?: 'Queries', billings?: { __typename?: 'PagingResultModelOfBillingModel', nodes?: Array<{ __typename?: 'BillingModel', id: any, description: string, currencyCode?: string | null, billingItemCount?: number | null, clientCount?: number | null, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any }> | null } | null };

export type BillingItemListQueryVariables = Exact<{
  input: GetBillingItemsInput;
}>;


export type BillingItemListQuery = { __typename?: 'Queries', billingItems?: { __typename?: 'PagingResultModelOfBillingItemModel', nodes?: Array<{ __typename?: 'BillingItemModel', id: any, billingId: any, dateFrom?: any | null, dateTo?: any | null, pricingId: any, pricing?: { __typename?: 'PricingModel', id: any, description: string, minServiceFees: any, pricingItems?: Array<{ __typename?: 'PricingItemModel', id: any, pricingId: any, description?: string | null, feePerDocument: any, feePerLine: any, maxNumberOfTransactions: number } | null> | null } | null }> | null } | null };

export type BillingListQueryVariables = Exact<{
  input: GetBillingsInput;
}>;


export type BillingListQuery = { __typename?: 'Queries', billings?: { __typename?: 'PagingResultModelOfBillingModel', nodes?: Array<{ __typename?: 'BillingModel', id: any, description: string, currencyCode?: string | null, billingItemCount?: number | null, clientCount?: number | null }> | null } | null };

export type BusinessAreasListQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessAreasListQuery = { __typename?: 'Queries', businessAreas?: { __typename?: 'PagingResultModelOfBusinessAreaModel', nodes?: Array<{ __typename?: 'BusinessAreaModel', name: string, description?: string | null, id: any }> | null } | null };

export type GetClientBillingAggregatesByClientKeyQueryVariables = Exact<{
  input: GetBillingAggregatesInput;
}>;


export type GetClientBillingAggregatesByClientKeyQuery = { __typename?: 'Queries', clientBillingAggregates?: { __typename?: 'PagingResultModelOfBillingAggregatesModel', nodes?: Array<{ __typename?: 'BillingAggregatesModel', id: any, internalClientCode: string, billingId: any, year: number, month: number, serviceFee: any, totalCharges: any, totalDocuments: number, totalLines: number, lineCharges: any, documentCharges: any, currencyCode: string, createdBy: any, createdTime: any, lastModifiedBy: any, lastModifiedTime: any }> | null } | null };

export type GetClientByIdQueryVariables = Exact<{
  input: GetClientsInput;
}>;


export type GetClientByIdQuery = { __typename?: 'Queries', clients?: { __typename?: 'PagingResultModelOfClientModel', nodes?: Array<{ __typename?: 'ClientModel', id: any, internalClientCode: string, isaQualifierCode: string, localeCode?: string | null, clientCode: string, name: string, defaultCurrencyCode?: string | null, primaryClientId?: string | null, productionDate?: any | null, statusCode?: ClientStatus | null, tenantId: any, website?: string | null, bulkNotificationTime?: any | null, missingAcknowledgementNotificationMode?: MissingAcknowledgementNotificationMode | null, erpDocumentFormat?: ErpDocumentFormat | null, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, salesForceCountryCode?: string | null, salesForceCustomerNumber?: string | null, salesForceEntityCode?: string | null, billingId?: any | null, billingStartDate?: any | null, billing?: { __typename?: 'BillingModel', id: any, description: string, currencyCode?: string | null } | null, addresses?: Array<{ __typename?: 'AddressModel', addressLine1: string, addressLine2?: string | null, addressLine3?: string | null, addressLine4?: string | null, city?: string | null, countryCode?: string | null, id: any, isPrimary?: boolean | null, postalCode?: string | null, stateId?: any | null, state?: { __typename?: 'StateModel', stateCode?: string | null, description?: string | null, id: any } | null } | null> | null, businessArea?: { __typename?: 'BusinessAreaModel', name: string, description?: string | null, id: any } | null, notificationFormatter?: { __typename?: 'NotificationFormatterModel', id: any, description: string, formatterType?: string | null, preprocessorType?: string | null } | null, errorFormatter?: { __typename?: 'NotificationFormatterModel', id: any, description: string, formatterType?: string | null, preprocessorType?: string | null } | null, clientAKAs?: Array<{ __typename?: 'ClientAkaModel', id: any, clientCode: string, isaQualifierCode: string, isaQualifier?: { __typename?: 'IsaQualifierModel', isaQualifierCode: string, description?: string | null } | null } | null> | null, clientNotificationRecipients?: Array<{ __typename?: 'ClientNotificationRecipientsModel', id: any, recipients: string } | null> | null, clientContacts?: Array<{ __typename?: 'ClientContactModel', id: string, clientId: any, name: string, description?: string | null, isActive?: boolean | null, isPrimary?: boolean | null, jobTitle?: string | null, addresses?: Array<{ __typename?: 'AddressModel', addressLine1: string, addressLine2?: string | null, addressLine3?: string | null, addressLine4?: string | null, city?: string | null, countryCode?: string | null, id: any, isPrimary?: boolean | null, postalCode?: string | null, stateId?: any | null, state?: { __typename?: 'StateModel', stateCode?: string | null, description?: string | null, id: any } | null } | null> | null, emails?: Array<{ __typename?: 'EmailModel', email: string, id: any, isPrimary?: boolean | null } | null> | null, phones?: Array<{ __typename?: 'PhoneModel', description?: string | null, id: any, phoneNumber?: string | null, phoneTypeCode?: string | null } | null> | null, notes?: Array<{ __typename?: 'NoteModel', createdBy: any, createdByName?: string | null, createdTime: any, header?: string | null, id: any, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, note: string, parentId: any } | null> | null } | null> | null, ediXmlConfig?: { __typename?: 'EdiXmlConfigModel', clientId: any, createdByName?: string | null, createdTime: any, lastModifiedByName?: string | null, lastModifiedTime: any, description?: string | null, fileName: string, documentString?: string | null, id: any } | null, emails?: Array<{ __typename?: 'EmailModel', email: string, id: any, isPrimary?: boolean | null } | null> | null, erpProduct?: { __typename?: 'ErpProductModel', id: any, name: string, isAptean?: boolean | null } | null, clientPartners?: Array<{ __typename?: 'ClientPartnerModel', id: any, totalTransactions?: number | null, partner: { __typename?: 'PartnerModel', partnerCode: string, id: any, name: string, isaQualifierCode: string, website?: string | null, totalTransactions?: number | null, businessArea?: { __typename?: 'BusinessAreaModel', name: string, id: any } | null, ediStandards?: Array<{ __typename?: 'EdiStandardModel', id?: any | null, name: string } | null> | null } } | null> | null, phones?: Array<{ __typename?: 'PhoneModel', phoneNumber?: string | null, description?: string | null, phoneTypeCode?: string | null, id: any } | null> | null, notes?: Array<{ __typename?: 'NoteModel', createdBy: any, createdByName?: string | null, createdTime: any, header?: string | null, id: any, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, note: string, parentId: any } | null> | null, attachments?: Array<{ __typename?: 'AttachmentModel', id: any, fileName: string, isLink?: boolean | null, description?: string | null, createdBy: any, createdByName?: string | null, createdTime: any, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, fileLastModifiedTime?: any | null } | null> | null }> | null } | null };

export type GetClientNotificationRecipientsQueryVariables = Exact<{
  input: GetClientNotificationRecipientsInput;
}>;


export type GetClientNotificationRecipientsQuery = { __typename?: 'Queries', clientNotificationRecipients?: { __typename?: 'PagingResultModelOfClientNotificationRecipientsModel', nodes?: Array<{ __typename?: 'ClientNotificationRecipientsModel', id: any, description?: string | null, notificationType: NotificationType, recipients: string, receivesNotifications?: boolean | null, receivesErrors?: boolean | null }> | null } | null };

export type GetClientPartnerByIdQueryVariables = Exact<{
  input: GetClientPartnersInput;
}>;


export type GetClientPartnerByIdQuery = { __typename?: 'Queries', clientPartners?: { __typename?: 'PagingResultModelOfClientPartnerModel', nodes?: Array<{ __typename?: 'ClientPartnerModel', id: any, createdTime: any, productionDate?: any | null, defaultCurrencyCode?: string | null, partner: { __typename?: 'PartnerModel', id: any, name: string, website?: string | null, statusCode?: PartnerStatus | null, partnerCode: string, ediStandards?: Array<{ __typename?: 'EdiStandardModel', id?: any | null, name: string } | null> | null }, client: { __typename?: 'ClientModel', id: any, name: string, defaultCurrencyCode?: string | null }, clientPartnerTransactions?: Array<{ __typename?: 'ClientPartnerTransactionModel', id: any, effectivePartnerInterchangeId?: string | null, destinationPath?: string | null, isPipelineInherited?: boolean | null, functionalReconciliationMode: FunctionalReconciliationMode, skipTargetDocumentCreation?: boolean | null, outboundAcknowledgementOption?: OutboundAcknowledgementType | null, partnerTransactionId: any, pipelineId?: any | null, partnerTransaction?: { __typename?: 'PartnerTransactionModel', id: any, functionalReconciliationMode: FunctionalReconciliationMode, pipeline?: { __typename?: 'PipelineModel', description?: string | null, id: any } | null, transaction?: { __typename?: 'TransactionModel', direction?: TransactionDirection | null } | null } | null, pipeline?: { __typename?: 'PipelineModel', description?: string | null, id: any } | null, clientPartnerTransactionMaps?: Array<{ __typename?: 'ClientPartnerTransactionMapModel', id: any, transactionMapId?: any | null, transactionMap?: { __typename?: 'TransactionMapModel', id: any, description: string, transactionId: any, documentString?: string | null, sourceFileName?: string | null } | null } | null> | null, clientPartnerTransactionPostProcessings?: Array<{ __typename?: 'ClientPartnerTransactionPostProcessingModel', ediProcessName?: ProcessName | null, id: any, postProcessingBlobId: any, processArguments: string, processName: string, sortOrder: number, postProcessingBlob?: { __typename?: 'PostProcessingBlobModel', description?: string | null } | null } | null> | null, clientPartnerTransactionSchemas?: Array<{ __typename?: 'ClientPartnerTransactionSchemaModel', id: any, partnerTransactionSchemaId: any, partnerTransactionSchema?: { __typename?: 'PartnerTransactionSchemaModel', id: any, description: string, standardVersion?: string | null, sourceFileName?: string | null } | null } | null> | null, clientPartnerTransactionAliases?: Array<{ __typename?: 'ClientPartnerTransactionAliasModel', id: any, alias: string } | null> | null } | null> | null, partnerTransactions?: Array<{ __typename?: 'PartnerTransactionModel', id: any, pipelineId?: any | null, transaction?: { __typename?: 'TransactionModel', id: any, name: string, description?: string | null, direction?: TransactionDirection | null, isActive?: boolean | null } | null, pipeline?: { __typename?: 'PipelineModel', description?: string | null, id: any } | null, transactionMaps?: Array<{ __typename?: 'TransactionMapModel', id: any, description: string, transactionId: any } | null> | null, partnerTransactionSchemas?: Array<{ __typename?: 'PartnerTransactionSchemaModel', id: any, description: string, standardVersion?: string | null, sourceFileName?: string | null } | null> | null } | null> | null, attachments?: Array<{ __typename?: 'AttachmentModel', id: any, fileName: string, isLink?: boolean | null, description?: string | null, createdBy: any, createdByName?: string | null, createdTime: any, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, fileLastModifiedTime?: any | null } | null> | null, fileGenerationNumber?: { __typename?: 'FileGenerationNumberModel', id: any, currentFileGenerationNumber: number, maxFileGenerationNumber: number } | null }> | null } | null };

export type GetClientPortalUsersQueryVariables = Exact<{
  input: GetPortalUsersInput;
}>;


export type GetClientPortalUsersQuery = { __typename?: 'Queries', clientPortalUsers?: Array<{ __typename?: 'ClientPortalUserModel', id: any, email: string, firstName: string, lastName: string, createdTime: any, customerRole: UserRole, subscriptionRole: UserRole, tenantId: any } | null> | null };

export type GetClientTransactionsByClientIdQueryVariables = Exact<{
  input: GetClientTransactionsInput;
}>;


export type GetClientTransactionsByClientIdQuery = { __typename?: 'Queries', clientTransactions?: { __typename?: 'PagingResultModelOfClientTransactionModel', nodes?: Array<{ __typename?: 'ClientTransactionModel', id: any, isActive?: boolean | null, notify?: boolean | null, bulkNotify?: boolean | null, fileNamePattern?: string | null, pipelineId?: any | null, transactionId: any, pipeline?: { __typename?: 'PipelineModel', description?: string | null, id: any, isTemplate?: boolean | null, transactionId?: any | null } | null, transaction?: { __typename?: 'TransactionModel', id: any, name: string, description?: string | null, direction?: TransactionDirection | null, isActive?: boolean | null } | null, erpTransactionSchema?: { __typename?: 'ErpTransactionSchemaModel', description: string, id: any } | null, notificationFormatter?: { __typename?: 'NotificationFormatterModel', id: any, description: string } | null }> | null } | null };

export type ClientsListQueryVariables = Exact<{
  input: GetClientsInput;
}>;


export type ClientsListQuery = { __typename?: 'Queries', clients?: { __typename?: 'PagingResultModelOfClientModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'ClientModel', name: string, id: any, statusCode?: ClientStatus | null, clientCode: string, website?: string | null, totalPartners?: number | null, businessArea?: { __typename?: 'BusinessAreaModel', name: string, id: any } | null, erpProduct?: { __typename?: 'ErpProductModel', name: string, id: any } | null }> | null } | null };

export type ClientsMissingBillingQueryVariables = Exact<{
  input: GetClientsInput;
}>;


export type ClientsMissingBillingQuery = { __typename?: 'Queries', clients?: { __typename?: 'PagingResultModelOfClientModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'ClientModel', name: string, id: any, statusCode?: ClientStatus | null, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any }> | null } | null };

export type ClientsMissingRecipientsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientsMissingRecipientsQuery = { __typename?: 'Queries', clientsNotificationsNoRecipients?: { __typename?: 'PagingResultModelOfClientModel', nodes?: Array<{ __typename?: 'ClientModel', name: string, id: any, statusCode?: ClientStatus | null, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any }> | null } | null };

export type ClientsOnboardingQueryVariables = Exact<{
  input: GetClientsInput;
}>;


export type ClientsOnboardingQuery = { __typename?: 'Queries', clients?: { __typename?: 'PagingResultModelOfClientModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'ClientModel', name: string, id: any, statusCode?: ClientStatus | null, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any }> | null } | null };

export type CounterListQueryVariables = Exact<{
  input: GetCounterInput;
}>;


export type CounterListQuery = { __typename?: 'Queries', counters?: { __typename?: 'PagingResultModelOfCounterModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'CounterModel', id: any, segment: CounterSegmentType, senderId: string, controlNumber?: string | null, comments?: string | null, machine?: string | null }> | null } | null };

export type CrossReferencesQueryVariables = Exact<{
  input: GetCrossReferenceInput;
}>;


export type CrossReferencesQuery = { __typename?: 'Queries', crossReferences?: { __typename?: 'PagingResultModelOfCrossReferenceModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'CrossReferenceModel', code?: string | null, description?: string | null, id: any, val?: string | null, version?: string | null }> | null } | null };

export type CurrenciesListQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrenciesListQuery = { __typename?: 'Queries', currencies?: { __typename?: 'PagingResultModelOfCurrencyModel', nodes?: Array<{ __typename?: 'CurrencyModel', currencyCode: string, description: string }> | null } | null };

export type GetDashboardCountsQueryVariables = Exact<{
  input: GetDashboardCountsInput;
}>;


export type GetDashboardCountsQuery = { __typename?: 'Queries', dashboardCounts?: { __typename?: 'DashboardModel', errorsCount: number, mappingErrorsCount: number, onboardingClientsCount: number, rejectedTransactionsCount: number, unacknowledgedTransactionsCount: number, notificationNotSentTransactionsCount: number, clientsNotificationsNoRecipientsCount: number, clientsBillingNotSetCount: number } | null };

export type DocumentArchiveByIdQueryVariables = Exact<{
  input: GetDocumentArchiveInput;
}>;


export type DocumentArchiveByIdQuery = { __typename?: 'Queries', documentArchive?: { __typename?: 'DocumentArchiveModel', id: any, acknowledgementRequestCount?: number | null, acknowledgementRequestTime?: any | null, acknowledgementStatus?: DocumentAcknowledgementStatus | null, bulkNotify?: boolean | null, controlNumber?: string | null, functionalGroupControlNumber?: string | null, transactionControlNumber?: string | null, createdTime: any, direction?: string | null, documentDate?: any | null, documentType?: string | null, ediDocument?: string | null, ediDocumentResentCount?: number | null, ediDocumentResentTime?: any | null, ediXml?: string | null, erpOrderNumber?: string | null, fileName?: string | null, originalFileName?: string | null, internalClientCode?: string | null, internalPartnerCode?: string | null, documentNumber?: string | null, isAbandoned: boolean, notifiedTime?: any | null, purchaseOrder?: string | null, receiverId?: string | null, senderId?: string | null, wasNotificationSent?: boolean | null, currencyCode?: string | null, internalTransactionId?: string | null, client?: { __typename?: 'ClientModel', id: any, name: string } | null, partner?: { __typename?: 'PartnerModel', id: any, name: string } | null, notes?: Array<{ __typename?: 'NoteModel', id: any, header?: string | null, note: string, lastModifiedTime: any, lastModifiedBy: any } | null> | null } | null };

export type DocumentArchiveListQueryVariables = Exact<{
  input: GetDocumentArchivesInput;
}>;


export type DocumentArchiveListQuery = { __typename?: 'Queries', documentArchives?: { __typename?: 'PagingResultModelOfDocumentArchiveModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'DocumentArchiveModel', id: any, acknowledgementStatus?: DocumentAcknowledgementStatus | null, bulkNotify?: boolean | null, controlNumber?: string | null, functionalGroupControlNumber?: string | null, transactionControlNumber?: string | null, createdTime: any, direction?: string | null, documentDate?: any | null, documentType?: string | null, fileName?: string | null, internalClientCode?: string | null, internalPartnerCode?: string | null, isAbandoned: boolean, purchaseOrder?: string | null, erpOrderNumber?: string | null, documentNumber?: string | null, notifiedTime?: any | null, receiverId?: string | null, senderId?: string | null, internalTransactionId?: string | null, client?: { __typename?: 'ClientModel', id: any, name: string } | null, partner?: { __typename?: 'PartnerModel', id: any, name: string } | null }> | null } | null };

export type EdiStandardsListQueryVariables = Exact<{ [key: string]: never; }>;


export type EdiStandardsListQuery = { __typename?: 'Queries', ediStandards?: { __typename?: 'PagingResultModelOfEdiStandardModel', nodes?: Array<{ __typename?: 'EdiStandardModel', name: string, description: string, id?: any | null }> | null } | null };

export type ErpTransactionSchemasQueryVariables = Exact<{
  input: GetErpTransactionSchemaInput;
}>;


export type ErpTransactionSchemasQuery = { __typename?: 'Queries', erpTransactionSchemas?: { __typename?: 'PagingResultModelOfErpTransactionSchemaModel', nodes?: Array<{ __typename?: 'ErpTransactionSchemaModel', id: any, transactionId: any, description: string, documentString?: string | null, sourceFileName?: string | null }> | null } | null };

export type ErrorFormattersListQueryVariables = Exact<{
  input: GetNotificationFormatterInput;
}>;


export type ErrorFormattersListQuery = { __typename?: 'Queries', notificationFormatters?: { __typename?: 'PagingResultModelOfNotificationFormatterModel', nodes?: Array<{ __typename?: 'NotificationFormatterModel', id: any, description: string }> | null } | null };

export type TransactionErrorByIdQueryVariables = Exact<{
  input: GetTransactionErrorsInput;
}>;


export type TransactionErrorByIdQuery = { __typename?: 'Queries', transactionErrors?: { __typename?: 'PagingResultModelOfTransactionErrorModel', nodes?: Array<{ __typename?: 'TransactionErrorModel', id: any, documentId?: string | null, description?: string | null, documentReferenceId?: string | null, messageType?: MessageType | null, originalFileName?: string | null, purchaseOrderNumber?: string | null, processName?: ProcessName | null, rawMessage?: string | null, status?: ExceptionStatus | null, createdTime?: any | null, resolvedTime?: any | null, resolvedByName?: string | null, client?: { __typename?: 'ClientModel', id: any, name: string } | null, partner?: { __typename?: 'PartnerModel', id: any, name: string } | null, clientPartner?: { __typename?: 'ClientPartnerModel', id: any } | null, transaction?: { __typename?: 'TransactionModel', id: any, name: string, direction?: TransactionDirection | null, normalizedDocumentType?: NormalizedDocumentType | null } | null, category?: { __typename?: 'TransactionErrorCategoryModel', id: any, name: string } | null, notes?: Array<{ __typename?: 'NoteModel', createdBy: any, createdByName?: string | null, createdTime: any, header?: string | null, id: any, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, note: string, parentId: any } | null> | null }> | null } | null };

export type ErrorLogCategoryListQueryVariables = Exact<{ [key: string]: never; }>;


export type ErrorLogCategoryListQuery = { __typename?: 'Queries', transactionErrorCategories?: { __typename?: 'PagingResultModelOfTransactionErrorCategoryModel', nodes?: Array<{ __typename?: 'TransactionErrorCategoryModel', id: any, name: string, description?: string | null }> | null } | null };

export type ErrorLogListQueryVariables = Exact<{
  input: GetTransactionErrorsInput;
}>;


export type ErrorLogListQuery = { __typename?: 'Queries', transactionErrors?: { __typename?: 'PagingResultModelOfTransactionErrorModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'TransactionErrorModel', id: any, documentId?: string | null, description?: string | null, documentReferenceId?: string | null, messageType?: MessageType | null, originalFileName?: string | null, purchaseOrderNumber?: string | null, processName?: ProcessName | null, rawMessage?: string | null, status?: ExceptionStatus | null, createdTime?: any | null, client?: { __typename?: 'ClientModel', id: any, name: string } | null, partner?: { __typename?: 'PartnerModel', id: any, name: string } | null, clientPartner?: { __typename?: 'ClientPartnerModel', id: any } | null, transaction?: { __typename?: 'TransactionModel', id: any, name: string, direction?: TransactionDirection | null, normalizedDocumentType?: NormalizedDocumentType | null } | null, category?: { __typename?: 'TransactionErrorCategoryModel', id: any, name: string } | null, notes?: Array<{ __typename?: 'NoteModel', note: string } | null> | null }> | null } | null };

export type FileDirectoriesQueryVariables = Exact<{
  input: GetDataLakeFileInput;
}>;


export type FileDirectoriesQuery = { __typename?: 'Queries', dataLakeFileDirectories?: { __typename?: 'DataLakeDirectoryListPayload', message?: string | null, result: RequestResult, directoryHierarchyJson?: string | null, errors?: Array<{ __typename?: 'ErrorModel', code?: string | null, message?: string | null } | null> | null } | null };

export type GetFileDirectoryByPathQueryVariables = Exact<{
  input: GetDataLakeFileInput;
}>;


export type GetFileDirectoryByPathQuery = { __typename?: 'Queries', dataLakeFilesAndSubDirectories?: { __typename?: 'DataLakeDirectoryModel', path: string, dataLakeFileModels?: Array<{ __typename?: 'DataLakeFileModel', name: string, path: string, fileSize: string, fileSizeBytes: any, lastModifiedTime: any, createdTime: any } | null> | null, childDirectories?: Array<{ __typename?: 'DataLakeDirectoryModel', name: string, path: string, lastModifiedTime: any, createdTime: any, isDeleteDisabled: boolean } | null> | null } | null };

export type GetFileDirectoryFilesQueryVariables = Exact<{
  input: GetDataLakeFileInput;
}>;


export type GetFileDirectoryFilesQuery = { __typename?: 'Queries', dataLakeFilesSearch?: Array<{ __typename?: 'DataLakeFileModel', name: string, path: string, fileSize: string, fileSizeBytes: any, lastModifiedTime: any, createdTime: any } | null> | null };

export type IsaQualifiersListQueryVariables = Exact<{ [key: string]: never; }>;


export type IsaQualifiersListQuery = { __typename?: 'Queries', isaQualifiers?: { __typename?: 'PagingResultModelOfIsaQualifierModel', nodes?: Array<{ __typename?: 'IsaQualifierModel', isaQualifierCode: string, description?: string | null }> | null } | null };

export type LocaleListQueryVariables = Exact<{ [key: string]: never; }>;


export type LocaleListQuery = { __typename?: 'Queries', locales?: { __typename?: 'PagingResultModelOfLocaleModel', nodes?: Array<{ __typename?: 'LocaleModel', localeCode: string, description?: string | null }> | null } | null };

export type MapsListQueryVariables = Exact<{
  input: GetTransactionMapInput;
}>;


export type MapsListQuery = { __typename?: 'Queries', transactionMaps?: { __typename?: 'PagingResultModelOfTransactionMapModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'TransactionMapModel', id: any, description: string, isMapDeployed: boolean, isMapLoaded: boolean, standardVersion?: string | null, totalPartners?: number | null, transaction?: { __typename?: 'TransactionModel', id: any, name: string, description?: string | null, direction?: TransactionDirection | null } | null }> | null } | null };

export type MessagingLogByIdQueryVariables = Exact<{
  input: GetMessagingLogsInput;
}>;


export type MessagingLogByIdQuery = { __typename?: 'Queries', messagingLogs?: { __typename?: 'PagingResultModelOfMessagingLogModel', nodes?: Array<{ __typename?: 'MessagingLogModel', id: any, documentId?: string | null, description?: string | null, direction?: string | null, documentDate?: any | null, documentType?: string | null, documentReferenceId?: string | null, fileName?: string | null, internalClientCode?: string | null, internalPartnerCode?: string | null, invoice?: string | null, isAcknowledged?: boolean | null, messageType?: string | null, originalFileName?: string | null, pO?: string | null, processName: ProcessName, rawMessage?: string | null, receiverId?: string | null, senderId?: string | null, status?: DocumentStatus | null, totalLines?: number | null, totalQuantity?: any | null, totalValue?: any | null, createdTime: any, client?: { __typename?: 'ClientModel', id: any, name: string } | null, partner?: { __typename?: 'PartnerModel', id: any, name: string } | null, clientPartner?: { __typename?: 'ClientPartnerModel', id: any } | null }> | null } | null };

export type MessagingLogListQueryVariables = Exact<{
  input: GetMessagingLogsInput;
}>;


export type MessagingLogListQuery = { __typename?: 'Queries', messagingLogs?: { __typename?: 'PagingResultModelOfMessagingLogModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'MessagingLogModel', id: any, documentId?: string | null, description?: string | null, direction?: string | null, documentDate?: any | null, documentType?: string | null, documentReferenceId?: string | null, fileName?: string | null, internalClientCode?: string | null, internalPartnerCode?: string | null, invoice?: string | null, isAcknowledged?: boolean | null, messageType?: string | null, originalFileName?: string | null, pO?: string | null, processName: ProcessName, rawMessage?: string | null, receiverId?: string | null, senderId?: string | null, status?: DocumentStatus | null, totalLines?: number | null, totalQuantity?: any | null, totalValue?: any | null, createdTime: any, client?: { __typename?: 'ClientModel', id: any, name: string } | null, partner?: { __typename?: 'PartnerModel', id: any, name: string } | null, clientPartner?: { __typename?: 'ClientPartnerModel', id: any } | null }> | null } | null };

export type NotificationFormatterByIdQueryVariables = Exact<{
  input?: InputMaybe<GetNotificationFormatterInput>;
}>;


export type NotificationFormatterByIdQuery = { __typename?: 'Queries', notificationFormatters?: { __typename?: 'PagingResultModelOfNotificationFormatterModel', nodes?: Array<{ __typename?: 'NotificationFormatterModel', id: any, description: string, fileType?: string | null, formatterType?: string | null, subject?: string | null, body?: string | null, bodyType?: NotificationFormatterBodyType | null, asAttachment?: boolean | null, isForError?: boolean | null, template?: string | null, sourceType?: NotificationSourceType | null, totalTransactions?: number | null, notificationFormatterTransactions?: Array<{ __typename?: 'NotificationFormatterTransactionModel', id: any, notificationFormatterId: any, transactionId: any, transaction?: { __typename?: 'TransactionModel', id: any, name: string, description?: string | null, direction?: TransactionDirection | null, isActive?: boolean | null } | null } | null> | null }> | null } | null };

export type NotificationFormatterTransactionsByTransactionIdQueryVariables = Exact<{
  input: GetNotificationFormatterTransactionsInput;
}>;


export type NotificationFormatterTransactionsByTransactionIdQuery = { __typename?: 'Queries', notificationFormatterTransactions?: { __typename?: 'PagingResultModelOfNotificationFormatterTransactionModel', nodes?: Array<{ __typename?: 'NotificationFormatterTransactionModel', id: any, notificationFormatterId: any, transactionId: any, notificationFormatter?: { __typename?: 'NotificationFormatterModel', id: any, description: string } | null }> | null } | null };

export type NotificationFormatterTransactionsListQueryVariables = Exact<{
  input: GetNotificationFormatterTransactionsInput;
}>;


export type NotificationFormatterTransactionsListQuery = { __typename?: 'Queries', notificationFormatterTransactions?: { __typename?: 'PagingResultModelOfNotificationFormatterTransactionModel', nodes?: Array<{ __typename?: 'NotificationFormatterTransactionModel', id: any, notificationFormatterId: any, transactionId: any, transaction?: { __typename?: 'TransactionModel', id: any, name: string, description?: string | null, direction?: TransactionDirection | null, isActive?: boolean | null } | null }> | null } | null };

export type NotificationFormattersListQueryVariables = Exact<{
  input: GetNotificationFormatterInput;
}>;


export type NotificationFormattersListQuery = { __typename?: 'Queries', notificationFormatters?: { __typename?: 'PagingResultModelOfNotificationFormatterModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'NotificationFormatterModel', id: any, description: string, bodyType?: NotificationFormatterBodyType | null, asAttachment?: boolean | null, isForError?: boolean | null, totalTransactions?: number | null }> | null } | null };

export type GetPartnerNotificationRecipientsQueryVariables = Exact<{
  input: GetPartnerNotificationRecipientsInput;
}>;


export type GetPartnerNotificationRecipientsQuery = { __typename?: 'Queries', partnerNotificationRecipients?: { __typename?: 'PagingResultModelOfPartnerNotificationRecipientsModel', nodes?: Array<{ __typename?: 'PartnerNotificationRecipientsModel', id: any, description?: string | null, notificationType: NotificationType, recipients: string, receivesNotifications?: boolean | null, receivesErrors?: boolean | null }> | null } | null };

export type PhoneTypesListQueryVariables = Exact<{
  input: GetPhoneTypeInput;
}>;


export type PhoneTypesListQuery = { __typename?: 'Queries', phoneTypes?: { __typename?: 'PagingResultModelOfPhoneTypeModel', nodes?: Array<{ __typename?: 'PhoneTypeModel', phoneTypeCode?: string | null, description?: string | null }> | null } | null };

export type GetPipelineByIdQueryVariables = Exact<{
  input: GetPipelinesInput;
}>;


export type GetPipelineByIdQuery = { __typename?: 'Queries', pipelines?: { __typename?: 'PagingResultModelOfPipelineModel', nodes?: Array<{ __typename?: 'PipelineModel', createdBy: any, createdByName?: string | null, createdTime: any, description?: string | null, id: any, isTemplate?: boolean | null, isLegacy?: boolean | null, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, transactionId?: any | null, pipelineItems?: Array<{ __typename?: 'PipelineItemModel', id: any, description?: string | null, ediProcessClassName?: string | null, jsonArgs?: string | null, sortOrder: number, configuration?: { __typename?: 'ConfigurationModel', id: any, ediProcess: string, description?: string | null } | null } | null> | null, transaction?: { __typename?: 'TransactionModel', description?: string | null, direction?: TransactionDirection | null, name: string, id: any } | null }> | null } | null };

export type PipelineItemClassListQueryVariables = Exact<{ [key: string]: never; }>;


export type PipelineItemClassListQuery = { __typename?: 'Queries', pipelineItemClassNames?: { __typename?: 'PagingResultModelOfPipelineItemClassNameModel', nodes?: Array<{ __typename?: 'PipelineItemClassNameModel', className: string, description?: string | null, typeName: string }> | null } | null };

export type GetPipelinesQueryVariables = Exact<{
  input: GetPipelinesInput;
}>;


export type GetPipelinesQuery = { __typename?: 'Queries', pipelines?: { __typename?: 'PagingResultModelOfPipelineModel', nodes?: Array<{ __typename?: 'PipelineModel', description?: string | null, id: any, isTemplate?: boolean | null, transactionId?: any | null }> | null } | null };

export type PipelinesListQueryVariables = Exact<{
  input: GetPipelinesInput;
}>;


export type PipelinesListQuery = { __typename?: 'Queries', pipelines?: { __typename?: 'PagingResultModelOfPipelineModel', nodes?: Array<{ __typename?: 'PipelineModel', id: any, description?: string | null, isLegacy?: boolean | null, transaction?: { __typename?: 'TransactionModel', id: any, name: string, description?: string | null, direction?: TransactionDirection | null } | null, pipelineItems?: Array<{ __typename?: 'PipelineItemModel', id: any } | null> | null }> | null } | null };

export type PortalTransactionListQueryVariables = Exact<{
  input: GetPortalTransactionsInput;
}>;


export type PortalTransactionListQuery = { __typename?: 'Queries', portalTransactions?: { __typename?: 'PagingResultModelOfPortalTransactionModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'PortalTransactionModel', id: any, acknowledgedTime?: any | null, acknowledgementStatus?: DocumentAcknowledgementStatus | null, clientId?: any | null, clientTenantId?: any | null, partnerId?: any | null, currencyCode?: string | null, documentDate?: any | null, documentId?: string | null, documentNumber?: string | null, documentReferenceId?: string | null, ediDocumentResentCount?: number | null, ediDocumentResentTime?: any | null, erpOrderNumber?: string | null, originalFileName?: string | null, internalTransactionId?: string | null, isAbandoned?: boolean | null, purchaseOrderNumber?: string | null, totalLines?: number | null, totalQuantity?: any | null, totalValue?: any | null, createdTime?: any | null, client?: { __typename?: 'ClientModel', id: any, name: string } | null, partner?: { __typename?: 'PartnerModel', id: any, name: string } | null, clientPartner?: { __typename?: 'ClientPartnerModel', id: any } | null, transaction?: { __typename?: 'TransactionModel', id: any, name: string, direction?: TransactionDirection | null, normalizedDocumentType?: NormalizedDocumentType | null } | null, transactionErrors?: Array<{ __typename?: 'TransactionErrorModel', id: any, status?: ExceptionStatus | null } | null> | null }> | null } | null };

export type PostProcessingBlobsQueryVariables = Exact<{
  input: GetPostProcessingBlobInput;
}>;


export type PostProcessingBlobsQuery = { __typename?: 'Queries', postProcessingBlobs?: { __typename?: 'PagingResultModelOfPostProcessingBlobModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'PostProcessingBlobModel', description?: string | null, id: any, lastModifiedBy: any, lastModifiedTime: any, processBlobString?: string | null }> | null } | null };

export type GetPricingByIdQueryVariables = Exact<{
  input: GetPricingsInput;
}>;


export type GetPricingByIdQuery = { __typename?: 'Queries', pricings?: { __typename?: 'PagingResultModelOfPricingModel', nodes?: Array<{ __typename?: 'PricingModel', description: string, id: any, minServiceFees: any, currencyCode: string, billingItemCount?: number | null, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, pricingItems?: Array<{ __typename?: 'PricingItemModel', id: any, description?: string | null, feePerDocument: any, feePerLine: any, maxNumberOfTransactions: number, pricingId: any } | null> | null }> | null } | null };

export type PricingsListQueryVariables = Exact<{
  input: GetPricingsInput;
}>;


export type PricingsListQuery = { __typename?: 'Queries', pricings?: { __typename?: 'PagingResultModelOfPricingModel', nodes?: Array<{ __typename?: 'PricingModel', description: string, id: any, minServiceFees: any, currencyCode: string, billingItemCount?: number | null }> | null } | null };

export type ProcessListQueryVariables = Exact<{
  input: GetConfigurationsInput;
}>;


export type ProcessListQuery = { __typename?: 'Queries', configurations?: { __typename?: 'PagingResultModelOfConfigurationModel', nodes?: Array<{ __typename?: 'ConfigurationModel', description?: string | null, destPath: string, ediProcess: string, executionMode: string, extension: string, id: any, p1?: string | null, p2?: string | null, p3?: string | null, p4?: string | null, p5?: string | null, p6?: string | null, tpgClient: string, watcherPath: string }> | null } | null };

export type ErpProductsListQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpProductsListQuery = { __typename?: 'Queries', erpProducts?: { __typename?: 'PagingResultModelOfErpProductModel', nodes?: Array<{ __typename?: 'ErpProductModel', name: string, description: string, id: any, isAptean?: boolean | null }> | null } | null };

export type StandardExchangeFormatFileListQueryVariables = Exact<{
  input: GetStandardExchangeFormatInput;
}>;


export type StandardExchangeFormatFileListQuery = { __typename?: 'Queries', standardExchangeFormatStorageFiles?: { __typename?: 'PagingResultModelOfBlobStorageModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'BlobStorageModel', id: any, blobDocumentType: BlobDocumentType, blobFileName: string, comment: string, fileName: string, isActive: boolean, version: number, createdBy: any, createdByName?: string | null, createdTime: any, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, blobStorageReference?: { __typename?: 'BlobStorageReferenceModel', id: any, blobStorageId: any, blobDocumentId: any } | null }> | null } | null };

export type StatesListQueryVariables = Exact<{ [key: string]: never; }>;


export type StatesListQuery = { __typename?: 'Queries', states?: { __typename?: 'PagingResultModelOfStateModel', nodes?: Array<{ __typename?: 'StateModel', countryCode?: string | null, description?: string | null, stateCode?: string | null, id: any }> | null } | null };

export type SystemConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type SystemConfigurationQuery = { __typename?: 'Queries', systemConfiguration?: { __typename?: 'SystemConfigurationModel', id: any, billingRecipientsEmail?: string | null, errorRecipientsEmail?: string | null, ediDirectRecipientsEmail?: string | null } | null };

export type GetActiveSystemNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveSystemNotificationQuery = { __typename?: 'Queries', activeSystemNotification?: { __typename?: 'SystemNotificationModel', id: any, message?: string | null, notificationType?: SystemNotificationType | null, dateStart?: any | null, dateEnd?: any | null, environment?: SystemNotificationEnvironment | null } | null };

export type SystemNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type SystemNotificationsQuery = { __typename?: 'Queries', systemNotifications?: Array<{ __typename?: 'SystemNotificationModel', id: any, message?: string | null, notificationType?: SystemNotificationType | null, dateStart?: any | null, dateEnd?: any | null, environment?: SystemNotificationEnvironment | null } | null> | null };

export type GetTradingPartnerByIdQueryVariables = Exact<{
  input: GetPartnersInput;
}>;


export type GetTradingPartnerByIdQuery = { __typename?: 'Queries', partners?: { __typename?: 'PagingResultModelOfPartnerModel', nodes?: Array<{ __typename?: 'PartnerModel', id: any, internalPartnerCode: string, isaQualifierCode: string, localeCode?: string | null, name: string, partnerCode: string, statusCode?: PartnerStatus | null, functionalReconciliationMode: FunctionalReconciliationMode, website?: string | null, totalTransactions?: number | null, addresses?: Array<{ __typename?: 'AddressModel', addressLine1: string, addressLine2?: string | null, addressLine3?: string | null, addressLine4?: string | null, city?: string | null, countryCode?: string | null, id: any, isPrimary?: boolean | null, postalCode?: string | null, stateId?: any | null, state?: { __typename?: 'StateModel', stateCode?: string | null, description?: string | null, id: any } | null } | null> | null, businessArea?: { __typename?: 'BusinessAreaModel', name: string, description?: string | null, id: any } | null, partnerAKAs?: Array<{ __typename?: 'PartnerAkaModel', id: any, partnerCode: string, isaQualifierCode: string, isaQualifier?: { __typename?: 'IsaQualifierModel', isaQualifierCode: string, description?: string | null } | null } | null> | null, partnerContacts?: Array<{ __typename?: 'PartnerContactModel', id: any, partnerId: string, name: string, description: string, isActive?: boolean | null, isPrimary?: boolean | null, jobTitle?: string | null, addresses?: Array<{ __typename?: 'AddressModel', addressLine1: string, addressLine2?: string | null, addressLine3?: string | null, addressLine4?: string | null, city?: string | null, countryCode?: string | null, id: any, isPrimary?: boolean | null, postalCode?: string | null, stateId?: any | null, state?: { __typename?: 'StateModel', stateCode?: string | null, description?: string | null, id: any } | null } | null> | null, emails?: Array<{ __typename?: 'EmailModel', email: string, id: any, isPrimary?: boolean | null } | null> | null, phones?: Array<{ __typename?: 'PhoneModel', description?: string | null, id: any, phoneNumber?: string | null, phoneTypeCode?: string | null } | null> | null, notes?: Array<{ __typename?: 'NoteModel', createdBy: any, createdByName?: string | null, createdTime: any, header?: string | null, id: any, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, note: string, parentId: any } | null> | null } | null> | null, clients?: Array<{ __typename?: 'ClientModel', id: any, name: string, clientCode: string, statusCode?: ClientStatus | null, totalTransactions?: number | null, businessArea?: { __typename?: 'BusinessAreaModel', id: any, name: string } | null, erpProduct?: { __typename?: 'ErpProductModel', id: any, name: string } | null } | null> | null, ediStandards?: Array<{ __typename?: 'EdiStandardModel', description: string, id?: any | null, name: string } | null> | null, emails?: Array<{ __typename?: 'EmailModel', email: string, id: any, isPrimary?: boolean | null } | null> | null, phones?: Array<{ __typename?: 'PhoneModel', phoneNumber?: string | null, phoneTypeCode?: string | null, description?: string | null, id: any } | null> | null, notes?: Array<{ __typename?: 'NoteModel', createdBy: any, createdByName?: string | null, createdTime: any, header?: string | null, id: any, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, note: string, parentId: any } | null> | null, partnerTransactions?: Array<{ __typename?: 'PartnerTransactionModel', id: any, pipelineId?: any | null, functionalReconciliationMode: FunctionalReconciliationMode, outboundAcknowledgementOption?: OutboundAcknowledgementType | null, transaction?: { __typename?: 'TransactionModel', id: any, name: string, description?: string | null, direction?: TransactionDirection | null, isActive?: boolean | null } | null, clientPartnerTransactions?: Array<{ __typename?: 'ClientPartnerTransactionModel', id: any } | null> | null, partnerTransactionSchemas?: Array<{ __typename?: 'PartnerTransactionSchemaModel', id: any, partnerTransactionId: any, standardVersion?: string | null, description: string, documentString?: string | null, sourceFileName?: string | null } | null> | null, pipeline?: { __typename?: 'PipelineModel', description?: string | null, id: any } | null } | null> | null, attachments?: Array<{ __typename?: 'AttachmentModel', id: any, fileName: string, isLink?: boolean | null, description?: string | null, createdBy: any, createdByName?: string | null, createdTime: any, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, fileLastModifiedTime?: any | null } | null> | null }> | null } | null };

export type PartnersListQueryVariables = Exact<{
  input: GetPartnersInput;
}>;


export type PartnersListQuery = { __typename?: 'Queries', partners?: { __typename?: 'PagingResultModelOfPartnerModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'PartnerModel', name: string, isaQualifierCode: string, id: any, partnerCode: string, website?: string | null, totalTransactions?: number | null, businessArea?: { __typename?: 'BusinessAreaModel', id: any, description?: string | null, name: string } | null, ediStandards?: Array<{ __typename?: 'EdiStandardModel', description: string, id?: any | null, name: string } | null> | null }> | null } | null };

export type GetTransactionByIdQueryVariables = Exact<{
  input: GetTransactionsInput;
}>;


export type GetTransactionByIdQuery = { __typename?: 'Queries', transactions?: { __typename?: 'PagingResultModelOfTransactionModel', nodes?: Array<{ __typename?: 'TransactionModel', id: any, name: string, description?: string | null, direction?: TransactionDirection | null, isActive?: boolean | null, isBillable?: boolean | null, ediStandardId?: any | null, billableFactor?: any | null, normalizedDocumentType?: NormalizedDocumentType | null, documentTransformationSchema?: string | null, skipTargetDocumentCreation?: boolean | null, ediStandard?: { __typename?: 'EdiStandardModel', id?: any | null, name: string } | null, transactionXPath?: { __typename?: 'TransactionXPathModel', id: string, transactionId: string, xPathJson?: string | null } | null }> | null } | null };

export type TransactionMapByIdQueryVariables = Exact<{
  input: GetTransactionMapInput;
}>;


export type TransactionMapByIdQuery = { __typename?: 'Queries', transactionMaps?: { __typename?: 'PagingResultModelOfTransactionMapModel', nodes?: Array<{ __typename?: 'TransactionMapModel', id: any, createdBy: any, createdByName?: string | null, createdTime: any, description: string, documentString?: string | null, isMapDeployed: boolean, isMapLoaded: boolean, lastModifiedBy: any, lastModifiedByName?: string | null, lastModifiedTime: any, sourceFileName?: string | null, standardVersion?: string | null, totalPartners?: number | null, transactionId: any, transaction?: { __typename?: 'TransactionModel', id: any, name: string, description?: string | null, direction?: TransactionDirection | null } | null }> | null } | null };

export type TransactionMapPartnersQueryVariables = Exact<{
  input: GetTransactionMapPartnerInput;
}>;


export type TransactionMapPartnersQuery = { __typename?: 'Queries', transactionMapPartners?: { __typename?: 'PagingResultModelOfTransactionMapPartnerModel', nodes?: Array<{ __typename?: 'TransactionMapPartnerModel', id: any, partnerId?: any | null, partner?: { __typename?: 'PartnerModel', name: string, id: any, totalTransactions?: number | null, website?: string | null, ediStandards?: Array<{ __typename?: 'EdiStandardModel', id?: any | null, name: string } | null> | null } | null }> | null } | null };

export type TransactionsListQueryVariables = Exact<{
  input: GetTransactionsInput;
}>;


export type TransactionsListQuery = { __typename?: 'Queries', transactions?: { __typename?: 'PagingResultModelOfTransactionModel', nodes?: Array<{ __typename?: 'TransactionModel', id: any, name: string, description?: string | null, direction?: TransactionDirection | null, isActive?: boolean | null, isBillable?: boolean | null, ediStandardId?: any | null, billableFactor?: any | null, normalizedDocumentType?: NormalizedDocumentType | null, ediStandard?: { __typename?: 'EdiStandardModel', id?: any | null, name: string } | null, transactionXPath?: { __typename?: 'TransactionXPathModel', id: string } | null }> | null } | null };

export type GetPersonByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetPersonByEmailQuery = { __typename?: 'Queries', user?: { __typename?: 'UserModel', id: any, firstName: string, lastName: string, email: string, role: UserRole, recents?: Array<{ __typename?: 'RecentModel', entityId: any, entityType: EntityType, name: string, lastViewed: any, id: any } | null> | null, favorites?: Array<{ __typename?: 'FavoriteModel', entityId: any, entityType: EntityType, name: string, id: any } | null> | null } | null };

export type UserListQueryVariables = Exact<{
  input: GetUsersInput;
}>;


export type UserListQuery = { __typename?: 'Queries', users?: { __typename?: 'PagingResultModelOfUserModel', totalCount?: number | null, cursor?: { __typename?: 'PageModel', nextPage?: string | null, previousPage?: string | null } | null, nodes?: Array<{ __typename?: 'UserModel', id: any, firstName: string, lastName: string, email: string, role: UserRole, isActive?: boolean | null }> | null } | null };


export const UpdateDocumentArchiveAcknowledgementStatusDocument = gql`
    mutation updateDocumentArchiveAcknowledgementStatus($input: UpdateDocumentArchivesInput!) {
  updateDocumentArchiveAcknowledgementStatus(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpdateDocumentArchiveAcknowledgementStatusMutationFn = Apollo.MutationFunction<UpdateDocumentArchiveAcknowledgementStatusMutation, UpdateDocumentArchiveAcknowledgementStatusMutationVariables>;

/**
 * __useUpdateDocumentArchiveAcknowledgementStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentArchiveAcknowledgementStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentArchiveAcknowledgementStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentArchiveAcknowledgementStatusMutation, { data, loading, error }] = useUpdateDocumentArchiveAcknowledgementStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentArchiveAcknowledgementStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentArchiveAcknowledgementStatusMutation, UpdateDocumentArchiveAcknowledgementStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentArchiveAcknowledgementStatusMutation, UpdateDocumentArchiveAcknowledgementStatusMutationVariables>(UpdateDocumentArchiveAcknowledgementStatusDocument, options);
      }
export type UpdateDocumentArchiveAcknowledgementStatusMutationHookResult = ReturnType<typeof useUpdateDocumentArchiveAcknowledgementStatusMutation>;
export type UpdateDocumentArchiveAcknowledgementStatusMutationResult = Apollo.MutationResult<UpdateDocumentArchiveAcknowledgementStatusMutation>;
export type UpdateDocumentArchiveAcknowledgementStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentArchiveAcknowledgementStatusMutation, UpdateDocumentArchiveAcknowledgementStatusMutationVariables>;
export const AddClientPartnerDocument = gql`
    mutation addClientPartner($input: AddClientPartnerInput!) {
  addClientPartner(input: $input) {
    message
    errors {
      code
      message
    }
    result
    clientPartnerId
  }
}
    `;
export type AddClientPartnerMutationFn = Apollo.MutationFunction<AddClientPartnerMutation, AddClientPartnerMutationVariables>;

/**
 * __useAddClientPartnerMutation__
 *
 * To run a mutation, you first call `useAddClientPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientPartnerMutation, { data, loading, error }] = useAddClientPartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddClientPartnerMutation(baseOptions?: Apollo.MutationHookOptions<AddClientPartnerMutation, AddClientPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClientPartnerMutation, AddClientPartnerMutationVariables>(AddClientPartnerDocument, options);
      }
export type AddClientPartnerMutationHookResult = ReturnType<typeof useAddClientPartnerMutation>;
export type AddClientPartnerMutationResult = Apollo.MutationResult<AddClientPartnerMutation>;
export type AddClientPartnerMutationOptions = Apollo.BaseMutationOptions<AddClientPartnerMutation, AddClientPartnerMutationVariables>;
export const AddClientPartnerTransactionsDocument = gql`
    mutation addClientPartnerTransactions($input: AddClientPartnerTransactionsInput!) {
  addClientPartnerTransactions(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type AddClientPartnerTransactionsMutationFn = Apollo.MutationFunction<AddClientPartnerTransactionsMutation, AddClientPartnerTransactionsMutationVariables>;

/**
 * __useAddClientPartnerTransactionsMutation__
 *
 * To run a mutation, you first call `useAddClientPartnerTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientPartnerTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientPartnerTransactionsMutation, { data, loading, error }] = useAddClientPartnerTransactionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddClientPartnerTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<AddClientPartnerTransactionsMutation, AddClientPartnerTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClientPartnerTransactionsMutation, AddClientPartnerTransactionsMutationVariables>(AddClientPartnerTransactionsDocument, options);
      }
export type AddClientPartnerTransactionsMutationHookResult = ReturnType<typeof useAddClientPartnerTransactionsMutation>;
export type AddClientPartnerTransactionsMutationResult = Apollo.MutationResult<AddClientPartnerTransactionsMutation>;
export type AddClientPartnerTransactionsMutationOptions = Apollo.BaseMutationOptions<AddClientPartnerTransactionsMutation, AddClientPartnerTransactionsMutationVariables>;
export const AddNotificationFormatterTransactionsDocument = gql`
    mutation addNotificationFormatterTransactions($input: AddNotificationFormatterTransactionsInput!) {
  addNotificationFormatterTransactions(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type AddNotificationFormatterTransactionsMutationFn = Apollo.MutationFunction<AddNotificationFormatterTransactionsMutation, AddNotificationFormatterTransactionsMutationVariables>;

/**
 * __useAddNotificationFormatterTransactionsMutation__
 *
 * To run a mutation, you first call `useAddNotificationFormatterTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationFormatterTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotificationFormatterTransactionsMutation, { data, loading, error }] = useAddNotificationFormatterTransactionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNotificationFormatterTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<AddNotificationFormatterTransactionsMutation, AddNotificationFormatterTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNotificationFormatterTransactionsMutation, AddNotificationFormatterTransactionsMutationVariables>(AddNotificationFormatterTransactionsDocument, options);
      }
export type AddNotificationFormatterTransactionsMutationHookResult = ReturnType<typeof useAddNotificationFormatterTransactionsMutation>;
export type AddNotificationFormatterTransactionsMutationResult = Apollo.MutationResult<AddNotificationFormatterTransactionsMutation>;
export type AddNotificationFormatterTransactionsMutationOptions = Apollo.BaseMutationOptions<AddNotificationFormatterTransactionsMutation, AddNotificationFormatterTransactionsMutationVariables>;
export const AddPartnerTransactionsDocument = gql`
    mutation addPartnerTransactions($input: AddPartnerTransactionsInput!) {
  addPartnerTransactions(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type AddPartnerTransactionsMutationFn = Apollo.MutationFunction<AddPartnerTransactionsMutation, AddPartnerTransactionsMutationVariables>;

/**
 * __useAddPartnerTransactionsMutation__
 *
 * To run a mutation, you first call `useAddPartnerTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPartnerTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPartnerTransactionsMutation, { data, loading, error }] = useAddPartnerTransactionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPartnerTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<AddPartnerTransactionsMutation, AddPartnerTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPartnerTransactionsMutation, AddPartnerTransactionsMutationVariables>(AddPartnerTransactionsDocument, options);
      }
export type AddPartnerTransactionsMutationHookResult = ReturnType<typeof useAddPartnerTransactionsMutation>;
export type AddPartnerTransactionsMutationResult = Apollo.MutationResult<AddPartnerTransactionsMutation>;
export type AddPartnerTransactionsMutationOptions = Apollo.BaseMutationOptions<AddPartnerTransactionsMutation, AddPartnerTransactionsMutationVariables>;
export const ClonePipelineDocument = gql`
    mutation clonePipeline($input: ClonePipelineInput!) {
  clonePipeline(input: $input) {
    message
    errors {
      code
      message
    }
    result
    pipeline {
      id
      description
      transaction {
        id
        name
        description
      }
    }
  }
}
    `;
export type ClonePipelineMutationFn = Apollo.MutationFunction<ClonePipelineMutation, ClonePipelineMutationVariables>;

/**
 * __useClonePipelineMutation__
 *
 * To run a mutation, you first call `useClonePipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClonePipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clonePipelineMutation, { data, loading, error }] = useClonePipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClonePipelineMutation(baseOptions?: Apollo.MutationHookOptions<ClonePipelineMutation, ClonePipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClonePipelineMutation, ClonePipelineMutationVariables>(ClonePipelineDocument, options);
      }
export type ClonePipelineMutationHookResult = ReturnType<typeof useClonePipelineMutation>;
export type ClonePipelineMutationResult = Apollo.MutationResult<ClonePipelineMutation>;
export type ClonePipelineMutationOptions = Apollo.BaseMutationOptions<ClonePipelineMutation, ClonePipelineMutationVariables>;
export const ClonePricingDocument = gql`
    mutation clonePricing($input: ClonePricingInput!) {
  clonePricing(input: $input) {
    message
    errors {
      code
      message
    }
    result
    pricing {
      id
    }
  }
}
    `;
export type ClonePricingMutationFn = Apollo.MutationFunction<ClonePricingMutation, ClonePricingMutationVariables>;

/**
 * __useClonePricingMutation__
 *
 * To run a mutation, you first call `useClonePricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClonePricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clonePricingMutation, { data, loading, error }] = useClonePricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClonePricingMutation(baseOptions?: Apollo.MutationHookOptions<ClonePricingMutation, ClonePricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClonePricingMutation, ClonePricingMutationVariables>(ClonePricingDocument, options);
      }
export type ClonePricingMutationHookResult = ReturnType<typeof useClonePricingMutation>;
export type ClonePricingMutationResult = Apollo.MutationResult<ClonePricingMutation>;
export type ClonePricingMutationOptions = Apollo.BaseMutationOptions<ClonePricingMutation, ClonePricingMutationVariables>;
export const CreateDataLakeDirectoryDocument = gql`
    mutation createDataLakeDirectory($input: DataLakeDirectoryCreateRequestInput!) {
  createDataLakeDirectory(input: $input) {
    message
    errors {
      code
      message
    }
    result
    data
  }
}
    `;
export type CreateDataLakeDirectoryMutationFn = Apollo.MutationFunction<CreateDataLakeDirectoryMutation, CreateDataLakeDirectoryMutationVariables>;

/**
 * __useCreateDataLakeDirectoryMutation__
 *
 * To run a mutation, you first call `useCreateDataLakeDirectoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataLakeDirectoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataLakeDirectoryMutation, { data, loading, error }] = useCreateDataLakeDirectoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDataLakeDirectoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateDataLakeDirectoryMutation, CreateDataLakeDirectoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDataLakeDirectoryMutation, CreateDataLakeDirectoryMutationVariables>(CreateDataLakeDirectoryDocument, options);
      }
export type CreateDataLakeDirectoryMutationHookResult = ReturnType<typeof useCreateDataLakeDirectoryMutation>;
export type CreateDataLakeDirectoryMutationResult = Apollo.MutationResult<CreateDataLakeDirectoryMutation>;
export type CreateDataLakeDirectoryMutationOptions = Apollo.BaseMutationOptions<CreateDataLakeDirectoryMutation, CreateDataLakeDirectoryMutationVariables>;
export const DeleteBusinessAreaDocument = gql`
    mutation deleteBusinessArea($input: DeleteBusinessAreaInput!) {
  deleteBusinessArea(input: $input) {
    message
    result
    errors {
      code
      message
    }
  }
}
    `;
export type DeleteBusinessAreaMutationFn = Apollo.MutationFunction<DeleteBusinessAreaMutation, DeleteBusinessAreaMutationVariables>;

/**
 * __useDeleteBusinessAreaMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessAreaMutation, { data, loading, error }] = useDeleteBusinessAreaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBusinessAreaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBusinessAreaMutation, DeleteBusinessAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBusinessAreaMutation, DeleteBusinessAreaMutationVariables>(DeleteBusinessAreaDocument, options);
      }
export type DeleteBusinessAreaMutationHookResult = ReturnType<typeof useDeleteBusinessAreaMutation>;
export type DeleteBusinessAreaMutationResult = Apollo.MutationResult<DeleteBusinessAreaMutation>;
export type DeleteBusinessAreaMutationOptions = Apollo.BaseMutationOptions<DeleteBusinessAreaMutation, DeleteBusinessAreaMutationVariables>;
export const DeleteClientContactDocument = gql`
    mutation deleteClientContact($input: DeleteClientContactInput!) {
  deleteClientContact(input: $input) {
    message
    result
    errors {
      code
      message
    }
    id
  }
}
    `;
export type DeleteClientContactMutationFn = Apollo.MutationFunction<DeleteClientContactMutation, DeleteClientContactMutationVariables>;

/**
 * __useDeleteClientContactMutation__
 *
 * To run a mutation, you first call `useDeleteClientContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientContactMutation, { data, loading, error }] = useDeleteClientContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteClientContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientContactMutation, DeleteClientContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientContactMutation, DeleteClientContactMutationVariables>(DeleteClientContactDocument, options);
      }
export type DeleteClientContactMutationHookResult = ReturnType<typeof useDeleteClientContactMutation>;
export type DeleteClientContactMutationResult = Apollo.MutationResult<DeleteClientContactMutation>;
export type DeleteClientContactMutationOptions = Apollo.BaseMutationOptions<DeleteClientContactMutation, DeleteClientContactMutationVariables>;
export const DeleteClientPortalUserRelationshipDocument = gql`
    mutation deleteClientPortalUserRelationship($input: DeleteClientPortalUserInput!) {
  deleteClientPortalUserRelationship(input: $input) {
    message
    result
    tenantId
    portalUserId
  }
}
    `;
export type DeleteClientPortalUserRelationshipMutationFn = Apollo.MutationFunction<DeleteClientPortalUserRelationshipMutation, DeleteClientPortalUserRelationshipMutationVariables>;

/**
 * __useDeleteClientPortalUserRelationshipMutation__
 *
 * To run a mutation, you first call `useDeleteClientPortalUserRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientPortalUserRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientPortalUserRelationshipMutation, { data, loading, error }] = useDeleteClientPortalUserRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteClientPortalUserRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientPortalUserRelationshipMutation, DeleteClientPortalUserRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientPortalUserRelationshipMutation, DeleteClientPortalUserRelationshipMutationVariables>(DeleteClientPortalUserRelationshipDocument, options);
      }
export type DeleteClientPortalUserRelationshipMutationHookResult = ReturnType<typeof useDeleteClientPortalUserRelationshipMutation>;
export type DeleteClientPortalUserRelationshipMutationResult = Apollo.MutationResult<DeleteClientPortalUserRelationshipMutation>;
export type DeleteClientPortalUserRelationshipMutationOptions = Apollo.BaseMutationOptions<DeleteClientPortalUserRelationshipMutation, DeleteClientPortalUserRelationshipMutationVariables>;
export const DeleteCurrencyDocument = gql`
    mutation deleteCurrency($input: DeleteCurrencyInput!) {
  deleteCurrency(input: $input) {
    message
    result
    errors {
      code
      message
    }
  }
}
    `;
export type DeleteCurrencyMutationFn = Apollo.MutationFunction<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>;

/**
 * __useDeleteCurrencyMutation__
 *
 * To run a mutation, you first call `useDeleteCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCurrencyMutation, { data, loading, error }] = useDeleteCurrencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>(DeleteCurrencyDocument, options);
      }
export type DeleteCurrencyMutationHookResult = ReturnType<typeof useDeleteCurrencyMutation>;
export type DeleteCurrencyMutationResult = Apollo.MutationResult<DeleteCurrencyMutation>;
export type DeleteCurrencyMutationOptions = Apollo.BaseMutationOptions<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>;
export const DeleteDataLakeDirectoryDocument = gql`
    mutation deleteDataLakeDirectory($input: DataLakeDirectoryDeleteRequestInput!) {
  deleteDataLakeDirectory(input: $input) {
    message
    errors {
      code
      message
    }
    result
    data
  }
}
    `;
export type DeleteDataLakeDirectoryMutationFn = Apollo.MutationFunction<DeleteDataLakeDirectoryMutation, DeleteDataLakeDirectoryMutationVariables>;

/**
 * __useDeleteDataLakeDirectoryMutation__
 *
 * To run a mutation, you first call `useDeleteDataLakeDirectoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataLakeDirectoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataLakeDirectoryMutation, { data, loading, error }] = useDeleteDataLakeDirectoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDataLakeDirectoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDataLakeDirectoryMutation, DeleteDataLakeDirectoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDataLakeDirectoryMutation, DeleteDataLakeDirectoryMutationVariables>(DeleteDataLakeDirectoryDocument, options);
      }
export type DeleteDataLakeDirectoryMutationHookResult = ReturnType<typeof useDeleteDataLakeDirectoryMutation>;
export type DeleteDataLakeDirectoryMutationResult = Apollo.MutationResult<DeleteDataLakeDirectoryMutation>;
export type DeleteDataLakeDirectoryMutationOptions = Apollo.BaseMutationOptions<DeleteDataLakeDirectoryMutation, DeleteDataLakeDirectoryMutationVariables>;
export const DeleteDataLakeFileDocument = gql`
    mutation deleteDataLakeFile($input: DataLakeFileDeleteRequestInput!) {
  deleteDataLakeFile(input: $input) {
    message
    result
    errors {
      code
      message
    }
  }
}
    `;
export type DeleteDataLakeFileMutationFn = Apollo.MutationFunction<DeleteDataLakeFileMutation, DeleteDataLakeFileMutationVariables>;

/**
 * __useDeleteDataLakeFileMutation__
 *
 * To run a mutation, you first call `useDeleteDataLakeFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataLakeFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataLakeFileMutation, { data, loading, error }] = useDeleteDataLakeFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDataLakeFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDataLakeFileMutation, DeleteDataLakeFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDataLakeFileMutation, DeleteDataLakeFileMutationVariables>(DeleteDataLakeFileDocument, options);
      }
export type DeleteDataLakeFileMutationHookResult = ReturnType<typeof useDeleteDataLakeFileMutation>;
export type DeleteDataLakeFileMutationResult = Apollo.MutationResult<DeleteDataLakeFileMutation>;
export type DeleteDataLakeFileMutationOptions = Apollo.BaseMutationOptions<DeleteDataLakeFileMutation, DeleteDataLakeFileMutationVariables>;
export const DeleteEntityByIdDocument = gql`
    mutation deleteEntityById($input: DeleteByIdInput!) {
  deleteById(input: $input) {
    message
    result
    errors {
      code
      message
    }
  }
}
    `;
export type DeleteEntityByIdMutationFn = Apollo.MutationFunction<DeleteEntityByIdMutation, DeleteEntityByIdMutationVariables>;

/**
 * __useDeleteEntityByIdMutation__
 *
 * To run a mutation, you first call `useDeleteEntityByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityByIdMutation, { data, loading, error }] = useDeleteEntityByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEntityByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEntityByIdMutation, DeleteEntityByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEntityByIdMutation, DeleteEntityByIdMutationVariables>(DeleteEntityByIdDocument, options);
      }
export type DeleteEntityByIdMutationHookResult = ReturnType<typeof useDeleteEntityByIdMutation>;
export type DeleteEntityByIdMutationResult = Apollo.MutationResult<DeleteEntityByIdMutation>;
export type DeleteEntityByIdMutationOptions = Apollo.BaseMutationOptions<DeleteEntityByIdMutation, DeleteEntityByIdMutationVariables>;
export const DeleteErpProductDocument = gql`
    mutation deleteErpProduct($input: DeleteErpProductInput!) {
  deleteErpProduct(input: $input) {
    message
    result
    errors {
      code
      message
    }
  }
}
    `;
export type DeleteErpProductMutationFn = Apollo.MutationFunction<DeleteErpProductMutation, DeleteErpProductMutationVariables>;

/**
 * __useDeleteErpProductMutation__
 *
 * To run a mutation, you first call `useDeleteErpProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteErpProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteErpProductMutation, { data, loading, error }] = useDeleteErpProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteErpProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteErpProductMutation, DeleteErpProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteErpProductMutation, DeleteErpProductMutationVariables>(DeleteErpProductDocument, options);
      }
export type DeleteErpProductMutationHookResult = ReturnType<typeof useDeleteErpProductMutation>;
export type DeleteErpProductMutationResult = Apollo.MutationResult<DeleteErpProductMutation>;
export type DeleteErpProductMutationOptions = Apollo.BaseMutationOptions<DeleteErpProductMutation, DeleteErpProductMutationVariables>;
export const DeleteTransactionDocument = gql`
    mutation deleteTransaction($input: DeleteTransactionInput!) {
  deleteTransaction(input: $input) {
    message
    result
    errors {
      code
      message
    }
  }
}
    `;
export type DeleteTransactionMutationFn = Apollo.MutationFunction<DeleteTransactionMutation, DeleteTransactionMutationVariables>;

/**
 * __useDeleteTransactionMutation__
 *
 * To run a mutation, you first call `useDeleteTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransactionMutation, { data, loading, error }] = useDeleteTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTransactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransactionMutation, DeleteTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransactionMutation, DeleteTransactionMutationVariables>(DeleteTransactionDocument, options);
      }
export type DeleteTransactionMutationHookResult = ReturnType<typeof useDeleteTransactionMutation>;
export type DeleteTransactionMutationResult = Apollo.MutationResult<DeleteTransactionMutation>;
export type DeleteTransactionMutationOptions = Apollo.BaseMutationOptions<DeleteTransactionMutation, DeleteTransactionMutationVariables>;
export const DeleteEdiUserDocument = gql`
    mutation deleteEdiUser($input: DeleteUserInput!) {
  deleteUser(input: $input) {
    message
    result
    userId
  }
}
    `;
export type DeleteEdiUserMutationFn = Apollo.MutationFunction<DeleteEdiUserMutation, DeleteEdiUserMutationVariables>;

/**
 * __useDeleteEdiUserMutation__
 *
 * To run a mutation, you first call `useDeleteEdiUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEdiUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEdiUserMutation, { data, loading, error }] = useDeleteEdiUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEdiUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEdiUserMutation, DeleteEdiUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEdiUserMutation, DeleteEdiUserMutationVariables>(DeleteEdiUserDocument, options);
      }
export type DeleteEdiUserMutationHookResult = ReturnType<typeof useDeleteEdiUserMutation>;
export type DeleteEdiUserMutationResult = Apollo.MutationResult<DeleteEdiUserMutation>;
export type DeleteEdiUserMutationOptions = Apollo.BaseMutationOptions<DeleteEdiUserMutation, DeleteEdiUserMutationVariables>;
export const ExecuteBlobStorageDownloadDocument = gql`
    mutation executeBlobStorageDownload($input: BlobDownloadRequestInput!) {
  executeBlobStorageDownload(input: $input) {
    message
    errors {
      code
      message
    }
    result
    data
  }
}
    `;
export type ExecuteBlobStorageDownloadMutationFn = Apollo.MutationFunction<ExecuteBlobStorageDownloadMutation, ExecuteBlobStorageDownloadMutationVariables>;

/**
 * __useExecuteBlobStorageDownloadMutation__
 *
 * To run a mutation, you first call `useExecuteBlobStorageDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteBlobStorageDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeBlobStorageDownloadMutation, { data, loading, error }] = useExecuteBlobStorageDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteBlobStorageDownloadMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteBlobStorageDownloadMutation, ExecuteBlobStorageDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteBlobStorageDownloadMutation, ExecuteBlobStorageDownloadMutationVariables>(ExecuteBlobStorageDownloadDocument, options);
      }
export type ExecuteBlobStorageDownloadMutationHookResult = ReturnType<typeof useExecuteBlobStorageDownloadMutation>;
export type ExecuteBlobStorageDownloadMutationResult = Apollo.MutationResult<ExecuteBlobStorageDownloadMutation>;
export type ExecuteBlobStorageDownloadMutationOptions = Apollo.BaseMutationOptions<ExecuteBlobStorageDownloadMutation, ExecuteBlobStorageDownloadMutationVariables>;
export const ExecuteBlobStorageUploadDocument = gql`
    mutation executeBlobStorageUpload($input: BlobUploadRequestInput!) {
  executeBlobStorageUpload(input: $input) {
    message
    errors {
      code
      message
    }
    result
    data
  }
}
    `;
export type ExecuteBlobStorageUploadMutationFn = Apollo.MutationFunction<ExecuteBlobStorageUploadMutation, ExecuteBlobStorageUploadMutationVariables>;

/**
 * __useExecuteBlobStorageUploadMutation__
 *
 * To run a mutation, you first call `useExecuteBlobStorageUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteBlobStorageUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeBlobStorageUploadMutation, { data, loading, error }] = useExecuteBlobStorageUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteBlobStorageUploadMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteBlobStorageUploadMutation, ExecuteBlobStorageUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteBlobStorageUploadMutation, ExecuteBlobStorageUploadMutationVariables>(ExecuteBlobStorageUploadDocument, options);
      }
export type ExecuteBlobStorageUploadMutationHookResult = ReturnType<typeof useExecuteBlobStorageUploadMutation>;
export type ExecuteBlobStorageUploadMutationResult = Apollo.MutationResult<ExecuteBlobStorageUploadMutation>;
export type ExecuteBlobStorageUploadMutationOptions = Apollo.BaseMutationOptions<ExecuteBlobStorageUploadMutation, ExecuteBlobStorageUploadMutationVariables>;
export const ExecuteDataLakeFileDownloadDocument = gql`
    mutation executeDataLakeFileDownload($input: DataLakeFileDownloadRequestInput!) {
  executeDataLakeFileDownload(input: $input) {
    message
    errors {
      code
      message
    }
    result
    data
  }
}
    `;
export type ExecuteDataLakeFileDownloadMutationFn = Apollo.MutationFunction<ExecuteDataLakeFileDownloadMutation, ExecuteDataLakeFileDownloadMutationVariables>;

/**
 * __useExecuteDataLakeFileDownloadMutation__
 *
 * To run a mutation, you first call `useExecuteDataLakeFileDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteDataLakeFileDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeDataLakeFileDownloadMutation, { data, loading, error }] = useExecuteDataLakeFileDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteDataLakeFileDownloadMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteDataLakeFileDownloadMutation, ExecuteDataLakeFileDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteDataLakeFileDownloadMutation, ExecuteDataLakeFileDownloadMutationVariables>(ExecuteDataLakeFileDownloadDocument, options);
      }
export type ExecuteDataLakeFileDownloadMutationHookResult = ReturnType<typeof useExecuteDataLakeFileDownloadMutation>;
export type ExecuteDataLakeFileDownloadMutationResult = Apollo.MutationResult<ExecuteDataLakeFileDownloadMutation>;
export type ExecuteDataLakeFileDownloadMutationOptions = Apollo.BaseMutationOptions<ExecuteDataLakeFileDownloadMutation, ExecuteDataLakeFileDownloadMutationVariables>;
export const ExecuteDataLakeFileUploadDocument = gql`
    mutation executeDataLakeFileUpload($input: BulkDataLakeFileUploadRequestInput!) {
  executeDataLakeFileUpload(input: $input) {
    message
    errors {
      code
      message
    }
    result
    data
  }
}
    `;
export type ExecuteDataLakeFileUploadMutationFn = Apollo.MutationFunction<ExecuteDataLakeFileUploadMutation, ExecuteDataLakeFileUploadMutationVariables>;

/**
 * __useExecuteDataLakeFileUploadMutation__
 *
 * To run a mutation, you first call `useExecuteDataLakeFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteDataLakeFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeDataLakeFileUploadMutation, { data, loading, error }] = useExecuteDataLakeFileUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteDataLakeFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteDataLakeFileUploadMutation, ExecuteDataLakeFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteDataLakeFileUploadMutation, ExecuteDataLakeFileUploadMutationVariables>(ExecuteDataLakeFileUploadDocument, options);
      }
export type ExecuteDataLakeFileUploadMutationHookResult = ReturnType<typeof useExecuteDataLakeFileUploadMutation>;
export type ExecuteDataLakeFileUploadMutationResult = Apollo.MutationResult<ExecuteDataLakeFileUploadMutation>;
export type ExecuteDataLakeFileUploadMutationOptions = Apollo.BaseMutationOptions<ExecuteDataLakeFileUploadMutation, ExecuteDataLakeFileUploadMutationVariables>;
export const ExecuteEdiActionSvcActionDocument = gql`
    mutation executeEdiActionSvcAction($input: EdiActionServiceInput!) {
  executeEdiActionSvcAction(input: $input) {
    message
    errors {
      code
      message
    }
    result
    data
  }
}
    `;
export type ExecuteEdiActionSvcActionMutationFn = Apollo.MutationFunction<ExecuteEdiActionSvcActionMutation, ExecuteEdiActionSvcActionMutationVariables>;

/**
 * __useExecuteEdiActionSvcActionMutation__
 *
 * To run a mutation, you first call `useExecuteEdiActionSvcActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteEdiActionSvcActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeEdiActionSvcActionMutation, { data, loading, error }] = useExecuteEdiActionSvcActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteEdiActionSvcActionMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteEdiActionSvcActionMutation, ExecuteEdiActionSvcActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteEdiActionSvcActionMutation, ExecuteEdiActionSvcActionMutationVariables>(ExecuteEdiActionSvcActionDocument, options);
      }
export type ExecuteEdiActionSvcActionMutationHookResult = ReturnType<typeof useExecuteEdiActionSvcActionMutation>;
export type ExecuteEdiActionSvcActionMutationResult = Apollo.MutationResult<ExecuteEdiActionSvcActionMutation>;
export type ExecuteEdiActionSvcActionMutationOptions = Apollo.BaseMutationOptions<ExecuteEdiActionSvcActionMutation, ExecuteEdiActionSvcActionMutationVariables>;
export const MassDeleteEntityByIdsDocument = gql`
    mutation massDeleteEntityByIds($input: DeleteMultipleByIdsInput!) {
  deleteMultipleByIds(input: $input) {
    message
    result
    errors {
      code
      message
    }
  }
}
    `;
export type MassDeleteEntityByIdsMutationFn = Apollo.MutationFunction<MassDeleteEntityByIdsMutation, MassDeleteEntityByIdsMutationVariables>;

/**
 * __useMassDeleteEntityByIdsMutation__
 *
 * To run a mutation, you first call `useMassDeleteEntityByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassDeleteEntityByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massDeleteEntityByIdsMutation, { data, loading, error }] = useMassDeleteEntityByIdsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMassDeleteEntityByIdsMutation(baseOptions?: Apollo.MutationHookOptions<MassDeleteEntityByIdsMutation, MassDeleteEntityByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MassDeleteEntityByIdsMutation, MassDeleteEntityByIdsMutationVariables>(MassDeleteEntityByIdsDocument, options);
      }
export type MassDeleteEntityByIdsMutationHookResult = ReturnType<typeof useMassDeleteEntityByIdsMutation>;
export type MassDeleteEntityByIdsMutationResult = Apollo.MutationResult<MassDeleteEntityByIdsMutation>;
export type MassDeleteEntityByIdsMutationOptions = Apollo.BaseMutationOptions<MassDeleteEntityByIdsMutation, MassDeleteEntityByIdsMutationVariables>;
export const MoveDataLakeFileDocument = gql`
    mutation moveDataLakeFile($input: DataLakeMoveFileRequestInput!) {
  moveDataLakeFile(input: $input) {
    message
    result
    errors {
      code
      message
    }
  }
}
    `;
export type MoveDataLakeFileMutationFn = Apollo.MutationFunction<MoveDataLakeFileMutation, MoveDataLakeFileMutationVariables>;

/**
 * __useMoveDataLakeFileMutation__
 *
 * To run a mutation, you first call `useMoveDataLakeFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveDataLakeFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveDataLakeFileMutation, { data, loading, error }] = useMoveDataLakeFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveDataLakeFileMutation(baseOptions?: Apollo.MutationHookOptions<MoveDataLakeFileMutation, MoveDataLakeFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveDataLakeFileMutation, MoveDataLakeFileMutationVariables>(MoveDataLakeFileDocument, options);
      }
export type MoveDataLakeFileMutationHookResult = ReturnType<typeof useMoveDataLakeFileMutation>;
export type MoveDataLakeFileMutationResult = Apollo.MutationResult<MoveDataLakeFileMutation>;
export type MoveDataLakeFileMutationOptions = Apollo.BaseMutationOptions<MoveDataLakeFileMutation, MoveDataLakeFileMutationVariables>;
export const ReprocessFailedDataLakeFileDocument = gql`
    mutation reprocessFailedDataLakeFile($input: DataLakeReprocessFailedFileRequestInput!) {
  reprocessFailedDataLakeFile(input: $input) {
    message
    result
    errors {
      code
      message
    }
  }
}
    `;
export type ReprocessFailedDataLakeFileMutationFn = Apollo.MutationFunction<ReprocessFailedDataLakeFileMutation, ReprocessFailedDataLakeFileMutationVariables>;

/**
 * __useReprocessFailedDataLakeFileMutation__
 *
 * To run a mutation, you first call `useReprocessFailedDataLakeFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessFailedDataLakeFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessFailedDataLakeFileMutation, { data, loading, error }] = useReprocessFailedDataLakeFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReprocessFailedDataLakeFileMutation(baseOptions?: Apollo.MutationHookOptions<ReprocessFailedDataLakeFileMutation, ReprocessFailedDataLakeFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReprocessFailedDataLakeFileMutation, ReprocessFailedDataLakeFileMutationVariables>(ReprocessFailedDataLakeFileDocument, options);
      }
export type ReprocessFailedDataLakeFileMutationHookResult = ReturnType<typeof useReprocessFailedDataLakeFileMutation>;
export type ReprocessFailedDataLakeFileMutationResult = Apollo.MutationResult<ReprocessFailedDataLakeFileMutation>;
export type ReprocessFailedDataLakeFileMutationOptions = Apollo.BaseMutationOptions<ReprocessFailedDataLakeFileMutation, ReprocessFailedDataLakeFileMutationVariables>;
export const UpdateBlobStorageActiveDocument = gql`
    mutation updateBlobStorageActive($input: UpdateBlobStorageInput!) {
  updateFileVersionIsActive(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpdateBlobStorageActiveMutationFn = Apollo.MutationFunction<UpdateBlobStorageActiveMutation, UpdateBlobStorageActiveMutationVariables>;

/**
 * __useUpdateBlobStorageActiveMutation__
 *
 * To run a mutation, you first call `useUpdateBlobStorageActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlobStorageActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlobStorageActiveMutation, { data, loading, error }] = useUpdateBlobStorageActiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBlobStorageActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlobStorageActiveMutation, UpdateBlobStorageActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlobStorageActiveMutation, UpdateBlobStorageActiveMutationVariables>(UpdateBlobStorageActiveDocument, options);
      }
export type UpdateBlobStorageActiveMutationHookResult = ReturnType<typeof useUpdateBlobStorageActiveMutation>;
export type UpdateBlobStorageActiveMutationResult = Apollo.MutationResult<UpdateBlobStorageActiveMutation>;
export type UpdateBlobStorageActiveMutationOptions = Apollo.BaseMutationOptions<UpdateBlobStorageActiveMutation, UpdateBlobStorageActiveMutationVariables>;
export const UpdateClientPartnerDocument = gql`
    mutation updateClientPartner($input: UpdateClientPartnerInput!) {
  updateClientPartner(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpdateClientPartnerMutationFn = Apollo.MutationFunction<UpdateClientPartnerMutation, UpdateClientPartnerMutationVariables>;

/**
 * __useUpdateClientPartnerMutation__
 *
 * To run a mutation, you first call `useUpdateClientPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientPartnerMutation, { data, loading, error }] = useUpdateClientPartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientPartnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientPartnerMutation, UpdateClientPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientPartnerMutation, UpdateClientPartnerMutationVariables>(UpdateClientPartnerDocument, options);
      }
export type UpdateClientPartnerMutationHookResult = ReturnType<typeof useUpdateClientPartnerMutation>;
export type UpdateClientPartnerMutationResult = Apollo.MutationResult<UpdateClientPartnerMutation>;
export type UpdateClientPartnerMutationOptions = Apollo.BaseMutationOptions<UpdateClientPartnerMutation, UpdateClientPartnerMutationVariables>;
export const UpdateClientPartnerTransactionDocument = gql`
    mutation updateClientPartnerTransaction($input: UpdateClientPartnerTransactionInput!) {
  updateClientPartnerTransaction(input: $input) {
    message
    errors {
      code
      message
    }
    result
    clientPartnerTransaction {
      id
    }
  }
}
    `;
export type UpdateClientPartnerTransactionMutationFn = Apollo.MutationFunction<UpdateClientPartnerTransactionMutation, UpdateClientPartnerTransactionMutationVariables>;

/**
 * __useUpdateClientPartnerTransactionMutation__
 *
 * To run a mutation, you first call `useUpdateClientPartnerTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientPartnerTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientPartnerTransactionMutation, { data, loading, error }] = useUpdateClientPartnerTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientPartnerTransactionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientPartnerTransactionMutation, UpdateClientPartnerTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientPartnerTransactionMutation, UpdateClientPartnerTransactionMutationVariables>(UpdateClientPartnerTransactionDocument, options);
      }
export type UpdateClientPartnerTransactionMutationHookResult = ReturnType<typeof useUpdateClientPartnerTransactionMutation>;
export type UpdateClientPartnerTransactionMutationResult = Apollo.MutationResult<UpdateClientPartnerTransactionMutation>;
export type UpdateClientPartnerTransactionMutationOptions = Apollo.BaseMutationOptions<UpdateClientPartnerTransactionMutation, UpdateClientPartnerTransactionMutationVariables>;
export const UpdateDocumentArchiveIsAbandonedDocument = gql`
    mutation updateDocumentArchiveIsAbandoned($input: UpdateDocumentArchivesInput!) {
  updateDocumentArchiveIsAbandoned(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpdateDocumentArchiveIsAbandonedMutationFn = Apollo.MutationFunction<UpdateDocumentArchiveIsAbandonedMutation, UpdateDocumentArchiveIsAbandonedMutationVariables>;

/**
 * __useUpdateDocumentArchiveIsAbandonedMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentArchiveIsAbandonedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentArchiveIsAbandonedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentArchiveIsAbandonedMutation, { data, loading, error }] = useUpdateDocumentArchiveIsAbandonedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentArchiveIsAbandonedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentArchiveIsAbandonedMutation, UpdateDocumentArchiveIsAbandonedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentArchiveIsAbandonedMutation, UpdateDocumentArchiveIsAbandonedMutationVariables>(UpdateDocumentArchiveIsAbandonedDocument, options);
      }
export type UpdateDocumentArchiveIsAbandonedMutationHookResult = ReturnType<typeof useUpdateDocumentArchiveIsAbandonedMutation>;
export type UpdateDocumentArchiveIsAbandonedMutationResult = Apollo.MutationResult<UpdateDocumentArchiveIsAbandonedMutation>;
export type UpdateDocumentArchiveIsAbandonedMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentArchiveIsAbandonedMutation, UpdateDocumentArchiveIsAbandonedMutationVariables>;
export const UpdatePartnerTransactionDocument = gql`
    mutation updatePartnerTransaction($input: UpdatePartnerTransactionInput!) {
  updatePartnerTransaction(input: $input) {
    message
    errors {
      code
      message
    }
    result
    partnerTransaction {
      id
    }
  }
}
    `;
export type UpdatePartnerTransactionMutationFn = Apollo.MutationFunction<UpdatePartnerTransactionMutation, UpdatePartnerTransactionMutationVariables>;

/**
 * __useUpdatePartnerTransactionMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerTransactionMutation, { data, loading, error }] = useUpdatePartnerTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePartnerTransactionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerTransactionMutation, UpdatePartnerTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerTransactionMutation, UpdatePartnerTransactionMutationVariables>(UpdatePartnerTransactionDocument, options);
      }
export type UpdatePartnerTransactionMutationHookResult = ReturnType<typeof useUpdatePartnerTransactionMutation>;
export type UpdatePartnerTransactionMutationResult = Apollo.MutationResult<UpdatePartnerTransactionMutation>;
export type UpdatePartnerTransactionMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerTransactionMutation, UpdatePartnerTransactionMutationVariables>;
export const UpdateTransactionErrorCategoryDocument = gql`
    mutation updateTransactionErrorCategory($input: UpdateTransactionErrorCategoryInput!) {
  updateTransactionErrorCategory(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpdateTransactionErrorCategoryMutationFn = Apollo.MutationFunction<UpdateTransactionErrorCategoryMutation, UpdateTransactionErrorCategoryMutationVariables>;

/**
 * __useUpdateTransactionErrorCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionErrorCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionErrorCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionErrorCategoryMutation, { data, loading, error }] = useUpdateTransactionErrorCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransactionErrorCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionErrorCategoryMutation, UpdateTransactionErrorCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionErrorCategoryMutation, UpdateTransactionErrorCategoryMutationVariables>(UpdateTransactionErrorCategoryDocument, options);
      }
export type UpdateTransactionErrorCategoryMutationHookResult = ReturnType<typeof useUpdateTransactionErrorCategoryMutation>;
export type UpdateTransactionErrorCategoryMutationResult = Apollo.MutationResult<UpdateTransactionErrorCategoryMutation>;
export type UpdateTransactionErrorCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionErrorCategoryMutation, UpdateTransactionErrorCategoryMutationVariables>;
export const UpdateTransactionErrorsDocument = gql`
    mutation updateTransactionErrors($input: UpdateTransactionErrorsInput!) {
  updateTransactionErrors(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpdateTransactionErrorsMutationFn = Apollo.MutationFunction<UpdateTransactionErrorsMutation, UpdateTransactionErrorsMutationVariables>;

/**
 * __useUpdateTransactionErrorsMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionErrorsMutation, { data, loading, error }] = useUpdateTransactionErrorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransactionErrorsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionErrorsMutation, UpdateTransactionErrorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionErrorsMutation, UpdateTransactionErrorsMutationVariables>(UpdateTransactionErrorsDocument, options);
      }
export type UpdateTransactionErrorsMutationHookResult = ReturnType<typeof useUpdateTransactionErrorsMutation>;
export type UpdateTransactionErrorsMutationResult = Apollo.MutationResult<UpdateTransactionErrorsMutation>;
export type UpdateTransactionErrorsMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionErrorsMutation, UpdateTransactionErrorsMutationVariables>;
export const UpsertBillingDocument = gql`
    mutation upsertBilling($input: UpsertBillingInput!) {
  upsertBilling(input: $input) {
    message
    errors {
      code
      message
    }
    result
    billing {
      id
    }
  }
}
    `;
export type UpsertBillingMutationFn = Apollo.MutationFunction<UpsertBillingMutation, UpsertBillingMutationVariables>;

/**
 * __useUpsertBillingMutation__
 *
 * To run a mutation, you first call `useUpsertBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBillingMutation, { data, loading, error }] = useUpsertBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertBillingMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBillingMutation, UpsertBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertBillingMutation, UpsertBillingMutationVariables>(UpsertBillingDocument, options);
      }
export type UpsertBillingMutationHookResult = ReturnType<typeof useUpsertBillingMutation>;
export type UpsertBillingMutationResult = Apollo.MutationResult<UpsertBillingMutation>;
export type UpsertBillingMutationOptions = Apollo.BaseMutationOptions<UpsertBillingMutation, UpsertBillingMutationVariables>;
export const UpsertBillingItemDocument = gql`
    mutation upsertBillingItem($input: UpsertBillingItemInput!) {
  upsertBillingItem(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertBillingItemMutationFn = Apollo.MutationFunction<UpsertBillingItemMutation, UpsertBillingItemMutationVariables>;

/**
 * __useUpsertBillingItemMutation__
 *
 * To run a mutation, you first call `useUpsertBillingItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBillingItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBillingItemMutation, { data, loading, error }] = useUpsertBillingItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertBillingItemMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBillingItemMutation, UpsertBillingItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertBillingItemMutation, UpsertBillingItemMutationVariables>(UpsertBillingItemDocument, options);
      }
export type UpsertBillingItemMutationHookResult = ReturnType<typeof useUpsertBillingItemMutation>;
export type UpsertBillingItemMutationResult = Apollo.MutationResult<UpsertBillingItemMutation>;
export type UpsertBillingItemMutationOptions = Apollo.BaseMutationOptions<UpsertBillingItemMutation, UpsertBillingItemMutationVariables>;
export const UpsertBusinessAreaDocument = gql`
    mutation upsertBusinessArea($input: UpsertBusinessAreaInput!) {
  upsertBusinessArea(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertBusinessAreaMutationFn = Apollo.MutationFunction<UpsertBusinessAreaMutation, UpsertBusinessAreaMutationVariables>;

/**
 * __useUpsertBusinessAreaMutation__
 *
 * To run a mutation, you first call `useUpsertBusinessAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBusinessAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBusinessAreaMutation, { data, loading, error }] = useUpsertBusinessAreaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertBusinessAreaMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBusinessAreaMutation, UpsertBusinessAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertBusinessAreaMutation, UpsertBusinessAreaMutationVariables>(UpsertBusinessAreaDocument, options);
      }
export type UpsertBusinessAreaMutationHookResult = ReturnType<typeof useUpsertBusinessAreaMutation>;
export type UpsertBusinessAreaMutationResult = Apollo.MutationResult<UpsertBusinessAreaMutation>;
export type UpsertBusinessAreaMutationOptions = Apollo.BaseMutationOptions<UpsertBusinessAreaMutation, UpsertBusinessAreaMutationVariables>;
export const UpsertClientDocument = gql`
    mutation upsertClient($input: UpsertClientInput!) {
  upsertClient(input: $input) {
    message
    errors {
      code
      message
    }
    result
    client {
      id
    }
  }
}
    `;
export type UpsertClientMutationFn = Apollo.MutationFunction<UpsertClientMutation, UpsertClientMutationVariables>;

/**
 * __useUpsertClientMutation__
 *
 * To run a mutation, you first call `useUpsertClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientMutation, { data, loading, error }] = useUpsertClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientMutation, UpsertClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientMutation, UpsertClientMutationVariables>(UpsertClientDocument, options);
      }
export type UpsertClientMutationHookResult = ReturnType<typeof useUpsertClientMutation>;
export type UpsertClientMutationResult = Apollo.MutationResult<UpsertClientMutation>;
export type UpsertClientMutationOptions = Apollo.BaseMutationOptions<UpsertClientMutation, UpsertClientMutationVariables>;
export const UpsertClientAkaDocument = gql`
    mutation upsertClientAKA($input: UpsertClientAkaInput!) {
  upsertClientAka(input: $input) {
    message
    errors {
      code
      message
    }
    result
    clientAKA {
      id
    }
  }
}
    `;
export type UpsertClientAkaMutationFn = Apollo.MutationFunction<UpsertClientAkaMutation, UpsertClientAkaMutationVariables>;

/**
 * __useUpsertClientAkaMutation__
 *
 * To run a mutation, you first call `useUpsertClientAkaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientAkaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientAkaMutation, { data, loading, error }] = useUpsertClientAkaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientAkaMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientAkaMutation, UpsertClientAkaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientAkaMutation, UpsertClientAkaMutationVariables>(UpsertClientAkaDocument, options);
      }
export type UpsertClientAkaMutationHookResult = ReturnType<typeof useUpsertClientAkaMutation>;
export type UpsertClientAkaMutationResult = Apollo.MutationResult<UpsertClientAkaMutation>;
export type UpsertClientAkaMutationOptions = Apollo.BaseMutationOptions<UpsertClientAkaMutation, UpsertClientAkaMutationVariables>;
export const UpsertClientAttachmentsDocument = gql`
    mutation upsertClientAttachments($input: UpsertClientAttachmentInput!) {
  upsertClientAttachment(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertClientAttachmentsMutationFn = Apollo.MutationFunction<UpsertClientAttachmentsMutation, UpsertClientAttachmentsMutationVariables>;

/**
 * __useUpsertClientAttachmentsMutation__
 *
 * To run a mutation, you first call `useUpsertClientAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientAttachmentsMutation, { data, loading, error }] = useUpsertClientAttachmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientAttachmentsMutation, UpsertClientAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientAttachmentsMutation, UpsertClientAttachmentsMutationVariables>(UpsertClientAttachmentsDocument, options);
      }
export type UpsertClientAttachmentsMutationHookResult = ReturnType<typeof useUpsertClientAttachmentsMutation>;
export type UpsertClientAttachmentsMutationResult = Apollo.MutationResult<UpsertClientAttachmentsMutation>;
export type UpsertClientAttachmentsMutationOptions = Apollo.BaseMutationOptions<UpsertClientAttachmentsMutation, UpsertClientAttachmentsMutationVariables>;
export const UpsertClientContactDocument = gql`
    mutation upsertClientContact($input: UpsertClientContactInput!) {
  upsertClientContact(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertClientContactMutationFn = Apollo.MutationFunction<UpsertClientContactMutation, UpsertClientContactMutationVariables>;

/**
 * __useUpsertClientContactMutation__
 *
 * To run a mutation, you first call `useUpsertClientContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientContactMutation, { data, loading, error }] = useUpsertClientContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientContactMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientContactMutation, UpsertClientContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientContactMutation, UpsertClientContactMutationVariables>(UpsertClientContactDocument, options);
      }
export type UpsertClientContactMutationHookResult = ReturnType<typeof useUpsertClientContactMutation>;
export type UpsertClientContactMutationResult = Apollo.MutationResult<UpsertClientContactMutation>;
export type UpsertClientContactMutationOptions = Apollo.BaseMutationOptions<UpsertClientContactMutation, UpsertClientContactMutationVariables>;
export const UpsertClientContactNoteDocument = gql`
    mutation upsertClientContactNote($input: UpsertNoteInput!) {
  upsertClientContactNote(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertClientContactNoteMutationFn = Apollo.MutationFunction<UpsertClientContactNoteMutation, UpsertClientContactNoteMutationVariables>;

/**
 * __useUpsertClientContactNoteMutation__
 *
 * To run a mutation, you first call `useUpsertClientContactNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientContactNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientContactNoteMutation, { data, loading, error }] = useUpsertClientContactNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientContactNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientContactNoteMutation, UpsertClientContactNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientContactNoteMutation, UpsertClientContactNoteMutationVariables>(UpsertClientContactNoteDocument, options);
      }
export type UpsertClientContactNoteMutationHookResult = ReturnType<typeof useUpsertClientContactNoteMutation>;
export type UpsertClientContactNoteMutationResult = Apollo.MutationResult<UpsertClientContactNoteMutation>;
export type UpsertClientContactNoteMutationOptions = Apollo.BaseMutationOptions<UpsertClientContactNoteMutation, UpsertClientContactNoteMutationVariables>;
export const UpsertClientNoteDocument = gql`
    mutation upsertClientNote($input: UpsertNoteInput!) {
  upsertClientNote(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertClientNoteMutationFn = Apollo.MutationFunction<UpsertClientNoteMutation, UpsertClientNoteMutationVariables>;

/**
 * __useUpsertClientNoteMutation__
 *
 * To run a mutation, you first call `useUpsertClientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientNoteMutation, { data, loading, error }] = useUpsertClientNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientNoteMutation, UpsertClientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientNoteMutation, UpsertClientNoteMutationVariables>(UpsertClientNoteDocument, options);
      }
export type UpsertClientNoteMutationHookResult = ReturnType<typeof useUpsertClientNoteMutation>;
export type UpsertClientNoteMutationResult = Apollo.MutationResult<UpsertClientNoteMutation>;
export type UpsertClientNoteMutationOptions = Apollo.BaseMutationOptions<UpsertClientNoteMutation, UpsertClientNoteMutationVariables>;
export const UpsertClientNotificationRecipientsDocument = gql`
    mutation upsertClientNotificationRecipients($input: UpsertClientNotificationRecipientsInput!) {
  upsertClientNotificationRecipients(input: $input) {
    message
    errors {
      code
      message
    }
    result
    clientNotificationRecipients {
      id
    }
  }
}
    `;
export type UpsertClientNotificationRecipientsMutationFn = Apollo.MutationFunction<UpsertClientNotificationRecipientsMutation, UpsertClientNotificationRecipientsMutationVariables>;

/**
 * __useUpsertClientNotificationRecipientsMutation__
 *
 * To run a mutation, you first call `useUpsertClientNotificationRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientNotificationRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientNotificationRecipientsMutation, { data, loading, error }] = useUpsertClientNotificationRecipientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientNotificationRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientNotificationRecipientsMutation, UpsertClientNotificationRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientNotificationRecipientsMutation, UpsertClientNotificationRecipientsMutationVariables>(UpsertClientNotificationRecipientsDocument, options);
      }
export type UpsertClientNotificationRecipientsMutationHookResult = ReturnType<typeof useUpsertClientNotificationRecipientsMutation>;
export type UpsertClientNotificationRecipientsMutationResult = Apollo.MutationResult<UpsertClientNotificationRecipientsMutation>;
export type UpsertClientNotificationRecipientsMutationOptions = Apollo.BaseMutationOptions<UpsertClientNotificationRecipientsMutation, UpsertClientNotificationRecipientsMutationVariables>;
export const UpsertClientPartnerAttachmentsDocument = gql`
    mutation upsertClientPartnerAttachments($input: UpsertClientPartnerAttachmentInput!) {
  upsertClientPartnerAttachment(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertClientPartnerAttachmentsMutationFn = Apollo.MutationFunction<UpsertClientPartnerAttachmentsMutation, UpsertClientPartnerAttachmentsMutationVariables>;

/**
 * __useUpsertClientPartnerAttachmentsMutation__
 *
 * To run a mutation, you first call `useUpsertClientPartnerAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientPartnerAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientPartnerAttachmentsMutation, { data, loading, error }] = useUpsertClientPartnerAttachmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientPartnerAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientPartnerAttachmentsMutation, UpsertClientPartnerAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientPartnerAttachmentsMutation, UpsertClientPartnerAttachmentsMutationVariables>(UpsertClientPartnerAttachmentsDocument, options);
      }
export type UpsertClientPartnerAttachmentsMutationHookResult = ReturnType<typeof useUpsertClientPartnerAttachmentsMutation>;
export type UpsertClientPartnerAttachmentsMutationResult = Apollo.MutationResult<UpsertClientPartnerAttachmentsMutation>;
export type UpsertClientPartnerAttachmentsMutationOptions = Apollo.BaseMutationOptions<UpsertClientPartnerAttachmentsMutation, UpsertClientPartnerAttachmentsMutationVariables>;
export const UpsertClientPartnerTransactionAliasDocument = gql`
    mutation upsertClientPartnerTransactionAlias($input: UpsertClientPartnerTransactionAliasInput!) {
  upsertClientPartnerTransactionAlias(input: $input) {
    message
    errors {
      code
      message
    }
    result
    clientPartnerTransactionAlias {
      id
    }
  }
}
    `;
export type UpsertClientPartnerTransactionAliasMutationFn = Apollo.MutationFunction<UpsertClientPartnerTransactionAliasMutation, UpsertClientPartnerTransactionAliasMutationVariables>;

/**
 * __useUpsertClientPartnerTransactionAliasMutation__
 *
 * To run a mutation, you first call `useUpsertClientPartnerTransactionAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientPartnerTransactionAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientPartnerTransactionAliasMutation, { data, loading, error }] = useUpsertClientPartnerTransactionAliasMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientPartnerTransactionAliasMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientPartnerTransactionAliasMutation, UpsertClientPartnerTransactionAliasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientPartnerTransactionAliasMutation, UpsertClientPartnerTransactionAliasMutationVariables>(UpsertClientPartnerTransactionAliasDocument, options);
      }
export type UpsertClientPartnerTransactionAliasMutationHookResult = ReturnType<typeof useUpsertClientPartnerTransactionAliasMutation>;
export type UpsertClientPartnerTransactionAliasMutationResult = Apollo.MutationResult<UpsertClientPartnerTransactionAliasMutation>;
export type UpsertClientPartnerTransactionAliasMutationOptions = Apollo.BaseMutationOptions<UpsertClientPartnerTransactionAliasMutation, UpsertClientPartnerTransactionAliasMutationVariables>;
export const UpsertClientPartnerTransactionMapDocument = gql`
    mutation upsertClientPartnerTransactionMap($input: UpsertClientPartnerTransactionMapInput!) {
  upsertClientPartnerTransactionMap(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertClientPartnerTransactionMapMutationFn = Apollo.MutationFunction<UpsertClientPartnerTransactionMapMutation, UpsertClientPartnerTransactionMapMutationVariables>;

/**
 * __useUpsertClientPartnerTransactionMapMutation__
 *
 * To run a mutation, you first call `useUpsertClientPartnerTransactionMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientPartnerTransactionMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientPartnerTransactionMapMutation, { data, loading, error }] = useUpsertClientPartnerTransactionMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientPartnerTransactionMapMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientPartnerTransactionMapMutation, UpsertClientPartnerTransactionMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientPartnerTransactionMapMutation, UpsertClientPartnerTransactionMapMutationVariables>(UpsertClientPartnerTransactionMapDocument, options);
      }
export type UpsertClientPartnerTransactionMapMutationHookResult = ReturnType<typeof useUpsertClientPartnerTransactionMapMutation>;
export type UpsertClientPartnerTransactionMapMutationResult = Apollo.MutationResult<UpsertClientPartnerTransactionMapMutation>;
export type UpsertClientPartnerTransactionMapMutationOptions = Apollo.BaseMutationOptions<UpsertClientPartnerTransactionMapMutation, UpsertClientPartnerTransactionMapMutationVariables>;
export const UpsertClientPartnerTransactionPostProcessingDocument = gql`
    mutation upsertClientPartnerTransactionPostProcessing($input: UpsertClientPartnerTransactionPostProcessingInput!) {
  upsertClientPartnerTransactionPostProcessing(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertClientPartnerTransactionPostProcessingMutationFn = Apollo.MutationFunction<UpsertClientPartnerTransactionPostProcessingMutation, UpsertClientPartnerTransactionPostProcessingMutationVariables>;

/**
 * __useUpsertClientPartnerTransactionPostProcessingMutation__
 *
 * To run a mutation, you first call `useUpsertClientPartnerTransactionPostProcessingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientPartnerTransactionPostProcessingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientPartnerTransactionPostProcessingMutation, { data, loading, error }] = useUpsertClientPartnerTransactionPostProcessingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientPartnerTransactionPostProcessingMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientPartnerTransactionPostProcessingMutation, UpsertClientPartnerTransactionPostProcessingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientPartnerTransactionPostProcessingMutation, UpsertClientPartnerTransactionPostProcessingMutationVariables>(UpsertClientPartnerTransactionPostProcessingDocument, options);
      }
export type UpsertClientPartnerTransactionPostProcessingMutationHookResult = ReturnType<typeof useUpsertClientPartnerTransactionPostProcessingMutation>;
export type UpsertClientPartnerTransactionPostProcessingMutationResult = Apollo.MutationResult<UpsertClientPartnerTransactionPostProcessingMutation>;
export type UpsertClientPartnerTransactionPostProcessingMutationOptions = Apollo.BaseMutationOptions<UpsertClientPartnerTransactionPostProcessingMutation, UpsertClientPartnerTransactionPostProcessingMutationVariables>;
export const UpsertClientPartnerTransactionSchemaDocument = gql`
    mutation upsertClientPartnerTransactionSchema($input: UpsertClientPartnerTransactionSchemaInput!) {
  upsertClientPartnerTransactionSchema(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertClientPartnerTransactionSchemaMutationFn = Apollo.MutationFunction<UpsertClientPartnerTransactionSchemaMutation, UpsertClientPartnerTransactionSchemaMutationVariables>;

/**
 * __useUpsertClientPartnerTransactionSchemaMutation__
 *
 * To run a mutation, you first call `useUpsertClientPartnerTransactionSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientPartnerTransactionSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientPartnerTransactionSchemaMutation, { data, loading, error }] = useUpsertClientPartnerTransactionSchemaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientPartnerTransactionSchemaMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientPartnerTransactionSchemaMutation, UpsertClientPartnerTransactionSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientPartnerTransactionSchemaMutation, UpsertClientPartnerTransactionSchemaMutationVariables>(UpsertClientPartnerTransactionSchemaDocument, options);
      }
export type UpsertClientPartnerTransactionSchemaMutationHookResult = ReturnType<typeof useUpsertClientPartnerTransactionSchemaMutation>;
export type UpsertClientPartnerTransactionSchemaMutationResult = Apollo.MutationResult<UpsertClientPartnerTransactionSchemaMutation>;
export type UpsertClientPartnerTransactionSchemaMutationOptions = Apollo.BaseMutationOptions<UpsertClientPartnerTransactionSchemaMutation, UpsertClientPartnerTransactionSchemaMutationVariables>;
export const UpsertClientPortalUserDocument = gql`
    mutation upsertClientPortalUser($input: UpsertPortalUserInput!) {
  upsertClientPortalUser(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertClientPortalUserMutationFn = Apollo.MutationFunction<UpsertClientPortalUserMutation, UpsertClientPortalUserMutationVariables>;

/**
 * __useUpsertClientPortalUserMutation__
 *
 * To run a mutation, you first call `useUpsertClientPortalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientPortalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientPortalUserMutation, { data, loading, error }] = useUpsertClientPortalUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientPortalUserMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientPortalUserMutation, UpsertClientPortalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientPortalUserMutation, UpsertClientPortalUserMutationVariables>(UpsertClientPortalUserDocument, options);
      }
export type UpsertClientPortalUserMutationHookResult = ReturnType<typeof useUpsertClientPortalUserMutation>;
export type UpsertClientPortalUserMutationResult = Apollo.MutationResult<UpsertClientPortalUserMutation>;
export type UpsertClientPortalUserMutationOptions = Apollo.BaseMutationOptions<UpsertClientPortalUserMutation, UpsertClientPortalUserMutationVariables>;
export const UpsertClientTransactionDocument = gql`
    mutation upsertClientTransaction($input: UpsertClientTransactionInput!) {
  upsertClientTransaction(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertClientTransactionMutationFn = Apollo.MutationFunction<UpsertClientTransactionMutation, UpsertClientTransactionMutationVariables>;

/**
 * __useUpsertClientTransactionMutation__
 *
 * To run a mutation, you first call `useUpsertClientTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientTransactionMutation, { data, loading, error }] = useUpsertClientTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertClientTransactionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientTransactionMutation, UpsertClientTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientTransactionMutation, UpsertClientTransactionMutationVariables>(UpsertClientTransactionDocument, options);
      }
export type UpsertClientTransactionMutationHookResult = ReturnType<typeof useUpsertClientTransactionMutation>;
export type UpsertClientTransactionMutationResult = Apollo.MutationResult<UpsertClientTransactionMutation>;
export type UpsertClientTransactionMutationOptions = Apollo.BaseMutationOptions<UpsertClientTransactionMutation, UpsertClientTransactionMutationVariables>;
export const UpsertCounterDocument = gql`
    mutation upsertCounter($input: UpsertCounterInput!) {
  upsertCounter(input: $input) {
    message
    errors {
      code
      message
    }
    result
    counter {
      id
    }
  }
}
    `;
export type UpsertCounterMutationFn = Apollo.MutationFunction<UpsertCounterMutation, UpsertCounterMutationVariables>;

/**
 * __useUpsertCounterMutation__
 *
 * To run a mutation, you first call `useUpsertCounterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCounterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCounterMutation, { data, loading, error }] = useUpsertCounterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCounterMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCounterMutation, UpsertCounterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCounterMutation, UpsertCounterMutationVariables>(UpsertCounterDocument, options);
      }
export type UpsertCounterMutationHookResult = ReturnType<typeof useUpsertCounterMutation>;
export type UpsertCounterMutationResult = Apollo.MutationResult<UpsertCounterMutation>;
export type UpsertCounterMutationOptions = Apollo.BaseMutationOptions<UpsertCounterMutation, UpsertCounterMutationVariables>;
export const UpsertCrossReferenceDocument = gql`
    mutation upsertCrossReference($input: UpsertCrossReferenceInput!) {
  upsertCrossReference(input: $input) {
    message
    errors {
      code
      message
    }
    result
    crossReference {
      id
    }
  }
}
    `;
export type UpsertCrossReferenceMutationFn = Apollo.MutationFunction<UpsertCrossReferenceMutation, UpsertCrossReferenceMutationVariables>;

/**
 * __useUpsertCrossReferenceMutation__
 *
 * To run a mutation, you first call `useUpsertCrossReferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCrossReferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCrossReferenceMutation, { data, loading, error }] = useUpsertCrossReferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCrossReferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCrossReferenceMutation, UpsertCrossReferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCrossReferenceMutation, UpsertCrossReferenceMutationVariables>(UpsertCrossReferenceDocument, options);
      }
export type UpsertCrossReferenceMutationHookResult = ReturnType<typeof useUpsertCrossReferenceMutation>;
export type UpsertCrossReferenceMutationResult = Apollo.MutationResult<UpsertCrossReferenceMutation>;
export type UpsertCrossReferenceMutationOptions = Apollo.BaseMutationOptions<UpsertCrossReferenceMutation, UpsertCrossReferenceMutationVariables>;
export const UpsertCurrencyDocument = gql`
    mutation upsertCurrency($input: UpsertCurrencyInput!) {
  upsertCurrency(input: $input) {
    message
    errors {
      code
      message
    }
    result
    currency {
      currencyCode
      description
    }
  }
}
    `;
export type UpsertCurrencyMutationFn = Apollo.MutationFunction<UpsertCurrencyMutation, UpsertCurrencyMutationVariables>;

/**
 * __useUpsertCurrencyMutation__
 *
 * To run a mutation, you first call `useUpsertCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCurrencyMutation, { data, loading, error }] = useUpsertCurrencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCurrencyMutation, UpsertCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCurrencyMutation, UpsertCurrencyMutationVariables>(UpsertCurrencyDocument, options);
      }
export type UpsertCurrencyMutationHookResult = ReturnType<typeof useUpsertCurrencyMutation>;
export type UpsertCurrencyMutationResult = Apollo.MutationResult<UpsertCurrencyMutation>;
export type UpsertCurrencyMutationOptions = Apollo.BaseMutationOptions<UpsertCurrencyMutation, UpsertCurrencyMutationVariables>;
export const UpsertDocumentArchiveNoteDocument = gql`
    mutation upsertDocumentArchiveNote($input: UpsertNoteInput!) {
  upsertDocumentArchiveNote(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertDocumentArchiveNoteMutationFn = Apollo.MutationFunction<UpsertDocumentArchiveNoteMutation, UpsertDocumentArchiveNoteMutationVariables>;

/**
 * __useUpsertDocumentArchiveNoteMutation__
 *
 * To run a mutation, you first call `useUpsertDocumentArchiveNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDocumentArchiveNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDocumentArchiveNoteMutation, { data, loading, error }] = useUpsertDocumentArchiveNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertDocumentArchiveNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDocumentArchiveNoteMutation, UpsertDocumentArchiveNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDocumentArchiveNoteMutation, UpsertDocumentArchiveNoteMutationVariables>(UpsertDocumentArchiveNoteDocument, options);
      }
export type UpsertDocumentArchiveNoteMutationHookResult = ReturnType<typeof useUpsertDocumentArchiveNoteMutation>;
export type UpsertDocumentArchiveNoteMutationResult = Apollo.MutationResult<UpsertDocumentArchiveNoteMutation>;
export type UpsertDocumentArchiveNoteMutationOptions = Apollo.BaseMutationOptions<UpsertDocumentArchiveNoteMutation, UpsertDocumentArchiveNoteMutationVariables>;
export const UpsertEdiStandardDocument = gql`
    mutation upsertEdiStandard($input: UpsertEdiStandardInput!) {
  upsertEdiStandard(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertEdiStandardMutationFn = Apollo.MutationFunction<UpsertEdiStandardMutation, UpsertEdiStandardMutationVariables>;

/**
 * __useUpsertEdiStandardMutation__
 *
 * To run a mutation, you first call `useUpsertEdiStandardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEdiStandardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEdiStandardMutation, { data, loading, error }] = useUpsertEdiStandardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertEdiStandardMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEdiStandardMutation, UpsertEdiStandardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEdiStandardMutation, UpsertEdiStandardMutationVariables>(UpsertEdiStandardDocument, options);
      }
export type UpsertEdiStandardMutationHookResult = ReturnType<typeof useUpsertEdiStandardMutation>;
export type UpsertEdiStandardMutationResult = Apollo.MutationResult<UpsertEdiStandardMutation>;
export type UpsertEdiStandardMutationOptions = Apollo.BaseMutationOptions<UpsertEdiStandardMutation, UpsertEdiStandardMutationVariables>;
export const UpsertEdiXmlConfigDocument = gql`
    mutation upsertEdiXmlConfig($input: UpsertEdiXmlConfigInput!) {
  upsertEdiXmlConfig(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertEdiXmlConfigMutationFn = Apollo.MutationFunction<UpsertEdiXmlConfigMutation, UpsertEdiXmlConfigMutationVariables>;

/**
 * __useUpsertEdiXmlConfigMutation__
 *
 * To run a mutation, you first call `useUpsertEdiXmlConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEdiXmlConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEdiXmlConfigMutation, { data, loading, error }] = useUpsertEdiXmlConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertEdiXmlConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEdiXmlConfigMutation, UpsertEdiXmlConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEdiXmlConfigMutation, UpsertEdiXmlConfigMutationVariables>(UpsertEdiXmlConfigDocument, options);
      }
export type UpsertEdiXmlConfigMutationHookResult = ReturnType<typeof useUpsertEdiXmlConfigMutation>;
export type UpsertEdiXmlConfigMutationResult = Apollo.MutationResult<UpsertEdiXmlConfigMutation>;
export type UpsertEdiXmlConfigMutationOptions = Apollo.BaseMutationOptions<UpsertEdiXmlConfigMutation, UpsertEdiXmlConfigMutationVariables>;
export const UpsertErpTransactionSchemaDocument = gql`
    mutation upsertErpTransactionSchema($input: UpsertErpTransactionSchemaInput!) {
  upsertErpTransactionSchema(input: $input) {
    message
    errors {
      code
      message
    }
    result
    transactionSchemaId
  }
}
    `;
export type UpsertErpTransactionSchemaMutationFn = Apollo.MutationFunction<UpsertErpTransactionSchemaMutation, UpsertErpTransactionSchemaMutationVariables>;

/**
 * __useUpsertErpTransactionSchemaMutation__
 *
 * To run a mutation, you first call `useUpsertErpTransactionSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertErpTransactionSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertErpTransactionSchemaMutation, { data, loading, error }] = useUpsertErpTransactionSchemaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertErpTransactionSchemaMutation(baseOptions?: Apollo.MutationHookOptions<UpsertErpTransactionSchemaMutation, UpsertErpTransactionSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertErpTransactionSchemaMutation, UpsertErpTransactionSchemaMutationVariables>(UpsertErpTransactionSchemaDocument, options);
      }
export type UpsertErpTransactionSchemaMutationHookResult = ReturnType<typeof useUpsertErpTransactionSchemaMutation>;
export type UpsertErpTransactionSchemaMutationResult = Apollo.MutationResult<UpsertErpTransactionSchemaMutation>;
export type UpsertErpTransactionSchemaMutationOptions = Apollo.BaseMutationOptions<UpsertErpTransactionSchemaMutation, UpsertErpTransactionSchemaMutationVariables>;
export const UpsertFavoriteDocument = gql`
    mutation upsertFavorite($input: UpsertFavoriteInput!) {
  upsertFavorite(input: $input) {
    message
    errors {
      code
      message
    }
    result
    favorite {
      id
    }
  }
}
    `;
export type UpsertFavoriteMutationFn = Apollo.MutationFunction<UpsertFavoriteMutation, UpsertFavoriteMutationVariables>;

/**
 * __useUpsertFavoriteMutation__
 *
 * To run a mutation, you first call `useUpsertFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFavoriteMutation, { data, loading, error }] = useUpsertFavoriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<UpsertFavoriteMutation, UpsertFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertFavoriteMutation, UpsertFavoriteMutationVariables>(UpsertFavoriteDocument, options);
      }
export type UpsertFavoriteMutationHookResult = ReturnType<typeof useUpsertFavoriteMutation>;
export type UpsertFavoriteMutationResult = Apollo.MutationResult<UpsertFavoriteMutation>;
export type UpsertFavoriteMutationOptions = Apollo.BaseMutationOptions<UpsertFavoriteMutation, UpsertFavoriteMutationVariables>;
export const UpsertMapDocument = gql`
    mutation upsertMap($input: UpsertTransactionMapInput!) {
  upsertTransactionMap(input: $input) {
    message
    errors {
      code
      message
    }
    result
    transactionMapId
  }
}
    `;
export type UpsertMapMutationFn = Apollo.MutationFunction<UpsertMapMutation, UpsertMapMutationVariables>;

/**
 * __useUpsertMapMutation__
 *
 * To run a mutation, you first call `useUpsertMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMapMutation, { data, loading, error }] = useUpsertMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertMapMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMapMutation, UpsertMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMapMutation, UpsertMapMutationVariables>(UpsertMapDocument, options);
      }
export type UpsertMapMutationHookResult = ReturnType<typeof useUpsertMapMutation>;
export type UpsertMapMutationResult = Apollo.MutationResult<UpsertMapMutation>;
export type UpsertMapMutationOptions = Apollo.BaseMutationOptions<UpsertMapMutation, UpsertMapMutationVariables>;
export const UpsertNotificationFormatterDocument = gql`
    mutation upsertNotificationFormatter($input: UpsertNotificationFormatterInput!) {
  upsertNotificationFormatter(input: $input) {
    message
    errors {
      code
      message
    }
    result
    notificationFormatter {
      id
    }
  }
}
    `;
export type UpsertNotificationFormatterMutationFn = Apollo.MutationFunction<UpsertNotificationFormatterMutation, UpsertNotificationFormatterMutationVariables>;

/**
 * __useUpsertNotificationFormatterMutation__
 *
 * To run a mutation, you first call `useUpsertNotificationFormatterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNotificationFormatterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNotificationFormatterMutation, { data, loading, error }] = useUpsertNotificationFormatterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertNotificationFormatterMutation(baseOptions?: Apollo.MutationHookOptions<UpsertNotificationFormatterMutation, UpsertNotificationFormatterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertNotificationFormatterMutation, UpsertNotificationFormatterMutationVariables>(UpsertNotificationFormatterDocument, options);
      }
export type UpsertNotificationFormatterMutationHookResult = ReturnType<typeof useUpsertNotificationFormatterMutation>;
export type UpsertNotificationFormatterMutationResult = Apollo.MutationResult<UpsertNotificationFormatterMutation>;
export type UpsertNotificationFormatterMutationOptions = Apollo.BaseMutationOptions<UpsertNotificationFormatterMutation, UpsertNotificationFormatterMutationVariables>;
export const UpsertPartnerAkaDocument = gql`
    mutation upsertPartnerAKA($input: UpsertPartnerAkaInput!) {
  upsertPartnerAka(input: $input) {
    message
    errors {
      code
      message
    }
    result
    partnerAKA {
      id
    }
  }
}
    `;
export type UpsertPartnerAkaMutationFn = Apollo.MutationFunction<UpsertPartnerAkaMutation, UpsertPartnerAkaMutationVariables>;

/**
 * __useUpsertPartnerAkaMutation__
 *
 * To run a mutation, you first call `useUpsertPartnerAkaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPartnerAkaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPartnerAkaMutation, { data, loading, error }] = useUpsertPartnerAkaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPartnerAkaMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPartnerAkaMutation, UpsertPartnerAkaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPartnerAkaMutation, UpsertPartnerAkaMutationVariables>(UpsertPartnerAkaDocument, options);
      }
export type UpsertPartnerAkaMutationHookResult = ReturnType<typeof useUpsertPartnerAkaMutation>;
export type UpsertPartnerAkaMutationResult = Apollo.MutationResult<UpsertPartnerAkaMutation>;
export type UpsertPartnerAkaMutationOptions = Apollo.BaseMutationOptions<UpsertPartnerAkaMutation, UpsertPartnerAkaMutationVariables>;
export const UpsertPartnerNotificationRecipientsDocument = gql`
    mutation upsertPartnerNotificationRecipients($input: UpsertPartnerNotificationRecipientsInput!) {
  upsertPartnerNotificationRecipients(input: $input) {
    message
    errors {
      code
      message
    }
    result
    partnerNotificationRecipients {
      id
    }
  }
}
    `;
export type UpsertPartnerNotificationRecipientsMutationFn = Apollo.MutationFunction<UpsertPartnerNotificationRecipientsMutation, UpsertPartnerNotificationRecipientsMutationVariables>;

/**
 * __useUpsertPartnerNotificationRecipientsMutation__
 *
 * To run a mutation, you first call `useUpsertPartnerNotificationRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPartnerNotificationRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPartnerNotificationRecipientsMutation, { data, loading, error }] = useUpsertPartnerNotificationRecipientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPartnerNotificationRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPartnerNotificationRecipientsMutation, UpsertPartnerNotificationRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPartnerNotificationRecipientsMutation, UpsertPartnerNotificationRecipientsMutationVariables>(UpsertPartnerNotificationRecipientsDocument, options);
      }
export type UpsertPartnerNotificationRecipientsMutationHookResult = ReturnType<typeof useUpsertPartnerNotificationRecipientsMutation>;
export type UpsertPartnerNotificationRecipientsMutationResult = Apollo.MutationResult<UpsertPartnerNotificationRecipientsMutation>;
export type UpsertPartnerNotificationRecipientsMutationOptions = Apollo.BaseMutationOptions<UpsertPartnerNotificationRecipientsMutation, UpsertPartnerNotificationRecipientsMutationVariables>;
export const UpsertPipelineDocument = gql`
    mutation upsertPipeline($input: UpsertPipelineInput!) {
  upsertPipeline(input: $input) {
    message
    errors {
      code
      message
    }
    result
    pipeline {
      id
    }
  }
}
    `;
export type UpsertPipelineMutationFn = Apollo.MutationFunction<UpsertPipelineMutation, UpsertPipelineMutationVariables>;

/**
 * __useUpsertPipelineMutation__
 *
 * To run a mutation, you first call `useUpsertPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPipelineMutation, { data, loading, error }] = useUpsertPipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPipelineMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPipelineMutation, UpsertPipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPipelineMutation, UpsertPipelineMutationVariables>(UpsertPipelineDocument, options);
      }
export type UpsertPipelineMutationHookResult = ReturnType<typeof useUpsertPipelineMutation>;
export type UpsertPipelineMutationResult = Apollo.MutationResult<UpsertPipelineMutation>;
export type UpsertPipelineMutationOptions = Apollo.BaseMutationOptions<UpsertPipelineMutation, UpsertPipelineMutationVariables>;
export const UpsertPipelineItemDocument = gql`
    mutation upsertPipelineItem($input: UpsertPipelineItemInput!) {
  upsertPipelineItem(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertPipelineItemMutationFn = Apollo.MutationFunction<UpsertPipelineItemMutation, UpsertPipelineItemMutationVariables>;

/**
 * __useUpsertPipelineItemMutation__
 *
 * To run a mutation, you first call `useUpsertPipelineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPipelineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPipelineItemMutation, { data, loading, error }] = useUpsertPipelineItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPipelineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPipelineItemMutation, UpsertPipelineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPipelineItemMutation, UpsertPipelineItemMutationVariables>(UpsertPipelineItemDocument, options);
      }
export type UpsertPipelineItemMutationHookResult = ReturnType<typeof useUpsertPipelineItemMutation>;
export type UpsertPipelineItemMutationResult = Apollo.MutationResult<UpsertPipelineItemMutation>;
export type UpsertPipelineItemMutationOptions = Apollo.BaseMutationOptions<UpsertPipelineItemMutation, UpsertPipelineItemMutationVariables>;
export const UpsertPostProcessingBlobDocument = gql`
    mutation upsertPostProcessingBlob($input: UpsertPostProcessingBlobInput!) {
  upsertPostProcessingBlob(input: $input) {
    message
    errors {
      code
      message
    }
    result
    postProcessingBlob {
      id
    }
  }
}
    `;
export type UpsertPostProcessingBlobMutationFn = Apollo.MutationFunction<UpsertPostProcessingBlobMutation, UpsertPostProcessingBlobMutationVariables>;

/**
 * __useUpsertPostProcessingBlobMutation__
 *
 * To run a mutation, you first call `useUpsertPostProcessingBlobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPostProcessingBlobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPostProcessingBlobMutation, { data, loading, error }] = useUpsertPostProcessingBlobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPostProcessingBlobMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPostProcessingBlobMutation, UpsertPostProcessingBlobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPostProcessingBlobMutation, UpsertPostProcessingBlobMutationVariables>(UpsertPostProcessingBlobDocument, options);
      }
export type UpsertPostProcessingBlobMutationHookResult = ReturnType<typeof useUpsertPostProcessingBlobMutation>;
export type UpsertPostProcessingBlobMutationResult = Apollo.MutationResult<UpsertPostProcessingBlobMutation>;
export type UpsertPostProcessingBlobMutationOptions = Apollo.BaseMutationOptions<UpsertPostProcessingBlobMutation, UpsertPostProcessingBlobMutationVariables>;
export const UpsertPricingDocument = gql`
    mutation upsertPricing($input: UpsertPricingInput!) {
  upsertPricing(input: $input) {
    message
    errors {
      code
      message
    }
    result
    pricing {
      id
    }
  }
}
    `;
export type UpsertPricingMutationFn = Apollo.MutationFunction<UpsertPricingMutation, UpsertPricingMutationVariables>;

/**
 * __useUpsertPricingMutation__
 *
 * To run a mutation, you first call `useUpsertPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPricingMutation, { data, loading, error }] = useUpsertPricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPricingMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPricingMutation, UpsertPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPricingMutation, UpsertPricingMutationVariables>(UpsertPricingDocument, options);
      }
export type UpsertPricingMutationHookResult = ReturnType<typeof useUpsertPricingMutation>;
export type UpsertPricingMutationResult = Apollo.MutationResult<UpsertPricingMutation>;
export type UpsertPricingMutationOptions = Apollo.BaseMutationOptions<UpsertPricingMutation, UpsertPricingMutationVariables>;
export const UpsertPricingItemDocument = gql`
    mutation upsertPricingItem($input: UpsertPricingItemInput!) {
  upsertPricingItem(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertPricingItemMutationFn = Apollo.MutationFunction<UpsertPricingItemMutation, UpsertPricingItemMutationVariables>;

/**
 * __useUpsertPricingItemMutation__
 *
 * To run a mutation, you first call `useUpsertPricingItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPricingItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPricingItemMutation, { data, loading, error }] = useUpsertPricingItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPricingItemMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPricingItemMutation, UpsertPricingItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPricingItemMutation, UpsertPricingItemMutationVariables>(UpsertPricingItemDocument, options);
      }
export type UpsertPricingItemMutationHookResult = ReturnType<typeof useUpsertPricingItemMutation>;
export type UpsertPricingItemMutationResult = Apollo.MutationResult<UpsertPricingItemMutation>;
export type UpsertPricingItemMutationOptions = Apollo.BaseMutationOptions<UpsertPricingItemMutation, UpsertPricingItemMutationVariables>;
export const UpsertProcessDocument = gql`
    mutation upsertProcess($input: UpsertConfigurationInput!) {
  upsertConfiguration(input: $input) {
    message
    errors {
      code
      message
    }
    result
    configuration {
      id
    }
  }
}
    `;
export type UpsertProcessMutationFn = Apollo.MutationFunction<UpsertProcessMutation, UpsertProcessMutationVariables>;

/**
 * __useUpsertProcessMutation__
 *
 * To run a mutation, you first call `useUpsertProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProcessMutation, { data, loading, error }] = useUpsertProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertProcessMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProcessMutation, UpsertProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProcessMutation, UpsertProcessMutationVariables>(UpsertProcessDocument, options);
      }
export type UpsertProcessMutationHookResult = ReturnType<typeof useUpsertProcessMutation>;
export type UpsertProcessMutationResult = Apollo.MutationResult<UpsertProcessMutation>;
export type UpsertProcessMutationOptions = Apollo.BaseMutationOptions<UpsertProcessMutation, UpsertProcessMutationVariables>;
export const UpsertErpProductDocument = gql`
    mutation upsertErpProduct($input: UpsertErpProductInput!) {
  upsertErpProduct(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertErpProductMutationFn = Apollo.MutationFunction<UpsertErpProductMutation, UpsertErpProductMutationVariables>;

/**
 * __useUpsertErpProductMutation__
 *
 * To run a mutation, you first call `useUpsertErpProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertErpProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertErpProductMutation, { data, loading, error }] = useUpsertErpProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertErpProductMutation(baseOptions?: Apollo.MutationHookOptions<UpsertErpProductMutation, UpsertErpProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertErpProductMutation, UpsertErpProductMutationVariables>(UpsertErpProductDocument, options);
      }
export type UpsertErpProductMutationHookResult = ReturnType<typeof useUpsertErpProductMutation>;
export type UpsertErpProductMutationResult = Apollo.MutationResult<UpsertErpProductMutation>;
export type UpsertErpProductMutationOptions = Apollo.BaseMutationOptions<UpsertErpProductMutation, UpsertErpProductMutationVariables>;
export const UpsertRecentDocument = gql`
    mutation upsertRecent($input: UpsertRecentInput!) {
  upsertRecent(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertRecentMutationFn = Apollo.MutationFunction<UpsertRecentMutation, UpsertRecentMutationVariables>;

/**
 * __useUpsertRecentMutation__
 *
 * To run a mutation, you first call `useUpsertRecentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRecentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRecentMutation, { data, loading, error }] = useUpsertRecentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertRecentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertRecentMutation, UpsertRecentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertRecentMutation, UpsertRecentMutationVariables>(UpsertRecentDocument, options);
      }
export type UpsertRecentMutationHookResult = ReturnType<typeof useUpsertRecentMutation>;
export type UpsertRecentMutationResult = Apollo.MutationResult<UpsertRecentMutation>;
export type UpsertRecentMutationOptions = Apollo.BaseMutationOptions<UpsertRecentMutation, UpsertRecentMutationVariables>;
export const UpsertSystemConfigurationDocument = gql`
    mutation upsertSystemConfiguration($input: UpsertSystemConfigurationInput!) {
  upsertSystemConfiguration(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertSystemConfigurationMutationFn = Apollo.MutationFunction<UpsertSystemConfigurationMutation, UpsertSystemConfigurationMutationVariables>;

/**
 * __useUpsertSystemConfigurationMutation__
 *
 * To run a mutation, you first call `useUpsertSystemConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSystemConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSystemConfigurationMutation, { data, loading, error }] = useUpsertSystemConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSystemConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSystemConfigurationMutation, UpsertSystemConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSystemConfigurationMutation, UpsertSystemConfigurationMutationVariables>(UpsertSystemConfigurationDocument, options);
      }
export type UpsertSystemConfigurationMutationHookResult = ReturnType<typeof useUpsertSystemConfigurationMutation>;
export type UpsertSystemConfigurationMutationResult = Apollo.MutationResult<UpsertSystemConfigurationMutation>;
export type UpsertSystemConfigurationMutationOptions = Apollo.BaseMutationOptions<UpsertSystemConfigurationMutation, UpsertSystemConfigurationMutationVariables>;
export const UpsertSystemNotificationDocument = gql`
    mutation upsertSystemNotification($input: UpsertSystemNotificationInput!) {
  upsertSystemNotification(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertSystemNotificationMutationFn = Apollo.MutationFunction<UpsertSystemNotificationMutation, UpsertSystemNotificationMutationVariables>;

/**
 * __useUpsertSystemNotificationMutation__
 *
 * To run a mutation, you first call `useUpsertSystemNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSystemNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSystemNotificationMutation, { data, loading, error }] = useUpsertSystemNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSystemNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSystemNotificationMutation, UpsertSystemNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSystemNotificationMutation, UpsertSystemNotificationMutationVariables>(UpsertSystemNotificationDocument, options);
      }
export type UpsertSystemNotificationMutationHookResult = ReturnType<typeof useUpsertSystemNotificationMutation>;
export type UpsertSystemNotificationMutationResult = Apollo.MutationResult<UpsertSystemNotificationMutation>;
export type UpsertSystemNotificationMutationOptions = Apollo.BaseMutationOptions<UpsertSystemNotificationMutation, UpsertSystemNotificationMutationVariables>;
export const UpsertTradingPartnerDocument = gql`
    mutation upsertTradingPartner($input: UpsertPartnerInput!) {
  upsertPartner(input: $input) {
    message
    errors {
      code
      message
    }
    result
    partner {
      id
    }
  }
}
    `;
export type UpsertTradingPartnerMutationFn = Apollo.MutationFunction<UpsertTradingPartnerMutation, UpsertTradingPartnerMutationVariables>;

/**
 * __useUpsertTradingPartnerMutation__
 *
 * To run a mutation, you first call `useUpsertTradingPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTradingPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTradingPartnerMutation, { data, loading, error }] = useUpsertTradingPartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTradingPartnerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTradingPartnerMutation, UpsertTradingPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTradingPartnerMutation, UpsertTradingPartnerMutationVariables>(UpsertTradingPartnerDocument, options);
      }
export type UpsertTradingPartnerMutationHookResult = ReturnType<typeof useUpsertTradingPartnerMutation>;
export type UpsertTradingPartnerMutationResult = Apollo.MutationResult<UpsertTradingPartnerMutation>;
export type UpsertTradingPartnerMutationOptions = Apollo.BaseMutationOptions<UpsertTradingPartnerMutation, UpsertTradingPartnerMutationVariables>;
export const UpsertPartnerAttachmentsDocument = gql`
    mutation upsertPartnerAttachments($input: UpsertPartnerAttachmentInput!) {
  upsertPartnerAttachment(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertPartnerAttachmentsMutationFn = Apollo.MutationFunction<UpsertPartnerAttachmentsMutation, UpsertPartnerAttachmentsMutationVariables>;

/**
 * __useUpsertPartnerAttachmentsMutation__
 *
 * To run a mutation, you first call `useUpsertPartnerAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPartnerAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPartnerAttachmentsMutation, { data, loading, error }] = useUpsertPartnerAttachmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPartnerAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPartnerAttachmentsMutation, UpsertPartnerAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPartnerAttachmentsMutation, UpsertPartnerAttachmentsMutationVariables>(UpsertPartnerAttachmentsDocument, options);
      }
export type UpsertPartnerAttachmentsMutationHookResult = ReturnType<typeof useUpsertPartnerAttachmentsMutation>;
export type UpsertPartnerAttachmentsMutationResult = Apollo.MutationResult<UpsertPartnerAttachmentsMutation>;
export type UpsertPartnerAttachmentsMutationOptions = Apollo.BaseMutationOptions<UpsertPartnerAttachmentsMutation, UpsertPartnerAttachmentsMutationVariables>;
export const UpsertTradingPartnerContactDocument = gql`
    mutation upsertTradingPartnerContact($input: UpsertPartnerContactInput!) {
  upsertPartnerContact(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertTradingPartnerContactMutationFn = Apollo.MutationFunction<UpsertTradingPartnerContactMutation, UpsertTradingPartnerContactMutationVariables>;

/**
 * __useUpsertTradingPartnerContactMutation__
 *
 * To run a mutation, you first call `useUpsertTradingPartnerContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTradingPartnerContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTradingPartnerContactMutation, { data, loading, error }] = useUpsertTradingPartnerContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTradingPartnerContactMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTradingPartnerContactMutation, UpsertTradingPartnerContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTradingPartnerContactMutation, UpsertTradingPartnerContactMutationVariables>(UpsertTradingPartnerContactDocument, options);
      }
export type UpsertTradingPartnerContactMutationHookResult = ReturnType<typeof useUpsertTradingPartnerContactMutation>;
export type UpsertTradingPartnerContactMutationResult = Apollo.MutationResult<UpsertTradingPartnerContactMutation>;
export type UpsertTradingPartnerContactMutationOptions = Apollo.BaseMutationOptions<UpsertTradingPartnerContactMutation, UpsertTradingPartnerContactMutationVariables>;
export const UpsertPartnerContactNoteDocument = gql`
    mutation upsertPartnerContactNote($input: UpsertNoteInput!) {
  upsertPartnerContactNote(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertPartnerContactNoteMutationFn = Apollo.MutationFunction<UpsertPartnerContactNoteMutation, UpsertPartnerContactNoteMutationVariables>;

/**
 * __useUpsertPartnerContactNoteMutation__
 *
 * To run a mutation, you first call `useUpsertPartnerContactNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPartnerContactNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPartnerContactNoteMutation, { data, loading, error }] = useUpsertPartnerContactNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPartnerContactNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPartnerContactNoteMutation, UpsertPartnerContactNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPartnerContactNoteMutation, UpsertPartnerContactNoteMutationVariables>(UpsertPartnerContactNoteDocument, options);
      }
export type UpsertPartnerContactNoteMutationHookResult = ReturnType<typeof useUpsertPartnerContactNoteMutation>;
export type UpsertPartnerContactNoteMutationResult = Apollo.MutationResult<UpsertPartnerContactNoteMutation>;
export type UpsertPartnerContactNoteMutationOptions = Apollo.BaseMutationOptions<UpsertPartnerContactNoteMutation, UpsertPartnerContactNoteMutationVariables>;
export const UpsertPartnerNoteDocument = gql`
    mutation upsertPartnerNote($input: UpsertNoteInput!) {
  upsertPartnerNote(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertPartnerNoteMutationFn = Apollo.MutationFunction<UpsertPartnerNoteMutation, UpsertPartnerNoteMutationVariables>;

/**
 * __useUpsertPartnerNoteMutation__
 *
 * To run a mutation, you first call `useUpsertPartnerNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPartnerNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPartnerNoteMutation, { data, loading, error }] = useUpsertPartnerNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPartnerNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPartnerNoteMutation, UpsertPartnerNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPartnerNoteMutation, UpsertPartnerNoteMutationVariables>(UpsertPartnerNoteDocument, options);
      }
export type UpsertPartnerNoteMutationHookResult = ReturnType<typeof useUpsertPartnerNoteMutation>;
export type UpsertPartnerNoteMutationResult = Apollo.MutationResult<UpsertPartnerNoteMutation>;
export type UpsertPartnerNoteMutationOptions = Apollo.BaseMutationOptions<UpsertPartnerNoteMutation, UpsertPartnerNoteMutationVariables>;
export const UpsertPartnerTransactionSchemaDocument = gql`
    mutation upsertPartnerTransactionSchema($input: UpsertPartnerTransactionSchemaInput!) {
  upsertPartnerTransactionSchema(input: $input) {
    message
    errors {
      code
      message
    }
    result
    transactionSchemaId
  }
}
    `;
export type UpsertPartnerTransactionSchemaMutationFn = Apollo.MutationFunction<UpsertPartnerTransactionSchemaMutation, UpsertPartnerTransactionSchemaMutationVariables>;

/**
 * __useUpsertPartnerTransactionSchemaMutation__
 *
 * To run a mutation, you first call `useUpsertPartnerTransactionSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPartnerTransactionSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPartnerTransactionSchemaMutation, { data, loading, error }] = useUpsertPartnerTransactionSchemaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPartnerTransactionSchemaMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPartnerTransactionSchemaMutation, UpsertPartnerTransactionSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPartnerTransactionSchemaMutation, UpsertPartnerTransactionSchemaMutationVariables>(UpsertPartnerTransactionSchemaDocument, options);
      }
export type UpsertPartnerTransactionSchemaMutationHookResult = ReturnType<typeof useUpsertPartnerTransactionSchemaMutation>;
export type UpsertPartnerTransactionSchemaMutationResult = Apollo.MutationResult<UpsertPartnerTransactionSchemaMutation>;
export type UpsertPartnerTransactionSchemaMutationOptions = Apollo.BaseMutationOptions<UpsertPartnerTransactionSchemaMutation, UpsertPartnerTransactionSchemaMutationVariables>;
export const UpsertTransactionDocument = gql`
    mutation upsertTransaction($input: UpsertTransactionInput!) {
  upsertTransaction(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertTransactionMutationFn = Apollo.MutationFunction<UpsertTransactionMutation, UpsertTransactionMutationVariables>;

/**
 * __useUpsertTransactionMutation__
 *
 * To run a mutation, you first call `useUpsertTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTransactionMutation, { data, loading, error }] = useUpsertTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTransactionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTransactionMutation, UpsertTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTransactionMutation, UpsertTransactionMutationVariables>(UpsertTransactionDocument, options);
      }
export type UpsertTransactionMutationHookResult = ReturnType<typeof useUpsertTransactionMutation>;
export type UpsertTransactionMutationResult = Apollo.MutationResult<UpsertTransactionMutation>;
export type UpsertTransactionMutationOptions = Apollo.BaseMutationOptions<UpsertTransactionMutation, UpsertTransactionMutationVariables>;
export const UpsertTransactionErrorNoteDocument = gql`
    mutation upsertTransactionErrorNote($input: UpsertNoteInput!) {
  upsertTransactionErrorNote(input: $input) {
    message
    errors {
      code
      message
    }
    result
  }
}
    `;
export type UpsertTransactionErrorNoteMutationFn = Apollo.MutationFunction<UpsertTransactionErrorNoteMutation, UpsertTransactionErrorNoteMutationVariables>;

/**
 * __useUpsertTransactionErrorNoteMutation__
 *
 * To run a mutation, you first call `useUpsertTransactionErrorNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTransactionErrorNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTransactionErrorNoteMutation, { data, loading, error }] = useUpsertTransactionErrorNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTransactionErrorNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTransactionErrorNoteMutation, UpsertTransactionErrorNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTransactionErrorNoteMutation, UpsertTransactionErrorNoteMutationVariables>(UpsertTransactionErrorNoteDocument, options);
      }
export type UpsertTransactionErrorNoteMutationHookResult = ReturnType<typeof useUpsertTransactionErrorNoteMutation>;
export type UpsertTransactionErrorNoteMutationResult = Apollo.MutationResult<UpsertTransactionErrorNoteMutation>;
export type UpsertTransactionErrorNoteMutationOptions = Apollo.BaseMutationOptions<UpsertTransactionErrorNoteMutation, UpsertTransactionErrorNoteMutationVariables>;
export const UpsertTransactionMapPartnerDocument = gql`
    mutation upsertTransactionMapPartner($input: UpsertTransactionMapPartnerInput!) {
  upsertTransactionMapPartner(input: $input) {
    message
    errors {
      code
      message
    }
    result
    transactionMapPartnerId
  }
}
    `;
export type UpsertTransactionMapPartnerMutationFn = Apollo.MutationFunction<UpsertTransactionMapPartnerMutation, UpsertTransactionMapPartnerMutationVariables>;

/**
 * __useUpsertTransactionMapPartnerMutation__
 *
 * To run a mutation, you first call `useUpsertTransactionMapPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTransactionMapPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTransactionMapPartnerMutation, { data, loading, error }] = useUpsertTransactionMapPartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTransactionMapPartnerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTransactionMapPartnerMutation, UpsertTransactionMapPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTransactionMapPartnerMutation, UpsertTransactionMapPartnerMutationVariables>(UpsertTransactionMapPartnerDocument, options);
      }
export type UpsertTransactionMapPartnerMutationHookResult = ReturnType<typeof useUpsertTransactionMapPartnerMutation>;
export type UpsertTransactionMapPartnerMutationResult = Apollo.MutationResult<UpsertTransactionMapPartnerMutation>;
export type UpsertTransactionMapPartnerMutationOptions = Apollo.BaseMutationOptions<UpsertTransactionMapPartnerMutation, UpsertTransactionMapPartnerMutationVariables>;
export const UpsertTransactionXPathDocument = gql`
    mutation upsertTransactionXPath($input: UpsertTransactionXPathInput!) {
  upsertTransactionXPath(input: $input) {
    message
    errors {
      code
      message
    }
    result
    transactionXPath {
      id
    }
  }
}
    `;
export type UpsertTransactionXPathMutationFn = Apollo.MutationFunction<UpsertTransactionXPathMutation, UpsertTransactionXPathMutationVariables>;

/**
 * __useUpsertTransactionXPathMutation__
 *
 * To run a mutation, you first call `useUpsertTransactionXPathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTransactionXPathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTransactionXPathMutation, { data, loading, error }] = useUpsertTransactionXPathMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTransactionXPathMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTransactionXPathMutation, UpsertTransactionXPathMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTransactionXPathMutation, UpsertTransactionXPathMutationVariables>(UpsertTransactionXPathDocument, options);
      }
export type UpsertTransactionXPathMutationHookResult = ReturnType<typeof useUpsertTransactionXPathMutation>;
export type UpsertTransactionXPathMutationResult = Apollo.MutationResult<UpsertTransactionXPathMutation>;
export type UpsertTransactionXPathMutationOptions = Apollo.BaseMutationOptions<UpsertTransactionXPathMutation, UpsertTransactionXPathMutationVariables>;
export const UpsertUserDocument = gql`
    mutation upsertUser($input: UpsertUserInput!) {
  upsertUser(input: $input) {
    user {
      id
      firstName
      lastName
      email
      role
      isActive
      __typename
    }
    message
    errors {
      code
      message
    }
    result
    isReactivated
  }
}
    `;
export type UpsertUserMutationFn = Apollo.MutationFunction<UpsertUserMutation, UpsertUserMutationVariables>;

/**
 * __useUpsertUserMutation__
 *
 * To run a mutation, you first call `useUpsertUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserMutation, { data, loading, error }] = useUpsertUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertUserMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserMutation, UpsertUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserMutation, UpsertUserMutationVariables>(UpsertUserDocument, options);
      }
export type UpsertUserMutationHookResult = ReturnType<typeof useUpsertUserMutation>;
export type UpsertUserMutationResult = Apollo.MutationResult<UpsertUserMutation>;
export type UpsertUserMutationOptions = Apollo.BaseMutationOptions<UpsertUserMutation, UpsertUserMutationVariables>;
export const GetAttachmentDocument = gql`
    query getAttachment($input: GetAttachmentInput!) {
  attachments(input: $input) {
    nodes {
      id
      parentId
      attachmentString
      fileName
      fileLastModifiedTime
      description
      mimeType
    }
  }
}
    `;

/**
 * __useGetAttachmentQuery__
 *
 * To run a query within a React component, call `useGetAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAttachmentQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentQuery, GetAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentQuery, GetAttachmentQueryVariables>(GetAttachmentDocument, options);
      }
export function useGetAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentQuery, GetAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentQuery, GetAttachmentQueryVariables>(GetAttachmentDocument, options);
        }
export type GetAttachmentQueryHookResult = ReturnType<typeof useGetAttachmentQuery>;
export type GetAttachmentLazyQueryHookResult = ReturnType<typeof useGetAttachmentLazyQuery>;
export type GetAttachmentQueryResult = Apollo.QueryResult<GetAttachmentQuery, GetAttachmentQueryVariables>;
export const AuditRecordByIdDocument = gql`
    query auditRecordById($input: GetAuditRecordsInput!) {
  auditRecords(input: $input) {
    nodes {
      id
      createdTime
      entityId
      entityName
      entityState
      newValues
      oldValues
      userId
      userName
    }
  }
}
    `;

/**
 * __useAuditRecordByIdQuery__
 *
 * To run a query within a React component, call `useAuditRecordByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditRecordByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditRecordByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditRecordByIdQuery(baseOptions: Apollo.QueryHookOptions<AuditRecordByIdQuery, AuditRecordByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditRecordByIdQuery, AuditRecordByIdQueryVariables>(AuditRecordByIdDocument, options);
      }
export function useAuditRecordByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditRecordByIdQuery, AuditRecordByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditRecordByIdQuery, AuditRecordByIdQueryVariables>(AuditRecordByIdDocument, options);
        }
export type AuditRecordByIdQueryHookResult = ReturnType<typeof useAuditRecordByIdQuery>;
export type AuditRecordByIdLazyQueryHookResult = ReturnType<typeof useAuditRecordByIdLazyQuery>;
export type AuditRecordByIdQueryResult = Apollo.QueryResult<AuditRecordByIdQuery, AuditRecordByIdQueryVariables>;
export const AuditRecordListDocument = gql`
    query auditRecordList($input: GetAuditRecordsInput!) {
  auditRecords(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      id
      createdTime
      entityId
      entityName
      entityState
      newValues
      oldValues
      userId
      userName
    }
  }
}
    `;

/**
 * __useAuditRecordListQuery__
 *
 * To run a query within a React component, call `useAuditRecordListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditRecordListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditRecordListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditRecordListQuery(baseOptions: Apollo.QueryHookOptions<AuditRecordListQuery, AuditRecordListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditRecordListQuery, AuditRecordListQueryVariables>(AuditRecordListDocument, options);
      }
export function useAuditRecordListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditRecordListQuery, AuditRecordListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditRecordListQuery, AuditRecordListQueryVariables>(AuditRecordListDocument, options);
        }
export type AuditRecordListQueryHookResult = ReturnType<typeof useAuditRecordListQuery>;
export type AuditRecordListLazyQueryHookResult = ReturnType<typeof useAuditRecordListLazyQuery>;
export type AuditRecordListQueryResult = Apollo.QueryResult<AuditRecordListQuery, AuditRecordListQueryVariables>;
export const GetBillingByIdDocument = gql`
    query getBillingById($input: GetBillingsInput!) {
  billings(input: $input) {
    nodes {
      id
      description
      currencyCode
      billingItemCount
      clientCount
      lastModifiedBy
      lastModifiedByName
      lastModifiedTime
    }
  }
}
    `;

/**
 * __useGetBillingByIdQuery__
 *
 * To run a query within a React component, call `useGetBillingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBillingByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBillingByIdQuery, GetBillingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingByIdQuery, GetBillingByIdQueryVariables>(GetBillingByIdDocument, options);
      }
export function useGetBillingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingByIdQuery, GetBillingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingByIdQuery, GetBillingByIdQueryVariables>(GetBillingByIdDocument, options);
        }
export type GetBillingByIdQueryHookResult = ReturnType<typeof useGetBillingByIdQuery>;
export type GetBillingByIdLazyQueryHookResult = ReturnType<typeof useGetBillingByIdLazyQuery>;
export type GetBillingByIdQueryResult = Apollo.QueryResult<GetBillingByIdQuery, GetBillingByIdQueryVariables>;
export const BillingItemListDocument = gql`
    query billingItemList($input: GetBillingItemsInput!) {
  billingItems(input: $input) {
    nodes {
      id
      billingId
      dateFrom
      dateTo
      pricingId
      pricing {
        id
        description
        minServiceFees
        pricingItems {
          id
          pricingId
          description
          feePerDocument
          feePerLine
          maxNumberOfTransactions
        }
      }
    }
  }
}
    `;

/**
 * __useBillingItemListQuery__
 *
 * To run a query within a React component, call `useBillingItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingItemListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingItemListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingItemListQuery(baseOptions: Apollo.QueryHookOptions<BillingItemListQuery, BillingItemListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingItemListQuery, BillingItemListQueryVariables>(BillingItemListDocument, options);
      }
export function useBillingItemListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingItemListQuery, BillingItemListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingItemListQuery, BillingItemListQueryVariables>(BillingItemListDocument, options);
        }
export type BillingItemListQueryHookResult = ReturnType<typeof useBillingItemListQuery>;
export type BillingItemListLazyQueryHookResult = ReturnType<typeof useBillingItemListLazyQuery>;
export type BillingItemListQueryResult = Apollo.QueryResult<BillingItemListQuery, BillingItemListQueryVariables>;
export const BillingListDocument = gql`
    query billingList($input: GetBillingsInput!) {
  billings(input: $input) {
    nodes {
      id
      description
      currencyCode
      billingItemCount
      clientCount
    }
  }
}
    `;

/**
 * __useBillingListQuery__
 *
 * To run a query within a React component, call `useBillingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingListQuery(baseOptions: Apollo.QueryHookOptions<BillingListQuery, BillingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingListQuery, BillingListQueryVariables>(BillingListDocument, options);
      }
export function useBillingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingListQuery, BillingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingListQuery, BillingListQueryVariables>(BillingListDocument, options);
        }
export type BillingListQueryHookResult = ReturnType<typeof useBillingListQuery>;
export type BillingListLazyQueryHookResult = ReturnType<typeof useBillingListLazyQuery>;
export type BillingListQueryResult = Apollo.QueryResult<BillingListQuery, BillingListQueryVariables>;
export const BusinessAreasListDocument = gql`
    query businessAreasList {
  businessAreas {
    nodes {
      name
      description
      id
    }
  }
}
    `;

/**
 * __useBusinessAreasListQuery__
 *
 * To run a query within a React component, call `useBusinessAreasListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAreasListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAreasListQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessAreasListQuery(baseOptions?: Apollo.QueryHookOptions<BusinessAreasListQuery, BusinessAreasListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAreasListQuery, BusinessAreasListQueryVariables>(BusinessAreasListDocument, options);
      }
export function useBusinessAreasListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAreasListQuery, BusinessAreasListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAreasListQuery, BusinessAreasListQueryVariables>(BusinessAreasListDocument, options);
        }
export type BusinessAreasListQueryHookResult = ReturnType<typeof useBusinessAreasListQuery>;
export type BusinessAreasListLazyQueryHookResult = ReturnType<typeof useBusinessAreasListLazyQuery>;
export type BusinessAreasListQueryResult = Apollo.QueryResult<BusinessAreasListQuery, BusinessAreasListQueryVariables>;
export const GetClientBillingAggregatesByClientKeyDocument = gql`
    query getClientBillingAggregatesByClientKey($input: GetBillingAggregatesInput!) {
  clientBillingAggregates(input: $input) {
    nodes {
      id
      internalClientCode
      billingId
      year
      month
      serviceFee
      totalCharges
      totalDocuments
      totalLines
      lineCharges
      documentCharges
      currencyCode
      createdBy
      createdTime
      lastModifiedBy
      lastModifiedTime
    }
  }
}
    `;

/**
 * __useGetClientBillingAggregatesByClientKeyQuery__
 *
 * To run a query within a React component, call `useGetClientBillingAggregatesByClientKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientBillingAggregatesByClientKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientBillingAggregatesByClientKeyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientBillingAggregatesByClientKeyQuery(baseOptions: Apollo.QueryHookOptions<GetClientBillingAggregatesByClientKeyQuery, GetClientBillingAggregatesByClientKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientBillingAggregatesByClientKeyQuery, GetClientBillingAggregatesByClientKeyQueryVariables>(GetClientBillingAggregatesByClientKeyDocument, options);
      }
export function useGetClientBillingAggregatesByClientKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientBillingAggregatesByClientKeyQuery, GetClientBillingAggregatesByClientKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientBillingAggregatesByClientKeyQuery, GetClientBillingAggregatesByClientKeyQueryVariables>(GetClientBillingAggregatesByClientKeyDocument, options);
        }
export type GetClientBillingAggregatesByClientKeyQueryHookResult = ReturnType<typeof useGetClientBillingAggregatesByClientKeyQuery>;
export type GetClientBillingAggregatesByClientKeyLazyQueryHookResult = ReturnType<typeof useGetClientBillingAggregatesByClientKeyLazyQuery>;
export type GetClientBillingAggregatesByClientKeyQueryResult = Apollo.QueryResult<GetClientBillingAggregatesByClientKeyQuery, GetClientBillingAggregatesByClientKeyQueryVariables>;
export const GetClientByIdDocument = gql`
    query getClientById($input: GetClientsInput!) {
  clients(input: $input) {
    nodes {
      id
      internalClientCode
      isaQualifierCode
      localeCode
      clientCode
      name
      defaultCurrencyCode
      primaryClientId
      productionDate
      statusCode
      tenantId
      website
      bulkNotificationTime
      missingAcknowledgementNotificationMode
      erpDocumentFormat
      lastModifiedBy
      lastModifiedByName
      lastModifiedTime
      salesForceCountryCode
      salesForceCustomerNumber
      salesForceEntityCode
      billingId
      billingStartDate
      billing {
        id
        description
        currencyCode
      }
      addresses {
        addressLine1
        addressLine2
        addressLine3
        addressLine4
        city
        countryCode
        id
        isPrimary
        postalCode
        stateId
        state {
          stateCode
          description
          id
        }
      }
      businessArea {
        name
        description
        id
      }
      notificationFormatter {
        id
        description
        formatterType
        preprocessorType
      }
      errorFormatter {
        id
        description
        formatterType
        preprocessorType
      }
      clientAKAs {
        id
        clientCode
        isaQualifierCode
        isaQualifier {
          isaQualifierCode
          description
        }
      }
      clientNotificationRecipients {
        id
        recipients
      }
      clientContacts {
        id
        clientId
        name
        description
        isActive
        isPrimary
        jobTitle
        addresses {
          addressLine1
          addressLine2
          addressLine3
          addressLine4
          city
          countryCode
          id
          isPrimary
          postalCode
          stateId
          state {
            stateCode
            description
            id
          }
        }
        emails {
          email
          id
          isPrimary
        }
        phones {
          description
          id
          phoneNumber
          phoneTypeCode
        }
        notes {
          createdBy
          createdByName
          createdTime
          header
          id
          lastModifiedBy
          lastModifiedByName
          lastModifiedTime
          note
          parentId
        }
      }
      ediXmlConfig {
        clientId
        createdByName
        createdTime
        lastModifiedByName
        lastModifiedTime
        description
        fileName
        documentString
        id
      }
      emails {
        email
        id
        isPrimary
      }
      erpProduct {
        id
        name
        isAptean
      }
      clientPartners {
        id
        totalTransactions
        partner {
          partnerCode
          id
          name
          isaQualifierCode
          website
          totalTransactions
          businessArea {
            name
            id
          }
          ediStandards {
            id
            name
          }
        }
      }
      phones {
        phoneNumber
        description
        phoneTypeCode
        id
      }
      notes {
        createdBy
        createdByName
        createdTime
        header
        id
        lastModifiedBy
        lastModifiedByName
        lastModifiedTime
        note
        parentId
      }
      attachments {
        id
        fileName
        isLink
        description
        createdBy
        createdByName
        createdTime
        lastModifiedBy
        lastModifiedByName
        lastModifiedTime
        fileLastModifiedTime
      }
    }
  }
}
    `;

/**
 * __useGetClientByIdQuery__
 *
 * To run a query within a React component, call `useGetClientByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientByIdQuery(baseOptions: Apollo.QueryHookOptions<GetClientByIdQuery, GetClientByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientByIdQuery, GetClientByIdQueryVariables>(GetClientByIdDocument, options);
      }
export function useGetClientByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientByIdQuery, GetClientByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientByIdQuery, GetClientByIdQueryVariables>(GetClientByIdDocument, options);
        }
export type GetClientByIdQueryHookResult = ReturnType<typeof useGetClientByIdQuery>;
export type GetClientByIdLazyQueryHookResult = ReturnType<typeof useGetClientByIdLazyQuery>;
export type GetClientByIdQueryResult = Apollo.QueryResult<GetClientByIdQuery, GetClientByIdQueryVariables>;
export const GetClientNotificationRecipientsDocument = gql`
    query getClientNotificationRecipients($input: GetClientNotificationRecipientsInput!) {
  clientNotificationRecipients(input: $input) {
    nodes {
      id
      description
      notificationType
      recipients
      receivesNotifications
      receivesErrors
    }
  }
}
    `;

/**
 * __useGetClientNotificationRecipientsQuery__
 *
 * To run a query within a React component, call `useGetClientNotificationRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientNotificationRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientNotificationRecipientsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientNotificationRecipientsQuery(baseOptions: Apollo.QueryHookOptions<GetClientNotificationRecipientsQuery, GetClientNotificationRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientNotificationRecipientsQuery, GetClientNotificationRecipientsQueryVariables>(GetClientNotificationRecipientsDocument, options);
      }
export function useGetClientNotificationRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientNotificationRecipientsQuery, GetClientNotificationRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientNotificationRecipientsQuery, GetClientNotificationRecipientsQueryVariables>(GetClientNotificationRecipientsDocument, options);
        }
export type GetClientNotificationRecipientsQueryHookResult = ReturnType<typeof useGetClientNotificationRecipientsQuery>;
export type GetClientNotificationRecipientsLazyQueryHookResult = ReturnType<typeof useGetClientNotificationRecipientsLazyQuery>;
export type GetClientNotificationRecipientsQueryResult = Apollo.QueryResult<GetClientNotificationRecipientsQuery, GetClientNotificationRecipientsQueryVariables>;
export const GetClientPartnerByIdDocument = gql`
    query getClientPartnerById($input: GetClientPartnersInput!) {
  clientPartners(input: $input) {
    nodes {
      id
      createdTime
      productionDate
      defaultCurrencyCode
      partner {
        id
        name
        website
        statusCode
        partnerCode
        ediStandards {
          id
          name
        }
      }
      client {
        id
        name
        defaultCurrencyCode
      }
      clientPartnerTransactions {
        id
        effectivePartnerInterchangeId
        destinationPath
        isPipelineInherited
        functionalReconciliationMode
        skipTargetDocumentCreation
        outboundAcknowledgementOption
        partnerTransactionId
        partnerTransaction {
          id
          functionalReconciliationMode
          pipeline {
            description
            id
          }
          transaction {
            direction
          }
        }
        pipelineId
        pipeline {
          description
          id
        }
        clientPartnerTransactionMaps {
          id
          transactionMapId
          transactionMap {
            id
            description
            transactionId
            documentString
            sourceFileName
          }
        }
        clientPartnerTransactionPostProcessings {
          ediProcessName
          id
          postProcessingBlob {
            description
          }
          postProcessingBlobId
          processArguments
          processName
          sortOrder
        }
        clientPartnerTransactionSchemas {
          id
          partnerTransactionSchemaId
          partnerTransactionSchema {
            id
            description
            standardVersion
            sourceFileName
          }
        }
        clientPartnerTransactionAliases {
          id
          alias
        }
      }
      partnerTransactions {
        id
        transaction {
          id
          name
          description
          direction
          isActive
        }
        pipeline {
          description
          id
        }
        pipelineId
        transactionMaps {
          id
          description
          transactionId
        }
        partnerTransactionSchemas {
          id
          description
          standardVersion
          sourceFileName
        }
      }
      attachments {
        id
        fileName
        isLink
        description
        createdBy
        createdByName
        createdTime
        lastModifiedBy
        lastModifiedByName
        lastModifiedTime
        fileLastModifiedTime
      }
      fileGenerationNumber {
        id
        currentFileGenerationNumber
        maxFileGenerationNumber
      }
    }
  }
}
    `;

/**
 * __useGetClientPartnerByIdQuery__
 *
 * To run a query within a React component, call `useGetClientPartnerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientPartnerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientPartnerByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientPartnerByIdQuery(baseOptions: Apollo.QueryHookOptions<GetClientPartnerByIdQuery, GetClientPartnerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientPartnerByIdQuery, GetClientPartnerByIdQueryVariables>(GetClientPartnerByIdDocument, options);
      }
export function useGetClientPartnerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientPartnerByIdQuery, GetClientPartnerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientPartnerByIdQuery, GetClientPartnerByIdQueryVariables>(GetClientPartnerByIdDocument, options);
        }
export type GetClientPartnerByIdQueryHookResult = ReturnType<typeof useGetClientPartnerByIdQuery>;
export type GetClientPartnerByIdLazyQueryHookResult = ReturnType<typeof useGetClientPartnerByIdLazyQuery>;
export type GetClientPartnerByIdQueryResult = Apollo.QueryResult<GetClientPartnerByIdQuery, GetClientPartnerByIdQueryVariables>;
export const GetClientPortalUsersDocument = gql`
    query getClientPortalUsers($input: GetPortalUsersInput!) {
  clientPortalUsers(input: $input) {
    id
    email
    firstName
    lastName
    createdTime
    customerRole
    subscriptionRole
    tenantId
  }
}
    `;

/**
 * __useGetClientPortalUsersQuery__
 *
 * To run a query within a React component, call `useGetClientPortalUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientPortalUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientPortalUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientPortalUsersQuery(baseOptions: Apollo.QueryHookOptions<GetClientPortalUsersQuery, GetClientPortalUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientPortalUsersQuery, GetClientPortalUsersQueryVariables>(GetClientPortalUsersDocument, options);
      }
export function useGetClientPortalUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientPortalUsersQuery, GetClientPortalUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientPortalUsersQuery, GetClientPortalUsersQueryVariables>(GetClientPortalUsersDocument, options);
        }
export type GetClientPortalUsersQueryHookResult = ReturnType<typeof useGetClientPortalUsersQuery>;
export type GetClientPortalUsersLazyQueryHookResult = ReturnType<typeof useGetClientPortalUsersLazyQuery>;
export type GetClientPortalUsersQueryResult = Apollo.QueryResult<GetClientPortalUsersQuery, GetClientPortalUsersQueryVariables>;
export const GetClientTransactionsByClientIdDocument = gql`
    query getClientTransactionsByClientId($input: GetClientTransactionsInput!) {
  clientTransactions(input: $input) {
    nodes {
      id
      isActive
      notify
      bulkNotify
      fileNamePattern
      pipeline {
        description
        id
        isTemplate
        transactionId
      }
      pipelineId
      transaction {
        id
        name
        description
        direction
        isActive
      }
      transactionId
      erpTransactionSchema {
        description
        id
      }
      notificationFormatter {
        id
        description
      }
    }
  }
}
    `;

/**
 * __useGetClientTransactionsByClientIdQuery__
 *
 * To run a query within a React component, call `useGetClientTransactionsByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTransactionsByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTransactionsByClientIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientTransactionsByClientIdQuery(baseOptions: Apollo.QueryHookOptions<GetClientTransactionsByClientIdQuery, GetClientTransactionsByClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientTransactionsByClientIdQuery, GetClientTransactionsByClientIdQueryVariables>(GetClientTransactionsByClientIdDocument, options);
      }
export function useGetClientTransactionsByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientTransactionsByClientIdQuery, GetClientTransactionsByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientTransactionsByClientIdQuery, GetClientTransactionsByClientIdQueryVariables>(GetClientTransactionsByClientIdDocument, options);
        }
export type GetClientTransactionsByClientIdQueryHookResult = ReturnType<typeof useGetClientTransactionsByClientIdQuery>;
export type GetClientTransactionsByClientIdLazyQueryHookResult = ReturnType<typeof useGetClientTransactionsByClientIdLazyQuery>;
export type GetClientTransactionsByClientIdQueryResult = Apollo.QueryResult<GetClientTransactionsByClientIdQuery, GetClientTransactionsByClientIdQueryVariables>;
export const ClientsListDocument = gql`
    query clientsList($input: GetClientsInput!) {
  clients(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      name
      id
      statusCode
      clientCode
      website
      businessArea {
        name
        id
      }
      erpProduct {
        name
        id
      }
      totalPartners
    }
  }
}
    `;

/**
 * __useClientsListQuery__
 *
 * To run a query within a React component, call `useClientsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClientsListQuery(baseOptions: Apollo.QueryHookOptions<ClientsListQuery, ClientsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsListQuery, ClientsListQueryVariables>(ClientsListDocument, options);
      }
export function useClientsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsListQuery, ClientsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsListQuery, ClientsListQueryVariables>(ClientsListDocument, options);
        }
export type ClientsListQueryHookResult = ReturnType<typeof useClientsListQuery>;
export type ClientsListLazyQueryHookResult = ReturnType<typeof useClientsListLazyQuery>;
export type ClientsListQueryResult = Apollo.QueryResult<ClientsListQuery, ClientsListQueryVariables>;
export const ClientsMissingBillingDocument = gql`
    query clientsMissingBilling($input: GetClientsInput!) {
  clients(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      name
      id
      statusCode
      lastModifiedBy
      lastModifiedByName
      lastModifiedTime
    }
  }
}
    `;

/**
 * __useClientsMissingBillingQuery__
 *
 * To run a query within a React component, call `useClientsMissingBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsMissingBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsMissingBillingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClientsMissingBillingQuery(baseOptions: Apollo.QueryHookOptions<ClientsMissingBillingQuery, ClientsMissingBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsMissingBillingQuery, ClientsMissingBillingQueryVariables>(ClientsMissingBillingDocument, options);
      }
export function useClientsMissingBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsMissingBillingQuery, ClientsMissingBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsMissingBillingQuery, ClientsMissingBillingQueryVariables>(ClientsMissingBillingDocument, options);
        }
export type ClientsMissingBillingQueryHookResult = ReturnType<typeof useClientsMissingBillingQuery>;
export type ClientsMissingBillingLazyQueryHookResult = ReturnType<typeof useClientsMissingBillingLazyQuery>;
export type ClientsMissingBillingQueryResult = Apollo.QueryResult<ClientsMissingBillingQuery, ClientsMissingBillingQueryVariables>;
export const ClientsMissingRecipientsDocument = gql`
    query clientsMissingRecipients {
  clientsNotificationsNoRecipients {
    nodes {
      name
      id
      statusCode
      lastModifiedBy
      lastModifiedByName
      lastModifiedTime
    }
  }
}
    `;

/**
 * __useClientsMissingRecipientsQuery__
 *
 * To run a query within a React component, call `useClientsMissingRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsMissingRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsMissingRecipientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientsMissingRecipientsQuery(baseOptions?: Apollo.QueryHookOptions<ClientsMissingRecipientsQuery, ClientsMissingRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsMissingRecipientsQuery, ClientsMissingRecipientsQueryVariables>(ClientsMissingRecipientsDocument, options);
      }
export function useClientsMissingRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsMissingRecipientsQuery, ClientsMissingRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsMissingRecipientsQuery, ClientsMissingRecipientsQueryVariables>(ClientsMissingRecipientsDocument, options);
        }
export type ClientsMissingRecipientsQueryHookResult = ReturnType<typeof useClientsMissingRecipientsQuery>;
export type ClientsMissingRecipientsLazyQueryHookResult = ReturnType<typeof useClientsMissingRecipientsLazyQuery>;
export type ClientsMissingRecipientsQueryResult = Apollo.QueryResult<ClientsMissingRecipientsQuery, ClientsMissingRecipientsQueryVariables>;
export const ClientsOnboardingDocument = gql`
    query clientsOnboarding($input: GetClientsInput!) {
  clients(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      name
      id
      statusCode
      lastModifiedBy
      lastModifiedByName
      lastModifiedTime
    }
  }
}
    `;

/**
 * __useClientsOnboardingQuery__
 *
 * To run a query within a React component, call `useClientsOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsOnboardingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClientsOnboardingQuery(baseOptions: Apollo.QueryHookOptions<ClientsOnboardingQuery, ClientsOnboardingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsOnboardingQuery, ClientsOnboardingQueryVariables>(ClientsOnboardingDocument, options);
      }
export function useClientsOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsOnboardingQuery, ClientsOnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsOnboardingQuery, ClientsOnboardingQueryVariables>(ClientsOnboardingDocument, options);
        }
export type ClientsOnboardingQueryHookResult = ReturnType<typeof useClientsOnboardingQuery>;
export type ClientsOnboardingLazyQueryHookResult = ReturnType<typeof useClientsOnboardingLazyQuery>;
export type ClientsOnboardingQueryResult = Apollo.QueryResult<ClientsOnboardingQuery, ClientsOnboardingQueryVariables>;
export const CounterListDocument = gql`
    query counterList($input: GetCounterInput!) {
  counters(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      id
      segment
      senderId
      controlNumber
      comments
      machine
    }
  }
}
    `;

/**
 * __useCounterListQuery__
 *
 * To run a query within a React component, call `useCounterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCounterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCounterListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCounterListQuery(baseOptions: Apollo.QueryHookOptions<CounterListQuery, CounterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CounterListQuery, CounterListQueryVariables>(CounterListDocument, options);
      }
export function useCounterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CounterListQuery, CounterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CounterListQuery, CounterListQueryVariables>(CounterListDocument, options);
        }
export type CounterListQueryHookResult = ReturnType<typeof useCounterListQuery>;
export type CounterListLazyQueryHookResult = ReturnType<typeof useCounterListLazyQuery>;
export type CounterListQueryResult = Apollo.QueryResult<CounterListQuery, CounterListQueryVariables>;
export const CrossReferencesDocument = gql`
    query crossReferences($input: GetCrossReferenceInput!) {
  crossReferences(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      code
      description
      id
      val
      version
    }
  }
}
    `;

/**
 * __useCrossReferencesQuery__
 *
 * To run a query within a React component, call `useCrossReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrossReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrossReferencesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCrossReferencesQuery(baseOptions: Apollo.QueryHookOptions<CrossReferencesQuery, CrossReferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrossReferencesQuery, CrossReferencesQueryVariables>(CrossReferencesDocument, options);
      }
export function useCrossReferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrossReferencesQuery, CrossReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrossReferencesQuery, CrossReferencesQueryVariables>(CrossReferencesDocument, options);
        }
export type CrossReferencesQueryHookResult = ReturnType<typeof useCrossReferencesQuery>;
export type CrossReferencesLazyQueryHookResult = ReturnType<typeof useCrossReferencesLazyQuery>;
export type CrossReferencesQueryResult = Apollo.QueryResult<CrossReferencesQuery, CrossReferencesQueryVariables>;
export const CurrenciesListDocument = gql`
    query currenciesList {
  currencies {
    nodes {
      currencyCode
      description
    }
  }
}
    `;

/**
 * __useCurrenciesListQuery__
 *
 * To run a query within a React component, call `useCurrenciesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrenciesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrenciesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrenciesListQuery(baseOptions?: Apollo.QueryHookOptions<CurrenciesListQuery, CurrenciesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrenciesListQuery, CurrenciesListQueryVariables>(CurrenciesListDocument, options);
      }
export function useCurrenciesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrenciesListQuery, CurrenciesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrenciesListQuery, CurrenciesListQueryVariables>(CurrenciesListDocument, options);
        }
export type CurrenciesListQueryHookResult = ReturnType<typeof useCurrenciesListQuery>;
export type CurrenciesListLazyQueryHookResult = ReturnType<typeof useCurrenciesListLazyQuery>;
export type CurrenciesListQueryResult = Apollo.QueryResult<CurrenciesListQuery, CurrenciesListQueryVariables>;
export const GetDashboardCountsDocument = gql`
    query getDashboardCounts($input: GetDashboardCountsInput!) {
  dashboardCounts(input: $input) {
    errorsCount
    mappingErrorsCount
    onboardingClientsCount
    rejectedTransactionsCount
    unacknowledgedTransactionsCount
    notificationNotSentTransactionsCount
    clientsNotificationsNoRecipientsCount
    clientsBillingNotSetCount
  }
}
    `;

/**
 * __useGetDashboardCountsQuery__
 *
 * To run a query within a React component, call `useGetDashboardCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDashboardCountsQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardCountsQuery, GetDashboardCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardCountsQuery, GetDashboardCountsQueryVariables>(GetDashboardCountsDocument, options);
      }
export function useGetDashboardCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardCountsQuery, GetDashboardCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardCountsQuery, GetDashboardCountsQueryVariables>(GetDashboardCountsDocument, options);
        }
export type GetDashboardCountsQueryHookResult = ReturnType<typeof useGetDashboardCountsQuery>;
export type GetDashboardCountsLazyQueryHookResult = ReturnType<typeof useGetDashboardCountsLazyQuery>;
export type GetDashboardCountsQueryResult = Apollo.QueryResult<GetDashboardCountsQuery, GetDashboardCountsQueryVariables>;
export const DocumentArchiveByIdDocument = gql`
    query documentArchiveById($input: GetDocumentArchiveInput!) {
  documentArchive(input: $input) {
    id
    acknowledgementRequestCount
    acknowledgementRequestTime
    acknowledgementStatus
    bulkNotify
    client {
      id
      name
    }
    controlNumber
    functionalGroupControlNumber
    transactionControlNumber
    createdTime
    direction
    documentDate
    documentType
    ediDocument
    ediDocumentResentCount
    ediDocumentResentTime
    ediXml
    erpOrderNumber
    fileName
    originalFileName
    internalClientCode
    internalPartnerCode
    documentNumber
    isAbandoned
    notifiedTime
    partner {
      id
      name
    }
    purchaseOrder
    receiverId
    senderId
    wasNotificationSent
    currencyCode
    internalTransactionId
    notes {
      id
      header
      note
      lastModifiedTime
      lastModifiedBy
    }
  }
}
    `;

/**
 * __useDocumentArchiveByIdQuery__
 *
 * To run a query within a React component, call `useDocumentArchiveByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentArchiveByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentArchiveByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDocumentArchiveByIdQuery(baseOptions: Apollo.QueryHookOptions<DocumentArchiveByIdQuery, DocumentArchiveByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentArchiveByIdQuery, DocumentArchiveByIdQueryVariables>(DocumentArchiveByIdDocument, options);
      }
export function useDocumentArchiveByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentArchiveByIdQuery, DocumentArchiveByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentArchiveByIdQuery, DocumentArchiveByIdQueryVariables>(DocumentArchiveByIdDocument, options);
        }
export type DocumentArchiveByIdQueryHookResult = ReturnType<typeof useDocumentArchiveByIdQuery>;
export type DocumentArchiveByIdLazyQueryHookResult = ReturnType<typeof useDocumentArchiveByIdLazyQuery>;
export type DocumentArchiveByIdQueryResult = Apollo.QueryResult<DocumentArchiveByIdQuery, DocumentArchiveByIdQueryVariables>;
export const DocumentArchiveListDocument = gql`
    query documentArchiveList($input: GetDocumentArchivesInput!) {
  documentArchives(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      id
      acknowledgementStatus
      bulkNotify
      client {
        id
        name
      }
      controlNumber
      functionalGroupControlNumber
      transactionControlNumber
      createdTime
      direction
      documentDate
      documentType
      fileName
      internalClientCode
      internalPartnerCode
      isAbandoned
      partner {
        id
        name
      }
      purchaseOrder
      erpOrderNumber
      documentNumber
      notifiedTime
      receiverId
      senderId
      internalTransactionId
    }
  }
}
    `;

/**
 * __useDocumentArchiveListQuery__
 *
 * To run a query within a React component, call `useDocumentArchiveListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentArchiveListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentArchiveListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDocumentArchiveListQuery(baseOptions: Apollo.QueryHookOptions<DocumentArchiveListQuery, DocumentArchiveListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentArchiveListQuery, DocumentArchiveListQueryVariables>(DocumentArchiveListDocument, options);
      }
export function useDocumentArchiveListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentArchiveListQuery, DocumentArchiveListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentArchiveListQuery, DocumentArchiveListQueryVariables>(DocumentArchiveListDocument, options);
        }
export type DocumentArchiveListQueryHookResult = ReturnType<typeof useDocumentArchiveListQuery>;
export type DocumentArchiveListLazyQueryHookResult = ReturnType<typeof useDocumentArchiveListLazyQuery>;
export type DocumentArchiveListQueryResult = Apollo.QueryResult<DocumentArchiveListQuery, DocumentArchiveListQueryVariables>;
export const EdiStandardsListDocument = gql`
    query ediStandardsList {
  ediStandards {
    nodes {
      name
      description
      id
    }
  }
}
    `;

/**
 * __useEdiStandardsListQuery__
 *
 * To run a query within a React component, call `useEdiStandardsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdiStandardsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdiStandardsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useEdiStandardsListQuery(baseOptions?: Apollo.QueryHookOptions<EdiStandardsListQuery, EdiStandardsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdiStandardsListQuery, EdiStandardsListQueryVariables>(EdiStandardsListDocument, options);
      }
export function useEdiStandardsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdiStandardsListQuery, EdiStandardsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdiStandardsListQuery, EdiStandardsListQueryVariables>(EdiStandardsListDocument, options);
        }
export type EdiStandardsListQueryHookResult = ReturnType<typeof useEdiStandardsListQuery>;
export type EdiStandardsListLazyQueryHookResult = ReturnType<typeof useEdiStandardsListLazyQuery>;
export type EdiStandardsListQueryResult = Apollo.QueryResult<EdiStandardsListQuery, EdiStandardsListQueryVariables>;
export const ErpTransactionSchemasDocument = gql`
    query erpTransactionSchemas($input: GetErpTransactionSchemaInput!) {
  erpTransactionSchemas(input: $input) {
    nodes {
      id
      transactionId
      description
      documentString
      sourceFileName
    }
  }
}
    `;

/**
 * __useErpTransactionSchemasQuery__
 *
 * To run a query within a React component, call `useErpTransactionSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpTransactionSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpTransactionSchemasQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErpTransactionSchemasQuery(baseOptions: Apollo.QueryHookOptions<ErpTransactionSchemasQuery, ErpTransactionSchemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErpTransactionSchemasQuery, ErpTransactionSchemasQueryVariables>(ErpTransactionSchemasDocument, options);
      }
export function useErpTransactionSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpTransactionSchemasQuery, ErpTransactionSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErpTransactionSchemasQuery, ErpTransactionSchemasQueryVariables>(ErpTransactionSchemasDocument, options);
        }
export type ErpTransactionSchemasQueryHookResult = ReturnType<typeof useErpTransactionSchemasQuery>;
export type ErpTransactionSchemasLazyQueryHookResult = ReturnType<typeof useErpTransactionSchemasLazyQuery>;
export type ErpTransactionSchemasQueryResult = Apollo.QueryResult<ErpTransactionSchemasQuery, ErpTransactionSchemasQueryVariables>;
export const ErrorFormattersListDocument = gql`
    query errorFormattersList($input: GetNotificationFormatterInput!) {
  notificationFormatters(input: $input) {
    nodes {
      id
      description
    }
  }
}
    `;

/**
 * __useErrorFormattersListQuery__
 *
 * To run a query within a React component, call `useErrorFormattersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrorFormattersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrorFormattersListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErrorFormattersListQuery(baseOptions: Apollo.QueryHookOptions<ErrorFormattersListQuery, ErrorFormattersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErrorFormattersListQuery, ErrorFormattersListQueryVariables>(ErrorFormattersListDocument, options);
      }
export function useErrorFormattersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErrorFormattersListQuery, ErrorFormattersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErrorFormattersListQuery, ErrorFormattersListQueryVariables>(ErrorFormattersListDocument, options);
        }
export type ErrorFormattersListQueryHookResult = ReturnType<typeof useErrorFormattersListQuery>;
export type ErrorFormattersListLazyQueryHookResult = ReturnType<typeof useErrorFormattersListLazyQuery>;
export type ErrorFormattersListQueryResult = Apollo.QueryResult<ErrorFormattersListQuery, ErrorFormattersListQueryVariables>;
export const TransactionErrorByIdDocument = gql`
    query transactionErrorById($input: GetTransactionErrorsInput!) {
  transactionErrors(input: $input) {
    nodes {
      id
      documentId
      description
      documentReferenceId
      messageType
      originalFileName
      purchaseOrderNumber
      processName
      rawMessage
      status
      createdTime
      resolvedTime
      resolvedByName
      client {
        id
        name
      }
      partner {
        id
        name
      }
      clientPartner {
        id
      }
      transaction {
        id
        name
        direction
        normalizedDocumentType
      }
      category {
        id
        name
      }
      notes {
        createdBy
        createdByName
        createdTime
        header
        id
        lastModifiedBy
        lastModifiedByName
        lastModifiedTime
        note
        parentId
      }
    }
  }
}
    `;

/**
 * __useTransactionErrorByIdQuery__
 *
 * To run a query within a React component, call `useTransactionErrorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionErrorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionErrorByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransactionErrorByIdQuery(baseOptions: Apollo.QueryHookOptions<TransactionErrorByIdQuery, TransactionErrorByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionErrorByIdQuery, TransactionErrorByIdQueryVariables>(TransactionErrorByIdDocument, options);
      }
export function useTransactionErrorByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionErrorByIdQuery, TransactionErrorByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionErrorByIdQuery, TransactionErrorByIdQueryVariables>(TransactionErrorByIdDocument, options);
        }
export type TransactionErrorByIdQueryHookResult = ReturnType<typeof useTransactionErrorByIdQuery>;
export type TransactionErrorByIdLazyQueryHookResult = ReturnType<typeof useTransactionErrorByIdLazyQuery>;
export type TransactionErrorByIdQueryResult = Apollo.QueryResult<TransactionErrorByIdQuery, TransactionErrorByIdQueryVariables>;
export const ErrorLogCategoryListDocument = gql`
    query errorLogCategoryList {
  transactionErrorCategories {
    nodes {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useErrorLogCategoryListQuery__
 *
 * To run a query within a React component, call `useErrorLogCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrorLogCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrorLogCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useErrorLogCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<ErrorLogCategoryListQuery, ErrorLogCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErrorLogCategoryListQuery, ErrorLogCategoryListQueryVariables>(ErrorLogCategoryListDocument, options);
      }
export function useErrorLogCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErrorLogCategoryListQuery, ErrorLogCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErrorLogCategoryListQuery, ErrorLogCategoryListQueryVariables>(ErrorLogCategoryListDocument, options);
        }
export type ErrorLogCategoryListQueryHookResult = ReturnType<typeof useErrorLogCategoryListQuery>;
export type ErrorLogCategoryListLazyQueryHookResult = ReturnType<typeof useErrorLogCategoryListLazyQuery>;
export type ErrorLogCategoryListQueryResult = Apollo.QueryResult<ErrorLogCategoryListQuery, ErrorLogCategoryListQueryVariables>;
export const ErrorLogListDocument = gql`
    query errorLogList($input: GetTransactionErrorsInput!) {
  transactionErrors(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      id
      documentId
      description
      documentReferenceId
      messageType
      originalFileName
      purchaseOrderNumber
      processName
      rawMessage
      status
      createdTime
      client {
        id
        name
      }
      partner {
        id
        name
      }
      clientPartner {
        id
      }
      transaction {
        id
        name
        direction
        normalizedDocumentType
      }
      category {
        id
        name
      }
      notes {
        note
      }
    }
  }
}
    `;

/**
 * __useErrorLogListQuery__
 *
 * To run a query within a React component, call `useErrorLogListQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrorLogListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrorLogListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErrorLogListQuery(baseOptions: Apollo.QueryHookOptions<ErrorLogListQuery, ErrorLogListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErrorLogListQuery, ErrorLogListQueryVariables>(ErrorLogListDocument, options);
      }
export function useErrorLogListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErrorLogListQuery, ErrorLogListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErrorLogListQuery, ErrorLogListQueryVariables>(ErrorLogListDocument, options);
        }
export type ErrorLogListQueryHookResult = ReturnType<typeof useErrorLogListQuery>;
export type ErrorLogListLazyQueryHookResult = ReturnType<typeof useErrorLogListLazyQuery>;
export type ErrorLogListQueryResult = Apollo.QueryResult<ErrorLogListQuery, ErrorLogListQueryVariables>;
export const FileDirectoriesDocument = gql`
    query fileDirectories($input: GetDataLakeFileInput!) {
  dataLakeFileDirectories(input: $input) {
    message
    errors {
      code
      message
    }
    result
    directoryHierarchyJson
  }
}
    `;

/**
 * __useFileDirectoriesQuery__
 *
 * To run a query within a React component, call `useFileDirectoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileDirectoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileDirectoriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFileDirectoriesQuery(baseOptions: Apollo.QueryHookOptions<FileDirectoriesQuery, FileDirectoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileDirectoriesQuery, FileDirectoriesQueryVariables>(FileDirectoriesDocument, options);
      }
export function useFileDirectoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileDirectoriesQuery, FileDirectoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileDirectoriesQuery, FileDirectoriesQueryVariables>(FileDirectoriesDocument, options);
        }
export type FileDirectoriesQueryHookResult = ReturnType<typeof useFileDirectoriesQuery>;
export type FileDirectoriesLazyQueryHookResult = ReturnType<typeof useFileDirectoriesLazyQuery>;
export type FileDirectoriesQueryResult = Apollo.QueryResult<FileDirectoriesQuery, FileDirectoriesQueryVariables>;
export const GetFileDirectoryByPathDocument = gql`
    query getFileDirectoryByPath($input: GetDataLakeFileInput!) {
  dataLakeFilesAndSubDirectories(input: $input) {
    path
    dataLakeFileModels {
      name
      path
      fileSize
      fileSizeBytes
      lastModifiedTime
      createdTime
    }
    childDirectories {
      name
      path
      lastModifiedTime
      createdTime
      isDeleteDisabled
    }
  }
}
    `;

/**
 * __useGetFileDirectoryByPathQuery__
 *
 * To run a query within a React component, call `useGetFileDirectoryByPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileDirectoryByPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileDirectoryByPathQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFileDirectoryByPathQuery(baseOptions: Apollo.QueryHookOptions<GetFileDirectoryByPathQuery, GetFileDirectoryByPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileDirectoryByPathQuery, GetFileDirectoryByPathQueryVariables>(GetFileDirectoryByPathDocument, options);
      }
export function useGetFileDirectoryByPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileDirectoryByPathQuery, GetFileDirectoryByPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileDirectoryByPathQuery, GetFileDirectoryByPathQueryVariables>(GetFileDirectoryByPathDocument, options);
        }
export type GetFileDirectoryByPathQueryHookResult = ReturnType<typeof useGetFileDirectoryByPathQuery>;
export type GetFileDirectoryByPathLazyQueryHookResult = ReturnType<typeof useGetFileDirectoryByPathLazyQuery>;
export type GetFileDirectoryByPathQueryResult = Apollo.QueryResult<GetFileDirectoryByPathQuery, GetFileDirectoryByPathQueryVariables>;
export const GetFileDirectoryFilesDocument = gql`
    query getFileDirectoryFiles($input: GetDataLakeFileInput!) {
  dataLakeFilesSearch(input: $input) {
    name
    path
    fileSize
    fileSizeBytes
    lastModifiedTime
    createdTime
  }
}
    `;

/**
 * __useGetFileDirectoryFilesQuery__
 *
 * To run a query within a React component, call `useGetFileDirectoryFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileDirectoryFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileDirectoryFilesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFileDirectoryFilesQuery(baseOptions: Apollo.QueryHookOptions<GetFileDirectoryFilesQuery, GetFileDirectoryFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileDirectoryFilesQuery, GetFileDirectoryFilesQueryVariables>(GetFileDirectoryFilesDocument, options);
      }
export function useGetFileDirectoryFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileDirectoryFilesQuery, GetFileDirectoryFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileDirectoryFilesQuery, GetFileDirectoryFilesQueryVariables>(GetFileDirectoryFilesDocument, options);
        }
export type GetFileDirectoryFilesQueryHookResult = ReturnType<typeof useGetFileDirectoryFilesQuery>;
export type GetFileDirectoryFilesLazyQueryHookResult = ReturnType<typeof useGetFileDirectoryFilesLazyQuery>;
export type GetFileDirectoryFilesQueryResult = Apollo.QueryResult<GetFileDirectoryFilesQuery, GetFileDirectoryFilesQueryVariables>;
export const IsaQualifiersListDocument = gql`
    query isaQualifiersList {
  isaQualifiers {
    nodes {
      isaQualifierCode
      description
    }
  }
}
    `;

/**
 * __useIsaQualifiersListQuery__
 *
 * To run a query within a React component, call `useIsaQualifiersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsaQualifiersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsaQualifiersListQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsaQualifiersListQuery(baseOptions?: Apollo.QueryHookOptions<IsaQualifiersListQuery, IsaQualifiersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsaQualifiersListQuery, IsaQualifiersListQueryVariables>(IsaQualifiersListDocument, options);
      }
export function useIsaQualifiersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsaQualifiersListQuery, IsaQualifiersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsaQualifiersListQuery, IsaQualifiersListQueryVariables>(IsaQualifiersListDocument, options);
        }
export type IsaQualifiersListQueryHookResult = ReturnType<typeof useIsaQualifiersListQuery>;
export type IsaQualifiersListLazyQueryHookResult = ReturnType<typeof useIsaQualifiersListLazyQuery>;
export type IsaQualifiersListQueryResult = Apollo.QueryResult<IsaQualifiersListQuery, IsaQualifiersListQueryVariables>;
export const LocaleListDocument = gql`
    query localeList {
  locales {
    nodes {
      localeCode
      description
    }
  }
}
    `;

/**
 * __useLocaleListQuery__
 *
 * To run a query within a React component, call `useLocaleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocaleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocaleListQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocaleListQuery(baseOptions?: Apollo.QueryHookOptions<LocaleListQuery, LocaleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocaleListQuery, LocaleListQueryVariables>(LocaleListDocument, options);
      }
export function useLocaleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocaleListQuery, LocaleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocaleListQuery, LocaleListQueryVariables>(LocaleListDocument, options);
        }
export type LocaleListQueryHookResult = ReturnType<typeof useLocaleListQuery>;
export type LocaleListLazyQueryHookResult = ReturnType<typeof useLocaleListLazyQuery>;
export type LocaleListQueryResult = Apollo.QueryResult<LocaleListQuery, LocaleListQueryVariables>;
export const MapsListDocument = gql`
    query mapsList($input: GetTransactionMapInput!) {
  transactionMaps(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      id
      description
      isMapDeployed
      isMapLoaded
      standardVersion
      totalPartners
      transaction {
        id
        name
        description
        direction
      }
    }
  }
}
    `;

/**
 * __useMapsListQuery__
 *
 * To run a query within a React component, call `useMapsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMapsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMapsListQuery(baseOptions: Apollo.QueryHookOptions<MapsListQuery, MapsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MapsListQuery, MapsListQueryVariables>(MapsListDocument, options);
      }
export function useMapsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MapsListQuery, MapsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MapsListQuery, MapsListQueryVariables>(MapsListDocument, options);
        }
export type MapsListQueryHookResult = ReturnType<typeof useMapsListQuery>;
export type MapsListLazyQueryHookResult = ReturnType<typeof useMapsListLazyQuery>;
export type MapsListQueryResult = Apollo.QueryResult<MapsListQuery, MapsListQueryVariables>;
export const MessagingLogByIdDocument = gql`
    query messagingLogById($input: GetMessagingLogsInput!) {
  messagingLogs(input: $input) {
    nodes {
      id
      documentId
      description
      direction
      documentDate
      documentType
      documentReferenceId
      fileName
      internalClientCode
      internalPartnerCode
      invoice
      isAcknowledged
      messageType
      originalFileName
      pO
      processName
      rawMessage
      receiverId
      senderId
      status
      totalLines
      totalQuantity
      totalValue
      createdTime
      client {
        id
        name
      }
      partner {
        id
        name
      }
      clientPartner {
        id
      }
    }
  }
}
    `;

/**
 * __useMessagingLogByIdQuery__
 *
 * To run a query within a React component, call `useMessagingLogByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagingLogByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagingLogByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessagingLogByIdQuery(baseOptions: Apollo.QueryHookOptions<MessagingLogByIdQuery, MessagingLogByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagingLogByIdQuery, MessagingLogByIdQueryVariables>(MessagingLogByIdDocument, options);
      }
export function useMessagingLogByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagingLogByIdQuery, MessagingLogByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagingLogByIdQuery, MessagingLogByIdQueryVariables>(MessagingLogByIdDocument, options);
        }
export type MessagingLogByIdQueryHookResult = ReturnType<typeof useMessagingLogByIdQuery>;
export type MessagingLogByIdLazyQueryHookResult = ReturnType<typeof useMessagingLogByIdLazyQuery>;
export type MessagingLogByIdQueryResult = Apollo.QueryResult<MessagingLogByIdQuery, MessagingLogByIdQueryVariables>;
export const MessagingLogListDocument = gql`
    query messagingLogList($input: GetMessagingLogsInput!) {
  messagingLogs(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      id
      documentId
      description
      direction
      documentDate
      documentType
      documentReferenceId
      fileName
      internalClientCode
      internalPartnerCode
      invoice
      isAcknowledged
      messageType
      originalFileName
      pO
      processName
      rawMessage
      receiverId
      senderId
      status
      totalLines
      totalQuantity
      totalValue
      createdTime
      client {
        id
        name
      }
      partner {
        id
        name
      }
      clientPartner {
        id
      }
    }
  }
}
    `;

/**
 * __useMessagingLogListQuery__
 *
 * To run a query within a React component, call `useMessagingLogListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagingLogListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagingLogListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessagingLogListQuery(baseOptions: Apollo.QueryHookOptions<MessagingLogListQuery, MessagingLogListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagingLogListQuery, MessagingLogListQueryVariables>(MessagingLogListDocument, options);
      }
export function useMessagingLogListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagingLogListQuery, MessagingLogListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagingLogListQuery, MessagingLogListQueryVariables>(MessagingLogListDocument, options);
        }
export type MessagingLogListQueryHookResult = ReturnType<typeof useMessagingLogListQuery>;
export type MessagingLogListLazyQueryHookResult = ReturnType<typeof useMessagingLogListLazyQuery>;
export type MessagingLogListQueryResult = Apollo.QueryResult<MessagingLogListQuery, MessagingLogListQueryVariables>;
export const NotificationFormatterByIdDocument = gql`
    query notificationFormatterById($input: GetNotificationFormatterInput) {
  notificationFormatters(input: $input) {
    nodes {
      id
      description
      fileType
      formatterType
      subject
      body
      bodyType
      asAttachment
      isForError
      template
      sourceType
      totalTransactions
      notificationFormatterTransactions {
        id
        notificationFormatterId
        transactionId
        transaction {
          id
          name
          description
          direction
          isActive
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationFormatterByIdQuery__
 *
 * To run a query within a React component, call `useNotificationFormatterByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationFormatterByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationFormatterByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificationFormatterByIdQuery(baseOptions?: Apollo.QueryHookOptions<NotificationFormatterByIdQuery, NotificationFormatterByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationFormatterByIdQuery, NotificationFormatterByIdQueryVariables>(NotificationFormatterByIdDocument, options);
      }
export function useNotificationFormatterByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationFormatterByIdQuery, NotificationFormatterByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationFormatterByIdQuery, NotificationFormatterByIdQueryVariables>(NotificationFormatterByIdDocument, options);
        }
export type NotificationFormatterByIdQueryHookResult = ReturnType<typeof useNotificationFormatterByIdQuery>;
export type NotificationFormatterByIdLazyQueryHookResult = ReturnType<typeof useNotificationFormatterByIdLazyQuery>;
export type NotificationFormatterByIdQueryResult = Apollo.QueryResult<NotificationFormatterByIdQuery, NotificationFormatterByIdQueryVariables>;
export const NotificationFormatterTransactionsByTransactionIdDocument = gql`
    query notificationFormatterTransactionsByTransactionId($input: GetNotificationFormatterTransactionsInput!) {
  notificationFormatterTransactions(input: $input) {
    nodes {
      id
      notificationFormatterId
      notificationFormatter {
        id
        description
      }
      transactionId
    }
  }
}
    `;

/**
 * __useNotificationFormatterTransactionsByTransactionIdQuery__
 *
 * To run a query within a React component, call `useNotificationFormatterTransactionsByTransactionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationFormatterTransactionsByTransactionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationFormatterTransactionsByTransactionIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificationFormatterTransactionsByTransactionIdQuery(baseOptions: Apollo.QueryHookOptions<NotificationFormatterTransactionsByTransactionIdQuery, NotificationFormatterTransactionsByTransactionIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationFormatterTransactionsByTransactionIdQuery, NotificationFormatterTransactionsByTransactionIdQueryVariables>(NotificationFormatterTransactionsByTransactionIdDocument, options);
      }
export function useNotificationFormatterTransactionsByTransactionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationFormatterTransactionsByTransactionIdQuery, NotificationFormatterTransactionsByTransactionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationFormatterTransactionsByTransactionIdQuery, NotificationFormatterTransactionsByTransactionIdQueryVariables>(NotificationFormatterTransactionsByTransactionIdDocument, options);
        }
export type NotificationFormatterTransactionsByTransactionIdQueryHookResult = ReturnType<typeof useNotificationFormatterTransactionsByTransactionIdQuery>;
export type NotificationFormatterTransactionsByTransactionIdLazyQueryHookResult = ReturnType<typeof useNotificationFormatterTransactionsByTransactionIdLazyQuery>;
export type NotificationFormatterTransactionsByTransactionIdQueryResult = Apollo.QueryResult<NotificationFormatterTransactionsByTransactionIdQuery, NotificationFormatterTransactionsByTransactionIdQueryVariables>;
export const NotificationFormatterTransactionsListDocument = gql`
    query notificationFormatterTransactionsList($input: GetNotificationFormatterTransactionsInput!) {
  notificationFormatterTransactions(input: $input) {
    nodes {
      id
      notificationFormatterId
      transactionId
      transaction {
        id
        name
        description
        direction
        isActive
      }
    }
  }
}
    `;

/**
 * __useNotificationFormatterTransactionsListQuery__
 *
 * To run a query within a React component, call `useNotificationFormatterTransactionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationFormatterTransactionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationFormatterTransactionsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificationFormatterTransactionsListQuery(baseOptions: Apollo.QueryHookOptions<NotificationFormatterTransactionsListQuery, NotificationFormatterTransactionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationFormatterTransactionsListQuery, NotificationFormatterTransactionsListQueryVariables>(NotificationFormatterTransactionsListDocument, options);
      }
export function useNotificationFormatterTransactionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationFormatterTransactionsListQuery, NotificationFormatterTransactionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationFormatterTransactionsListQuery, NotificationFormatterTransactionsListQueryVariables>(NotificationFormatterTransactionsListDocument, options);
        }
export type NotificationFormatterTransactionsListQueryHookResult = ReturnType<typeof useNotificationFormatterTransactionsListQuery>;
export type NotificationFormatterTransactionsListLazyQueryHookResult = ReturnType<typeof useNotificationFormatterTransactionsListLazyQuery>;
export type NotificationFormatterTransactionsListQueryResult = Apollo.QueryResult<NotificationFormatterTransactionsListQuery, NotificationFormatterTransactionsListQueryVariables>;
export const NotificationFormattersListDocument = gql`
    query notificationFormattersList($input: GetNotificationFormatterInput!) {
  notificationFormatters(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      id
      description
      bodyType
      asAttachment
      isForError
      totalTransactions
    }
  }
}
    `;

/**
 * __useNotificationFormattersListQuery__
 *
 * To run a query within a React component, call `useNotificationFormattersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationFormattersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationFormattersListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificationFormattersListQuery(baseOptions: Apollo.QueryHookOptions<NotificationFormattersListQuery, NotificationFormattersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationFormattersListQuery, NotificationFormattersListQueryVariables>(NotificationFormattersListDocument, options);
      }
export function useNotificationFormattersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationFormattersListQuery, NotificationFormattersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationFormattersListQuery, NotificationFormattersListQueryVariables>(NotificationFormattersListDocument, options);
        }
export type NotificationFormattersListQueryHookResult = ReturnType<typeof useNotificationFormattersListQuery>;
export type NotificationFormattersListLazyQueryHookResult = ReturnType<typeof useNotificationFormattersListLazyQuery>;
export type NotificationFormattersListQueryResult = Apollo.QueryResult<NotificationFormattersListQuery, NotificationFormattersListQueryVariables>;
export const GetPartnerNotificationRecipientsDocument = gql`
    query getPartnerNotificationRecipients($input: GetPartnerNotificationRecipientsInput!) {
  partnerNotificationRecipients(input: $input) {
    nodes {
      id
      description
      notificationType
      recipients
      receivesNotifications
      receivesErrors
    }
  }
}
    `;

/**
 * __useGetPartnerNotificationRecipientsQuery__
 *
 * To run a query within a React component, call `useGetPartnerNotificationRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerNotificationRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerNotificationRecipientsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPartnerNotificationRecipientsQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerNotificationRecipientsQuery, GetPartnerNotificationRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerNotificationRecipientsQuery, GetPartnerNotificationRecipientsQueryVariables>(GetPartnerNotificationRecipientsDocument, options);
      }
export function useGetPartnerNotificationRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerNotificationRecipientsQuery, GetPartnerNotificationRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerNotificationRecipientsQuery, GetPartnerNotificationRecipientsQueryVariables>(GetPartnerNotificationRecipientsDocument, options);
        }
export type GetPartnerNotificationRecipientsQueryHookResult = ReturnType<typeof useGetPartnerNotificationRecipientsQuery>;
export type GetPartnerNotificationRecipientsLazyQueryHookResult = ReturnType<typeof useGetPartnerNotificationRecipientsLazyQuery>;
export type GetPartnerNotificationRecipientsQueryResult = Apollo.QueryResult<GetPartnerNotificationRecipientsQuery, GetPartnerNotificationRecipientsQueryVariables>;
export const PhoneTypesListDocument = gql`
    query phoneTypesList($input: GetPhoneTypeInput!) {
  phoneTypes(input: $input) {
    nodes {
      phoneTypeCode
      description
    }
  }
}
    `;

/**
 * __usePhoneTypesListQuery__
 *
 * To run a query within a React component, call `usePhoneTypesListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneTypesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneTypesListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePhoneTypesListQuery(baseOptions: Apollo.QueryHookOptions<PhoneTypesListQuery, PhoneTypesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhoneTypesListQuery, PhoneTypesListQueryVariables>(PhoneTypesListDocument, options);
      }
export function usePhoneTypesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhoneTypesListQuery, PhoneTypesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhoneTypesListQuery, PhoneTypesListQueryVariables>(PhoneTypesListDocument, options);
        }
export type PhoneTypesListQueryHookResult = ReturnType<typeof usePhoneTypesListQuery>;
export type PhoneTypesListLazyQueryHookResult = ReturnType<typeof usePhoneTypesListLazyQuery>;
export type PhoneTypesListQueryResult = Apollo.QueryResult<PhoneTypesListQuery, PhoneTypesListQueryVariables>;
export const GetPipelineByIdDocument = gql`
    query getPipelineById($input: GetPipelinesInput!) {
  pipelines(input: $input) {
    nodes {
      createdBy
      createdByName
      createdTime
      description
      id
      isTemplate
      isLegacy
      lastModifiedBy
      lastModifiedByName
      lastModifiedTime
      pipelineItems {
        id
        description
        ediProcessClassName
        jsonArgs
        sortOrder
        configuration {
          id
          ediProcess
          description
        }
      }
      transaction {
        description
        direction
        name
        id
      }
      transactionId
    }
  }
}
    `;

/**
 * __useGetPipelineByIdQuery__
 *
 * To run a query within a React component, call `useGetPipelineByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPipelineByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPipelineByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPipelineByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPipelineByIdQuery, GetPipelineByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPipelineByIdQuery, GetPipelineByIdQueryVariables>(GetPipelineByIdDocument, options);
      }
export function useGetPipelineByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPipelineByIdQuery, GetPipelineByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPipelineByIdQuery, GetPipelineByIdQueryVariables>(GetPipelineByIdDocument, options);
        }
export type GetPipelineByIdQueryHookResult = ReturnType<typeof useGetPipelineByIdQuery>;
export type GetPipelineByIdLazyQueryHookResult = ReturnType<typeof useGetPipelineByIdLazyQuery>;
export type GetPipelineByIdQueryResult = Apollo.QueryResult<GetPipelineByIdQuery, GetPipelineByIdQueryVariables>;
export const PipelineItemClassListDocument = gql`
    query pipelineItemClassList {
  pipelineItemClassNames {
    nodes {
      className
      description
      typeName
    }
  }
}
    `;

/**
 * __usePipelineItemClassListQuery__
 *
 * To run a query within a React component, call `usePipelineItemClassListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineItemClassListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineItemClassListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePipelineItemClassListQuery(baseOptions?: Apollo.QueryHookOptions<PipelineItemClassListQuery, PipelineItemClassListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelineItemClassListQuery, PipelineItemClassListQueryVariables>(PipelineItemClassListDocument, options);
      }
export function usePipelineItemClassListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelineItemClassListQuery, PipelineItemClassListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelineItemClassListQuery, PipelineItemClassListQueryVariables>(PipelineItemClassListDocument, options);
        }
export type PipelineItemClassListQueryHookResult = ReturnType<typeof usePipelineItemClassListQuery>;
export type PipelineItemClassListLazyQueryHookResult = ReturnType<typeof usePipelineItemClassListLazyQuery>;
export type PipelineItemClassListQueryResult = Apollo.QueryResult<PipelineItemClassListQuery, PipelineItemClassListQueryVariables>;
export const GetPipelinesDocument = gql`
    query getPipelines($input: GetPipelinesInput!) {
  pipelines(input: $input) {
    nodes {
      description
      id
      isTemplate
      transactionId
    }
  }
}
    `;

/**
 * __useGetPipelinesQuery__
 *
 * To run a query within a React component, call `useGetPipelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPipelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPipelinesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPipelinesQuery(baseOptions: Apollo.QueryHookOptions<GetPipelinesQuery, GetPipelinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPipelinesQuery, GetPipelinesQueryVariables>(GetPipelinesDocument, options);
      }
export function useGetPipelinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPipelinesQuery, GetPipelinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPipelinesQuery, GetPipelinesQueryVariables>(GetPipelinesDocument, options);
        }
export type GetPipelinesQueryHookResult = ReturnType<typeof useGetPipelinesQuery>;
export type GetPipelinesLazyQueryHookResult = ReturnType<typeof useGetPipelinesLazyQuery>;
export type GetPipelinesQueryResult = Apollo.QueryResult<GetPipelinesQuery, GetPipelinesQueryVariables>;
export const PipelinesListDocument = gql`
    query pipelinesList($input: GetPipelinesInput!) {
  pipelines(input: $input) {
    nodes {
      id
      description
      isLegacy
      transaction {
        id
        name
        description
        direction
      }
      pipelineItems {
        id
      }
    }
  }
}
    `;

/**
 * __usePipelinesListQuery__
 *
 * To run a query within a React component, call `usePipelinesListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelinesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelinesListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePipelinesListQuery(baseOptions: Apollo.QueryHookOptions<PipelinesListQuery, PipelinesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelinesListQuery, PipelinesListQueryVariables>(PipelinesListDocument, options);
      }
export function usePipelinesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelinesListQuery, PipelinesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelinesListQuery, PipelinesListQueryVariables>(PipelinesListDocument, options);
        }
export type PipelinesListQueryHookResult = ReturnType<typeof usePipelinesListQuery>;
export type PipelinesListLazyQueryHookResult = ReturnType<typeof usePipelinesListLazyQuery>;
export type PipelinesListQueryResult = Apollo.QueryResult<PipelinesListQuery, PipelinesListQueryVariables>;
export const PortalTransactionListDocument = gql`
    query portalTransactionList($input: GetPortalTransactionsInput!) {
  portalTransactions(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      id
      acknowledgedTime
      acknowledgementStatus
      clientId
      clientTenantId
      partnerId
      currencyCode
      documentDate
      documentId
      documentNumber
      documentReferenceId
      ediDocumentResentCount
      ediDocumentResentTime
      erpOrderNumber
      originalFileName
      internalTransactionId
      isAbandoned
      purchaseOrderNumber
      totalLines
      totalQuantity
      totalValue
      createdTime
      client {
        id
        name
      }
      partner {
        id
        name
      }
      clientPartner {
        id
      }
      transaction {
        id
        name
        direction
        normalizedDocumentType
      }
      transactionErrors {
        id
        status
      }
    }
  }
}
    `;

/**
 * __usePortalTransactionListQuery__
 *
 * To run a query within a React component, call `usePortalTransactionListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalTransactionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalTransactionListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePortalTransactionListQuery(baseOptions: Apollo.QueryHookOptions<PortalTransactionListQuery, PortalTransactionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalTransactionListQuery, PortalTransactionListQueryVariables>(PortalTransactionListDocument, options);
      }
export function usePortalTransactionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalTransactionListQuery, PortalTransactionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalTransactionListQuery, PortalTransactionListQueryVariables>(PortalTransactionListDocument, options);
        }
export type PortalTransactionListQueryHookResult = ReturnType<typeof usePortalTransactionListQuery>;
export type PortalTransactionListLazyQueryHookResult = ReturnType<typeof usePortalTransactionListLazyQuery>;
export type PortalTransactionListQueryResult = Apollo.QueryResult<PortalTransactionListQuery, PortalTransactionListQueryVariables>;
export const PostProcessingBlobsDocument = gql`
    query postProcessingBlobs($input: GetPostProcessingBlobInput!) {
  postProcessingBlobs(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      description
      id
      lastModifiedBy
      lastModifiedTime
      processBlobString
    }
  }
}
    `;

/**
 * __usePostProcessingBlobsQuery__
 *
 * To run a query within a React component, call `usePostProcessingBlobsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostProcessingBlobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostProcessingBlobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostProcessingBlobsQuery(baseOptions: Apollo.QueryHookOptions<PostProcessingBlobsQuery, PostProcessingBlobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostProcessingBlobsQuery, PostProcessingBlobsQueryVariables>(PostProcessingBlobsDocument, options);
      }
export function usePostProcessingBlobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostProcessingBlobsQuery, PostProcessingBlobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostProcessingBlobsQuery, PostProcessingBlobsQueryVariables>(PostProcessingBlobsDocument, options);
        }
export type PostProcessingBlobsQueryHookResult = ReturnType<typeof usePostProcessingBlobsQuery>;
export type PostProcessingBlobsLazyQueryHookResult = ReturnType<typeof usePostProcessingBlobsLazyQuery>;
export type PostProcessingBlobsQueryResult = Apollo.QueryResult<PostProcessingBlobsQuery, PostProcessingBlobsQueryVariables>;
export const GetPricingByIdDocument = gql`
    query getPricingById($input: GetPricingsInput!) {
  pricings(input: $input) {
    nodes {
      description
      id
      minServiceFees
      currencyCode
      billingItemCount
      lastModifiedBy
      lastModifiedByName
      lastModifiedTime
      pricingItems {
        id
        description
        feePerDocument
        feePerLine
        maxNumberOfTransactions
        pricingId
      }
    }
  }
}
    `;

/**
 * __useGetPricingByIdQuery__
 *
 * To run a query within a React component, call `useGetPricingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPricingByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPricingByIdQuery, GetPricingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingByIdQuery, GetPricingByIdQueryVariables>(GetPricingByIdDocument, options);
      }
export function useGetPricingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingByIdQuery, GetPricingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingByIdQuery, GetPricingByIdQueryVariables>(GetPricingByIdDocument, options);
        }
export type GetPricingByIdQueryHookResult = ReturnType<typeof useGetPricingByIdQuery>;
export type GetPricingByIdLazyQueryHookResult = ReturnType<typeof useGetPricingByIdLazyQuery>;
export type GetPricingByIdQueryResult = Apollo.QueryResult<GetPricingByIdQuery, GetPricingByIdQueryVariables>;
export const PricingsListDocument = gql`
    query pricingsList($input: GetPricingsInput!) {
  pricings(input: $input) {
    nodes {
      description
      id
      minServiceFees
      currencyCode
      billingItemCount
    }
  }
}
    `;

/**
 * __usePricingsListQuery__
 *
 * To run a query within a React component, call `usePricingsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePricingsListQuery(baseOptions: Apollo.QueryHookOptions<PricingsListQuery, PricingsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricingsListQuery, PricingsListQueryVariables>(PricingsListDocument, options);
      }
export function usePricingsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricingsListQuery, PricingsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricingsListQuery, PricingsListQueryVariables>(PricingsListDocument, options);
        }
export type PricingsListQueryHookResult = ReturnType<typeof usePricingsListQuery>;
export type PricingsListLazyQueryHookResult = ReturnType<typeof usePricingsListLazyQuery>;
export type PricingsListQueryResult = Apollo.QueryResult<PricingsListQuery, PricingsListQueryVariables>;
export const ProcessListDocument = gql`
    query processList($input: GetConfigurationsInput!) {
  configurations(input: $input) {
    nodes {
      description
      destPath
      ediProcess
      executionMode
      extension
      id
      p1
      p2
      p3
      p4
      p5
      p6
      tpgClient
      watcherPath
    }
  }
}
    `;

/**
 * __useProcessListQuery__
 *
 * To run a query within a React component, call `useProcessListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessListQuery(baseOptions: Apollo.QueryHookOptions<ProcessListQuery, ProcessListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessListQuery, ProcessListQueryVariables>(ProcessListDocument, options);
      }
export function useProcessListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessListQuery, ProcessListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessListQuery, ProcessListQueryVariables>(ProcessListDocument, options);
        }
export type ProcessListQueryHookResult = ReturnType<typeof useProcessListQuery>;
export type ProcessListLazyQueryHookResult = ReturnType<typeof useProcessListLazyQuery>;
export type ProcessListQueryResult = Apollo.QueryResult<ProcessListQuery, ProcessListQueryVariables>;
export const ErpProductsListDocument = gql`
    query erpProductsList {
  erpProducts {
    nodes {
      name
      description
      id
      isAptean
    }
  }
}
    `;

/**
 * __useErpProductsListQuery__
 *
 * To run a query within a React component, call `useErpProductsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpProductsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpProductsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpProductsListQuery(baseOptions?: Apollo.QueryHookOptions<ErpProductsListQuery, ErpProductsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErpProductsListQuery, ErpProductsListQueryVariables>(ErpProductsListDocument, options);
      }
export function useErpProductsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpProductsListQuery, ErpProductsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErpProductsListQuery, ErpProductsListQueryVariables>(ErpProductsListDocument, options);
        }
export type ErpProductsListQueryHookResult = ReturnType<typeof useErpProductsListQuery>;
export type ErpProductsListLazyQueryHookResult = ReturnType<typeof useErpProductsListLazyQuery>;
export type ErpProductsListQueryResult = Apollo.QueryResult<ErpProductsListQuery, ErpProductsListQueryVariables>;
export const StandardExchangeFormatFileListDocument = gql`
    query standardExchangeFormatFileList($input: GetStandardExchangeFormatInput!) {
  standardExchangeFormatStorageFiles(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      id
      blobDocumentType
      blobFileName
      comment
      fileName
      isActive
      version
      createdBy
      createdByName
      createdTime
      lastModifiedBy
      lastModifiedByName
      lastModifiedTime
      blobStorageReference {
        id
        blobStorageId
        blobDocumentId
      }
    }
  }
}
    `;

/**
 * __useStandardExchangeFormatFileListQuery__
 *
 * To run a query within a React component, call `useStandardExchangeFormatFileListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStandardExchangeFormatFileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardExchangeFormatFileListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStandardExchangeFormatFileListQuery(baseOptions: Apollo.QueryHookOptions<StandardExchangeFormatFileListQuery, StandardExchangeFormatFileListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StandardExchangeFormatFileListQuery, StandardExchangeFormatFileListQueryVariables>(StandardExchangeFormatFileListDocument, options);
      }
export function useStandardExchangeFormatFileListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StandardExchangeFormatFileListQuery, StandardExchangeFormatFileListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StandardExchangeFormatFileListQuery, StandardExchangeFormatFileListQueryVariables>(StandardExchangeFormatFileListDocument, options);
        }
export type StandardExchangeFormatFileListQueryHookResult = ReturnType<typeof useStandardExchangeFormatFileListQuery>;
export type StandardExchangeFormatFileListLazyQueryHookResult = ReturnType<typeof useStandardExchangeFormatFileListLazyQuery>;
export type StandardExchangeFormatFileListQueryResult = Apollo.QueryResult<StandardExchangeFormatFileListQuery, StandardExchangeFormatFileListQueryVariables>;
export const StatesListDocument = gql`
    query statesList {
  states(input: {order: [{countryCode: ASC}, {stateCode: ASC}], limit: 250}) {
    nodes {
      countryCode
      description
      stateCode
      id
    }
  }
}
    `;

/**
 * __useStatesListQuery__
 *
 * To run a query within a React component, call `useStatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useStatesListQuery(baseOptions?: Apollo.QueryHookOptions<StatesListQuery, StatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatesListQuery, StatesListQueryVariables>(StatesListDocument, options);
      }
export function useStatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatesListQuery, StatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatesListQuery, StatesListQueryVariables>(StatesListDocument, options);
        }
export type StatesListQueryHookResult = ReturnType<typeof useStatesListQuery>;
export type StatesListLazyQueryHookResult = ReturnType<typeof useStatesListLazyQuery>;
export type StatesListQueryResult = Apollo.QueryResult<StatesListQuery, StatesListQueryVariables>;
export const SystemConfigurationDocument = gql`
    query systemConfiguration {
  systemConfiguration {
    id
    billingRecipientsEmail
    errorRecipientsEmail
    ediDirectRecipientsEmail
  }
}
    `;

/**
 * __useSystemConfigurationQuery__
 *
 * To run a query within a React component, call `useSystemConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useSystemConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<SystemConfigurationQuery, SystemConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemConfigurationQuery, SystemConfigurationQueryVariables>(SystemConfigurationDocument, options);
      }
export function useSystemConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemConfigurationQuery, SystemConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemConfigurationQuery, SystemConfigurationQueryVariables>(SystemConfigurationDocument, options);
        }
export type SystemConfigurationQueryHookResult = ReturnType<typeof useSystemConfigurationQuery>;
export type SystemConfigurationLazyQueryHookResult = ReturnType<typeof useSystemConfigurationLazyQuery>;
export type SystemConfigurationQueryResult = Apollo.QueryResult<SystemConfigurationQuery, SystemConfigurationQueryVariables>;
export const GetActiveSystemNotificationDocument = gql`
    query getActiveSystemNotification {
  activeSystemNotification {
    id
    message
    notificationType
    dateStart
    dateEnd
    environment
  }
}
    `;

/**
 * __useGetActiveSystemNotificationQuery__
 *
 * To run a query within a React component, call `useGetActiveSystemNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveSystemNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveSystemNotificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveSystemNotificationQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveSystemNotificationQuery, GetActiveSystemNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveSystemNotificationQuery, GetActiveSystemNotificationQueryVariables>(GetActiveSystemNotificationDocument, options);
      }
export function useGetActiveSystemNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveSystemNotificationQuery, GetActiveSystemNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveSystemNotificationQuery, GetActiveSystemNotificationQueryVariables>(GetActiveSystemNotificationDocument, options);
        }
export type GetActiveSystemNotificationQueryHookResult = ReturnType<typeof useGetActiveSystemNotificationQuery>;
export type GetActiveSystemNotificationLazyQueryHookResult = ReturnType<typeof useGetActiveSystemNotificationLazyQuery>;
export type GetActiveSystemNotificationQueryResult = Apollo.QueryResult<GetActiveSystemNotificationQuery, GetActiveSystemNotificationQueryVariables>;
export const SystemNotificationsDocument = gql`
    query systemNotifications {
  systemNotifications {
    id
    message
    notificationType
    dateStart
    dateEnd
    environment
  }
}
    `;

/**
 * __useSystemNotificationsQuery__
 *
 * To run a query within a React component, call `useSystemNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSystemNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<SystemNotificationsQuery, SystemNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemNotificationsQuery, SystemNotificationsQueryVariables>(SystemNotificationsDocument, options);
      }
export function useSystemNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemNotificationsQuery, SystemNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemNotificationsQuery, SystemNotificationsQueryVariables>(SystemNotificationsDocument, options);
        }
export type SystemNotificationsQueryHookResult = ReturnType<typeof useSystemNotificationsQuery>;
export type SystemNotificationsLazyQueryHookResult = ReturnType<typeof useSystemNotificationsLazyQuery>;
export type SystemNotificationsQueryResult = Apollo.QueryResult<SystemNotificationsQuery, SystemNotificationsQueryVariables>;
export const GetTradingPartnerByIdDocument = gql`
    query getTradingPartnerById($input: GetPartnersInput!) {
  partners(input: $input) {
    nodes {
      id
      internalPartnerCode
      isaQualifierCode
      localeCode
      name
      partnerCode
      statusCode
      functionalReconciliationMode
      website
      totalTransactions
      addresses {
        addressLine1
        addressLine2
        addressLine3
        addressLine4
        city
        countryCode
        id
        isPrimary
        postalCode
        stateId
        state {
          stateCode
          description
          id
        }
      }
      businessArea {
        name
        description
        id
      }
      partnerAKAs {
        id
        partnerCode
        isaQualifierCode
        isaQualifier {
          isaQualifierCode
          description
        }
      }
      partnerContacts {
        id
        partnerId
        name
        description
        isActive
        isPrimary
        jobTitle
        addresses {
          addressLine1
          addressLine2
          addressLine3
          addressLine4
          city
          countryCode
          id
          isPrimary
          postalCode
          stateId
          state {
            stateCode
            description
            id
          }
        }
        emails {
          email
          id
          isPrimary
        }
        phones {
          description
          id
          phoneNumber
          phoneTypeCode
        }
        notes {
          createdBy
          createdByName
          createdTime
          header
          id
          lastModifiedBy
          lastModifiedByName
          lastModifiedTime
          note
          parentId
        }
      }
      clients {
        id
        name
        clientCode
        statusCode
        totalTransactions
        businessArea {
          id
          name
        }
        erpProduct {
          id
          name
        }
      }
      ediStandards {
        description
        id
        name
      }
      emails {
        email
        id
        isPrimary
      }
      phones {
        phoneNumber
        phoneTypeCode
        description
        id
      }
      notes {
        createdBy
        createdByName
        createdTime
        header
        id
        lastModifiedBy
        lastModifiedByName
        lastModifiedTime
        note
        parentId
      }
      partnerTransactions {
        id
        transaction {
          id
          name
          description
          direction
          isActive
        }
        clientPartnerTransactions {
          id
        }
        partnerTransactionSchemas {
          id
          partnerTransactionId
          standardVersion
          description
          documentString
          sourceFileName
        }
        pipeline {
          description
          id
        }
        pipelineId
        functionalReconciliationMode
        outboundAcknowledgementOption
      }
      attachments {
        id
        fileName
        isLink
        description
        createdBy
        createdByName
        createdTime
        lastModifiedBy
        lastModifiedByName
        lastModifiedTime
        fileLastModifiedTime
      }
    }
  }
}
    `;

/**
 * __useGetTradingPartnerByIdQuery__
 *
 * To run a query within a React component, call `useGetTradingPartnerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTradingPartnerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTradingPartnerByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTradingPartnerByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTradingPartnerByIdQuery, GetTradingPartnerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTradingPartnerByIdQuery, GetTradingPartnerByIdQueryVariables>(GetTradingPartnerByIdDocument, options);
      }
export function useGetTradingPartnerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTradingPartnerByIdQuery, GetTradingPartnerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTradingPartnerByIdQuery, GetTradingPartnerByIdQueryVariables>(GetTradingPartnerByIdDocument, options);
        }
export type GetTradingPartnerByIdQueryHookResult = ReturnType<typeof useGetTradingPartnerByIdQuery>;
export type GetTradingPartnerByIdLazyQueryHookResult = ReturnType<typeof useGetTradingPartnerByIdLazyQuery>;
export type GetTradingPartnerByIdQueryResult = Apollo.QueryResult<GetTradingPartnerByIdQuery, GetTradingPartnerByIdQueryVariables>;
export const PartnersListDocument = gql`
    query partnersList($input: GetPartnersInput!) {
  partners(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      name
      isaQualifierCode
      id
      partnerCode
      website
      totalTransactions
      businessArea {
        id
        description
        name
      }
      ediStandards {
        description
        id
        name
      }
    }
  }
}
    `;

/**
 * __usePartnersListQuery__
 *
 * To run a query within a React component, call `usePartnersListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnersListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnersListQuery(baseOptions: Apollo.QueryHookOptions<PartnersListQuery, PartnersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnersListQuery, PartnersListQueryVariables>(PartnersListDocument, options);
      }
export function usePartnersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnersListQuery, PartnersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnersListQuery, PartnersListQueryVariables>(PartnersListDocument, options);
        }
export type PartnersListQueryHookResult = ReturnType<typeof usePartnersListQuery>;
export type PartnersListLazyQueryHookResult = ReturnType<typeof usePartnersListLazyQuery>;
export type PartnersListQueryResult = Apollo.QueryResult<PartnersListQuery, PartnersListQueryVariables>;
export const GetTransactionByIdDocument = gql`
    query getTransactionById($input: GetTransactionsInput!) {
  transactions(input: $input) {
    nodes {
      id
      name
      description
      ediStandard {
        id
        name
      }
      direction
      isActive
      isBillable
      ediStandardId
      billableFactor
      normalizedDocumentType
      documentTransformationSchema
      skipTargetDocumentCreation
      transactionXPath {
        id
        transactionId
        xPathJson
      }
    }
  }
}
    `;

/**
 * __useGetTransactionByIdQuery__
 *
 * To run a query within a React component, call `useGetTransactionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTransactionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>(GetTransactionByIdDocument, options);
      }
export function useGetTransactionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>(GetTransactionByIdDocument, options);
        }
export type GetTransactionByIdQueryHookResult = ReturnType<typeof useGetTransactionByIdQuery>;
export type GetTransactionByIdLazyQueryHookResult = ReturnType<typeof useGetTransactionByIdLazyQuery>;
export type GetTransactionByIdQueryResult = Apollo.QueryResult<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>;
export const TransactionMapByIdDocument = gql`
    query transactionMapById($input: GetTransactionMapInput!) {
  transactionMaps(input: $input) {
    nodes {
      id
      createdBy
      createdByName
      createdTime
      description
      documentString
      isMapDeployed
      isMapLoaded
      lastModifiedBy
      lastModifiedByName
      lastModifiedTime
      sourceFileName
      standardVersion
      totalPartners
      transaction {
        id
        name
        description
        direction
      }
      transactionId
    }
  }
}
    `;

/**
 * __useTransactionMapByIdQuery__
 *
 * To run a query within a React component, call `useTransactionMapByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionMapByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionMapByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransactionMapByIdQuery(baseOptions: Apollo.QueryHookOptions<TransactionMapByIdQuery, TransactionMapByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionMapByIdQuery, TransactionMapByIdQueryVariables>(TransactionMapByIdDocument, options);
      }
export function useTransactionMapByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionMapByIdQuery, TransactionMapByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionMapByIdQuery, TransactionMapByIdQueryVariables>(TransactionMapByIdDocument, options);
        }
export type TransactionMapByIdQueryHookResult = ReturnType<typeof useTransactionMapByIdQuery>;
export type TransactionMapByIdLazyQueryHookResult = ReturnType<typeof useTransactionMapByIdLazyQuery>;
export type TransactionMapByIdQueryResult = Apollo.QueryResult<TransactionMapByIdQuery, TransactionMapByIdQueryVariables>;
export const TransactionMapPartnersDocument = gql`
    query transactionMapPartners($input: GetTransactionMapPartnerInput!) {
  transactionMapPartners(input: $input) {
    nodes {
      id
      partner {
        ediStandards {
          id
          name
        }
        name
        id
        totalTransactions
        website
      }
      partnerId
    }
  }
}
    `;

/**
 * __useTransactionMapPartnersQuery__
 *
 * To run a query within a React component, call `useTransactionMapPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionMapPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionMapPartnersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransactionMapPartnersQuery(baseOptions: Apollo.QueryHookOptions<TransactionMapPartnersQuery, TransactionMapPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionMapPartnersQuery, TransactionMapPartnersQueryVariables>(TransactionMapPartnersDocument, options);
      }
export function useTransactionMapPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionMapPartnersQuery, TransactionMapPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionMapPartnersQuery, TransactionMapPartnersQueryVariables>(TransactionMapPartnersDocument, options);
        }
export type TransactionMapPartnersQueryHookResult = ReturnType<typeof useTransactionMapPartnersQuery>;
export type TransactionMapPartnersLazyQueryHookResult = ReturnType<typeof useTransactionMapPartnersLazyQuery>;
export type TransactionMapPartnersQueryResult = Apollo.QueryResult<TransactionMapPartnersQuery, TransactionMapPartnersQueryVariables>;
export const TransactionsListDocument = gql`
    query transactionsList($input: GetTransactionsInput!) {
  transactions(input: $input) {
    nodes {
      id
      name
      description
      ediStandard {
        id
        name
      }
      direction
      isActive
      isBillable
      ediStandardId
      billableFactor
      normalizedDocumentType
      transactionXPath {
        id
      }
    }
  }
}
    `;

/**
 * __useTransactionsListQuery__
 *
 * To run a query within a React component, call `useTransactionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransactionsListQuery(baseOptions: Apollo.QueryHookOptions<TransactionsListQuery, TransactionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsListQuery, TransactionsListQueryVariables>(TransactionsListDocument, options);
      }
export function useTransactionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsListQuery, TransactionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsListQuery, TransactionsListQueryVariables>(TransactionsListDocument, options);
        }
export type TransactionsListQueryHookResult = ReturnType<typeof useTransactionsListQuery>;
export type TransactionsListLazyQueryHookResult = ReturnType<typeof useTransactionsListLazyQuery>;
export type TransactionsListQueryResult = Apollo.QueryResult<TransactionsListQuery, TransactionsListQueryVariables>;
export const GetPersonByEmailDocument = gql`
    query getPersonByEmail($email: String!) {
  user(input: {email: $email}) {
    id
    firstName
    lastName
    email
    role
    recents {
      entityId
      entityType
      name
      lastViewed
      id
    }
    favorites {
      entityId
      entityType
      name
      id
    }
  }
}
    `;

/**
 * __useGetPersonByEmailQuery__
 *
 * To run a query within a React component, call `useGetPersonByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetPersonByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetPersonByEmailQuery, GetPersonByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonByEmailQuery, GetPersonByEmailQueryVariables>(GetPersonByEmailDocument, options);
      }
export function useGetPersonByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonByEmailQuery, GetPersonByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonByEmailQuery, GetPersonByEmailQueryVariables>(GetPersonByEmailDocument, options);
        }
export type GetPersonByEmailQueryHookResult = ReturnType<typeof useGetPersonByEmailQuery>;
export type GetPersonByEmailLazyQueryHookResult = ReturnType<typeof useGetPersonByEmailLazyQuery>;
export type GetPersonByEmailQueryResult = Apollo.QueryResult<GetPersonByEmailQuery, GetPersonByEmailQueryVariables>;
export const UserListDocument = gql`
    query userList($input: GetUsersInput!) {
  users(input: $input) {
    cursor {
      nextPage
      previousPage
    }
    totalCount
    nodes {
      id
      firstName
      lastName
      email
      role
      isActive
    }
  }
}
    `;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserListQuery(baseOptions: Apollo.QueryHookOptions<UserListQuery, UserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
      }
export function useUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListLazyQueryHookResult = ReturnType<typeof useUserListLazyQuery>;
export type UserListQueryResult = Apollo.QueryResult<UserListQuery, UserListQueryVariables>;